{
  "abbreviation": "Abbreviation",
  "abbreviationTooltip": "The custom field abbreviation and its value will be displayed on the shipment summary card for quick reference.",
  "above": "Above",
  "accelerationType_x": "Accel. X",
  "accelerationType_y": "Accel. Y",
  "accelerationType_z": "Accel. Z",
  "access": "Access",
  "accessRule": "Access rule",
  "accountDeactivation": "Are you sure you would like to deactivate this account?",
  "accountSettings": "Account settings",
  "accuracy": "Accuracy",
  "acknowledge": "Acknowledge",
  "acknowledged": "Acknowledged",
  "acknowledgedEvents": "Acknowledged events",
  "Acknowledged Events": "Acknowledged events",
  "acknowledgedRiskEvents": "Acknowledged risk events",
  "acknowledgedTitle": "Acknowledged",
  "acres": "Acres",
  "action_reasons_breakdown": "Breakdown",
  "action_reasons_door_open_for_deliveries": "Door open for deliveries",
  "action_reasons_other": "Other",
  "actionRequired": "Action required",
  "actions": "Actions",
  "activate": "Activate",
  "activateCustomField": "Activate custom field",
  "activated": "Activated",
  "activateRouteModaldescription": "Edit and activate this route to use it in other shipments that you create in the future.",
  "activateSegment": "Activate segment",
  "active": "Active",
  "activeAlerts": "Active alerts",
  "activeCustomer": "Active customer",
  "activeNow": "Active now",
  "activeSegmentConfirmation": "Would you like to activate?",
  "activeSegmentSelectedState": "Activating this segment will move this shipment to the selected state.",
  "activeSegmentWarning": "ARE YOU SURE? Activating this segment will hide the current segment's events from the timeline.",
  "activeShipment": "Active shipment",
  "active_shipments": "Active shipments",
  "activeShipments": "Active shipments",
  "activeShipmentsInRedZone": "Active shipments in RedZone",
  "activeShipmentsInRedZoneKPIHint": "Total shipments currently in the RedZone over total active shipments",
  "activeShipmentsTooltip": "The metric won't be affected by the date time picker and will show all shipments with an active status",
  "activeState": "State",
  "activityBreakdown": "Activity breakdown",
  "activityLog": "Activity log",
  "actual": "Actual",
  "add": "Add",
  "add2ndDriver": "Add 2nd driver",
  "addAdditionalNotes": "Add additional notes...",
  "addAirMode": "Add air mode",
  "addAsset": "Add asset",
  "addAssociation": "Add association",
  "addAttachment": "Add attachment",
  "add_carrier": "Add carrier",
  "addCarrier.addCarrierModalDescription": "Enter the USDOT number to validate carrier details with FMCSA. Validation helps ensure your carrier is accurate and safe to do business with.",
  "addCarrier.errorDescription_carrierNotFound": "Please confirm that the number is correct and try again.",
  "addCarrier.errorDescription_unknownCarrierError": "Something went wrong. Check your internet connection and try again.",
  "addCarrier.errorTitle_carrierNotFound": "No FMCSA data found for USDOT {usdotNumber}.",
  "addCarrier.errorTitle_unknownCarrierError": "Unable to validate and retrieve data for USDOT {usdotNumber}.",
  "addCarrier.label_validateCarrier": "Validate with FMCSA",
  "addCarrier.noResultsFoundDescription": "Would you like to add this carrier?",
  "addCarrier.noResultsFoundTitle": "No results found for {query}",
  "addCarrier.reviewCarrierInfoTitle": "Review carrier company information",
  "addCarriers": "Add carriers company",
  "addCarrier.successDescription_carrierValidated": "Validation date:",
  "addCarrier.successMessage_carrierAdded": "The new carrier was added and their risk score has been calculated.",
  "addCarrier.successTitle_carrierAdded": "Carrier added!",
  "addCarrier.successTitle_carrierValidated": "Your USDOT number was successfully validated with the FMCSA.",
  "addChecklists": "Add checklists",
  "addCompanyAssociation": "Add company association",
  "addContact": "Add contact",
  "addContactBtn": "Add contact",
  "addContacts": "Add contacts",
  "addContactSuccessMessage": "{firstName} {lastName} was successfully created as an escalation contact.",
  "addCustomField": "Add custom field",
  "addDataToShare": "Please enter email address or phone number to share public link",
  "addDepartment": "Add department",
  "addDepartmentAssociation": "Add department association",
  "addDepartmentAssociationSubTitle": "In the case of multi-tenancy, select the company as well.",
  "addDepartmentAssociationTitle": "Select the department to add the contact to.",
  "addDepartmentAssociationWarningMessage": "The contact’s individual associations will be removed.",
  "addDepartmentSubTitle": "Select the portal and company and provide a name to create a department.",
  "addDevice": "Add device",
  "addDevices": "Add devices",
  "addDeviceVendor": "Add device vendor",
  "addDriver": "Add driver",
  "added": "Added",
  "addEventVariant": "Add event variant",
  "addEventVariantModalTitle": "Select the event to add a variant for",
  "addEventVariantTitle": "Add event variant",
  "addFilter": "Add filter",
  "add_freight_forwarder": "Add freight forwarder",
  "addGeofence": "Add geofence",
  "addGroup": "ADD GROUP",
  "addHumidityRange": "Add humidity range",
  "addingSecondDriverPreferable": "Adding a second driver is preferred.",
  "additionalAttributes": "Additional attributes",
  "additionalAttributesUpdateErrorMessage": "Location attributes saved successfully however there was an error when saving additional attributes.",
  "additionalDetails": "Additional details",
  "additional_info": "Additional info",
  "additionalNotesComments": "Additional notes or comments",
  "additionalSettings": "Additional settings",
  "addLanguage": "Add language",
  "addLanguageOption": "Add language option",
  "addLightRange": "Add light range",
  "addLocation": "Add location",
  "addMoreLeg": "Add one more leg",
  "addNew": "Add new",
  "add_new_carrier": "Add new carrier",
  "addNewCompany": "Add new company",
  "addNewContact": "Add new contact",
  "addNewDevice": "Add new device",
  "addNewDriver": "Add new driver",
  "add_new_freight_forwarder": "Add new freight forwarder",
  "addNewRole": "Add new role",
  "addNewTag": "Add new tag",
  "addNewUser": "Add new user",
  "addNote": "Add note",
  "addNotes": "Add notes",
  "addOceanMode": "Add ocean mode",
  "addOpeningHours": "Add opening hours",
  "addPO": "Add PO#",
  "addPriorityGroup": "Add new priority group",
  "addRailMode": "Add rail mode",
  "addReport": "Add report",
  "address": "Address",
  "addressRiskLevel.high": "High",
  "addressRiskLevel.medium": "Medium",
  "addressRiskLevel.noRisk": "No risk",
  "addRestrictions": "Add restrictions",
  "addRoadMode": "Add road mode",
  "addRoute": "Add route",
  "addRouteExternalLocationConfirmation": "Are you sure you want to create a new location?",
  "addRoutes": "Add routes",
  "addSecondDriver": "Add second driver",
  "addSegment": "Add segment",
  "addShippers": "Add shippers company",
  "addSOPInstructions": "Add SOP instructions",
  "addTag": "Add tag",
  "addTemperatureRange": "Add temperature range",
  "add_tractor": "Add new tractor",
  "add_trailer": "Add new trailer",
  "addUser": "Add user",
  "addUser.emailError": "This user already exists, please contact Customer Operations at <a>{email}</a>",
  "addUserPin": "Add user PIN",
  "addUsers": "Add users",
  "addVerifiedCompany_modalInfo": "Enter the USDOT number to validate company details with FMCSA. Validation helps ensure your company is accurate and safe to do business with.",
  "addVerifiedCompany_reviewInfo": "Review company information",
  "addVerifiedCompany_validate": "Validate with FMCSA",
  "addVerifiedCompany_validationDate": "Validation date",
  "addVerifiedCompany_verificationErrorMessage": "Please confirm that the number is correct and try again.",
  "addVerifiedCompany_verificationErrorTitle": "No FMCSA data found for USDOT {usdotNumber}.",
  "addVerifiedCompany_verificationSuccessTitle": "Your USDOT number was successfully validated with the FMCSA.",
  "addVerifiedCompany_verificationUnknownErrorTitle": "Unable to validate and retrieve data for USDOT {usdotNumber}.",
  "addWorkflow": "Add workflow",
  "adjustYourSearchFilter": "Try adjusting your search or filter to find what you're looking for.",
  "admin": "Admin",
  "advanced": "Advanced",
  "advisory": "Advisory",
  "afterAlertBreachTime": "After",
  "afterHoursAvailability": "After hours",
  "ago": "Ago",
  "agreed": "Agreed",
  "agreedDate": "Agreed date",
  "air": "Air",
  "airportDetentionTimeMinutes": "Airport detention time (minutes)",
  "airport_ids": "Airport",
  "airportOfDelivery": "Airport of delivery",
  "airportOfNotification": "Airport of notification",
  "airportOfReceipt": "Airport of receipt",
  "airports": "Airports",
  "Airports": "Airports",
  "airport_wait_time_exceeded_shipment_event": "Airport wait time exceeded",
  "airport_wait_time_exceeded_violation": "Airport wait time exceeded",
  "airportWithCode": "{code} airport",
  "airSettings": "Air settings",
  "airShippingMode": "Mode: air",
  "airWorkflowCreated": "Air workflow is successfully created",
  "airWorkflowUpdated": "Air workflow is successfully updated",
  "alarm": "Alarm",
  "alarmCode": "Alarm code",
  "alarmDescription": "Alarm description",
  "alert": "Alert",
  "alertName": "Alert name",
  "alertOff": "Alert off",
  "alertOn": "Alert on",
  "alertResponseTime": "Alert response time",
  "alertRiskLevel": "Alert risk level",
  "alertsAndEvents": "Alerts & events",
  "alertsAndNotifications": "Alerts & Notifications",
  "alertsPerPeriod": "Alerts per period",
  "alertType": "Alert type",
  "alias": "Alias",
  "all": "All",
  "allAddresses": "All addresses",
  "allAirports": "All airports",
  "allAssets": "All assets",
  "allBrokersPlaceholder": "All brokers",
  "allCarriers": "All carriers",
  "allCarriersPlaceholder": "All carriers",
  "allChangesWillBeLost": "All the changes will be lost.",
  "allCities": "All cities",
  "allCountries": "All countries",
  "allCustomersPlaceholder": "All customers",
  "allDay": "All day",
  "allDestinations": "All destinations",
  "allDevices": "All devices",
  "allDimensions": "All dimensions",
  "allDirections": "All directions",
  "allDrivers": "All drivers",
  "allEscortDriversPlaceholder": "All escort drivers",
  "allEscortsPlaceholder": "All escorts",
  "allEtaStatuses": "All ETA's",
  "allEvents": "All events",
  "allLocations": "All locations",
  "allLocationsPlaceholder": "All locations",
  "allOrigins": "All origins",
  "allowContainerTrackingWithoutScacCode": "Allow container tracking without ocean SCAC code",
  "allowContainerTrackingWithoutScacCodeTooltip": "It is strongly recommended to use the ocean SCAC code for container tracking. Not providing this field could pull in a previous shipment container lifecycle",
  "allowSherpaChecklistToggle": "Enable and display in Driver Connect",
  "allowSherpaPickupToggle": "Enable and display in Driver Connect",
  "allPortalsPlaceholder": "All portals",
  "allRightsReserved": "© {year} Overhaul group, inc. All rights reserved.",
  "allRisks": "All risks",
  "allRoutesPlaceholder": "All routes",
  "allSeaports": "All seaports",
  "allShipments": "All shipments",
  "allShippersPlaceholder": "All shippers",
  "allStatuses": "All statuses",
  "allStatusesPlaceholder": "All statuses",
  "allUpdates": "All updates",
  "allWorkflows": "All workflows",
  "ambient": "Ambient",
  "amount": "Amount",
  "amountOfCopiedEmails": "{amount} email(s) copied for {type}",
  "and": "And",
  "applyBtn": "Apply",
  "applyLogo": "Apply logo",
  "applyRoute": "Apply route",
  "applyToAllGroups": "Apply to all groups",
  "approvalEventBanner.subtitle_awaitingApproval": "Approvers notified at <datetime/>",
  "approvalEventBanner.title_awaitingApprovalDuringPickup": "Shipment is awaiting approval during pickup",
  "approvalEventBanner.title_awaitingApprovalDuringPlanning": "Shipment is awaiting approval during planning",
  "approvalEventBanner.title_pickupRejectedAutoDecision": "Shipment's pickup carrier/driver rejected",
  "approvalEventBanner.title_pickupRejectedByAnApprover": "Shipment's actual carrier/driver rejected by {approverName}",
  "approvalEventBanner.title_planningRejectedAutoDecision": "Shipment's planned carrier/driver rejected",
  "approvalEventBanner.title_planningRejectedByAnApprover": "Shipment's planned carrier/driver rejected by {approverName}",
  "approvalSOPInstructions": "Approval SOP instructions",
  "archive": "Archive",
  "archivedCustomer": "Archived customer",
  "areaAllowedToStop": "Allowed to stop",
  "arrival": "Arrival",
  "arrival_at_airport_location": "Arrival at airport location",
  "arrival_at_seaport_location": "Arrival at seaport location",
  "arrival_confirmed_outside_location_violation": "Arrival confirmed outside",
  "arrivalFields": "Arrival fields",
  "arrival_shipment_event": "Arrival at pickup location",
  "arrivalTime": "Arrival time",
  "arrived": "Arrived",
  "Arrived": "Arrived",
  "arrivedAtLocationName": "Arrived at {locationName} {locationType}",
  "arrivedAtSegmentDestination": "Arrived at segment destination",
  "arrivedDateNotProvided": "Arrived date not provided",
  "arrivedToFinalGeofence": "Arrival at delivery",
  "askBackInTransit": "Are you sure you would like to “Re-open shipment” and move the shipment",
  "askBackInTransitEnd": "Back to in transit",
  "askCancel": "Are you sure you would like to cancel shipment",
  "askCloseShipment": "Are you sure you would like to close shipment",
  "askMoveAtDelivery": "Are you sure you would like to move load to \"At delivery\"",
  "askMoveAtPickup": "Are you sure you would like to move load to \"At pickup\"",
  "askMoveDelivered": "Are you sure you would like to move load to \"Delivered\"",
  "askMoveInTransit": "Are you sure you would like to move load to \"In transit\"",
  "askMoveToPickedUp": "Are you sure you would like to move load to \"Picked up\"",
  "askRiskGpt": "Ask RiskGPT",
  "asset": "Asset",
  "assetActions": "Asset actions - current & future",
  "assetActionsSimple": "Asset actions",
  "assetApointmentEventSource_asset": "Asset",
  "assetApointmentEventSource_manual": "Manual",
  "assetApointmentEventSource_milestone": "Milestone",
  "assetAppointments.label_appointmentDetails": "Appointment details",
  "assetAppointments.label_appointmentType": "Appointment type",
  "assetAppointmentStatus_droppedOff": "Dropped off",
  "assetAppointmentStatus_inRouteInTransit": "In route / in transit",
  "assetAppointments.title_createAppointment": "Create appointment",
  "assetAppointments.title_editAppointment": "Edit appointment",
  "assetAssignments.label_appointmentDetails": "Appointment details",
  "assetAssignments.label_appointmentTimeline": "Appointment timeline",
  "assetAssignments.label_assignmentDetails": "Appointment details",
  "assetAssignments.label_contractEnd": "Contract end",
  "assetAssignments.label_contractEndDate": "Contract end date & time",
  "assetAssignments.label_contractStart": "Contract start",
  "assetAssignments.label_contractStartDate": "Contract start date & time",
  "assetAssignments.label_selectAssets": "Select assets",
  "assetAssignmentStatus_assigned": "Assigned",
  "assetAssignmentStatus_atAgency": "At agency",
  "assetAssignmentStatus_cancelled": "Cancelled",
  "assetAssignmentStatus_checkedIn": "Checked in",
  "assetAssignmentStatus_inTransit": "In transit",
  "assetAssignmentStatus_opened": "Opened",
  "assetAssignmentStatus_poComplete": "PO complete",
  "assetAssignmentStatus_procedureComplete": "Procedure complete",
  "assetAssignmentStatus_readyForPickup": "Ready for pickup",
  "assetAssignmentStatus_readyForProcedure": "Ready for procedure",
  "assetAssignmentStatus_submitted": "Submitted",
  "assetAssignments.title_createAssignment": "Create assignment",
  "assetAssignmentType_assigned": "Assigned to asset",
  "assetAssignmentType_notAssigned": "Not assigned to asset",
  "assetAttributes": "Asset attributes",
  "assetCategory": "Asset category",
  "assetClass_air": "Air",
  "assetClass_marine": "Marine",
  "assetClass_products": "Products",
  "assetClass_road": "Road",
  "assetDetails": "Asset details",
  "assetDimensions": "Asset dimensions",
  "assetEvent_assetInactive": "Asset status set to inactive",
  "assetEvent_batteryPingRatesAutoUpdatedAlert": "Device ping/reporting rates auto-updated",
  "assetEvent_countryWithRestrictionsEntry": "Entry to country with trade restrictions",
  "assetEvent_countryWithRestrictionsExit": "Exit from country with trade restrictions",
  "assetEvent_doorClosed": "Door closed",
  "assetEvent_doorOpen": "Door opened",
  "assetEventFilter_arrivalAtLocation": "Arrived at location",
  "assetEventFilter_departedFromLocation": "Departed from location",
  "assetEventFilter_doorClosed": "Door closed",
  "assetEventFilter_doorOpen": "Door opened",
  "assetEventFilter_locationArrival": "Location arrival",
  "assetEventFilter_locationDeparture": "Location departure",
  "assetEventFilter_moving": "Motion status change - moving",
  "assetEventFilter_polygonArrival": "Polygon arrival",
  "assetEventFilter_polygonDeparture": "Polygon departure",
  "assetEventFilter_stationary": "Motion status change - stationary",
  "assetEvent_humidityAlert": "Humidity alert",
  "assetEvent_medicalDeviceArrivedAtAppointmentLocation": "Arrived at appointment location",
  "assetEvent_medicalDeviceAtAgency": "At agency",
  "assetEvent_medicalDeviceInTransitToAppointmentLocation": "In transit",
  "assetEvent_medicalDeviceInTransitToAssignmentLocation": "In transit",
  "assetEvent_medicalDeviceReadyForProcedure": "Ready for procedure",
  "assetEvent_medicalDeviceReportedFromSterilization": "Reported from sterilization",
  "assetEvent_medicalDeviceReportFromOutboundRoom": "Reported from outbound room",
  "assetEvent_moving": "Motion status change: moving",
  "assetEvent_reportingStatusActive": "Reporting status: active",
  "assetEvent_reportingStatusInactive": "Reporting status: inactive",
  "assetEvent_sanctionedStateEntry": "Entry to state with restrictions",
  "assetEvent_sanctionedStateExit": "Exit from state with restrictions",
  "assetEvent_sealClosed": "Seal closed",
  "assetEvent_sealOpen": "Seal open",
  "assetEvent_shockAlert": "Shock alert",
  "assetEvent_speedAlert": "Speed alert",
  "assetEvent_stationary": "Motion status change: stationary",
  "assetEvent_temperatureAlert": "Temperature alert",
  "assetEvent_tempMinMaxInRange": "Temp Min/Max IN RANGE",
  "assetEvent_tempMinMaxOutOfRange": "Temp Min/Max OUT OF RANGE",
  "assetEvent_tiltAlert": "Tilt alert",
  "assetId": "Asset ID",
  "assetIDAscending": "Asset ID ascending",
  "assetIDDescending": "Asset ID descending",
  "assetIDLargest": "Asset ID largest to smallest",
  "assetIDSmallest": "Asset ID smallest to largest",
  "assetInfo": "Asset information",
  "assetList": "Asset list",
  "assetListFilter": "Asset list filter",
  "asset_manager": "Asset Manager",
  "assetManager.deviceNotRespondingTime": "Device not responding ({nta} hours)",
  "assetManagerView": "Asset Manager view",
  "assetMovingStatus_moving": "Moving",
  "assetMovingStatus_stationary": "Stationary",
  "assetNmbr": "Asset",
  "assetOrigin": "Assigned venue",
  "assetReportingStatus_active": "Active",
  "assetReportingStatus_inactive": "Inactive",
  "assetRisksCount": "{count} risks",
  "assets": "Assets",
  "assetsAtLocation": "Assets at location",
  "assetsAtLocationHint": "Count of all assets at selected location",
  "assetsDerivedInbound": "Assets derived inbound",
  "assetsDerivedOutbound": "Assets derived outbound",
  "assetsDerrivedInboundHint": "Count of Location's assets that are inbound",
  "assetsDerrivedOutboundHint": "Count of Location's assets that are outbound",
  "assetStatus": "Asset status",
  "asset_statuses": "Asset status",
  "assetType": "Asset type",
  "assetType_barge": "Barge",
  "assetType_electronics": "Electronics",
  "assetType_medicalDevice": "Medical device",
  "assetType_plane": "Plane",
  "assetType_ship": "Ship",
  "assetType_tractor": "Tractor",
  "assetType_trailer": "Trailer",
  "assetWorkflow.doorSettings": "Door state change",
  "assetWorkflow.event_lightAlert": "Light alert",
  "assetWorkflow.label_assetsUsingWorkflow": "Number of assets using this workflow",
  "assetWorkflow.label_batteryAlertsEnabled": "Generate battery level alerts",
  "assetWorkflow.label_batterySettings": "Battery - automated device control",
  "assetWorkflow.label_countriesWithTradeRestrictions": "Countries with trade restrictions",
  "assetWorkflow.label_doorStateEnabled": "Generate door state changes alerts",
  "assetWorkflow.label_firstBatteryLevelAlert": "First battery level alert",
  "assetWorkflow.label_maxHumidity": "Max humidity",
  "assetWorkflow.label_maxShock": "Max shock",
  "assetWorkflow.label_maxSpeed": "Max speed",
  "assetWorkflow.label_maxTilt": "Max tilt",
  "assetWorkflow.label_movingPingRate": "Moving ping rate",
  "assetWorkflow.label_notRestricted": "Non-restricted",
  "assetWorkflow.label_restricted": "Restricted",
  "assetWorkflow.label_sealStateChangeEnabled": "Generate seal state changes alerts",
  "assetWorkflow.label_secondBatteryLevelAlert": "Second battery level alert",
  "assetWorkflow.label_statesRestrictions": "US states with/without restrictions",
  "assetWorkflow.label_stationaryPingRate": "Stationary ping rate",
  "assetWorkflow.label_thirdBatteryLevelAlert": "Third battery level alert",
  "assetWorkflow.lightSettings_generateLightAlters": "Generate light alerts",
  "assetWorkflow.reportingInactiveSettings": "Reporting inactive threshold",
  "assetWorkflows": "Asset Manager workflows",
  "assetWorkflow.sealStateChangeSettings": "Seal state change",
  "assetWorkflows.label_suppressAlertAtAssignedLocation": "Suppress alert at assigned location",
  "assetWorkflows.label_suppressAlertsAtLocationTypes": "Suppress alert at these location types",
  "assignContacts": "Assign contacts",
  "assignContactsRegion": "Assign contacts to {assignTo}",
  "assignDevice": "Assign device",
  "assigned": "Assigned",
  "assignedAssest": "Assigned assets",
  "assignedAssetsAtLocation": "Assigned assets at location",
  "assignedAssetsAtLocationHint": "Count of assets that are assigned to location and currently at location",
  "assignedLocation": "Assigned location",
  "assignedParentImei": "Assigned parent IMEI",
  "assignedTagImei": "Assigned tag IMEI",
  "assignedToMe": "Assigned to me",
  "assignedTractor": "Assigned tractor",
  "assignedTrailer": "Assigned trailer",
  "assignedVenue": "Assigned venue",
  "assignedVenueStatus": "Assigned venue status",
  "assignmentCategory_maintenance": "Maintenance",
  "assignmentEvent_arrivedAtAppointmentLocation": "Arrived at appointment location",
  "assignmentEvent_assetsDepartedForAppointment": "Assets departed for appointment",
  "assignmentEvent_assigned": "Assets assigned",
  "assignmentEvent_atAgency": "Assets at agency",
  "assignmentEvent_cancelled": "Cancelled",
  "assignmentEvent_checkedIn": "Assets checked in",
  "assignmentEvent_droppedOff": "Dropped off",
  "assignmentEvent_POComplete": "PO complete",
  "assignmentEvent_procedureComplete": "Procedure complete",
  "assignmentEvent_readyForPickup": "Ready for pickup",
  "assignmentEvent_readyForProcedure": "Assets ready for procedure",
  "assignmentEvent_submitted": "Submitted",
  "assignmentWarningForDeviceBattery": "Assignment warning for device battery",
  "assignmentWarningForDevicePing": "Assignment warning for device ping",
  "assignSelectedDevice": "Assign selected device(s) from the previous shipment segment to the new one?",
  "associated": "Associated",
  "associationAlreadyExist": "This association for that user already exist",
  "associations": "Associations",
  "associationsTitle": "Is your contact responsible for location-based or in-transit escalations?",
  "at": "At",
  "atAssignedVenue": "At assigned venue",
  "at_delivery": "At delivery",
  "at_destination_airport": "At destination airport",
  "at_destination_port": "At destination port",
  "at_intermediate_airport": "At intermediate airport",
  "at_intermediate_port": "At intermediate port",
  "atOrigin": "At origin",
  "at_origin_airport": "At origin airport",
  "at_origin_port": "At origin port",
  "at_pickup": "At pickup",
  "at_risk": "At risk",
  "atRisk": "ETA at risk",
  "atRiskETAStatus": "ETA - at risk - expected time of delivery",
  "atRiskTooltip": "Expected time delivery - AT RISK: active & projecting to deliver at risk",
  "attachFile": "Attach file",
  "attachment": "Attachment",
  "attachments": "Attachments",
  "attachmentsGallery_noPhotosSubtitle": "No photos available",
  "attachmentSource.driverConnect": "Driver Connect",
  "attachmentSource.email": "Email",
  "attachmentSource.escortConnect": "Escort Connect",
  "attachmentSource.iot": "IoT",
  "attachmentSource.manualUpload": "Manual upload",
  "attachmentSource.photoVerificationApp": "Photo verification app",
  "attachmentSource.shipmentConnect": "Shipment Connect",
  "attachmentSource.shipmentConnectGo": "Shipment Connect Go",
  "attachmentSource.sms": "SMS",
  "atTimeDateFormat": "{monthYear} [at] {time}",
  "attributes": "Attributes",
  "attributesSelection": "Compare and select attributes",
  "auditLogReportCategory_compliance": "Compliance",
  "auditLogReportCategory_generic": "Generic",
  "auditLogReportCategory_iotData": "IoT data",
  "auditLogReportCategory_iotDevices": "IoT devices",
  "auditLogReportCategory_powerBiShipments": "Power BI shipments",
  "auditLogReportCategory_shipments": "Shipments",
  "auditLogReportCategory_users": "Users",
  "auditTrail": "Audit trail",
  "auditTrailFor": "Audit trail for",
  "auth.alt_overhaulLogo": "Overhaul logo",
  "auth.alt_portalLogo": "Portal logo",
  "auth.description_passwordChangedSuccessfully": "Your password has been changed successfully",
  "auth.description_resetEmailSent": "We've sent a password reset link to {email}",
  "auth.description_resetPassword": "Enter your email address and we'll get you back on track",
  "auth.error_invalidCredentials": "Email or password is incorrect",
  "auth.error_userEmailNotFound": "Sorry. We couldn't find a user with this email",
  "auth.label_backToLogin": "Back to login",
  "auth.label_createNewPassword": "Create new password",
  "auth.label_email": "Email",
  "auth.label_forgotPassword": "Forgot password?",
  "auth.label_login": "Login",
  "auth.label_password": "Password",
  "auth.label_resetPassword": "Reset password",
  "auth.label_retypeNewPassword": "Retype new password",
  "auth.label_savePassword": "Save password",
  "auth.label_ssoLogin": "SSO login",
  "authorityRecentlyGranted.all": "All recently granted",
  "authorityRecentlyGranted.none": "None recently granted",
  "authorityRecentlyGranted.some": "Some recently granted",
  "authorityRevoked.allRevoked": "All revoked",
  "authorityRevoked.noneRevoked": "None revoked",
  "authorityRevoked.someRevoked": "Some revoked",
  "authorizedForHireStatus_authorizedForHire": "Authorised for hire",
  "authorizedForHireStatus_exempt": "Exempt",
  "authorizedForHireStatus_other": "Other",
  "authorizedForHireStatus_private": "Private",
  "auth.title_checkEmail": "Check your email",
  "auth.title_login": "Login to your account",
  "auth.title_passwordSaved": "Password saved",
  "auth.title_resetPassword": "Reset password",
  "auth.validation_resetPasswordTokenExpired": "Reset password link has expired",
  "auto": "Auto",
  "autoAlertsAndNotificationSettings": "Auto Alerts & Notifications settings",
  "automatedAlertSettings": "Automated alert settings",
  "automatedDeviceControl": "Automated device control",
  "automaticallyCloseInactiveShipmentsAfterDays": "Automatically close inactive shipments after (days)",
  "autoOffsetApplyBoxConfirmation": "Apply the same offset to all subsequent locations in the segment?",
  "autoOffsetApplyBoxTitle": "You've updated the date/time: {duration}",
  "autoWaived": "Auto-Waived",
  "autoWaiveEventAfter": "Auto-Waive event after",
  "autoWaiveTooltip": "Risk events will be automatically waived after the specified number of days. If blank, the event will remain active indefinitely",
  "availability": "Availability",
  "availabilitySubTitle": "Manage work schedule, out of office and escalation priority.",
  "availabilityTitle": "Set the working hours during which the contact is available:",
  "available": "Available",
  "availableWorkflow": "Available workflow",
  "availableWorkflows": "Available workflows",
  "avatarPictureFormats": "The picture should be png, jpeg or jpg format.",
  "average": "Average",
  "averageResponseTime": "Average response time",
  "awaitingLocationData": "Awaiting location data",
  "awaiting_pickup": "Awaiting pickup",
  "aws": "AWS",
  "azure": "Azure",
  "back": "Back",
  "backBtn": "Back",
  "backToCompanyManagement": "Back to companies",
  "backToLocations": "Back to my locations",
  "bar": "Bar",
  "barcodeScanner_caption": "Position the barcode within the frame.",
  "bargeType_deck": "Deck",
  "bargeType_hopper": "Hopper",
  "bargeType_tank": "Tank",
  "basicInfo": "Basic info",
  "battery": "Battery",
  "batteryLevel": "Battery level",
  "batterySettings": "Battery settings",
  "batteryShort": "Batt.",
  "below": "Below",
  "berthName": "Berth name",
  "between": "Between",
  "bluetoothSeal": "Bluetooth seal",
  "breadth": "Breadth",
  "Break Down": "Break down",
  "broker": "Broker",
  "brokerAbbr": "BRK",
  "brokerCode": "Broker code",
  "brokerLabel": "Broker",
  "brokerNotRequiredAttribute": "Broker (not required)",
  "brokerReference": "Broker reference",
  "brokerRefNum": "Broker ref.",
  "brokerRequired": "Broker required",
  "brokerRequiredAttribute": "Broker (required)",
  "brokers": "Broker",
  "brokersLabel": "Brokers",
  "browse": "Browse",
  "bulkActions": "Bulk actions",
  "bulkActions.closeSelectedShipments": "Are you sure you want to close the selected shipments?",
  "bulkActions.label_bulkActionsresults": "Bulk actions results",
  "bulkActions.label_close_shipments": "Bulk close shipments",
  "bulkActions.noTrackedShipments": "They will no longer be tracked",
  "businessType_agriculture": "Agriculture",
  "businessType_apparelTextiles": "Apparel & textiles",
  "businessType_automotive": "Automotive",
  "businessType_chemicals": "Chemicals",
  "businessType_constructionMaterials": "Construction materials",
  "businessType_consumerElectronics": "Consumer electronics",
  "businessType_cosmetics": "Cosmetics",
  "businessType_foodBeverage": "Food/Beverage",
  "businessType_furniture": "Furniture",
  "businessType_healthcarePharma": "Healthcare / pharma",
  "businessType_highEndRetail": "High-end retail",
  "businessType_insurance": "Insurance",
  "businessType_manufacturing": "Manufacturing",
  "businessType_other": "Other",
  "businessType_paperPackaging": "Paper & packaging",
  "businessType_shipper": "3PL/Shipper",
  "byUser": "By <tooltip><bold>{user}</bold></tooltip>",
  "ca_driver": "Driver",
  "calamp": "CalAmp",
  "callSign": "CallSign",
  "callSignTooltip": "Unique ID for the transmitter station",
  "callStatus_answered": "Answered call",
  "callStatus_closed": "Call ended",
  "callStatus_connecting": "Connecting...",
  "callStatus_missed": "Missed call",
  "callStatus_open": "In a call",
  "callStatus_pending": "Pending...",
  "callStatus_reconnecting": "Reconnecting...",
  "callStatus_ringing": "Ringing...",
  "callType_inbound": "Inbound call",
  "callType_outbound": "Outbound call",
  "callVoicemailStatus_noVoicemail": "No voicemail",
  "callVoicemailStatus_voicemail": "Voicemail",
  "cancel": "Cancel",
  "cancelBtn": "Cancel",
  "cancelConfirmation": "Cancel shipment confirmation",
  "canceled": "Canceled",
  "cancelEditing": "Cancel editing",
  "canceled_lockdown": "Shipment unlocked",
  "canceledStatusDesc": "This shipment will move to the completed shipment list in Shipment Manager and removed from the active shipment list in Risk Monitor.",
  "cancelInvestigation": "Cancel investigation",
  "cancelledFlight": "Cancelled flight",
  "cancelled_flight_alert_shipment_event": "Cancel flight alert",
  "cancelled_flight_violation": "Cancelled flight",
  "cancelPortalCreation": "Cancel portal creation",
  "cancelPortalEditing": "Cancel portal editing",
  "cancelReminer": "Cancel reminder",
  "cancelShipmentReason_customerRequest": "Requested by customer / CSM",
  "cancelShipmentReason_duplicateShipment": "Duplicate shipment",
  "cancelShipmentReason_incompleteOrIncorrectData": "Incomplete / incorrect data",
  "cancelShipmentReason_incorrectDeviceAssignment": "Incorrect device assignment",
  "cancelShipmentReason_mirrorAccountProblems": "Mirror account problems “telematics (do not have / do not meet criteria)",
  "cancelShipmentReason_notComplyCheckListRequirements": "Does not comply with check list requirements",
  "cancelWorkflowEditingWorkflow": "Are you sure you want to cancel editing the workflow?",
  "cannotBeImpersonated": "This user cannot be impersonated",
  "cantDeactivateWorkflow": "This workflow cannot be deactivated because it is actively used by shipments.",
  "ca_owner": "Account owner",
  "caption_createLocationManually": "Or create an address manually",
  "cargo": "Cargo",
  "cargoType_agrochemicals": "Agrochemicals",
  "cargoType_alcoholSpirits": "Alcohol/Spirits",
  "cargoType_appliances": "Appliances",
  "cargoType_athleticWear": "Athletic wear (including shoes)",
  "cargoType_automotive": "Automotive",
  "cargoType_chipsAccessories": "Computers inc chips & accessories",
  "cargoType_fashionClothing": "Fashion/Clothing",
  "cargoType_food": "Food",
  "cargoType_gamingSystems": "Gaming systems",
  "cargoType_goldCurrency": "Gold/Currency",
  "cargoType_handheldConsumerElectronics": "Handheld consumer electronics",
  "cargoType_makeup": "Makeup",
  "cargoType_metalsPrecious": "Metals/Precious data",
  "cargoType_military": "Military",
  "cargoType_other": "Other",
  "cargoType_pharma": "Pharma",
  "cargoType_servers": "Servers (including AI)",
  "cargoType_televisions": "Televisions",
  "cargoType_tobacco": "Tobacco",
  "carrier": "Carrier",
  "carrierAbbr": "CAR",
  "carrierCompanyCategory_archived": "Archived",
  "carrierCompanyCategory_new": "New",
  "carrierCompanyCategory_trusted": "Trusted",
  "carrierCompanyCategory_unauthorized": "Unauthorized",
  "carrierCompanyCategory_uncategorized": "Uncategorized",
  "carrierComplianceByRiskEvents": "Carrier compliance by risk events",
  "carrierDrivers": "Carrier drivers",
  "carrierGroups.errorTitle": "Carrier groups could not be fetched",
  "carrierName": "Carrier name",
  "carrierReference": "Carrier reference",
  "carrierRefNum": "Carrier ref.",
  "carrierRiskDashboard.description_carrierActivityFeed": "Review recent updates and changes for this carrier, including risk scores, category updates, and network activity.",
  "carrierRiskDashboard.errorMessage_carrierAddToNetworkFail": "The carrier could not be added to your network",
  "carrierRiskDashboard.errorMessage_carrierRemoveFromNetworkFail": "The carrier could not be removed from your network",
  "carrierRiskDashboard.infoMessage_inNetworkCarriersAdmin": "Carriers who transported customer's shipments only",
  "carrierRiskDashboard.infoMessage_inNetworkCarriersCustomer": "Carriers who transported your shipments only",
  "carrierRiskDashboard.inNetworkCarriers": "In-Network carriers ({total})",
  "carrierRiskDashboard.label_activityFeed": "Activity feed",
  "carrierRiskDashboard.label_addToMyNetwork": "Add to my network",
  "carrierRiskDashboard.label_carrierAddedToNetwork": "Added to my network",
  "carrierRiskDashboard.label_highestRisk": "Highest risk",
  "carrierRiskDashboard.label_importCarriers": "Import carriers",
  "carrierRiskDashboard.label_inMyNetwork": "In network",
  "carrierRiskDashboard.label_intoGroup": "Into a custom group",
  "carrierRiskDashboard.label_intoMyNetwork": "Into my network",
  "carrierRiskDashboard.label_lowestRisk": "Lowest risk",
  "carrierRiskDashboard.label_newScore": "New score",
  "carrierRiskDashboard.label_noThreats": "No threats",
  "carrierRiskDashboard.label_noThreatsIdentified": "No threats identified",
  "carrierRiskDashboard.label_previousScore": "Previous score",
  "carrierRiskDashboard.label_riskScoreChanged": "Risk score changed",
  "carrierRiskDashboard.label_riskScoreDecreased": "Risk score decreased",
  "carrierRiskDashboard.label_riskScoreIncreased": "Risk score increased",
  "carrierRiskDashboard.label_riskScoreUnchanged": "Risk score unchanged",
  "carrierRiskDashboard.outOfNetworkCarriers": "Out-of-Network carriers ({total})",
  "carrierRiskDashboard.successMessage_carrierAddedToNetwork": "The carrier was added to your network",
  "carrierRiskDashboard.successMessage_carrierRemovedFromNetwork": "The carrier was removed from your network",
  "carrierRiskScoreDashboard.label_dataPointsAnalyzed": "<b>{count}</b> data points analyzed",
  "carriers": "Carriers",
  "carriersLabel": "Carriers",
  "carrierWatchlist": "Carrier watchlist",
  "carrierWhitelist": "Carrier whitelist",
  "cat": "CAT scale locations",
  "catalog.description_itemAttributes": "Optional details to help identify and store this item.",
  "catalog.description_itemDetails": "Basic information required to create this catalog item.",
  "catalog.failedExportDescription": "The current selection contains more than 10,000 catalog items. Please apply additional filters to reduce the amount of catalog items.",
  "catalogManagement.label_addCatalogItem": "Create catalog item",
  "catalogManagement.label_editCatalogItem": "Edit catalog item",
  "category": "Category",
  "celcius": "Celsius",
  "cep": "Ping accuracy (CEP, m)",
  "cepShort": "Ping acc.",
  "chainOfCustodyReport": "Chain of custody report",
  "change": "Change",
  "changeCurrentPassword": "Change your current password",
  "changed": "Changed",
  "changeInPlanProposed.eventDescription": "Driver intends to use different entities than originally planned.",
  "changeLanguageAlertMessage": "You have unsaved changes for the current language. Do you want to save them?",
  "changePortalAlertMessage": "You have unsaved changes for the current portal. Do you want to save them?",
  "changeRole": "Change role",
  "changeRoute": "Change route",
  "changesSaved": "Changes saved successfully",
  "changesSavedTitle": "Changes saved",
  "changesWillBeLost": "Your changes will be lost if you don’t save them.",
  "changeWorkflowAlertMessage": "You have unsaved changes for the current workflow. Do you want to save them?",
  "changingLocationForNumberRoutes": "You are changing locations for {value} route(s).",
  "chat": "Chat",
  "chatHistory": "Chat history",
  "chatWithRiskGPT": "Chat with RiskGPT",
  "checkboxes": "Checkboxes",
  "checklist": "Checklist",
  "checklistLabel": "Checklist label",
  "checkout_shipment_event": "Arrival at planned stop location",
  "checkStatus.notCompleted": "Not completed",
  "childLocations": "Child locations",
  "chooseDate": "Please choose date in future",
  "chooseDevice": "Choose device",
  "chooseFile": "Choose file",
  "chooseLocation": "Choose location",
  "chooseOverlay": "Choose overlay",
  "choosePortal": "Please choose portal",
  "chooseRole": "Choose role",
  "chooseState": "Choose state",
  "chooseUserPortal": "Choose user portal",
  "chooseYear": "Choose year",
  "chosePOI": "Choose POI",
  "cities": "Cities",
  "city": "City",
  "claim_submission_shipment_event": "Claims buddy submission",
  "claim_submission_violation": "Claim submission",
  "clear": "Clear",
  "clearAll": "Clear all",
  "clickToBrowseFiles": "Or click to browse the file",
  "clickToMeasure": "Click on the map to add the line to the route",
  "client": "Client",
  "clientName": "Client name",
  "close": "Close",
  "closeCreateConfirmation": "Are you sure you want to close the creator?",
  "closed": "Closed",
  "closeEditLocationConfirmation": "Are you sure you want to close the editor?",
  "closeEditRouteConfirmation": "Are you sure you want to close the editor?",
  "closeLocationCreator": "Close location creator",
  "closeLocationEditor": "Close location editor",
  "closeRouteCreation": "Close route creation",
  "closeRouteEditor": "Close route editor",
  "closeShipment": "Close shipment",
  "co2e": "Total OTR CO2e",
  "co2EmissionsSummaryOTR": "CO2 emissions summary",
  "co2EmissionsSummaryOTRHint": "This is an estimation of CO2e for over the road shipments only, based on an industry standard calculation for OTR GWP. Please contact your account manager for a detailed CO2 report",
  "coldChainTemperatureHint": "When enabled, quality temperature settings will replace other temperature settings on shipment creation",
  "coldchainTemperatureThresholds": "Quality temperature thresholds",
  "cold-storage": "Cold storage",
  "collapse": "Collapse",
  "collapseAll": "Collapse all",
  "collapseAssetCards": "Collapse asset cards",
  "color": "Color",
  "columns": "Columns",
  "comment": "Comment",
  "companies": "Companies",
  "companies.label_importCompanies": "Import companies",
  "companiesPlaceholder": "All companies",
  "companiesToMerge": "Companies to merge",
  "company": "Company",
  "companyAccessRule_contributor": "Contributor",
  "companyAccessRule_contributorDescription": "Allows editing rights exclusively for content directly associated with this company.",
  "companyAccessRule_owner": "Owner",
  "companyAccessRule_ownerDescription": "Grants full editing rights across the entire portal, including all company-related content and settings.",
  "companyAccessRule_resource": "Resource",
  "companyAccessRule_resourceDescription": "Inhibits user access to the portal, but provides the company as an available option for shipments.",
  "companyAccessRule_spectator": "Spectator",
  "companyAccessRule_spectatorDescription": "Provides viewing access solely to content that pertains to this company.",
  "companyAssociationsSubTitle": "Add or remove companies that this contact is associated with.",
  "companyContactCompleteness": "Adding this information will ensure that you can be contacted appropriately regarding relevant shipment risks.",
  "companyContacts": "Company contacts",
  "companyCreatePopupSubtitle": "Select the portal and type for company that you want to create.",
  "companyCreatePopupTitle": "Select portal and company type",
  "companyDesc": "Company description",
  "companyId": "Company ID",
  "companyLegalName": "Company legal name",
  "companyLinkOnProfile": "Company(ies)",
  "companyManagement": "Company management",
  "companyName": "Company name",
  "companySettings": "Company settings",
  "companySettings.assetMaintenance": "Asset Manager assignments - maintenance",
  "companySettings.assetManagerAccess": "Asset Manager",
  "companySettings.autocreateAssetsFromVehiclePings": "Autocreate new tractor/trailer assets from vehicle pings",
  "companySettings.commandCenterAccess": "Command Center",
  "companySettings.deviceManagementAccess": "Device & tag management",
  "companySettings.embeddedReportsAccess": "Embedded reports",
  "companySettings.escortConnectAccess": "Escort Connect",
  "companySettings.intelFeatureAccess": "FraudWatch",
  "companySettings.inventoryPageAccess": "Inventory management",
  "companySettings.notificationsEnabled": "Notifications",
  "companySettings.omnitrucksIntergration": "Omnitracs integration",
  "companySettings.outboundIntegration": "Outbound integration",
  "companySettings.riskMonitorAccess": "Risk Monitor",
  "companySettings.shipmentManagerAccess": "Shipment Manager",
  "companySettings.shipmentManagerLegacyAccess": "Shipment Manager (legacy)",
  "companySettings.shipmentRiskScoresAccess": "Apply weightings to this company’s shipments",
  "companyTradeName": "Company trade name",
  "companyType": "Company type",
  "companyType_broker": "Broker",
  "companyType_carrier": "Carrier",
  "companyType_customer": "Customer",
  "companyType_escort": "Escort",
  "companyType_oh": "Overhaul",
  "companyType_shipper": "Shipper",
  "companyUsers": "{companyName} company users",
  "complete": "Complete",
  "completed": "Completed",
  "completingToday": "Completing today",
  "completingTodayKPIHint": "Total shipments completing today over total active shipments",
  "complianceKPIGroup": "Compliance KPIs",
  "complianceScore": "Compliance score",
  "compliant": "Compliant",
  "configuration": "Configuration",
  "configurationDescription": "Select the KPIs you want on your dashboard.",
  "configurationDescriptionNoAccess": "You don't have access to select KPI and modify the Command Center. Get in touch with your administrator.",
  "configureUserAccessRestrictions": "Configure the access restrictions for the user(s)",
  "confirm": "Confirm",
  "confirmActivation": "Yes, activate",
  "confirmAndGenerateStop": "Require 2+ tracking source to confirm and release stop events",
  "confirmation": "Are you sure you want to {action} this {type}?",
  "confirmation_deleteMessage": "Are you sure you want to delete {name}?",
  "confirmation_deletePackingUnit": "Are you sure you want to delete this packing unit?",
  "confirmationDescription_allowPickup": "Approving this pickup means you accept the identified risks. The shipment will be cleared to depart with the flagged carrier / driver(s).",
  "confirmationDescription_rejectPickup": "Rejecting this pickup will instruct ground staff to prevent departure. The shipment will need to be rebooked with a safer carrier.",
  "confirmationMessage_activate": "Are you sure you want to activate {name}?",
  "confirmationMessage_activateEmbeddedReport": "Are you sure you want to activate report {name}?",
  "confirmationMessage_activateWorkflow": "Are you sure you want to activate {name} workflow?",
  "confirmationMessage_allowPickup": "Are you sure you want to allow this pickup?",
  "confirmationMessage_archiveShipmentWorkflow": "{name} workflow will be archived, are you sure you want to proceed?",
  "confirmationMessage_assignSelectedProducts": "Assign selected product(s) from the previous shipment segment to the new one?",
  "confirmationMessage_attachToEvent": "Are you sure you want to attach photo to selected event?",
  "confirmationMessage_attachToShipment": "Are you sure you want to attach photo to shipment timeline?",
  "confirmationMessage_bulkCancelAppointments": "Are you sure you want to cancel the selected appointments?",
  "confirmationMessage_bulkDeactivateDevices": "Are you sure you want to deactivate selected devices?",
  "confirmationMessage_cancel": "Are you sure you want to cancel {name}?",
  "confirmationMessage_cancelAppointment": "Are you sure you want to cancel this appointment?",
  "confirmationMessage_cancelAssignment": "Are you sure you want to cancel this assignment?",
  "confirmationMessage_completePackingList": "Complete packing list?",
  "confirmationMessage_deactivate": "Are you sure you want to deactivate {name}?",
  "confirmationMessage_deactivateEmbeddedReport": "Are you sure you want to deactivate report {name}?",
  "confirmationMessage_deactivateWorkflow": "Are you sure you want to deactivate {name} workflow?",
  "confirmationMessage_delete": "Are you sure you want to delete {name}?",
  "confirmationMessage_deleteEmbeddedReport": "Are you sure you want to delete report configuration: {reportName}?",
  "confirmationMessage_deleteShipmentWorkflow": "{name} workflow will be permanently deleted, are you sure you want to proceed?",
  "confirmationMessage_enableDebugMode": "Warning! You are attempting to enable debug mode. Please check with the IoT team before continuing.",
  "confirmationMessage_hardReprocessShipment": "Are you sure you want to hard reprocess this shipment?",
  "confirmationMessage_hardResetShipment": "Are you sure you want to hard reset this shipment?",
  "confirmationMessage_lockDevice": "You are attempting to engage the lock on this device. Are you sure you wish to continue?",
  "confirmationMessage_markAsAvailable": "Are you sure you want to mark {name} as available?",
  "confirmationMessage_markAsUnavailable": "Are you sure you want to mark {name} as unavailable?",
  "confirmationMessage_overwriteSavedFilter": "A saved filter with this name already exists. Do you want to overwrite it?",
  "confirmationMessage_powerDownDevice": "You are about to send a powerdown command to this device, are you sure you wish to continue?",
  "confirmationMessage_proceedWithEdit": "Are you sure you want to proceed with the edit?",
  "confirmationMessage_qualityReviewStatusChange": "Are you sure you would like to change the quality review status from \"{currentStatus}\" to \"{newStatus}\"?",
  "confirmationMessage_refurbishDevice": "You are about to refurbish this device, are you sure you wish to continue?",
  "confirmationMessage_rejectPickup": "Are you sure you want to reject this pickup?",
  "confirmationMessage_removeInvalidUsers": "Do you want to remove the following users that do not belong to selected companies?",
  "confirmationMessage_removeSavedFilter": "Are you sure you want to delete {name} template?",
  "confirmationMessage_replacePhoto": "Are you sure you want to replace this photo?",
  "confirmationMessage_replacePhotoDescription": "The existing photo will be removed and replaced with the new one. This action cannot be undone.",
  "confirmationMessage_replaceSignature": "Are you sure you want to replace this signature?",
  "confirmationMessage_replaceSignatureDescription": "The existing signature will be removed and replaced with the new one. This action cannot be undone.",
  "confirmationMessage_resetExpirationDate": "You are about to reset the expiration date on this device. The new expiration date will be exactly 365 days from now. Are you sure you wish to continue?",
  "confirmationMessage_resetFirstReport": "Are you sure you wish to reset the first report timestamp?",
  "confirmationMessage_setActiveDestination": "Are you sure you want to change the destination?",
  "confirmationMessage_setActiveDestinationSubtitle": "Deviation events will occur based on the new active destination.",
  "confirmationMessage_switchToMobileVersion": "Do you want to switch to mobile version ?",
  "confirmationMessage_tagsReassignmentWarning": "The device model you are attempting to update does not support automatic reassigning of tags. By continuing, all tag associations will be removed and must be manually reassigned.",
  "confirmationMessage_unassign": "Are you sure you want to unassign {name}?",
  "confirmationMessage_unassignAssetDevicesFromShipments": "This asset is on an active shipment. Removing the selected device(s) will unassign them from the shipment. If no other tracking method remains on the shipment, it will be closed.",
  "confirmationMessage_unlockDevice": "You are attempting to disengage the lock on this device. Are you sure you wish to continue?",
  "confirmationMessage_updateActiveLocation": "Warning. You are attempting to update a location that is used on a route. If there are any active shipments, historical data on the route will be lost and new route will be created.",
  "confirmation_removeColdChainTemperatureGroup": "Are you sure you want to delete this temperature setting group and all settings inside it?",
  "confirmation_removeColdChainTemperatureSetting": "Are you sure you want to delete this temperature setting?",
  "confirmation_removeShipmentIdSetting": "Are you sure you want to delete this rule?",
  "confirmationTitle": "{action} {type}",
  "confirmDeletion": "Yes, delete",
  "confirmedAt": "Confirmed at",
  "confirmed_theft_violation": "Confirmed theft",
  "confirmShipmentInfo": "Confirm shipment information",
  "confirmUserFullAccessModalTitle": "Confirm full access",
  "consecutive": "Consecutive",
  "contactCardPreview": "Contact card preview",
  "contactCompleteness": "Contact completeness",
  "contactInformationStep": "Contact information",
  "contactInformationTitle": "Fill in contact information:",
  "contactMatching.warningMessage_contactInformationExists": "Contact information already exists.",
  "contactMatching.warningMessage_description": "Select an existing contact to share it with your company.",
  "contactMethod": "Contact method",
  "contactMethodEmergency": "Emergency only",
  "contactMethodMixed": "Regular and emergencies",
  "contactMethodRegular": "Only regular escalations",
  "contactMethodsGroupTitle": "Select the options that reflect when and how this contact can be reached.",
  "contacts": "Contacts",
  "contactsInTotal": "Contacts in total",
  "contactTimezonePlaceholder": "Select the contact’s timezone",
  "contactType": "Contact type",
  "contactYourManager": "Contact your manager",
  "container": "Container",
  "container_arrival_at_transshipment_port_shipment_event": "Transshipment - container arrival",
  "container_arrival_shipment_event": "Container arrival at seaport location",
  "container_departure_from_transshipment_port_shipment_event": "Transshipment - container departure from port",
  "container_departure_shipment_event": "Container departure from seaport location",
  "container_discharged_at_transshipment_port_shipment_event": "Transshipment - container discharged",
  "container_discharged_shipment_event": "Container discharged",
  "container_gate_in_empty_shipment_event": "Gate in empty",
  "container_gate_in_full_shipment_event": "Gate in full",
  "container_gate_out_empty_shipment_event": "Gate out empty",
  "container_gate_out_full_shipment_event": "Gate out full",
  "container_loaded_at_transshipment_port_shipment_event": "Transshipment - container loaded",
  "container_loaded_shipment_event": "Container loaded",
  "content": "Content",
  "continue": "Continue",
  "continuous": "Continuous",
  "contracting": "Contracting",
  "coordinates": "Coordinates",
  "coordinatesPlaceholder": "Lat, lng",
  "coordinatesSelectPlaceholder": "Insert latitude and longitude to receive address suggestions",
  "coordinatesValidationText": "The coordinates entered are invalid. Please enter a valid pair of latitude and longitude.",
  "copied": "Copied",
  "copiedToClipboard": "Copied to clipboard",
  "copy": "Copy",
  "copyEscalationEmails": "Copy escalation emails",
  "copyFromExistingPortal": "Copy from existing portal",
  "copyFromExistingWorkflow": "Copy from existing workflow",
  "copyPermissions": "Copy permissions from",
  "correction": "Correction",
  "countdown": "Countdown",
  "countdownTimer": "Countdown timer",
  "counterNotesAdded": "<a>{counter}</a> notes added to events in the timeline.",
  "countries": "Countries",
  "country": "Country",
  "countryState": "State",
  "create": "Create",
  "createAirWorkflow": "Create air workflow",
  "createAsset": "Create asset",
  "created": "Created",
  "createDashboard": "Create dashboard",
  "createdAt": "Created at",
  "createdBy": "Created by",
  "createdDate": "Created date",
  "createDeviceViaShipmentConnect": "Create device via Shipment Connect",
  "createDNS": "Create DNS",
  "createEvent": "Create new event",
  "createFilter": "Create filter",
  "createFromExisting": "Create from existing",
  "createNew": "Create new",
  "createNewAssetThroughShipment": "Create new asset through shipment",
  "createNewPortal": "Create new portal",
  "createNewRoute": "Please create the new route.",
  "createNewShipment": "Create new shipment",
  "createOceanWorkflow": "Create ocean workflow",
  "createOrUpdateEvent": "Create or update incident",
  "createPortal": "Create portal and continue",
  "createRailWorkflow": "Create rail workflow",
  "createRegionalWorkflow": "Create regional workflow",
  "createRoadWorkflow": "Create road workflow",
  "createRoute": "Create route",
  "createRouteMessage": "You are creating a new route, so it needs a unique route name",
  "createTMSShipments": "Create TMS shipments",
  "createWorkflow": "Create workflow",
  "criticalBasedRiskLevel.critical": "Critical",
  "criticalBasedRiskLevel.high": "High",
  "criticalBasedRiskLevel.medium": "Medium",
  "criticalBasedRiskLevel.noRisk": "No risk",
  "criticalEvent": "Critical event",
  "criticalEvents": "Critical events",
  "crossIn": "Cross in",
  "crossOut": "Cross out",
  "CSV": "CSV",
  "csvError_maxAcknowledgeReason": "Row #{rowNumber}: acknowledge reason is too long",
  "csvError_maxLengthReasons": "Row #{rowNumber}: event should have maximum 5 reasons",
  "csvError_maxWaiveReason": "Row #{rowNumber}: waive reason is too long",
  "csvError_maxWaiweReason": "Row #{rowNumber}: waive reason is too long",
  "csvError_reasonCommaError": "Row #{rowNumber}: reason should not contain comma",
  "csvError_unknownName": "Row #{rowNumber}: unknown event name",
  "cumulative": "Cumulative",
  "currentDestinations": "Current destinations",
  "currentLocation": "Current location",
  "currentOrigins": "Current origins",
  "currentPort": "Current port",
  "currentPortal": "Current portal",
  "currentPortals": "Current portal(s)",
  "currentStatus": "Current status",
  "current_status_update_manual_shipment_event": "Current status update",
  "custom": "Custom",
  "customEntry": "Custom entry",
  "customerAssociationDescriptions": "Select customer(s) to restrict user access.",
  "customerCrossIn": "Customer cross IN radius (miles)",
  "customerCrossInTooltip": "The radius for arriving at a customer location",
  "customerCrossOut": "Customer cross OUT radius (miles)",
  "customerCrossOutTooltip": "The radius for departing a customer location",
  "customerMonitored": "Customer monitored",
  "customerPOs": "Customer PO#s",
  "customers.successMessage_created": "Customer {name} successfully created",
  "customers.successMessage_updated": "Customer {name} successfully updated",
  "customField": "Custom field",
  "customFieldLabel": "Custom field",
  "customFieldName": "Custom field name",
  "customFields": "Custom fields",
  "customFieldsFilterSubtitle": "Select a portal to view custom fields associated to it",
  "customFields.wantActivateCustomField": "Are you sure you would like to activate this custom field ?",
  "customFieldType": "Custom field type",
  "customID": "Custom ID",
  "cycleSentry": "Cycle sentry",
  "dactivateDevice": "Are you sure you want to deactivate the device {id}?",
  "dailyShipmentStatus": "Daily shipment status",
  "dailyShipmentStatusKPIHint": "Today's shipments by the ETA statuses of at risk, early, late, no status and on time",
  "damaged_manual_incident_shipment_event": "Damaged",
  "damaged_manual_incident_violation": "Damaged",
  "dark": "Dark",
  "dashboard": "Dashboard",
  "dashboardName": "Dashboard name",
  "dashboards": "Dashboards",
  "dashboardsNotShared": "Dashboards not shared",
  "dashboardsShared": "Dashboards I’ve shared",
  "dashboardsSharedWithMe": "Dashboards shared with me",
  "dashboardUpdateDescription": "The last time your dashboard data was refreshed from the Overhaul platform",
  "dashboardWasCreated": "{dashboardName} dashboard was created",
  "dashboardWasSaved": "{dashboardName} dashboard was saved",
  "dashboardWasShared": "{dashboardName} dashboard was shared",
  "dashboardWasUnshared": "{dashboardName} dashboard was unshared",
  "dashboardWidgetHint_qualityExcursionByTimePeriod": "Average time spent in temperature, humidity, tilt and shock excursions",
  "dashboardWidgetHint_shipmentTemperatureAlerts": "Summary for no alerts, too cold, too hot and uncategorised temperature alerts",
  "dashboardWidget_qualityExcursionByTimePeriod": "Quality excursions by time period",
  "dashboardWidget_qualityExcursionIncidents": "Quality alerts & alert response times",
  "dashboardWidget_qualityRegulatoryHeatMap": "Quality regulatory Non-Compliance heat map",
  "dashboardWidget_qualityRiskScore": "Quality risk score",
  "dashboardWidget_qualityRiskStatus": "Quality risk status",
  "dashboardWidget_riskEventsPerformanceDashboardWidget": "Carrier/Broker/FF quality performance",
  "dashboardWidget_shipmentTemperatureAlerts": "Shipment temperature alerts",
  "dashboardWidget_timeSpentInQualityExcursion": "Time spent in quality excursions",
  "dataTable": "Data table",
  "date": "Date",
  "dateAdded": "Date added",
  "dateCreated": "Date created",
  "dateFormat_timeDate": "{timeFormat} [on] {dateFormat}",
  "dateFrom": "Date from",
  "dateOfDelivery": "Date and time of delivery",
  "dateOfPickup": "Date and time of pickup",
  "dateRange": "Date range",
  "dateRangeCustomErrorMessage": "Date should not be later than maximum date",
  "dateRangeType": "Date range type",
  "dateShouldBeLater": "Date should be later than previous location",
  "dateTo": "Date to",
  "day": "Day",
  "days": "Days",
  "dayTime": "Day time",
  "dcCrossIn": "DC cross IN radius (miles)",
  "dcCrossInTooltip": "The radius for arriving at a distribution centre",
  "dcCrossOut": "DC cross OUT radius (miles)",
  "dcCrossOutTooltip": "The radius for departing a distribution centre",
  "ddiRequired": "DDI required",
  "deactivate": "Deactivate",
  "deactivateCompany": "Deactivate company",
  "deactivateCustomField": "Deactivate custom field",
  "deactivated": "Deactivated",
  "deactivateDatePickerLabel": "Deactivate on",
  "deactivateDeviceTooltip": "Deactivate device",
  "deactivatedSuccessfully": "Routes deactivated successfully",
  "deactivateSelectedLocations": "Are you sure you want to deactivate selected locations?",
  "deactivateSelectedRoutes": "Are you sure you want to deactivate selected routes?",
  "deactivationDateColumn": "Deactivation date",
  "decreaseMapZoom": "Decrease map zoom",
  "defaultApp": "Default application",
  "defaultShipperCompany": "Default shipper company",
  "defaultWorkflow": "Default workflow",
  "delayed_departure_after_pickup_shipment_event": "Delayed departure after pickup submission",
  "delayedDepartureAfterPickupSubmission": "Delayed departure after pickup submission (minutes)",
  "delayed_departure_after_pickup_violation": "Delayed departure after pickup",
  "delayed_vessel_arrival_shipment_event": "Delayed vessel arrival",
  "delayedVesselArrivalThreshold": "Delayed vessel arrival threshold (hours)",
  "delayed_vessel_arrival_violation": "Delayed vessel arrival",
  "delete": "Delete",
  "deleteAttachmentConfirmation": "Are you sure you want to delete the attachment \"{attachmentName}\"?",
  "deleteDepartments": "Are you sure you want to delete the department {departmentName}?",
  "deleteDepartmentsDescription": "This action cannot be undone.",
  "deleteRegionalWorkflow": "Delete regional workflow",
  "deleteRegionalWorkflowConfirmation": "Are you sure you want to delete the regional workflow ({workflow}) for {country}?",
  "delivered": "Delivered",
  "deliveredAt": "Delivered at",
  "deliveredAtFinalDestination": "Delivered at final destination",
  "deliveredDateNotProvided": "Delivered date not provided",
  "deliveredTo": "Delivered to",
  "deliveries": "Deliveries",
  "deliveringFarthest": "Delivering farthest (plan)",
  "deliveringFarthestEta": "Delivering farthest (ETA)",
  "deliveringSoonest": "Delivering soonest (plan)",
  "deliveringSoonestEta": "Delivering soonest (ETA)",
  "deliver_shipment_event": "Arrival at delivery location",
  "delivery": "Delivery",
  "Delivery": "Delivery",
  "deliveryCrossInRadius": "Delivery Cross-In radius",
  "deliveryCrossInRadiusMiles": "Delivery cross IN radius (miles)",
  "deliveryDate": "Delivery date",
  "deliveryDeparture": "Delivery & departure",
  "deliveryDetentionTime": "Delivery detention time (minutes)",
  "deliveryEvents": "Delivery events",
  "DeliveryLocation": "Delivery location",
  "deliveryLocationsLabel": "Delivery locations",
  "deliveryOffset": "Delivery offset",
  "delivery_outside_violation": "Delivery outside",
  "deliveryType": "Delivery type",
  "deliveryTypes": "Delivery types",
  "departed": "Departed",
  "Departed": "Departed",
  "departed_delivery": "Departed delivery",
  "departedFromFinalGeofence": "Departure from delivery",
  "departedFromLocationName": "Departed from {locationName} {locationType}",
  "departed_pickup": "Departed pickup",
  "department": "Department",
  "departmentAssociationExist": "This association for that department already exist",
  "departmentAssociationsTitle": "Is your department responsible for location-based or in-transit escalations?",
  "departmentId": "Department ID",
  "departmentIsRelevantToShipments": "This department is relevant to shipments where",
  "departmentLinkOnProfile": "Department(s)",
  "departmentName": "Department name",
  "departments": "Departments",
  "departmentsAndIndividual": "Departments & individual",
  "departmentSettings": "Department settings: {departmentName}",
  "departmentsName": "Departments name",
  "departmentsSubTitle": "Add or remove departments that this contact is associated with.",
  "departmentsTitle": "Department associations",
  "departureDetention": "Departure & detention",
  "departure_shipment_event": "Origin pickup submission & photos",
  "departureTime": "Departure time",
  "depotCrossIn": "Depot cross IN radius (miles)",
  "depotCrossInTooltip": "The radius for arriving at a depot location",
  "depotCrossOut": "Depot cross OUT radius (miles)",
  "depotCrossOutTooltip": "The radius for departing a depot location",
  "depth": "Depth",
  "derivedDirection": "Derived direction",
  "derivedInbound": "Derived inbound",
  "derivedOutbound": "Derived outbound",
  "description": "Description",
  "description_addDemoShipmentEvent": "Configure all of the event details before adding it to the shipment timeline.",
  "description_addDeviceToCreateFirstPackingUnit": "Add a device to create your first packing unit.",
  "description_cameraAccessDenied": "This step needs your live camera. Open your browser's site settings for this page, allow camera, then reload.",
  "description_completePackingList": "Please make sure all packing and tracking details are correct. Once completed, the packing list can't be edited.",
  "description_confirmCarrierDriversEquipmentAndDevice": "Confirm the carrier, drivers, equipment, and device that arrived for pickup",
  "description_couldNotFindShipment": "We couldn’t find a shipment with this reference number at your origin. Please check the number and try again.",
  "description_createSecureBolUsers": "Create SecureBOL access for one or multiple origins.",
  "description_createShipmentTile": "Create new shipment with essential shipment details.",
  "description_demoShipmentEventRiskScore": "Select a predefined value or provide a custom risk score.",
  "description_downloadAddressValuesImportTemplate": "Import multiple addresses using file import button below. <a>Download template</a>. A maximum of 10,000 values can be added in total and values must include address, city and state.",
  "description_downloadStringValuesImportTemplate": "Import multiple values using file import button below. <a>Download template</a>. A maximum of 10,000 values can be added in total and values must be at least two characters long.",
  "description_driverProceedToPickupLocation": "Please proceed to the pickup location. Once you arrive, continue to complete your pre-departure checklist and pickup steps.",
  "description_mustEnableLocationToPickup": "You must enable location permissions and be at the pickup location to continue.",
  "description_photoVerificationLocationAccess": "When you tap start verification, we'll ask you in a window to allow access to your location. Please tap allow so we can verify where and when your photos were taken.",
  "description_photoVerificationLocationAccessDenied": "Open your browser's site settings for this page, allow location, then reload. Location is required to submit your photos.",
  "description_photoVerificationRequestFromOverhaul": "This request is from Overhaul. Verify or ask questions: {phone}",
  "description_photoVerificationRiskEvent": "A risk event occurred on shipment {shipmentId}. Please verify your trailer with a few photos.",
  "description_pickupShipmentTile": "Find shipment and confirm carrier, driver, equipment, and assign device.",
  "description_pingControlsTimeAndLocation": "Remove the selected ping in the dropdown to enter them manually.",
  "description_pinsWillBeSentAutomatically": "PINs will be sent automatically to each user’s email.",
  "description_pinWillAutoGenerate": "PIN will auto generate for this user when the user is added.",
  "description_searchForShipmentReference": "Enter the shipment reference number to complete pre-pickup checks and start pickup.",
  "description_shipmentConnectGoWorkspace": "Complete essential tasks quickly from one simple workspace.",
  "description_vendorsSettings": "Select vendors to provide specific settings.",
  "description_verifyCarrierThenAddDriversAndEquipment": "Verify the carrier that arrived for pickup, then add the drivers and equipment details",
  "description_youAssignedToShipment": "You have been assigned to the following shipment:",
  "deselectsCurrentSelectedAsset": "Deselects the current selected asset",
  "destination": "Destination",
  "destinationContacts": "Destination contacts",
  "destinationIATA": "Destination IATA",
  "destinationICAO": "Destination ICAO",
  "destinationLocation": "Destination location",
  "destinationLocations": "Destination locations",
  "destinationPort": "Destination port",
  "destinationPortMovingRate": "Destination port moving rate",
  "destinationPortMovingTooltip": "Settings for exiting out of ocean mode at the destination port. This settings will automatically be applied once the shipment transitions off of the ocean segment",
  "destinationPortStationaryRate": "Destination port stationary rate",
  "destinationPortTimeframe": "Device warning - destination port timeframe (hours)",
  "destinations": "Destinations",
  "details": "Details",
  "detention": "Detention",
  "detentionDelayAtAirportSeaport": "Detention delay at Airport/Seaport",
  "detentionDelayAtOriginDestination": "Detention delay at Origin/Destination",
  "detention_time_exceeded_shipment_event": "Detention time exceeded",
  "detention_time_exceeded_violation": "Detention time exceeded",
  "deviationDistanceFromPlannedRoute": "Deviation distance from planned route (miles)",
  "device": "Device",
  "deviceAdded": "Device added successfully",
  "deviceAndTagManagement": "Device & tag management",
  "deviceCertification_actionButtonLabel": "Device certification",
  "deviceCertification_calibrationDate": "Date of calibration",
  "deviceCertification_downloadButtonLabel": "Download certificate",
  "deviceCertification_errorMessage": "Device certificate is not available",
  "deviceCertification_modalTitle": "Device certification",
  "deviceCertification_passedCertificationLabel": "Device {model} passed certification",
  "deviceData": "Device data",
  "deviceDataChart": "Device data chart",
  "deviceDeactivationSuccessfullMessage": "Device deactivated successfully",
  "deviceDelivery": "Device delivery",
  "deviceDetails": "Device details",
  "device_details_tab_data": "Data",
  "device_details_tab_sensorTimeline": "Sensor timeline",
  "deviceDwellThresholdDays": "Device dwell threshold (days)",
  "device_external": "External device",
  "deviceGenerated": "Device generated",
  "device_Generated_DTS": "Device generated DTS:",
  "device_gps": "GPS device",
  "device_GPS_Accuracy": "Device GPS accuracy (CEP metres):",
  "deviceGPSAccuracyMetres": "Device GPS accuracy (CEP metres)",
  "deviceId": "Device ID",
  "device_inactive_pre_pickup_location_shipment_event": "Pre pickup device inactive",
  "deviceIsNotReporting": "Device is not reporting",
  "deviceIsOnShipment": "This device is currently active on shipment {shipmentId}. Are you sure you want to reassign this device?",
  "deviceIsPoweredOff": "Device is powered off",
  "deviceIsReporting": "Device is reporting",
  "device_light": "Light device",
  "deviceManagement_description_humidityLogging": "Whether humidity reports should be logged. Use the \"Humidity sensor logging period\" to change the interval between logs.",
  "deviceManagement_description_sensorLoggingPeriod": "Interval between logged measurements",
  "deviceManagement_label_humidityLogging": "Humidity logging",
  "deviceManagement_label_humiditySensorLoggingPeriod": "Humidity sensor logging period",
  "deviceManagement_label_temperatureSensorLoggingPeriod": "Temperature sensor logging period",
  "deviceManufacturer": "Device manufacturer",
  "deviceModel": "Device model",
  "deviceModel.label_cep": "CEP value (cellular error of probability)",
  "deviceModel.label_modefInfoDescription": "Add the model details.",
  "deviceModel.successMessage_created": "Device model {name} successfully created",
  "deviceModel.successMessage_updated": "Device model {name} successfully updated",
  "deviceModelType_external": "External",
  "deviceModelType_gateway": "Gateway",
  "deviceModelType_gps": "GPS",
  "deviceModelType_light": "Light",
  "deviceModelType_temperature": "Temperature",
  "deviceMotion_moving": "Moving",
  "deviceMotion_starting": "Starting",
  "deviceMotion_stationary": "Stationary",
  "deviceMotion_stopping": "Stopping",
  "deviceName": "Device: {name}",
  "deviceNotResponding": "Device not responding (hours)",
  "deviceNowAvailable": "{imei} is now available",
  "deviceNta": "Device NTA (mins)",
  "device_off_site_at_flight_departure_shipment_event": "Device off-site at flight departure",
  "device_off_site_at_flight_departure_violation": "Device off site at flight departure",
  "devicePingFromMost": "Device ping from most recent to oldest",
  "devicePingFromOldest": "Device ping from oldest to most recent",
  "devicePlacement": "Device placement",
  "devicePlacement_allPlacements": "All placements",
  "devicePlacement_ambient": "Ambient",
  "devicePlacement_cargo": "Cargo",
  "devicePlacement_driverConnect": "Driver Connect",
  "devicePlacement_escortConnect": "Escort Connect",
  "devicePlacement_packingUnit": "Packing unit",
  "devicePlacement_product": "Product",
  "devicePlacement_shippingContainer": "Shipping container",
  "devicePlacement_side": "Side",
  "devicePlacement_top": "Top",
  "devicePlacement_tractor": "Tractor",
  "devicePlacement_trailer": "Trailer",
  "device_power_down_shipment_event": "Power down alert",
  "device_power_down_violation": "Power down alert",
  "deviceProfile.confirmationMessage_delete": "Are you sure you want to delete the {name} profile?",
  "deviceProfile.label_delete": "Delete profile",
  "deviceProfile.label_edit": "Edit profile",
  "deviceProfile.successMessage_created": "Device profile {name} successfully created",
  "deviceProfile.successMessage_deleteDescription": "Device profile {name} was successfully deleted",
  "deviceProfile.successMessage_updated": "Device profile {name} successfully updated",
  "device_reassignment_shipment_event": "Device reassignment",
  "device_reassignment_violation": "Device reassignment",
  "deviceReportingStatus_notReported": "Not reported",
  "deviceReportingStatus_reported": "Reported",
  "deviceRequired": "Require an assigned device",
  "devices": "Devices",
  "deviceSensorSetup": "Device sensor setup",
  "device_separation_violation": "Device separation",
  "devicesNavBtn": "Devices",
  "deviceSource_app": "Application",
  "deviceSource_deviceManagement": "Device management",
  "deviceSource_import": "Import",
  "deviceSource_rmo": "Shipment Connect",
  "deviceSource_scGo": "Shipment Connect Go",
  "deviceSource_tms": "TMS",
  "devicesSegmentError": "Please assign device to this segment",
  "deviceStatus_assigned": "Assigned",
  "deviceStatus_assignedToOrigin": "Assigned to origin",
  "deviceStatus_assignedToPortal": "Assigned to portal",
  "deviceStatus_atDestination": "At destination",
  "deviceStatus_billed": "Billed",
  "deviceStatus_dwell": "Dwell",
  "deviceStatus_inTransit": "In transit",
  "deviceStatus_invalid": "Invalid",
  "deviceStatus_lost": "Lost",
  "deviceStatus_new": "New",
  "deviceStatus_offSite": "Off-Site",
  "deviceStatus_onSite": "On-Site",
  "deviceStatus_returned": "Returned",
  "deviceStatus_returningToFulfillment": "Returning to fulfillment",
  "deviceStatus_returningToOrigin": "Returning to origin",
  "device_temperature": "Temperature device",
  "deviceTimestampEnabled": "Device timestamp enabled",
  "deviceTracking": "Device tracking",
  "deviceType": "Device type",
  "deviceUpdated": "Device updated successfully",
  "deviceUsageType_disposable": "Disposable",
  "deviceUsageType_reusable": "Reusable",
  "deviceVendor": "Device vendor",
  "deviceVendor.label_edit": "Edit vendor",
  "deviceVendor_modalDescription": "Input the vendor name.",
  "deviceVendors": "Device vendors",
  "difference": "Difference",
  "dimensions": "Dimensions",
  "disabled": "Disabled",
  "disableErrantPingDetection": "Disable errant ping detection",
  "disableGPS": "Disable GPS for position report",
  "disableGPSHint": "Whether the GPS should be disabled for position reports",
  "disableTranslusentTrailer": "Disable translucent trailer",
  "discard": "Discard changes",
  "discardDescription": "Are you sure you want to discard changes",
  "disclaimer": "Disclaimer",
  "dispatch": "Dispatch",
  "dispatching": "Dispatching",
  "displaySegmentEta": "Display segment ETA",
  "displayShipmentEta": "Display shipment ETA",
  "disposable": "Disposable",
  "distance": "Distance",
  "distanceFrom": "Distance from origin",
  "distanceFromAssignedVenue": "Distance from assigned venue",
  "distanceFromAssignedVenueInMiles": "Distance from assigned venue: {distance} miles",
  "distanceFromVenue": "Distance from assigned venue",
  "distanceKilometers": "Kilometers",
  "distance_meters": "{meters} m",
  "distanceMiles": "Miles",
  "distanceTotal": "Distance total",
  "dmvMatchStatus.matched": "Matched",
  "dmvMatchStatus.notApplicable": "Not applicable",
  "dmvMatchStatus.notCompleted": "Not completed",
  "dmvMatchStatus.notMatched": "Not matched",
  "dnsStatus": "DNS status",
  "dnsWasEnabledSuccessfully": "DNS for {name} was enabled successfully",
  "document": "Document",
  "done": "Done",
  "doNotDisturbTimeError": "\"To\" date should be after \"From\" date",
  "doNotDisturbTimeErrorFrom": "\"From\" date should be before \"To\" date",
  "door": "Door",
  "doorClosed": "Door closed",
  "door_closed_shipment_event": "Door closed event",
  "doorOpen": "Door open",
  "door_open_shipment_event": "Door opened event",
  "doorStateChangeAlert": "Door state change alert",
  "door_state_change_shipment_event": "Door close/open event",
  "door_state_change_violation": "Door state change",
  "doorStatus": "Door status",
  "door_status_change": "Door status change",
  "doorStatus_closed": "Door closed",
  "doorStatus_open": "Door open",
  "doorStatus_opened": "Door opened",
  "door_tamper_alert_violation": "Door tamper alert",
  "door_tamper_shipment_event": "Door tamper",
  "DOT Break": "DOT break",
  "doubleFloor": "Double floor",
  "doubleHull": "Double hull",
  "double_loading_manual_incident_shipment_event": "Double-Loading",
  "double_loading_manual_incident_violation": "Double-Loading",
  "doubleShellPlating": "Double shell plating",
  "download": "Download",
  "downloadAndContinue": "Download & continue",
  "downloadConfigFile": "Download {extension} config",
  "downloadErrorsFile": "Error descriptions were added to the last column in the file. Download the error file, fix and upload again.",
  "downloadImportTemplate": "Import multiple records using file import button below. To learn more on how to properly format and upload your spreadsheet, <a>download our template with instructions</a>.",
  "downloadInstructionsTemplate": "Download our template with instructions",
  "dragAndDron": "Drag & drop here",
  "driver": "Driver",
  "driverId": "Driver ID",
  "driverName": "Driver name",
  "driverNumber": "Driver number",
  "driverNumberVerification": "Require driver number verification",
  "driverPhone": "Driver phone",
  "driver_pick_up": "Driver pick up",
  "driverPickup.addSignatureDescription": "Please sign below to confirm that the pickup information is accurate.",
  "driverPickup.button_addSignature": "Add signature",
  "driverPickup.button_replaceSignature": "Replace signature",
  "driverPickup.button_retakePhoto": "Retake photo",
  "driverPickup.button_submitChecklist": "Submit checklist",
  "driverPickup.button_submitPickup": "Submit pickup form",
  "driverPickup.button_takePhoto": "Take photo",
  "driverPickup.caption_pickupSubmitted": "Thank you. This pickup has been recorded. You may now close this page.",
  "driverPickup.description_cdlNotDetected": "A commercial driver’s license (CDL) was not detected. A valid CDL is required for this shipment",
  "driverPickup.description_confirmDriverIdentity": "Confirm each driver’s identity before pickup. This protects the shipment and the carrier.",
  "driverPickup.description_documentNotDetected": "License verification could not be completed, as the document was not detected. Please try again",
  "driverPickup.description_documentNotSupported": "License verification could not be completed, as the document was not supported. Please try again using a commercial driverʼs license",
  "driverPickup.description_enterCodeSentTo": "Enter the 6-digit code sent to {phone}.",
  "driverPickup.description_expiredLicense": "{name}’s license expired. This driver should not take possession of the load, please contact your supervisor for further instructions or resubmit with a valid license",
  "driverPickup.description_imageQualityIssues": "We couldn’t confidently verify this license due to image quality. Retake the photo in better lighting and ensure the full license is visible. You may submit anyway but verification will remain incomplete",
  "driverPickup.description_liveSelfieIssue": "License verification could not be completed because a live selfie could not be confirmed. Please try again and ensure the driver completes the live selfie step",
  "driverPickup.description_verifyLicenseValidity": "Verify {driverName}ʼs license validity and expiry.",
  "driverPickup.description_verifyPhoneNumber": "Verify {driverName}ʼs phone number via SMS.",
  "driverPickup.error_signatureRequired": "Plase make signature first",
  "driverPickup.label_driverLicenseVerification": "Driver’s license verification",
  "driverPickup.label_driversLicense": "Driver’s license",
  "driverPickup.label_enterVerificationCode": "Enter verification code",
  "driverPickup.label_expiry": "Expiry",
  "driverPickup.label_lastChecked": "Last checked",
  "driverPickup.label_noLicenseCheck": "No license check yet",
  "driverPickup.label_nonUsa": "Non USA",
  "driverPickup.label_noPhoneNumber": "No phone number, please update",
  "driverPickup.label_phoneNumberVerification": "Phone number verification",
  "driverPickup.label_sendVerificationSms": "Send verification SMS",
  "driverPickup.label_updateAndProceedToChecklist": "Update and proceed to checklist",
  "driverPickup.label_usa": "USA",
  "driverPickup.label_verifyDriverDetails": "Verify driver details",
  "driverPickup.label_verifyLicense": "Verify license",
  "driverPickup.message_eventSubmitted": "Shipment event was submitted",
  "driverPickup.message_otpCodeSent": "OTP code sent",
  "driverPickup.message_phoneVerificationSuccess": "Driver phone number verified successfully.",
  "driverPickup.pickupProgress": "{completed} of {total} fields completed",
  "driverPickup.resendIfDidNotReceiveOtp": "Didn’t receive code? Resend",
  "driverPickup.resendIfDidNotReceiveOtpInTime": "Didn’t receive code? Resend in {time}",
  "driver_pickup_submission_shipment_event": "Driver pickup",
  "driverPickup.subtitle_checklist": "This checklist must be completed.",
  "driverPickup.subtitle_selectCountry": "Select the country where your driver's license was issued.",
  "driverPickup.title_addSignature": "Add your signature",
  "driverPickup.title_pickupSubmitted": "Pickup submitted successfully!",
  "driverRiskScoreTrend.description_emptyState": "Available when the driver's score is next recalculated",
  "drivers": "Drivers",
  "driver_shipment_start": "Driver pre-pickup checklist",
  "driversMaxTwo": "Drivers (max. 2)",
  "driver_sos_alert_shipment_event": "Driver SOS Alert/Shipment event",
  "driver_sos_alert_violation": "Driver sos alert",
  "dryVan": "Dry van",
  "duplicate": "Duplicate",
  "duplicatePhoneNumberMessage": "If a phone number is associated with another driver, saving will reassign the phone number to the driver entered above.",
  "duplicateTo": "Duplicate to",
  "duplicateToAnotherPortal": "Duplicate to another portal",
  "duplicateWithNewLocations": "Duplicate with new locations",
  "duration": "Duration",
  "durationActive": "Duration active",
  "duration_lessThanAMinute": "less than a minute",
  "duration_shortUnitDay": "d",
  "duration_shortUnitHour": "hr",
  "duration_shortUnitMilisecond": "ms",
  "duration_shortUnitMinute": "min",
  "duration_shortUnitMonth": "mo",
  "duration_shortUnitSecond": "s",
  "duration_shortUnitWeek": "w",
  "duration_shortUnitYear": "yr",
  "duration_updatedAgo": "{duration} ago",
  "duration_updatedIn": "in {duration}",
  "dwellTimeLabel": "Dwell time (hours)",
  "dwellTimeLegend": "Dwell time {dwell_time}hr",
  "early": "Early",
  "early_eta_delivery_shipment_event": "Early ETA delivery",
  "earlyEtaMinutes": "Early ETA (minutes)",
  "earlyETAStatus": "ETA - early - expected time of delivery",
  "earlyETAStatusKPIHint": "Expected time delivery - EARLY: active & projecting to deliver early",
  "early_final_delivery_departure_shipment_event": "Early departure from final delivery",
  "early_final_delivery_departure_violation": "Early departure from final delivery",
  "ebolDescription": "Copy and share this electronic bill of lading.",
  "ebolManager.label_acceptedAtDelivery": "Accepted at delivery",
  "ebolManager.label_acceptedWithDiscrepancies": "Accepted with discrepancies",
  "ebolManager.label_rejectedAtDelivery": "Rejected at delivery",
  "ebolManager.label_scannedQrCodeCaption": "Scanned <strong>QR code</strong> at",
  "ebolManager.label_updatedDeliveryDecision": "Updated <strong>delivery decision</strong>",
  "ebolPageInstruction": "Enter a secureBOL user name, location and generate a pin",
  "ebolStatus_accepted": "Accepted",
  "ebolStatus_acceptedWithDiscrepancies": "Accepted with discrepancies",
  "ebolStatus_rejected": "Rejected",
  "edit": "Edit",
  "editAssetNumber": "Edit asset #{number}",
  "editAttachments": "Edit attachments",
  "editAutomatedAlertTemplate": "Edit automated alert template",
  "editCompany": "Edit company",
  "editCompany.infoMessage_verifiedUSBroker": "Broker's USDOT successfully validated and details synced with the FMCSA.",
  "editCompany.infoMessage_verifiedUSCarrier": "Carrier's USDOT successfully validated and details synced with the FMCSA.",
  "editCompany.infoTitle_verifiedUSBroker": "Verified US broker",
  "editCompany.infoTitle_verifiedUSCarrier": "Verified US carrier",
  "editCompany.label_companyPortalAliases": "Portal aliases",
  "editCompany.label_companySharingAndAliases": "Portal access & aliases",
  "editCompanyLogo": "Edit company logo",
  "editCustomField": "Edit custom field",
  "editDashboard": "Edit dashboard",
  "editDepartment": "Edit department",
  "editDevice": "Edit device",
  "editDeviceTooltip": "Edit device",
  "editDeviceVendor": "Device vendor: {name}",
  "editEscalationTemplate": "Edit escalation template",
  "editGeofence": "Edit geofence",
  "editGlobalTemplateSubtitle": "The global template(s) defined below will be used as standard to escalate the risk event name for all portals.",
  "editLocation": "Edit location",
  "editLocationPermissionError": "User doesn’t have a permission to edit location with such location type",
  "editNotificationTemplate": "Edit notification template",
  "editOpeningHours": "Edit opening hours",
  "editPortal": "Edit portal",
  "editPriorityGroup": "Edit priority group",
  "editRegionalWorkflow": "Edit regional workflow",
  "editRegionalWorkflowTitle": "Edit regional workflow: {name}",
  "editReport": "Edit report",
  "editRole": "Edit role",
  "editRoleName": "Edit role: {name}",
  "editRoute": "Edit route",
  "editTag": "Edit tag",
  "editTagTooltip": "Edit tag",
  "editUser": "Edit user",
  "editUserAccountSettings": "Edit user account settings",
  "editWorkflow": "Edit workflow: {name}",
  "elapsedTime": "Elapsed time",
  "elapsedTimeDescription": "Time passed since protection time expired.",
  "eld": "Eld",
  "email": "Email",
  "emailAddress": "Email address",
  "emailContent": "Email content",
  "emailIsInvalid": "Email is invalid",
  "emailOrPhoneReq": "Email or phone is required",
  "emailSubject": "Email subject",
  "emailTemplate": "Email template",
  "emailTemplatePreview": "Email template preview",
  "emailTemplatePreviewDescription": "Prior actions summary will be included at the top of the email that escalation contacts receive:",
  "embeddedReport_activateSuccessDescription": "Report {name} was successfully activated",
  "embeddedReport_createSuccessDescription": "Report {name} was successfully created",
  "embeddedReport_deactivateSuccessDescription": "Report {name} was successfully deactivated",
  "embeddedReport_deleteSuccessDescription": "Report {name} was successfully deleted",
  "embeddedReport_emptyListState": "No embedded reports have been configured for this portal. Please contact support.",
  "embeddedReport.label_subscriptions": "Subscriptions",
  "embeddedReport.label_subscriptionsDescription": "Track your data by setting up a subscription to receive this report via email at a regular cadence.",
  "embeddedReports": "Embedded reports",
  "embeddedReports.confirmationMessage_activateSubscription": "Are you sure you want to activate {name} subscription?",
  "embeddedReports.confirmationMessage_deactivateSubscription": "Are you sure you want to deactivate {name} subscription?",
  "embeddedReports.confirmationMessage_deleteSubscription": "Are you sure you want to delete {name} subscription?",
  "embeddedReports.successMessage_activateDescription": "Subscription {name} was successfully activated.",
  "embeddedReports.successMessage_deactivateDescription": "Subscription {name} was successfully deactivated.",
  "embeddedReports.successMessage_deletedDescription": "Subscription {name} was successfully deleted.",
  "embeddedReport_updateSuccessDescription": "Report {name} was successfully updated",
  "embededReportCategory_core": "Core",
  "embededReportCategory_specialized": "Specialized",
  "embededReportGroup_custom": "Custom",
  "embededReportGroupDescription_custom": "This report will appear under the custom header on the reports landing page.",
  "embededReportGroupDescription_intel": "This report will appear under the intel header on the reports landing page.",
  "embededReportGroupDescription_none": "Report will be hidden from users. The grouping is intended for billing and reporting.",
  "embededReportGroupDescription_paginated": "This report will appear under the paginated header on the reports landing page.",
  "embededReportGroupDescription_pharma": "NOTE: this report will appear on Risk Monitor and Shipment Manager when the relevant user roles are enabled.",
  "embededReportGroupDescription_standard": "This report will appear under the standard header on the reports landing page.",
  "embededReportGroup_intel": "Intel",
  "embededReportGroup_none": "None",
  "embededReportGroup_paginated": "Paginated",
  "embededReportGroup_pharma": "Pharma",
  "embededReportGroup_standard": "Standard",
  "embededReportTooltip_global": "Available by default for all users with embedded reports access. The report can still be deactivated within company settings.",
  "embededReportTooltip_internal": "Visible only to members of OH company.",
  "embededReportTooltip_shipment": "Expects a shipment ID from the app to populate the report. Does not appear on the reports page.",
  "embededReportType_dashboard": "Dashboard",
  "embededReportType_dispatch": "Dispatch",
  "embededReportType_paginatedReport": "Paginated report",
  "embededReportType_report": "Report",
  "emergenciesSubTitle": "Select the contact methods that this contact can be reached by for emergency escalations.",
  "emergenciesTitle": "Emergencies",
  "emergencyOnly": "Emergency only",
  "emptyDashboardPlaceholder": "Select your first widget",
  "enable": "Enable",
  "enabled": "Enabled",
  "enabledDNS": "Enable DNS",
  "enableDeliveryEvents": "Enable delivery events",
  "enableGSOCMonitoring_toggle": "Enable GSOC monitoring",
  "enableMovementDetection": "Movement detection",
  "enableMovementDetectionHint": "Whether the device should enter movement state if the movement is detected",
  "enableRegionalWorkflows": "Enable regional workflows",
  "enableRequiedFields": "Enable required fields",
  "enableShipmentConnectAtPortal": "Enable Shipment Connect at portal level",
  "enableWatcherRole_toggle": "Enable watcher role",
  "engineEventsEnabled": "Engine on/off events enabled from telematics integration",
  "engineHours": "Engine hours",
  "english": "English",
  "ENI": "ENI",
  "ENITooltip": "European number of identification. A unique 8 digit id assigned to vessels navigating on inland european waters",
  "enterComment": "Enter comment here",
  "enterEmail": "Enter email",
  "enterMessage": "Enter message here",
  "enterNameOrUniqueId": "Enter name or unique identifier",
  "enterNickname": "Enter nickname",
  "enterNotesComment": "Enter comment here",
  "enterReasonsDescription": "Enter a maximum of {reasonsNumber} event reasons per section (blank sections will not be displayed)",
  "enterTextHere": "Enter text here",
  "enterTitle": "Enter title",
  "equipment": "Equipment",
  "equipmentType": "Equipment type",
  "errantPings": "Errant pings",
  "error": "Error",
  "error_cameraAccessDenied": "Camera access denied",
  "errorDescription_locationsNotDuplicated": "Selected locations were already present or locations with the same name currently exist on the destination portal(s) and could not be duplicated to them. Review the selection and try again.",
  "error_driverNotAtPickupLocation": "You must be at the origin location to start the pre-pickup checklist.",
  "error_locationAccessDenied": "Location access denied",
  "errorMessage_callEnded": "Call ended",
  "errorMessage_callRecordingLoadFailed": "Unable to load call recording",
  "errorMessage_callRecordingUnavailable": "Unable to retrieve the call recording right now. You'll be able to view it in Call Room in a few minutes",
  "errorMessage_callServiceConnectionLost": "Connection to calling service lost",
  "errorMessage_callServiceReconnectFailed": "Failed to reconnect to calling service. Please try again or reload the page",
  "errorMessage_callServiceUnavailable": "Calling service is unavailable",
  "errorMessage_callTranscriptionLoadFailed": "Unable to load call transcription",
  "errorMessage_callTransfer": "Call transfer failed. Please try again.",
  "errorMessage_canceledShipment": "This shipment has a status of cancelled.",
  "errorMessage_columnSettingsValidation": "At least one column must be visible",
  "errorMessage_contactInfo": "Unable to fetch contact information",
  "errorMessage_copyIsNotSupported": "Action is not supported by the browser. Please copy the text manually",
  "errorMessage.createVerifiedCarrier": "Please confirm that the number is correct and try again.",
  "errorMessage_disableIncomingCalls": "Failed to disable incoming calls",
  "errorMessage_duplicateLocationToPortals": "Duplication to other portals is only available for hot zones, open mic zones, danger zones and safe zones that are not global. Please change your location selection and try again",
  "errorMessage_employeePin": "Error loading pin value",
  "errorMessage_enableIncomingCalls": "Failed to enable incoming calls.",
  "errorMessage_enableWebGL": "Please enable WebGL and hardware acceleration in your browser",
  "errorMessage_exceedExportLimit": "The current selection contains more than {exportLimit} records. Please apply additional filters to reduce the amount of records.",
  "errorMessage_formContainsErrors": "Please review the form and fix the errors before saving",
  "errorMessage_geofencePointsLimit": "There is a 100 vertices/points limit on polygons.",
  "errorMessage_geolocationNotSupported": "Geolocation is not supported by your browser",
  "errorMessage_incomingCallsEnabledInAnotherTab": "Incoming calls are already enabled in another browser tab",
  "errorMessage_invalidCropImage": "Invalid or broken image - no crop available",
  "errorMessage_invalidPhoneGroup": "Your phone group is no longer available. Please refresh the page and try again.",
  "errorMessage_locationsNotDuplicated": "Duplications were unsuccessful.",
  "errorMessage_lockShipmentTimeoutError": "Shiment processing is taking too long. Please reload shipment data.",
  "errorMessage_longExport": "Sorry, it’s taking longer than usual. Try reducing the date range set or come back later",
  "errorMessage_maxAttachmentsCount": "The maximum number of images that can be uploaded, in a single upload, is {count}.",
  "errorMessage_maxBulkShipmentAmout": "No more than {count} shipments can be closed at a time. Please reduce the number selected and try again",
  "errorMessage_maxEmailAttachments": "Maximum 10 attachments allowed",
  "errorMessage_maximumAllowedDateAndTime": "Max allowed: {date}",
  "errorMessage_mergeLocationCoordinates": "Cannot merge some locations because lat/lng is not a match to one decimal place",
  "errorMessage_microphoneAccessDenied": "Microphone access is blocked. Allow microphone access in your browser settings to make and receive calls",
  "errorMessage_microphoneUnavailable": "Microphone is unavailable. Make sure it is connected and not used by another application",
  "errorMessage_minimumAllowedDateAndTime": "Min allowed: {date}",
  "errorMessage_noEventsToRemove": "There are no events to remove",
  "errorMessage_noPageAccess": "You do not have access to view this page",
  "errorMessage_noQrcLinks": "No assigned QRC links yet",
  "errorMessage_noRecipients": "No recipients added",
  "errorMessage_pleaseSelectAccessType": "Please select an access type",
  "errorMessage_pleaseSelectAtLeastOneRestriction": "Please select at least one restriction option",
  "errorMessage_pleaseSelectFile": "Please select a file",
  "errorMessage_recipientEmailAddress": "This shipment can only be Accepted/Rejected by entering the ‘Shipment delivery recipient email address’ used when the shipment was created",
  "errorMessage_recordingLoadFailed": "Unable to load recording",
  "errorMessage_reopenModal": "Close and reopen the modal to try again.",
  "errorMessage_reportsUnavailable": "No reports are available for shipments with the status of cancelled.",
  "errorMessage_richEditorParseState": "Error parsing state string. Unable to display the text.",
  "errorMessage_shipmentIsNotAvailable": "This shipment is no longer available",
  "errorMessage_shipmentNotExist": "Shipment does not exist.",
  "errorMessage_startCallFailed": "Failed to start the call. Please try again or reload the page",
  "errorMessage_trafficMapToolNotAvailable": "Traffic is not available at the moment. Please reload the page or try again later.",
  "errorMessage_unableToExportPdf": "Unable to export PDF",
  "errorMessage_unableToFetchData": "Unable to fetch data",
  "errorTitle.createVerifiedCarrier": "USDOT {usdotNumber} does not have carrier authority with the FMCSA.",
  "error_unableToAccessLocation": "Unable to access your location.",
  "error_unableToLoadShipmentData": "Unable to load shipment data.",
  "error_unableToLoadSubmissionData": "Unable to load submission data.",
  "escalate": "Escalate",
  "escalated": "Escalated",
  "escalatedTo": "Escalated to",
  "escalateFrom": "From",
  "escalateTo": "Escalate to",
  "escalateToAll": "Escalate to all",
  "escalationEmails.label_totalContacts": "Total contacts included",
  "escalationNumber": "Escalation # {number}",
  "escalationOn": "Escalation on",
  "escalationOnShipmentEvent": "Escalation on {eventNm} /shipment ID {shipmentId}",
  "escalationPriority": "Escalation priority",
  "escalationPrioritySubTitle": "Set the order of priority for the selected contact, subject to schedule, as part of escalations to this company.",
  "escalationReminders.createEditPageInfo": "Provide a custom name for the template; set up timings for each reminder & automatic solving; and write the right text messages. A few sentences of text about the logic of reminders timing.",
  "escalationReminders.firstReminder": "Reminder #1",
  "escalationReminders.firstReminderInfo": "Will be sent in {time} after a reply to the escalation email if the customer is not responding.",
  "escalationReminders.firstTiming": "Reminder #1 timing",
  "escalationReminders.secondReminder": "Reminder #2",
  "escalationReminders.secondReminderInfo": "Will be sent in {time} after reminder #1 if the customer is not responding.",
  "escalationReminders.secondTiming": "Reminder #2 timing",
  "escalationReminders.solveReminder": "Auto solve",
  "escalationReminders.solveReminderInfo": "Will be sent in {time} after reminder #2 if the customer is not responding.",
  "escalationReminders.solveTiming": "Solve timing",
  "escalations": "Escalations",
  "Escalations": "Escalations",
  "escalationsCount": "Escalations {count}",
  "escalationSubject": "Escalation on {eventName}_{eventCreatedAt}_{assetType}_{assetNumber}",
  "escalationTemplates": "Escalation templates",
  "escalationTemplateType": "Escalation",
  "escalationTooltip": "Escalation #",
  "escortAbbr": "ESC",
  "escort_arrived_at_origin_manual_shipment_event": "Escort arrived at origin",
  "escort_checked_in_shipment_event": "Escort checked in",
  "escortCheckIn.checkedInWithSecurity": "Checked in with security",
  "escortCheckIn.delayed": "Delayed",
  "escortCheckIn.insideFacility": "Inside facility",
  "escortCheckIn.madeContactWithDriver": "Made contact with driver",
  "escortCheckIn.waitingForDriver": "Waiting for driver",
  "escortCheckIn.waitingOutsideGate": "Waiting outside gate",
  "escortCompany.successMessage_created": "Escort company {name} successfully created",
  "escortDrivers": "Escort drivers",
  "escortDriver.successMessage_created": "Escort driver {name} successfully created",
  "escort_ended_manual_shipment_event": "Escort ended",
  "escortSosSituationType_accident": "Accident",
  "escortSosSituationType_cargoAtRisk": "Cargo at risk",
  "escortSosSituationType_hostileSituation": "Hostile situation",
  "escortSosSituationType_medicalEmergency": "Medical emergency",
  "escortStopReason_checkLoad": "Check load",
  "escortStopReason_plannedStop": "Planned",
  "escortStopReason_refuelRefresh": "Refuel / refresh",
  "escortStopReason_unplannedStop": "Unplanned stop",
  "estimated": "Estimated",
  "estimatedArrival": "Estimated arrival",
  "estimatedArrivalAtSegmentDestination": "Estimated arrival at segment destination",
  "estimatedDeliveryAtFinalDestination": "Estimated delivery at final destination",
  "estimatedDeliveryLabel": "Estimated delivery",
  "estimatedDeparture": "Estimated departure",
  "estimatedPickup": "Estimated pickup",
  "estimatedTime": "Planned duration",
  "ETA": "ETA",
  "etaAtRiskAwaiting": "ETA at risk: awaiting ETA",
  "etaAtRiskAwaitingDeliveryTimes": "Awaiting delivery times",
  "etaAtRiskEarly": "ETA at risk: early",
  "etaAtRiskEarlyLess": "\"ETA at risk: early\" must be less than \"Early ETA\"",
  "etaAtRiskEarlyMinutes": "ETA at risk: early (minutes)",
  "etaAtRiskEarlyMore": "\"Early ETA\" must be more than \"ETA at risk: early\"",
  "etaAtRiskLate": "ETA at risk: late",
  "etaAtRiskLateLess": "\"ETA at risk: late\" must be less than \"Late ETA\"",
  "etaAtRiskLateMinutes": "ETA at risk: late (minutes)",
  "etaAtRiskLateMore": "\"Late ETA\" must be more than \"ETA at risk: late\"",
  "ETACalculation": "ETA calculation",
  "etaDelivery": "ETA at the next delivery location",
  "eta_exceeding_delivery_shipment_event": "Eta exceeding delivery time",
  "eta_exceeding_delivery_violation": "Eta exceeding delivery",
  "ETAs": "ETAs",
  "etaStatus": "ETA",
  "ETAStatusConsiderSubsequentDwellTime": "ETA status: consider subsequent dwell time",
  "etaStatusLastUpdated": "ETA status last updated",
  "etaTimeNotProvided": "Destination planned date not provided",
  "etaToDeliveryAlertMinutes": "ETA to delivery alert (minutes)",
  "ETDShipmentStatusMap": "Expected time of delivery shipment status map",
  "ETDShipmentStatusMapKPIHint": "Expected time of delivery shipment status map for shipments at the final segment but not yet delivered",
  "event": "Event",
  "event_acceptDelivery": "User accepted delivery",
  "eventAcknowledged": "Event acknowledged",
  "eventAcknowledgedByUser": "Event acknowledged by {userName}",
  "event_airport_wait_time_exceeded_shipment_event": "Airport wait time exceeded",
  "event_arrival_at_airport_location": "Arrival at airport location",
  "event_arrival_at_seaport_location": "Arrival at seaport location",
  "eventAttachments": "Event attachments",
  "eventAutoAcknowledged": "Event auto-acknowledged",
  "event_awb_booked_shipment_event": "Booked",
  "event_awb_consignee_notified_shipment_event": "Consignee notified",
  "event_awb_received_from_flight_shipment_event": "Received from flight",
  "event_cancelled_flight_alert_shipment_event": "Cancel flight alert",
  "event_carrierRiskScore": "Carrier risk score",
  "event_changeInPlanProposed": "Change in plan proposed",
  "event_claim_submission_shipment_event": "Claims buddy submission",
  "event_coldChainTemperatureAlert": "Quality temperature alert",
  "event_compoundShipmentEvent": "Compound",
  "event_container_arrival_at_transshipment_port_shipment_event": "Transshipment - container arrival",
  "event_container_arrival_shipment_event": "Container arrival at seaport location",
  "event_container_departure_from_transshipment_port_shipment_event": "Transshipment - container departure from port",
  "event_container_departure_shipment_event": "Container departure from seaport location",
  "event_container_discharged_at_transshipment_port_shipment_event": "Transshipment - container discharged",
  "event_container_discharged_shipment_event": "Container discharged",
  "event_container_gate_in_empty_shipment_event": "Gate in empty",
  "event_container_gate_in_full_shipment_event": "Gate in full",
  "event_container_gate_out_empty_shipment_event": "Gate out empty",
  "event_container_gate_out_full_shipment_event": "Gate out full",
  "event_container_loaded_at_transshipment_port_shipment_event": "Transshipment - container loaded",
  "event_container_loaded_shipment_event": "Container loaded",
  "event_containerRailArrived": "Container arrived at facility",
  "event_containerRailArrivedAtDestination": "Container arrived at final rail facility",
  "event_containerRailArrivedAtInlandDestination": "Container arrived at inland destination",
  "event_containerRailArrivedAtInterchangeFacility": "Container arrived at facility to change railway carrier",
  "event_containerRailArrivedAtOriginPort": "Container on rail at origin port",
  "event_containerRailDeparted": "Container departed on rail",
  "event_containerRailDepartedFromDestinationPort": "Container departed on rail from destination port",
  "event_containerRailDepartedFromInlandOrigin": "Container departed on rail from inland origin",
  "event_containerRailDepartedFromInterchangeFacility": "Container departed on rail from interchange facility",
  "event_containerRailDischarged": "Container discharged from rail",
  "event_containerRailDischargedAtInlandDestination": "Container discharged from rail at inland destination",
  "event_containerRailDischargedAtInterchangeFacility": "Container discharged from rail at interchange facility",
  "event_containerRailDischargedAtOriginPort": "Container discharged from rail at origin port",
  "event_containerRailLoaded": "Container loaded on rail",
  "event_containerRailLoadedAtDestinationPort": "Container loaded on rail at destination port",
  "event_containerRailLoadedAtInterchangeFacility": "Container loaded on rail at interchange facility",
  "event_container_tracking_subscribed_shipment_event": "Container tracking subscribed",
  "event_containerWellnessCheck": "Container wellness check",
  "event_convoyDeviation": "Convoy deviation alert",
  "event_damaged_manual_incident_shipment_event": "Damaged",
  "event_dangerZoneRestart": "Dangerzone stop start",
  "event_dangerZoneStop": "Dangerzone stop",
  "event_dangerZoneTractorSlowdown": "Danger zone tractor slowdown",
  "event_decideRiskGpt": "Decide risk GPT",
  "event_delayed_departure_after_pickup_shipment_event": "Delayed departure after pickup submission",
  "event_delayed_vessel_arrival_shipment_event": "Delayed vessel arrival",
  "event_deliveryActionExpected": "Accept/Reject delivery option not selected",
  "event_demurrageWarningAtDestinationPort": "Demurrage warning at destination port",
  "event_departure_shipment_event": "Origin pickup submission & photos",
  "event_detention_time_exceeded_shipment_event": "Detention time exceeded",
  "event_device_inactive_pre_pickup_location_shipment_event": "Pre pickup device inactive",
  "event_device_off_site_at_flight_departure_shipment_event": "Device off-site at flight departure",
  "event_device_power_down_shipment_event": "Power down alert",
  "event_device_reassignment_shipment_event": "Device reassignment",
  "event_distanceToDestinationAlert": "Distance to destination alert",
  "event_door_closed": "Door closed event",
  "event_door_closed_shipment_event": "Door closed",
  "event_door_opened": "Door opened event",
  "event_door_open_shipment_event": "Door opened",
  "event_doubleBrokeredShipmentEvent": "Shipment double brokered",
  "event_double_loading_manual_incident_shipment_event": "Double-Loading",
  "event_driverChecklist": "Driver pre-pickup without violations",
  "event_driverDeclinedShipment": "Driver declined shipment",
  "event_driverLicenseVerificationFailed": "Driver license validation failed",
  "event_driverPickup": "Driver pick up",
  "event_driverPreclearanceSubmission": "Driver preclearance submission",
  "event_driverRiskScore": "Driver risk score",
  "event_driver_sos_alert_shipment_event": "Driver SOS Alert/Shipment event",
  "event_early_final_delivery_departure_shipment_event": "Early departure from final delivery",
  "event_enter_delivery_location_shipment_event": "Arrival at delivery location",
  "eventEscalatedByUserToUsers": "Event escalated by {userName}",
  "event_escortAccepted": "Escort accepted",
  "event_escortAssignedShipmentEvent": "Escort assigned",
  "event_escortBegins": "Escort begins",
  "event_escortCheckedIn": "Escort checked in",
  "event_escortCompleted": "Escort completed",
  "event_escortSosAlertShipmentEvent": "Escort SOS alert",
  "event_escortStopShipmentEvent": "Escort stop start",
  "event_escortVehicleAssigned": "Escort vehicle assigned",
  "event_finish_shipment_event": "PoD submission",
  "event_firstTimeCarrier": "First time carrier seen in Overhaul",
  "event_firstTimeDriver": "First time driver seen in Overhaul",
  "eventGenerated": "Event generated",
  "event_Generated_DTS": "Event generated DTS:",
  "event_handlingUnitQualityTemperature": "Packing unit temperature alert",
  "event_high_riskscore_alert_shipment_event": "Weather alert",
  "event_home_restart": "Home stop start",
  "event_home_stop": "Home stop",
  "event_hot_zone_restart": "Hotzone stop start",
  "event_hotZoneTractorSlowdown": "Hot zone tractor slowdown",
  "event_humidity_shipment_event": "Humidity alert",
  "event_ignition_off_shipment_event": "Engine ignition event (off)",
  "event_ignition_on_shipment_event": "Engine ignition event (on)",
  "event_incident_response_manual_incident_shipment_event": "Incident response",
  "event_incompleteDriverChecklist": "Incomplete driver pre-pickup checklist",
  "event_incompleteDriverPickup": "Incomplete driver pickup",
  "event_incomplete_information_shipment_event": "Incomplete shipment information",
  "event_incomplete_pickup_submission_shipment_event": "Incomplete pickup submission & photos",
  "event_incomplete_pre_check_shipment_event": "Incomplete origin pre-departure checklist confirmation",
  "event_in_hot_zone_stop_shipment_event": "Hotzone stop",
  "event_in_safe_zone_detention_time_exceeded_shipment_event": "Safezone stop detention alert",
  "event_invalid_container_tracking_at_seaport_shipment_event": "Invalid container tracking at seaport",
  "event_invalid_flight_tracking_shipment_event": "Invalid flight tracking",
  "event_itemQualityTemperature": "Item quality temperature alert",
  "event_leave_ddi_radius_shipment_event": "Departure from pickup",
  "event_leave_location_shipment_event": "Departure from planned stop",
  "event_leaving_lockdown_location_shipment_event": "Lock down exit alert",
  "event_light_shipment_event": "Light alert",
  "event_lightStopCompound": "Light & Stop(compound)",
  "event_low_battery_level_shipment_event": "Low battery level",
  "event_manifestOnFlight": "Manifest on flight",
  "event_mechanical_failure_manual_shipment_event": "Mechanical failure",
  "event_missed_flight_alert_shipment_event": "Missed flight alert",
  "event_missed_ship_alert_shipment_event": "Missed vessel alert",
  "event_missing_ddi": "Incomplete origin pickup submission & photos",
  "event_missing_pod": "Incomplete delivery",
  "event_moving": "Motion status change - moving",
  "event_moving_away_from_delivery_shipment_event": "Shipment deviation alert",
  "eventName": "Event name",
  "eventNames": "Event reason codes",
  "eventNamesPageDescription": "The global logic watch officers use to acknowledge or waive an event is managed here. Watch officers are still able to add in additional notes, general information, and job difficulty along with any options provided below. There will also always be an 'other' event reason if the options below do not work with the specified event.",
  "event_no_container_subscription_found_shipment_event": "No container subscription found",
  "event_no_device_tracking_at_flight_departure_shipment_event": "No device tracking at flight departure",
  "event_non_red_zone_restart": "Non-Redzone stop start",
  "event_non_redzone_stop": "Non-Redzone stop",
  "event_non_risk_zone_no_tracking_shipment_event": "Non-Risk zone no tracking alert",
  "event_no_route_between_ports_shipment_event": "No route between ports",
  "eventNotes": "Event notes",
  "event_no_tracking_shipment_event": "No tracking alert",
  "event_no_vessel_info_shipment_event": "No vessel info",
  "eventOccurred": "Event occurred",
  "event_ocean_mode_warning_at_destination_shipment_event": "Device warning - ocean mode at destination port",
  "event_ocean_mode_warning_at_origin_shipment_event": "Device warning - ocean mode at origin port",
  "event_openMicTractorSlowdown": "Open mic zone tractor slowdown",
  "event_openMicZoneEnter": "OpenMic zone entry",
  "event_openMicZoneExit": "OpenMic zone exit",
  "event_outOfHoursSeaportDeparture": "Out of hours seaport departure",
  "event_outOfNetworkCarrier": "Out-of-network carrier",
  "event_panic_alert_shipment_event": "Panic alert",
  "event_partialDelivery": "Partial delivery",
  "event_partial_delivery_manual_shipment_event": "Partial delivery (manual)",
  "event_pickupApprovalRequested": "Pickup approval requested",
  "event_pickup_without_tracking_shipment_event": "Pickup submitted with no tracking",
  "event_pilferage_manual_incident_shipment_event": "Pilferage",
  "event_plane_delayed_shipment_event": "Flight delay event",
  "event_plane_departure_shipment_event": "Departure from airport location",
  "event_planned_route_deviation_shipment_event": "Route deviation alert",
  "event_planningApprovalRequested": "Planning approval requested",
  "event_portContainerWellnessCheck": "Container wellness check (port)",
  "event_preclearanceApprovalRequested": "Preclearance approval requested",
  "event_preclearanceSubmissionOverdue": "Preclearance submission overdue",
  "event_qrWebpageAccess": "Shipment QR webpage access",
  "event_qualityReviewStatusChange": "QR status updated",
  "event_railContainerWellnessCheck": "Container wellness check (rail)",
  "eventReasonArrayError": "*Every event reason list must have at least 1 item",
  "eventReasonCommaError": "Event reason should not contain comma",
  "eventReasonsSubtitle": "Select a reason",
  "eventReceived": "Event received",
  "event_recovered_manual_incident_shipment_event": "Recovered",
  "event_redFlagPhotoAlert": "Red flag photo - USDOT",
  "event_red_zone_crossed_shipment_event": "Redzone exit",
  "event_red_zone_restart": "Redzone stop start",
  "event_redzoneTractorSlowdown": "Redzone tractor slowdown",
  "event_regular_restart": "Stop start",
  "event_rejectDelivery": "User rejected delivery",
  "event_removeFromConvoy": "Shipment removed from convoy",
  "event_risk_zone_no_tracking_shipment_event": "Risk zone no tracking alert",
  "eventRoute": "Event route",
  "events": "Events",
  "event_safe_zone_restart": "Safezone stop start",
  "event_safezoneTractorSlowdown": "Safezone tractor slowdown",
  "event_seal_low_battery_level_shipment_event": "Low battery - bluetooth seal",
  "event_sealOpenAndStopCompound": "Seal open & Stop(compound)",
  "event_separation_shipment_event": "Separation alert",
  "event_ship_departure_shipment_event": "Departure from seaport location",
  "event_shipment_awaiting_pickup_shipment_event": "Awaiting pickup",
  "event_shipment_closed_shipment_event": "Closed",
  "event_shipmentInfoValidation": "Shipment info validation",
  "event_shipment_in_route_to_pickup_shipment_event": "In route to pickup",
  "event_shipment_moved_to_at_pickup_shipment_event": "Shipment moved to at pickup",
  "event_shipmentReportedIssues": "Shipment reported issues",
  "event_shipmentStaging": "Shipment staging",
  "event_shipment_status_closed": "Shipment closed",
  "event_shipment_status_in_transit": "Shipment re-opened",
  "event_shock_shipment_event": "Shock alert",
  "event_snoozed": "Snoozed alert",
  "eventSource_api": "API",
  "eventSource_app": "App",
  "eventSource_auto": "Auto",
  "eventSource_device": "Device",
  "eventSource_electronics": "Electronics",
  "eventSource_import": "Import",
  "eventSource_loadLock": "Load lock",
  "eventSource_milestone": "Milestone",
  "eventSource_mobile": "Mobile",
  "eventSource_mobileApplication": "Mobile application",
  "eventSource_observer": "Observer",
  "eventSource_overhaulContainerTracking": "Overhaul container tracking",
  "eventSource_plane": "Plane",
  "eventSource_rmo": "RMO",
  "eventSource_scGo": "SC Go",
  "eventSource_sensorDevice": "Sensor device",
  "eventSource_ship": "Ship",
  "eventSource_tagDevice": "Tag device",
  "eventSource_tractor": "Tractor",
  "eventSource_trailer": "Trailer",
  "eventSource_train": "Train",
  "eventSource_web": "Web",
  "eventSource_worker": "Background app processing",
  "event_splitShipment": "Split shipment",
  "event_spoiled_manual_incident_shipment_event": "Spoiled",
  "event_stationary": "Motion status change - stationary",
  "event_stop": "Stop",
  "event_stop_event": "Stop",
  "event_subscribed_to_flight_alert_shipment_event": "Subscribed to flight",
  "eventsWithAttachments": "Events with attachments",
  "eventsWithNotes": "Events with notes",
  "event_tagReunited": "Tag reunited",
  "event_tagSeparated": "Tag separation detected",
  "event_telematicsJamming": "Telematics jamming",
  "event_telematics_unavailable_manual_shipment_event": "Telematics unavailable",
  "event_temperature_shipment_event": "Temperature alert",
  "event_theft_manual_incident_shipment_event": "Theft",
  "event_tilt_shipment_event": "Tilt alert",
  "event_tractorInactivePrePickupLocation": "Pre pickup tractor inactive",
  "event_tractorSlowdown": "Tractor slowdown",
  "event_tractor_stolen_shipment_event": "Confirmed theft",
  "event_traffic_accident_manual_incident_shipment_event": "Traffic accident",
  "event_trailerInactivePrePickupLocation": "Pre pickup trailer inactive",
  "event_tts_threshold_exceeded_shipment_event": "TTS threshold exceeded",
  "event_tts_validated_duration_exceeded_shipment_event": "TTS validated duration exceeded",
  "eventType": "Event type",
  "event_unapproved_carrier_shipment_event": "Unapproved carrier",
  "event_unapproved_driver_shipment_event": "Unapproved driver",
  "event_unexpectedActualCarrier": "Unexpected actual carrier",
  "event_unplanned_detention_time_exceeded_shipment_event": "Unplanned stop detention alert",
  "event_unplanned_restart": "Unplanned stop start",
  "event_unplannedStop": "Unplanned stop",
  "event_updatedFlightInfo": "Updated flight info",
  "event_updated_vessel_info_shipment_event": "Updated vessel info",
  "eventWaived": "Event waived",
  "eventWaivedByUser": "Event waived by {userName}",
  "event_weather": "Weather",
  "event_wrong_flight_number_alert_shipment_event": "Wrong flight number alert",
  "exceedDevicesExportLimit": "The current selection contains more than 10,000 devices. Please apply additional filters to reduce the amount of devices.",
  "exceedDuplicateRoutesLimitError": "The current duplicate settings will generate more than the maximum of {value} routes. Please update the number of Origins/Destinations to reduce the number of routes to be created",
  "exceedExportLimit": "The current selection contains more than 10,000 routes. Please apply additional filters to reduce the amount of routes.",
  "exceedLocationsExportLimit": "The current selection contains more than 10,000 locations. Please apply additional filters to reduce the amount of locations.",
  "exceedTagsExportLimit": "The current selection contains more than 10,000 tags. Please apply additional filters to reduce the amount of tags.",
  "exclude": "Exclude",
  "excludeArrivalSeaportDelay": "Exclude arrival at destination seaport delay",
  "existingLocations": "My existing locations",
  "expand": "Expand",
  "expandAll": "Expand all",
  "expandAssetCards": "Expand asset cards",
  "expandWatchableStatus": "Expand watchable status for shipments without tracking",
  "expected": "Expected",
  "expectedDeliveryTime": "Expected delivery time",
  "expectedRoute": "Expected route",
  "expiredLicenseStatus.expired": "Expired",
  "expiredLicenseStatus.notApplicable": "Not applicable",
  "expiredLicenseStatus.notCompleted": "Not completed",
  "expiredLicenseStatus.valid": "Valid",
  "export": "Export",
  "exportData": "Export data",
  "exportDeviceData": "Export device data",
  "exportDeviceDataTitle": "Export {device_id} data",
  "exportDevices": "Export devices",
  "exportDeviceSettings": "Export device settings",
  "exportFile_shipmentRisk": "Shipment risk",
  "exportGateways": "Export gateways",
  "exporting": "Exporting...",
  "exportingDevice": "Exporting device",
  "exportingDevices": "Exporting devices",
  "exportingGateways": "Exporting gateways",
  "exportingLocations": "Exporting locations",
  "exportingPingData": "Exporting ping data",
  "exportingRoutes": "Exporting routes",
  "exportingTags": "Exporting tags",
  "exportingTrackingPings": "Exporting tracking pings",
  "exportingUsers": "Exporting users",
  "exportIsUnavailable": "Export is unavailable",
  "exportLocations": "Export locations",
  "exportRoutes": "Export routes",
  "exportTags": "Export tags",
  "exportTo": "Export to...",
  "exportToFormat": "Export to {format}",
  "exportToPdf": "Export to PDF",
  "extendedDwellTime": "Extended dwell time",
  "extension": "Extension",
  "externalLocations": "External locations",
  "extraFields": "Extra fields",
  "extraFields.tab_instructions": "Instructions",
  "extraFields.tab_translations": "Translations",
  "fahrenheit": "Fahrenheit",
  "failed": "Failed",
  "false": "False",
  "fewSeconds": "a few seconds",
  "fields": "Fields",
  "fieldStatus": "Field status",
  "fieldWasRenamedTo": "{from} was renamed to {to}.",
  "fileCannotBeDownloaded": "Error. The file cannot be downloaded.",
  "fileCannotBeUploaded": "Error. The file cannot be uploaded.",
  "fileName": "File name",
  "fillFirstPickup": "Please fill first pickup location, it will change value of the last delivery location of the previous segment.",
  "fillLastDeliveryOfPrevSegm": "Please fill last delivery location from previous segment.",
  "fillReqFields": "Please fill in required fields to save the shipment",
  "fillSameFirstPickup": "Please fill the same first pickup location for this shipment.",
  "filter": "Filter",
  "filterBy": "Filter by",
  "filterByAssociations": "Filter by associations",
  "filterByFinalDestination": "Filter by final destination",
  "filterCustList": "Filter customers list",
  "filterName": "Filter name",
  "filterPlaceholder_violationTypes": "All violation types",
  "filters": "Filters",
  "finalDeliveryGeofence": "Final delivery geofence",
  "finalDestination": "Final destination",
  "finalDuration": "Final duration",
  "finish_shipment_event": "PoD submission",
  "firstBatteryLevelAlert": "First battery level alert (%)",
  "firstBatteryLevelMovingPingRate": "First battery level moving ping rate",
  "firstBatteryLevelMovingPingRateRailTooltip": "These settings will only apply over the rail settings tive devices will be mapped differently than the rest of the supported devices: if settings are at 15min then apply 20min if 4h then apply 6h if 8h then apply 12h",
  "firstBatteryLevelMovingPingRateRoadTooltip": "These are the battery level alert settings for road, air and ocean. Note: battery ping rate automation is only applied to road segments",
  "firstBatteryLevelStationaryPingRate": "First battery level stationary ping rate",
  "firstName": "First name",
  "firstNamePlaceholder": "Enter first name",
  "firstNotif": "First notification",
  "firstTimeCarrier.eventDescription": "Stay vigilant and carefully review the Carrier's details during pickup submission.",
  "firstTimeDriver.eventDescription": "Stay vigilant and carefully review the Driver's details during pickup submission.",
  "flag": "Flag",
  "flashFallback": "Flash fallback",
  "flashFallbackHint": "If enabled and the device is unable to report then the message is stored in flash memory and sent to the server on the next successful connection",
  "flatbed": "Flatbed",
  "flighNumber": "Flight number",
  "flight": "Flight",
  "flightCancelledAlert": "Flight cancelled alert",
  "flightDelayedAlert": "Flight delayed alert",
  "flightDelayedAlertMinutes": "Flight delayed alert (minutes)",
  "flightDelayedAlertSubSegments": "Flight delayed alert having subsequent plane segments (minutes)",
  "flight_mode": "Flight mode",
  "flight_mode_desc": "Flight mode enables device settings for flight shipments",
  "flying-travel": "Pilot/Flying J",
  "FMCSA.label_activeStatus": "FMCSA > Active status",
  "FMCSA.label_authorizedForHireStatus": "FMCSA > Authorised for hire status",
  "FMCSA.label_authorizedForHireStatusShort": "Authorised for hire status",
  "FMCSA.label_driverOutOfServiceViolationRate": "FMCSA > Driver Out-of-Service violation rate",
  "FMCSA.label_driverOutOfServiceViolationRateShort": "Driver Out-of-Service violation rate",
  "FMCSA.label_driverViolationRate": "FMCSA > Driver violation rate",
  "FMCSA.label_driverViolationRateShort": "Driver violation rate",
  "FMCSA.label_drugArrestsRate": "FMCSA > Drug arrests rate",
  "FMCSA.label_drugArrestsRateShort": "Drug arrests rate",
  "FMCSA.label_expiredMCSForm": "FMCSA > MCS form submitted more than 3 years ago",
  "FMCSA.label_operatingAuthority": "FMCSA > Operating authority status",
  "FMCSA.label_operatingAuthorityShort": "Operating authority status",
  "FMCSA.label_saferStatus": "FMCSA > Safer status",
  "FMCSA.label_saferStatusUpdatedAt": "FMCSA > Safer status last updated at",
  "FMCSA.label_safetyRating": "FMCSA > Safety rating",
  "FMCSA.label_safetyRatingShort": "Safety rating",
  "FMCSA.label_totalViolationRate": "FMCSA > Total violation rate",
  "FMCSA.label_totalViolationRateShort": "Total violation rate",
  "FMCSA.label_usdotStatus": "FMCSA > USDOT status",
  "FMCSA.label_usdotStatusShort": "USDOT status",
  "FMCSA.label_vehicleOutOfServiceViolationRate": "FMCSA > Vehicle Out-of-Service violation rate",
  "FMCSA.label_vehicleOutOfServiceViolationRateShort": "Vehicle Out-of-Service violation rate",
  "FMCSA.violationRate": "FMCSA > Violation rate",
  "followingRoutesCantBeDuplicated": "The following routes could not be duplicated:",
  "for": "For",
  "forbiddenToStop": "Forbidden to stop",
  "forward": "Forward",
  "fraudwatch.description_carrierAverageViolationRate": "How often this carrier breaks compliance rules. A low rate indicates safe and reliable operating conditions.",
  "fraudwatch.description_carrierDetailsPlaceholder": "Search for a carrier and select it to view its risk assessment.",
  "fraudwatch.description_carrierFMCSADriverOOSRate": "How often drivers are put “Out of service” during FMCSA inspections. Low rates demonstrate safety and regulatory adherence.",
  "fraudwatch.description_carrierFMCSAOperationalKPIs": "Track critical safety and compliance statistics sourced from the FMCSA to ensure your fleet operates within federal regulations, enhancing reliability and reducing risk",
  "fraudwatch.description_carrierFMCSAOperationalVehicleOOSRate": "How often vehicles are put “Out of service” during FMCSA inspections. Low rates demonstrate safety and regulatory adherence.",
  "fraudwatch.description_carrierFMCSAViolationRate": "How often carriers experience FMCSA violations during FMCSA inspections. Low rates demonstrate safety and regulatory adherence.",
  "fraudwatch.description_carrierIncidentRate": "How often thefts and pilferages are experienced by carriers in your network. Lower rates reflect safer carrier operations.",
  "fraudwatch.description_carrierOhOperationalKPIs": "Based on the carrier's performance with Overhaul-tracked shipments: the average number of compliance violations per shipment handled by the carrier. A consistently low rate indicates better adherence to regulations and standards.",
  "fraudwatch.description_categoryDoesNotExist": "Such category does not exist",
  "fraudwatch.description_driverDetailsEmptyState": "Search for a driver and select it to view its risk assessment.",
  "fraudwatch.description_driverSearchEmptyState": "Type a driver's name or phone number",
  "fraudwatch.description_fmcsaAverageDriverOOSRate": "How often drivers are put “Out of service” during FMCSA inspections. Low rates demonstrate safety and regulatory adherence.",
  "fraudwatch.description_fmcsaAverageDrugArrestsRate": "How often drivers are arrested during FMCSA inspections due to drugs being found / influence detected. Low rates demonstrate effective screening and enforcement.",
  "fraudwatch.description_fmcsaAverageVehicleOOSRate": "How often vehicles are put “Out of service” during FMCSA inspections. Low rates demonstrate safety and regulatory adherence.",
  "fraudwatch.description_fmcsaAverageViolationRate": "How often carriers experience violations from FMCSA inspections. Low rates demonstrate better operational practices and compliance with safety standards.",
  "fraudwatch.description_fmcsaOperationalKPIs": "Track critical safety and compliance statistics sourced from the FMCSA to ensure your fleet operates within federal regulations, enhancing reliability and reducing risk.",
  "fraudwatch.description_groupAverageIncidentRate": "How often thefts and pilferages are experienced by carriers in your group. Lower rates reflect safer carrier operations.",
  "fraudwatch.description_groupAverageViolationRate": "How often carriers in your group break compliance rules. A low rate indicates safe and reliable operating conditions.",
  "fraudwatch.description_groupOhOperationalKPIs": "Showing data for carriers in your group that have transported loads with Overhaul",
  "fraudwatch.description_myNetworkEmptyState": "Add carriers to your network to start monitoring their risks.",
  "fraudwatch.description_networkAverageIncidentRate": "How often thefts and pilferages are experienced by carriers in your network. Lower rates reflect safer carrier operations.",
  "fraudwatch.description_networkAverageViolationRate": "How often carriers in your network break compliance rules. A low rate indicates safe and reliable operating conditions.",
  "fraudwatch.description_newCarriersEmptyState": "New carriers added to your network will appear here.",
  "fraudwatch.description_noCarriersFound": "Review the USDOT number to make sure there are no typos in it or type in a new query",
  "fraudwatch.description_ohOperationalKPIs": "Showing data for carriers in your network that have transported loads with Overhaul",
  "fraudwatch.description_searchForCarriers": "Type a name, USDOT or MC number to find any carrier.",
  "fraudwatch.description_selectCarrierFromTheList": "Click on a carrier name to view the risk score, charts and threats breakdown.",
  "fraudwatch.description_trustedCarriersEmptyState": "Mark carriers as trusted once you've verified they meet your safety standards.",
  "fraudwatch.description_trustedDriversEmptyState": "Mark drivers as trusted once you've verified they meet your safety standards.",
  "fraudwatch.description_unauthorizedCarriersEmptyState": "Mark carriers as unauthorized when you decide they're too risky to work with.",
  "fraudwatch.description_unauthorizedDriversEmptyState": "Mark drivers as unauthorized when you decide they're too risky to work with.",
  "fraudwatch.infoGroup_FMCSAMirror": "FMCSA mirror",
  "fraudwatch.infoGroup_MOTUSLegacy": "MOTUS / legacy",
  "fraudwatch.label_archivedCarriers": "Archived carriers",
  "fraudwatch.label_carrierNetworkOverview": "Carrier network overview",
  "fraudwatch.label_driverSearch": "Search by driver name or phone",
  "fraudwatch.label_firstSeenInOverhaul": "First seen in Overhaul",
  "fraudwatch.label_fmcsaCarrierList": "Found in FMCSA",
  "fraudwatch.label_groupByRiskLevel": "Group by risk level",
  "fraudwatch.label_groupOverview": "Group overview",
  "fraudwatch.label_inNetwork": "In network",
  "fraudwatch.label_myCarrierNetwork": "My carrier network",
  "fraudwatch.label_myDriverNetwork": "My driver network",
  "fraudwatch.label_networkByRiskLevel": "Network by risk level",
  "fraudwatch.label_newCarriers": "New carriers",
  "fraudwatch.label_oneInCountOfInspections": "1 in {count} inspections",
  "fraudwatch.label_oneInCountOfShipments": "1 in {count} shipments",
  "fraudwatch.label_oneInEvents": "1 in {count} events",
  "fraudwatch.label_outOfNetwork": "Out of network",
  "fraudwatch.label_ratePerEachEvent": "{rateValue} per event",
  "fraudwatch.label_ratePerInspection": "{rateValue} per inspection",
  "fraudwatch.label_ratePerShipment": "{rateValue} per shipment",
  "fraudwatch.label_recentlyAddedToNetwork": "Most recently added to network",
  "fraudwatch.label_searchResults": "Search results",
  "fraudwatch.label_thirtyDaysChange": "Top score changes (past 30 days)",
  "fraudwatch.label_trustedCarriers": "Trusted carriers",
  "fraudwatch.label_trustedDrivers": "Trusted drivers",
  "fraudwatch.label_unauthorizedCarriers": "Unauthorized carriers",
  "fraudwatch.label_unauthorizedDrivers": "Unauthorized drivers",
  "fraudwatch.label_uncategorizedCarriers": "Uncategorized carriers",
  "fraudWatchSettings.successMessage_saved": "FraudWatch settings are successfully saved",
  "fraudwatch.subgroup_authorityAndRegistrationStatus": "Authority & registration status",
  "fraudwatch.subgroup_cargoAndFreightAuthority": "Cargo & freight authority",
  "fraudwatch.subgroup_contactAndAddressRisk": "Contact & address risk",
  "fraudwatch.subgroup_contactAndIdentity": "Contact & identity",
  "fraudwatch.subgroup_fleetAndOperations": "Fleet & operations",
  "fraudwatch.subgroup_insuranceAndBonds": "Insurance & bonds",
  "fraudwatch.subgroup_safetyAndViolations": "Safety & violations",
  "fraudwatch.subgroup_score": "Score",
  "fraudwatch.subgroup_sharedIdentifiersRisk": "Shared identifiers risk",
  "fraudwatch.successMessage_carrierRemovedFromDirectlyContractedNetwork": "Carrier removed from directly-contracted network. Carrier still in-network because it's provided by one or more Broker(s). Open \"Portals\" to see which Broker(s) is managing network access for this carrier.",
  "fraudwatch.title_archivedCarriersEmptyState": "No archived carriers yet",
  "fraudwatch.title_carrierDetailsPlaceholder": "Carrier details will appear here",
  "fraudwatch.title_driverDetailsEmptyState": "Driver details will appear here",
  "fraudwatch.title_driverSearchEmptyState": "Search for drivers",
  "fraudwatch.title_fmcsaOperationalKPIs": "FMCSA operational KPIs",
  "fraudwatch.title_myNetworkEmptyState": "No carriers in your network yet",
  "fraudwatch.title_newCarriersEmptyState": "No new carriers yet",
  "fraudwatch.title_noCarriersFound": "No carriers found",
  "fraudwatch.title_noDriversFound": "No drivers found",
  "fraudwatch.title_ohOperationalKPIs": "Overhaul operational KPIs",
  "fraudwatch.title_searchForCarriers": "Search for carriers",
  "fraudwatch.title_selectCarrierFromTheList": "Select a carrier to view details",
  "fraudwatch.title_topCarriersByNonCompliance": "Top 10 carriers by non-compliance",
  "fraudwatch.title_topRiskiestDrivers": "Top 10 riskiest drivers",
  "fraudwatch.title_trustedCarriersEmptyState": "No trusted carriers yet",
  "fraudwatch.title_trustedDriversEmptyState": "No trusted drivers yet",
  "fraudwatch.title_unauthorizedCarriersEmptyState": "No unauthorized carriers yet",
  "fraudwatch.title_unauthorizedDriversEmptyState": "No unauthorized drivers yet",
  "freezerDoorLocation": "Freezer door location",
  "freight_forwarder": "Freight forwarder",
  "freightForwarderAbbr": "FRF",
  "frequency_daily": "Daily",
  "frequency_monthly": "Monthly",
  "frequency_weekly": "Weekly",
  "friday": "Friday",
  "from": "From",
  "fuel": "Truck/Fuel stops",
  "fuelLevels": "Fuel levels",
  "fulfillmentLocation": "Fulfillment location",
  "fullAtTimeDate": "{weekDayMonthYear} [at] {time}",
  "fullMapView": "Full map view",
  "fullName": "Full name",
  "fyiTemplateType": "FYI",
  "gateCode": "Gate code",
  "gatewayChargingStatus_charging": "Charging",
  "gatewayChargingStatus_notCharging": "Not charging",
  "gatewayInstallationType_autoclave": "Autoclave",
  "gatewayInstallationType_deliveryVehicle": "Delivery vehicle",
  "gatewayInstallationType_outbound": "Outbound",
  "gatewayInstallationType_portable": "Portable",
  "gatewayInstallationType_sterilization": "Sterilization",
  "gatewayReportingStatus_notReporting": "Not reporting",
  "gatewayReportingStatus_poweredOff": "Device is powered off",
  "gatewayReportingStatus_reporting": "Reporting",
  "general": "General",
  "generalInfoMobile": "General info",
  "generalInformation": "General information",
  "generalSettings": "General settings",
  "generalShipmentInfo": "General shipment info",
  "generateEtaStatus": "Generate ETA status",
  "generateReport": "Generate report",
  "geoArrivalDwellTime": "Geofence arrival dwell time (minutes)",
  "geofence": "Geofence",
  "geofenceBuffer": "Buffer",
  "geofenceEditor": "Geofence editor",
  "geofenceToggle": "Geofences",
  "geographicalRegion_europe": "Europe",
  "geographicalRegion_global": "Global",
  "geographicalRegion_northAmerica": "US, Canada",
  "geographicalRegion_ocean": "Ocean",
  "geographicalRegion_restOfWorld": "Asia, rest of world",
  "geographicalRegion_southAmerica": "Mx, Brazil, Latin America",
  "getInformationBasedOnVin": "Get information based on VIN (vehicle identification number)",
  "givenName": "Given name",
  "global": "Global",
  "globalDashboards": "Global dashboards",
  "globalFiltering": "Global filtering",
  "globalRailOverlay": "Global rail overlay",
  "globalTemplate": "Global template",
  "goBack": "Go back",
  "gpsDevice": "GPS device",
  "gpsLocation": "GPS location",
  "grainCapacity": "Grain capacity",
  "grossTonnage": "Gross tonnage",
  "grossVehicleWeightRating": "Gross vehicle weight rating",
  "groupByPriority": "Group by event priority",
  "groupError": "This group name already exists",
  "groupFilter": "Group filter",
  "groupGraph.description_emptyState": "Add carriers to your group to start seeing data here.",
  "grouplink_admin": "Admin",
  "grouplink_dashboards": "Dashboards",
  "grouplink_fraudwatch": "FraudWatch",
  "grouplink_healthcare": "Healthcare",
  "grouplink_insights": "Insights",
  "grouplink_inventory": "Inventory",
  "grouplink_medicalDevices": "Medical devices",
  "grouplink_quality": "Quality",
  "grouplink_reports": "Reports",
  "grouplink_risk": "Risk Monitor",
  "grouplink_setup": "Setup",
  "grouplink_shipmentConnectGo": "Shipment Connect Go",
  "grouplink_visibility": "Visibility",
  "groupName": "Group name",
  "groupSettings": "GROUP SETTINGS",
  "groupType": "Group type",
  "gsocMonitored": "GSOC monitored workflow",
  "gsocMonitoredColumn": "GSOC monitored",
  "gsocTeamColumn": "GSOC team",
  "gsocTeamLabel": "GSOC team (brand)",
  "hasActiveShipment": "Has active shipment",
  "HBOL": "HBOL",
  "headerLogo": "Header logo",
  "heading_away_alert_violation": "Shipment deviation alert",
  "healtcare.errorMessage_cannotEditAppointment": "Appointment in status \"{status}\" cannot be edited",
  "healthcare.amountPerMonth": "<strong>{count}</strong> per month",
  "healthcare.appointmentEvent_arrivedAtAppointmentLocation": "Arrived at appointment location",
  "healthcare.appointmentEvent_assigned": "Medical devices assigned",
  "healthcare.appointmentEvent_atAgency": "Medical devices at agency",
  "healthcare.appointmentEvent_autoclaveWarning": "Autoclave warning",
  "healthcare.appointmentEvent_cancelled": "Cancelled",
  "healthcare.appointmentEvent_checkedIn": "Medical devices checked in",
  "healthcare.appointmentEvent_droppedOff": "Dropped off",
  "healthcare.appointmentEvent_leadTimeAlert": "Lead time alert",
  "healthcare.appointmentEvent_medicalDeviceOffSite": "Medical device off-site",
  "healthcare.appointmentEvent_medicalDevicesDepartedForAppointment": "Medical devices departed for appointment",
  "healthcare.appointmentEvent_POComplete": "PO complete",
  "healthcare.appointmentEvent_postOpFailureToPickup": "Post-op failure to pickup",
  "healthcare.appointmentEvent_procedureComplete": "Procedure complete",
  "healthcare.appointmentEvent_readyForPickup": "Ready for pickup",
  "healthcare.appointmentEvent_readyForProcedure": "Ready for procedure",
  "healthcare.appointmentEventSource_asset": "Asset",
  "healthcare.appointmentEventSource_auto": "Auto",
  "healthcare.appointmentEventSource_manual": "Manual",
  "healthcare.appointmentEventSource_medicalDevice": "Medical device",
  "healthcare.appointmentEventSource_milestone": "Milestone",
  "healthcare.appointmentEvent_sterilizationWarning": "Sterilization warning",
  "healthcare.appointmentEvent_submitted": "Submitted",
  "healthcare.appointmentHistory": "Appointment history",
  "healthcare.appointmentStatus_assigned": "Medical devices assigned",
  "healthcare.appointmentStatus_atAgency": "At agency",
  "healthcare.appointmentStatus_cancelled": "Cancelled",
  "healthcare.appointmentStatus_checkedIn": "Checked in",
  "healthcare.appointmentStatus_droppedOff": "Dropped off",
  "healthcare.appointmentStatus_inRouteInTransit": "In route / in transit",
  "healthcare.appointmentStatus_inTransit": "In transit",
  "healthcare.appointmentStatus_leadTimeAlert": "Lead time alert",
  "healthcare.appointmentStatus_medicalDeviceOffSite": "Medical device off-site",
  "healthcare.appointmentStatus_poComplete": "PO complete",
  "healthcare.appointmentStatus_postOpFailureToPickup": "Post-op failure to pickup",
  "healthcare.appointmentStatus_procedureComplete": "Procedure complete",
  "healthcare.appointmentStatus_readyForPickup": "Ready for pickup",
  "healthcare.appointmentStatus_readyForProcedure": "Ready for procedure",
  "healthcare.appointmentStatus_sterilizationWarning": "Sterilization warning",
  "healthcare.appointmentStatus_submitted": "Submitted",
  "healthcareAppointmentWorkflow.description_leadTimeAlert": "Amount of hours before lead time elapses to generate the lead time alert event",
  "healthcareAppointmentWorkflow.description_procedureComplete": "This event is automatically generated if no closing event occurs within a configurable time window after the appointment",
  "healthcareAppointmentWorkflow.label_autoclaveTime": "Autoclave time",
  "healthcareAppointmentWorkflow.label_leadTimeAlert": "Lead time alert",
  "healthcareAppointmentWorkflow.label_procedureCompletionWindow": "Procedure completion window",
  "healthcareAppointmentWorkflow.label_sterilizationTime": "Sterilization time",
  "healthcareAppointmentWorkflow.label_toteReadyLeadTime": "Tote & “Other” ready lead time",
  "healthcareAppointmentWorkflow.label_trayReadyLeadTime": "Tray ready lead time",
  "healthcareAppointmentWorkflow.label_workflowTimingValues": "Workflow timing values",
  "healthcare.consignedStatus_consigned": "Consigned",
  "healthcare.consignedStatus_nonConsigned": "Non-consigned",
  "healthcare.createMedicalDevice": "Add device",
  "healthcare.currentAppointment": "Current appointment",
  "healthcare.currentMonth": "Current",
  "healthcare.currentWeek": "Current",
  "healthcare.description_autoclaveCount": "Monthly count of autoclave cycles for this tray, regardless of appointment",
  "healthcare.description_deactivateAttribute": "While deactivated, this attribute cannot be added to any medical devices in the future",
  "healthcare.description_logisticalTurns": "A complete trip from a distribution center to one or more hospitals/surgical centers and back, counts as one logistical turn",
  "healthcare.description_sterilizationCount": "Monthly count of autoclave cycles for this tray, regardless of appointment",
  "healthcare.dwellRange_hours": "{hoursFrom}-{hoursTo} hours",
  "healthcare.dwellRange_hoursPlus": "{hoursFrom}+ hours",
  "healthcare.errorMessage_cannotEditAppointment": "Appointment in status \"{status}\" cannot be edited",
  "healthcare.eventSource_manual": "Manual",
  "healthcare.eventSource_medicalDevice": "Medical device",
  "healthcare.eventSource_milestone": "Milestone",
  "healthcare.exportingMedicalDevices": "Exporting medical devices",
  "healthcare.exportMedicalDevices": "Export medical devices",
  "healthcare.futureAppointments": "Future appointments",
  "healthcare.helperText_currentLocation": "Name and address reflect the current location",
  "healthcare.helperText_medicalDeviceFamily": "A grouping of identical medical devices",
  "healthcare.helperText_medicalDeviceID": "Unique identifier for the specific medical device",
  "healthcare.helperText_productFamily": "Clinical category containing multiple medical device families",
  "healthcare.helperText_productLine": "Clinical category containing multiple product families",
  "healthcare.helperText_utilizationTarget": "Corporate-defined usage goal for how often the device should be used within a monthly period.",
  "healthcare.infoMessage_deviceNotUsed": "Device has not been used in the past months",
  "healthcare.infoMessage_logisticalTurnsDisabledByWorkflow": "Turns are disabled via workflow and are not being tracked.",
  "healthcare.infoMessage_noCurrentAppointment": "No current appointment",
  "healthcare.infoMessage_noCurrentAppointments": "No current appointments",
  "healthcare.infoMessage_noFutureAppointments": "No future appointments",
  "healthcare.infoMessage_noRecoveredDevices": "No associated devices have been recovered",
  "healthcare.infoMessage_selectedDevicesFiltering": "Selected devices are always shown at the top, even if they don’t match current filters.",
  "healthcare.label_activeAlerts": "Active alerts",
  "healthcare.label_activeExceptions": "Active exceptions",
  "healthcare.label_addNewAppointmentSubtype": "Add new appointment sub-type",
  "healthcare.label_addNewAppointmentType": "Add new appointment type",
  "healthcare.label_addNewGroupType": "Add new group type",
  "healthcare.label_addNewMedicalDeviceFamily": "Add new family",
  "healthcare.label_addNewMedicalDeviceGroup": "Add new group",
  "healthcare.label_addNewMedicalDeviceGroupType": "Add new group type",
  "healthcare.label_addNewPhysician": "Add new physician name",
  "healthcare.label_addNewProductFamily": "Add new product family",
  "healthcare.label_addNewProductLine": "Add new product line",
  "healthcare.label_appointment": "Appointment",
  "healthcare.label_appointmentDateRange": "Appointment date range",
  "healthcare.label_appointmentDatetime": "Appointment date & time",
  "healthcare.label_appointmentDetails": "Appointment details",
  "healthcare.label_appointmentLocation": "Appointment location",
  "healthcare.label_appointmentStatus": "Appointment status",
  "healthcare.label_appointmentSubType": "Appointment sub-type",
  "healthcare.label_appointmentTimeline": "Appointment timeline",
  "healthcare.label_appointmentType": "Appointment type",
  "healthcare.label_appointmentTypes": "Appointment types",
  "healthcare.label_assignMedicalDevice": "Assign medical device",
  "healthcare.label_assignMultipleMedicalDevices": "Assign {number} of {total} medical devices",
  "healthcare.label_autoclaveCount": "Autoclave count",
  "healthcare.label_changeMedicalDevice": "Change medical device",
  "healthcare.label_consigned": "Consigned",
  "healthcare.label_consignedLocation": "Consigned location",
  "healthcare.label_consignedStatus": "Consigned status",
  "healthcare.label_currentDwellingDeviceFamilies": "Current dwelling device families",
  "healthcare.label_currentDwellingDeviceFamiliesSubtitle": "Sorted by thresholds",
  "healthcare.label_deviceCannotBeDeactivated": "This device cannot be deactivated because it is assigned to an appointment",
  "healthcare.label_deviceFamilies": "Device families",
  "healthcare.label_exceptionBreakdown": "Exception breakdown",
  "healthcare.label_exceptionBreakdownSubtitle": "Active exceptions associated to active current devices",
  "healthcare.label_exceptionBreakdownTooltip": "A medical device may have multiple active exceptions simultaneously. As a result, it can appear in more than one exception category",
  "healthcare.label_exceptions": "Exceptions",
  "healthcare.label_excessiveDwellExceptionTooltip": "Device has stayed at one location longer than its excessive dwell threshold (default 48 hours). Open a device’s details to see its threshold.",
  "healthcare.label_families": "Families",
  "healthcare.label_familyName": "Family name",
  "healthcare.label_groupType": "Group type",
  "healthcare.label_groupTypes": "Group types",
  "healthcare.label_highestAutoclavedFamilies": "Highest autoclaved device families",
  "healthcare.label_highestAutoclavedFamiliesSubtitle": "Week over week",
  "healthcare.label_highestDwellingDevices": "Highest dwelling devices",
  "healthcare.label_highestDwellingDevicesSubtitle": "Devices with current highest dwell",
  "healthcare.label_importSurgicalAppointments": "Import surgical appointments",
  "healthcare.label_leastTurns": "Least turns",
  "healthcare.label_logisticalTurns": "Logistical turns",
  "healthcare.label_logisticalTurnsExceptionTooltip": "Logistical turns is a complete trip from a distribution center to one or more hospitals/surgical centers and back, counts as one logistical turn.",
  "healthcare.label_lowAutoclaveExceptionTooltip": "Low autoclave is not meeting the corporate monthly count of autoclave cycles for this tray, regardless of appointment.",
  "healthcare.label_lowAutoclaveForMonth": "Low autoclave for {month}",
  "healthcare.label_lowestAutoclavedFamilies": "Lowest autoclaves by device family",
  "healthcare.label_lowLogisticalTurnsForMonth": "Low logistical turns for {month}",
  "healthcare.label_lowUtilizationExceptionTooltip": "Low utilization is not meeting the corporate-defined usage goal for how often the device should be used within a monthly period.",
  "healthcare.label_lowUtilizationForMonth": "Low utilization for {month}",
  "healthcare.label_medicalDeviceArrivedAtLocation": "Medical device arrived at {location}",
  "healthcare.label_medicalDeviceDepartedFromLocation": "Medical device departed from {location}",
  "healthcare.label_medicalDeviceFamily": "Family",
  "healthcare.label_medicalDeviceFamilyName": "Medical device family name",
  "healthcare.label_medicalDeviceGroup": "Group",
  "healthcare.label_medicalDeviceGroups": "Groups",
  "healthcare.label_medicalDeviceGroupType": "Group type",
  "healthcare.label_medicalDeviceGroupTypes": "Group types",
  "healthcare.label_medicalDevices": "Medical devices",
  "healthcare.label_medicalDevicesByStatus": "Medical device by status",
  "healthcare.label_medicalDevicesByStatusSubtitle": "Current status of all active medical devices",
  "healthcare.label_mostTurns": "Most turns",
  "healthcare.label_noActiveAlerts": "There are no active alerts on your appointments",
  "healthcare.label_noActiveExceptions": "There are no active exceptions on your medical devices",
  "healthcare.label_noActiveMedicalDevices": "There are no active medical devices",
  "healthcare.label_noAppointments": "No appointments associated with your company",
  "healthcare.label_noAutoclaveData": "No autoclave data",
  "healthcare.label_noAvailableMedicalDevices": "No available medical devices to assign",
  "healthcare.label_noCurrentDwellingDeviceFamilies": "No devices are currently dwelling",
  "healthcare.label_noDeviceFamilies": "No device families",
  "healthcare.label_noFollowingAppointment": "No following appointment",
  "healthcare.label_noLogisticalTurnsData": "No logistical turns data",
  "healthcare.label_noMedicalDevices": "No medical devices associated with your company",
  "healthcare.label_noPriorAppointment": "No prior appointment",
  "healthcare.label_noSalesTeams": "No sales teams associated with your company",
  "healthcare.label_over30DaysRolling": "Over last 30 days",
  "healthcare.label_physician": "Physician",
  "healthcare.label_physicianName": "Physician name",
  "healthcare.label_physicians": "Physicians",
  "healthcare.label_postOpDateTime": "Post-Op date/time",
  "healthcare.label_preOpDateTime": "Pre-Op date/time",
  "healthcare.label_productFamilies": "Product families",
  "healthcare.label_productFamily": "Product family",
  "healthcare.label_productFamilyName": "Product family name",
  "healthcare.label_productLine": "Product line",
  "healthcare.label_productLines": "Product lines",
  "healthcare.label_productType": "Product type",
  "healthcare.label_proposedAppointment": "Proposed appointment",
  "healthcare.label_recoveredDevices": "Recovered devices",
  "healthcare.label_recoveredDevicesSubtitle": "In the past week",
  "healthcare.label_salesTeam": "Sales team",
  "healthcare.label_salesTeamMember": "Sales team member",
  "healthcare.label_salesTeams": "Sales teams",
  "healthcare.label_silentDeviceExceptionTooltip": "A silent device is a device that has not communicated for over 1 hour when at a distribution center or over 48 hours at any hospital or other location",
  "healthcare.label_sterilizationCount": "Sterilization count",
  "healthcare.label_surroundingAppointments": "Surrounding appointments",
  "healthcare.label_totalMedicalDevices": "Total medical devices",
  "healthcare.label_trackLogisticalTurns": "Track logistical turns",
  "healthcare.label_transferMedicalDevice": "Transfer medical device to another company",
  "healthcare.label_turns": "Turns",
  "healthcare.label_unresolvedLocation": "Unresolved location",
  "healthcare.label_unresolvedLocationTooltip": "We couldn't determine the location for this event. The location will update if more information becomes available.",
  "healthcare.label_upcomingAppointments": "Upcoming appointments",
  "healthcare.label_utilizationTarget": "Utilization target",
  "healthcare.lastPingDateThreshold_critical": "> 1 week",
  "healthcare.lastPingDateThreshold_never": "Never heard",
  "healthcare.lastPingDateThreshold_recent": "< 2 days",
  "healthcare.lastPingDateThreshold_stale": "2 days - 1 week",
  "healthcare.medicalDeviceEvent_arrivedAtAppointmentLocation": "Arrived at appointment location",
  "healthcare.medicalDeviceEvent_atAgency": "At agency",
  "healthcare.medicalDeviceEvent_autoclave": "Autoclave",
  "healthcare.medicalDeviceEvent_autoclaveWithLocation": "Autoclave {location}",
  "healthcare.medicalDeviceEvent_excessiveDwell": "Excessive dwell",
  "healthcare.medicalDeviceEvent_inTransit": "In transit",
  "healthcare.medicalDeviceEvent_inTransitToAppointmentLocation": "In transit to appointment location",
  "healthcare.medicalDeviceEvent_locationArrival": "Medical device arrived",
  "healthcare.medicalDeviceEvent_locationDeparture": "Medical device departed",
  "healthcare.medicalDeviceEvent_lowAutoclave": "Low autoclave",
  "healthcare.medicalDeviceEvent_lowLogisticalTurns": "Low logistical turns",
  "healthcare.medicalDeviceEvent_lowUtilization": "Low utilization",
  "healthcare.medicalDeviceEvent_procedureComplete": "Procedure complete",
  "healthcare.medicalDeviceEvent_readyForPickup": "Ready for pickup",
  "healthcare.medicalDeviceEvent_readyForProcedure": "Ready for procedure",
  "healthcare.medicalDeviceEvent_readyForReturn": "Ready for return",
  "healthcare.medicalDeviceEvent_reportFromAutoclave": "Reported from autoclave",
  "healthcare.medicalDeviceEvent_reportFromOutboundRoom": "Reported from outbound room",
  "healthcare.medicalDeviceEvent_reportFromSterilization": "Reported from sterilization",
  "healthcare.medicalDeviceEvent_silentDevice": "Silent device",
  "healthcare.medicalDeviceEvent_sterilization": "Sterilization",
  "healthcare.medicalDeviceEvent_unavailableForAppointment": "Moved to unavailable",
  "healthcare.medicalDeviceFamilySubtype_other": "Other",
  "healthcare.medicalDeviceFamilySubtype_tote": "Tote",
  "healthcare.medicalDeviceFamilySubtype_tray": "Tray",
  "healthcare.medicalDeviceIdentifier": "Medical device ID",
  "healthcare.medicalDeviceStatusChangeEvent_atLocation": "At location",
  "healthcare_medicalDeviceTimeline": "Medical device timeline",
  "healthcare.monthOverMonth": "Month over month",
  "healthcare.notification_autoclaved": "Autoclaved",
  "healthcare.notification_excessiveDwell": "Excessive dwell",
  "healthcare.notification_logisticalTurn": "Logistical turn",
  "healthcare.notification_lowAutoclave": "Low autoclaves",
  "healthcare.notification_lowLogisticalTurns": "Low logistical turns",
  "healthcare.notification_lowUtilization": "Low utilization",
  "healthcare.notification_silentDevice": "Silent device",
  "healthcare.title_createAppointment": "Create appointment",
  "healthcare.title_createMedicalDevice": "Create medical device",
  "healthcare.title_editAppointment": "Edit appointment",
  "healthcare.title_editMedicalDevice": "Edit medical device",
  "healthcare.validation_assignNumberOfDevices": "You can assign up to {number} devices",
  "height": "Height",
  "helperText_carrierWhitelist": "Carrier company names where whitelist name is an exact match will NOT generate watchlist alerts",
  "helperText_chooseMatchingResult": "Choose a matching result.",
  "helperText_defaultIs": "Default is {defaultValue}",
  "helperText_linkedPing": "Use an existing device ping to set this event's time and location.",
  "helperText_populatedFromCallerInfo": "Auto populated from caller information",
  "helperText_regeneratePinWarning": "Regenerating the PIN will revoke access for this user. They will be logged out of secureBOL and will need to log in again using the new PIN.",
  "helperText_riskScoreRange": "Enter any whole number from {min} to {max}.",
  "here": "Here",
  "hi": "Hi",
  "hide": "Hide",
  "hideAll": "Hide all",
  "hideAllAddresses": "Hide all addresses",
  "hideDetails": "Hide details",
  "hideNoAnswersOnChecklist": "Hide \"No\" answers on DDI",
  "high": "High",
  "highest": "Highest",
  "highLimitValue": "Upper {value}{units} limit",
  "highPriorityRisk": "High priority risk",
  "highPriorityRisks": "High priority risks",
  "High Priority Risks": "High priority risks",
  "highRisk": "High risk",
  "highRiskCount": "{count} high risk",
  "highRiskPopulation": "High risk population",
  "high_riskscore_alert_shipment_event": "High riskscore alert",
  "high_riskscore_violation": "High riskscore",
  "highRiskShipmentsByEventType": "High risk shipments by event type",
  "highRiskViolations": "High risk violations",
  "highSecurity": "Law enforcement",
  "highway": "Highway",
  "historyMapping": "History mapping",
  "home_restart": "Home stop start",
  "home_stop": "Home stop",
  "hospitalBeds": "Hospital beds",
  "hotzoneDetentionTime": "Hotzone detention time (minutes)",
  "hot_zone_restart": "Hotzone stop start",
  "hot_zone_restart_violation": "Hotzone stop start",
  "hotZones": "Hot zones",
  "hot_zone_stop": "Hotzone stop",
  "hotzone_stop": "Hotzone stop",
  "hotzoneStopDetentionTime": "Hotzone stop detention time (minutes)",
  "hotzone_stop_violation": "Hotzone stop",
  "hours": "Hours",
  "houseAirWaybill": "House air waybill",
  "hr": "Hr",
  "humidity": "Humidity",
  "humidityAlertDelay": "Humidity alert delay",
  "humidity_alert_violation": "Humidity alert",
  "humidityLowerLimitInPercents": "Lower humidity limit for devices (%)",
  "humidityRange": "Humidity range",
  "humidityRangeName": "Humidity range name",
  "humidity_settings": "Humidity settings",
  "humidity_shipment_event": "Humidity alert",
  "humidityTimeBreach": "Time range for humidity breach (minutes)",
  "humidityUpperLimitInPercents": "Upper humidity limit for devices (%)",
  "hypervergeDriverCheckStatus.failed": "Failed",
  "hypervergeDriverCheckStatus.notCompleted": "Not completed",
  "hypervergeDriverCheckStatus.passed": "Passed",
  "hypervergeDriverCheckStatus.requiresManualReview": "Requires manual review",
  "hypervergeStatus.approved": "Approved",
  "hypervergeStatus.autoApproved": "Auto approved",
  "hypervergeStatus.autoDeclined": "Auto declined",
  "hypervergeStatus.cancelledByUser": "User cancelled",
  "hypervergeStatus.declined": "Declined",
  "hypervergeStatus.errored": "Errored",
  "hypervergeStatus.manuallyApproved": "Manually approved",
  "hypervergeStatus.manuallyDeclined": "Manually declined",
  "hypervergeStatus.manualReviewRequired": "Requires manual review",
  "hypervergeStatus.neverStarted": "Never started",
  "IATA": "IATA",
  "ICAO": "ICAO",
  "icc_id_label": "ICC ID",
  "ICUBeds": "ICU beds",
  "id": "Id",
  "idealRange": "Ideal",
  "identicalRouteError": "Error. An identical route called {name} already exists.",
  "identityProviderType_azureAD": "Azure AD",
  "identityProviderType_OIDC": "OIDC",
  "identityProviderType_shared": "Shared",
  "ignition_off_shipment_event": "Engine ignition event (off)",
  "ignition_on_shipment_event": "Engine ignition event (on)",
  "ignitionStatus": "Ignition status",
  "imei": "Imei",
  "imeiNumber": "IMEI",
  "immediate": "Immediate",
  "imo": "Imo",
  "IMO": "IMO",
  "IMOTooltip": "International maritime organization. A unique number beginning IMO followed by 7 digits",
  "impactIndexes": "Impact indexes",
  "imperial": "Imperial",
  "impersonate": "Impersonate",
  "impersonatedUserHint": "You are currently impersonating {first_name} {last_name} from {company_name}",
  "import": "Import",
  "importContacts": "Import contacts",
  "importDevices": "Import devices",
  "importError": "No records could be imported. Please follow the instructions provided in the template file.",
  "importError.label_noRecordsImported": "No records could be imported",
  "importErrors": "We found errors in the following cells",
  "importEscalationContacts": "Import escalation contacts",
  "importGateways": "Import gateways",
  "importHistory": "Import history",
  "importLocations": "Import locations",
  "importOverlays": "Import overlays",
  "importPartiallySuccessful": "Import was partially successful.",
  "importRoutes": "Import routes",
  "importShipments": "Import shipments",
  "importSuccessful": "Import successful.",
  "importTags": "Import tags",
  "importTractors": "Import tractors",
  "importTrailers": "Import trailers",
  "importUsers": "Import users",
  "inaccurateGeofence": "Inaccurate geofence",
  "inactive": "Inactive",
  "inApp": "In app",
  "inAppCalls.changeUserStatus": "Change user status",
  "inAppCalls.label_activeAgents": "Active agents",
  "inAppCalls.label_callback": "Call back",
  "inAppCalls.label_inactiveAgents": "Inactive agents",
  "inAppCalls.label_transferUnavailable": "Transfer unavailable",
  "inAppCalls.label_voicemail": "Voicemail",
  "inAppSms.errorMessage_photoRemoved": "Photo was removed by <strong>{username}</strong> on <strong><datetime /></strong>",
  "inAppSms.successMessage_photoAttachedToEvent": "Photo successfully attached to <strong>event ID: {eventID}</strong> by <strong>{username}</strong> at <strong><datetime /></strong>",
  "inAppSms.successMessage_photoAttachedToShipment": "Photo successfully attached to <strong>shipment ID: {shipmentID}</strong> by <strong>{username}</strong> at <strong><datetime /></strong>",
  "inboundShipmentsRisk": "Inbound shipments by risk by segment mode",
  "inboundShipmentsRiskKPIHint": "Inbound shipments by risk by segment mode where the origin location does not have a location type of distribution centre, depot, or outside storage",
  "incident_accident": "Accident",
  "incident_congestion": "Congestion",
  "incident_construction": "Construction",
  "incident_disabled_vehicle": "Disabled vehicle",
  "incident_lane_restriction": "Lane restriction",
  "incident_response_manual_incident_shipment_event": "Incident response",
  "incident_response_manual_incident_violation": "Incident response",
  "incident_road_closure": "Road closure",
  "incident_road_hazard": "Road hazard",
  "incidents": "Incidents",
  "incidentType": "Incident type",
  "incident_weather": "Weather",
  "include": "Include",
  "includeInAllEmails": "E-mail (include in all e-mails)",
  "includeWaivedEvents": "Include waived events",
  "includeWhenAvailable": "E-mail (include when available)",
  "incluePublicLink?": "Inclue public link?",
  "incomplete": "Incomplete",
  "incomplete_information_alert_first_segment_only": "Do not generate an alert on 2+ segments",
  "incomplete_information_shipment_event": "Incomplete shipment information",
  "incomplete_pickup_submission_violation": "Incomplete origin pickup submission & photos",
  "incomplete_planned_stop_submission_violation": "Incomplete planned stop submission",
  "incomplete_pre_check_violation": "Incomplete origin pre-departure checklist confirmation",
  "incomplete_proof_of_delivery_violation": "Incomplete proof of delivery",
  "incompleteShipmentInfoAlerts": "Incomplete shipment information alerts",
  "incomplete_shipment_information_violation": "Incomplete shipment information",
  "incorrectFileFormat": "Incorrect file format",
  "incorrectFileFormatError": "Error. The file format is incorrect. Supported file formats: {ext}",
  "incorrectPin": "Incorrect pin",
  "increaseMapZoom": "Increase map zoom",
  "individualAssociations": "Individual associations",
  "individualAssociationsInfoMessage": "To add individual associations, the contact can not be part of any departments.",
  "individualAssociationsSubTitle": "Configure location or in transit based locations for the individual contact.",
  "individualAssociations.successMessage_updated": "Individual associations successfully updated",
  "individualAssociationsWarningMessage": "Please select the portal that the individual associations should be created for.",
  "individualContacts": "Individual contacts",
  "info": "Info",
  "infoMessage_acceptRejectShipmentButtons": "Accept/Reject buttons appear on this page only when the shipment is at the delivery location",
  "infoMessage_alertCooldown": "Alert cooldown is the time period between sending generating alerts to prevent multiple alerts being generated where a shipment goes constantly in and out of range.",
  "infoMessage_assetAppointment": "Allow appointment features for the asset",
  "infoMessage_assetAssetInactiveAutoDetails": "The asset status was updated to inactive because the asset has not reported within the workflow time threshold of {workflowTimeThreshold} days",
  "infoMessage_assetAssetInactiveManualDetails": "User {userName} manually updated the asset status to inactive.",
  "infoMessage_assetAssignment": "Allow assignment features for the asset",
  "infoMessage_assetDoorClosedDetails": "The door was open but is now closed",
  "infoMessage_assetDoorOpenDetails": "The door was closed but is now open",
  "infoMessage_assetInactiveAutoDetails": "The asset status was updated to inactive because the asset has not reported within the workflow time threshold of {workflowTimeThreshold} days",
  "infoMessage_assetInactiveManualDetails": "User {userName} manually updated the asset status to inactive.",
  "infoMessage_assetLightAlertDetails": "Device model {deviceModel} that has device IMEI {deviceImei} has generated a light value of {value} that exceeds the max setting of {settingValue}",
  "infoMessage_assetReportingStatusActiveDetails": "Asset has had an automatic update to its asset reporting status. The reporting status was auto updated to active.",
  "infoMessage_assetReportingStatusInactiveDetails": "Asset has had an automatic update to its asset reporting status. The reporting status was auto updated to inactive.",
  "infoMessage_assetSealClosedDetails": "The door seal was open but is now closed",
  "infoMessage_assetSealOpenDetails": "The door seal was closed but is now open",
  "infoMessage_batteryPingRatesAlertCaption": "Device {imei} located on asset {equipmentClass} {equipment} associated with company {company} has had an update to its ping/reporting rates",
  "infoMessage_batteryPingRatesAlertDetails": "The rates were auto updated because the battery level on the device dropped below {batteryLevel}%",
  "infoMessage_callRecordingLoading": "Loading call recording...",
  "infoMessage_callRecordingProcessing": "Processing call recording, please wait if you wish to listen back",
  "infoMessage_callTranscriptionDoesNotExist": "Call transcription does not exist",
  "infoMessage_callTranscriptionLoading": "Loading call transcription...",
  "infoMessage_countryWithRestrictionsEntry": "Asset has entered a country with trade restrictions {countryName}",
  "infoMessage_countryWithRestrictionsExit": "Asset has exited a country with trade restrictions {countryName}",
  "infoMessage_createSavedFilter": "This filter will be available only to you",
  "infoMessage_crossOutHelperText": "Cross-out radius as a percentage greater than the cross-in radius. E.G. 100 will be double the cross-in radius",
  "infoMessage_driverRiskscoreThresholdDescription": "Select this option to receive notifications when a driver is added to a shipment that exceeds the workflow > Road > Alerts & events > Intelligence > Driver risk-score threshold.",
  "infoMessage_geofenceCrossOutHelperText": "Buffer as a percentage greater than the geofence size. E.G. 100 will be double the size of the geofence",
  "infoMessage_importCarriersGroupModeDescription": "Import any group to help avoid carriers that don't meet your safety standards. Carriers added to a group will not affect your network and can be monitored separately.",
  "infoMessage_importCarriersGroupSelection": "Select a group name here to import carrier into the group.",
  "infoMessage_importCarriersNetworkModeDescription": "Import your network to avoid carriers that don't meet your safety standards. FraudWatch embedded: carriers in your network will be available for ground staff to assign to Overhaul shipments.",
  "infoMessage_incomingCallDescription": "You have an incoming call on another tab",
  "infoMessage_incomingCallTitle": "Answer incoming call",
  "infoMessage_noPreview": "No preview available",
  "infoMessage_noShipmentLockDowns": "No lockdowns have been set so far",
  "infoMessage_oneDeviceOnly": "Please choose one device only to view thresholds.",
  "infoMessage_reconnectToReceiveIncomingCalls": "Reconnect to continue receiving incoming calls",
  "infoMessage_recordingLoading": "Loading recording...",
  "infoMessage_reminderInfo": "A reminder is currently active for another <strong>{timeLeft}</strong> until <strong><until/></strong>",
  "infoMessage_replayProcessHasBegun": "Replay process has begun",
  "infoMessage_routeDevicesAssignment": "Devices selected here will be applied to all segments on this route",
  "infoMessage_sanctionedStateEntry": "Asset has entered a state with state restrictions, {stateName}",
  "infoMessage_sanctionedStateExit": "Asset has exited a state with state restrictions, {stateName}",
  "infoMessage_selectShipmentSegment": "Please choose single shipment segment",
  "infoMessage_shareShipment": "Please enter an email address or phone number to share a public link to this shipment.",
  "infoMessage_usCarrierRiskscoreThresholdDescription": "Overhaul automatically screens US road carriers for risk when USDOT numbers are added to shipments. \"Carrier risk score\" events will generate when a carrier's score exceeds the configured threshold.",
  "infoMessage_usCarriersEnabled": "When enabled: a) US verified carriers will be available to assign to shipments and b) the actual carrier captured during pickup will be specified by entering the carrier's USDOT number. Disable if the workflow will never have shipments with US road segments. When disabled: a) US verified carriers will be excluded when assigning carriers and b) the actual carrier captured during pickup will be captured by selecting an unverified carrier from a list",
  "infoMessage_USCarriersEnabled": "When enabled:<br /> a) US verified carriers will be available for assigning to shipments; and<br /> b) the actual carrier captured at pickup will be specified using the carrier's USDOT number. Disable this option if the shipment workflow will never involve US road segments. <br /> <br />When Disabled: <br /> a) US verified carriers won't be available for assigning to shipments; and <br /> b) the actual carrier captured at pickup will be selected from a list of unverified carriers.",
  "infoMessage_verifiedCarrier": "US motor carriers confirmed by the FMCSA records",
  "infoMessage_verifiedCompany": "US motor company confirmed by FMCSA records",
  "infoMessage_viewAllRefShipments": "View all reference shipments",
  "infoMessage_workflowCompanyHint": "Assigns the workflow to ALL companies",
  "in_hot_zone_detention_time_exceeded_shipment_event": "Hotzone stop detention alert",
  "in_hot_zone_stop_shipment_event": "Hotzone stop",
  "initialWarning": "Initial warning.",
  "inputType": "Input type",
  "in_red_zone_detention_time_exceeded_shipment_event": "Redzone stop detention alert",
  "in_red_zone_stop_shipment_event": "Redzone stop",
  "in_route_to_pickup": "In route to pickup",
  "in_safe_zone_detention_time_exceeded_shipment_event": "Safezone stop detention alert",
  "insertName": "Insert name",
  "insertValue": "Insert value",
  "inside": "Inside",
  "insideHeight": "Inside height",
  "insideLength": "Inside length",
  "insideWidth": "Inside width",
  "inStage": "In stage",
  "instructions": "Instructions",
  "insurer": "Insurer",
  "interactiveQrc": "Interactive QRC",
  "internalPONumber": "Internal PO number",
  "interrupt": "Interrupt",
  "inTotal": "In total",
  "in_transit": "In transit",
  "inTransit": "In transit",
  "inTransitDepartment": "In transit department",
  "inTransitDepartmentSubtitle": "Select the relevant in-transit conditions where the department is shown:",
  "inTransitEscalations": "In transit escalations",
  "inTransitEscalationsSubtitle": "Select the relevant in-transit conditions where the contact is shown:",
  "inTransitStatusDesc": "This shipment will remain / be set to active and its map location will not move.",
  "inUse": "In use",
  "invalid_container_tracking_at_seaport_shipment_event": "Invalid container tracking at seaport",
  "invalid_container_tracking_at_seaport_violation": "Invalid container tracking at seaport",
  "invalidDate": "Invalid date",
  "invalid_flight_tracking_shipment_event": "Invalid flight tracking",
  "invalid_flight_tracking_violation": "Invalid flight tracking",
  "invalidLockdownDuration": "Invalid lockdown duration",
  "invalidReminderDuration": "Invalid reminder duration",
  "invalidUnits": "Invalid units",
  "invalid_vessel_info_shipment_event": "Invalid vessel info",
  "invalid_vessel_info_violation": "Invalid vessel info",
  "invalidWeight": "Invalid weight",
  "inventory.availabilityType_inStock": "In stock",
  "inventory.availabilityType_lowStock": "Low stock",
  "inventory.availabilityType_outOfStock": "Out of stock",
  "inventory.batteryRequiredHelperText": "Indicates that the item requires batteries to operate.",
  "inventory.calculationMode_adjust": "Adjust quantity",
  "inventory.calculationMode_setNew": "Set new quantity",
  "inventory.description_addNewInventoryLot": "Add a new lot of an item from the catalog to inventory. Each lot should have a unique lot number and expiration date.",
  "inventory.description_editInventoryLot": "Update the stock levels, lot number, and expiration date for this inventory lot.",
  "inventory.description_expired": "Past expiration date",
  "inventory.description_expiring": "Within {count} days",
  "inventory.description_lowStock": "Below threshold",
  "inventory.description_noThreshold": "Without threshold",
  "inventory.exceedExportLimit": "The current selection contains more than 10,000 inventory items. Please apply additional filters to reduce the amount of inventory items.",
  "inventory.expirationStatus_expired": "Expired",
  "inventory.expirationStatus_expiring": "Expiring",
  "inventory.expirationStatus_unknown": "Unknown",
  "inventory.expirationStatus_valid": "Valid",
  "inventory.label_editStockThreshold": "Edit stock threshold",
  "inventory.label_enterAmountToAdd": "Enter amount to add",
  "inventory.label_enterAmountToRemove": "Enter amount to remove",
  "inventory.label_thresholdHelperText": "Alerts are triggered when total stock across all lots falls below this number.",
  "inventory.lotStockUpdateTitle": "Stock update",
  "inventory.materialHelperText": "E.g. Latex, nitrile, plastic",
  "inventory.measurementType_box": "Box",
  "inventory.measurementType_case": "Case",
  "inventory.measurementType_each": "Each",
  "inventory.measurementType_kit": "Kit",
  "inventory.measurementType_package": "Package",
  "inventory.measurementType_pallet": "Pallet",
  "inventory.sizeHelperText": "E.g. Small, medium, 10x10 cm",
  "inventory.sterileHelperText": "Indicates that the item is supplied sterile.",
  "inventory.storageType_frozen": "Frozen",
  "inventory.storageTypeHelperText": "Choose how this item should be stored.",
  "inventory.storageType_refrigerated": "Refrigerated",
  "inventory.storageType_roomTemp": "Room temp",
  "inventory.thresholdStatus_noThreshold": "No threshold",
  "inventory.thresholdStatus_set": "Threshold set",
  "inventory.thresholdSubtitle": "Configure the minimum stock level for this item. You'll be alerted when total stock falls below this threshold.",
  "inventory.thresholdTitle": "Set stock threshold for {name}",
  "inventory.tooltip_expiration": "Expiring means the item is going to expire within the next {count} days",
  "investigating": "Investigating",
  "investigationFinished": "Investigation finished",
  "investigationFinishedByUserName": "Investigation finished by {userName}",
  "investigationInitiated": "Investigation initiated by",
  "investigationReopenedByUser": "Investigation reopened by {userName}",
  "investigationStarted": "Investigation started",
  "investigationStartedByUser": "Investigation started by {userName}",
  "inviteNewUser": "Invite new user",
  "inviteUser": "Invite user",
  "invoice": "Invoice",
  "involvedSteps": "Involved steps",
  "is": "Is",
  "isNot": "Is not",
  "isNotFound": "Is not found",
  "isRequired": "Is required",
  "itemProfile.kind_box": "Box",
  "itemProfile.kind_drum": "Drum",
  "itemProfile.kind_other": "Other",
  "itemProfile.kind_package": "Package",
  "itemProfile.kind_pallet": "Pallet",
  "itemProfile.kind_shippingContainer": "Shipping container",
  "itemProfile.kind_singleItem": "Single item",
  "itemProfile.label_addHandlingUnit": "Add handling unit",
  "itemProfile.label_addItem": "Add item",
  "itemProfile.label_primaryPackagingType": "Primary packaging type",
  "itemProfile.label_secondaryPackagingType": "Secondary packaging type",
  "itemProfile.label_tertiaryPackagingType": "Tertiary packaging type",
  "itemProfile.primaryPackagingType_ampouleVial": "Ampoule/Vial",
  "itemProfile.primaryPackagingType_blister": "Blister",
  "itemProfile.primaryPackagingType_bottle": "Bottle",
  "itemProfile.primaryPackagingType_jar": "Jar",
  "itemProfile.primaryPackagingType_sachetPauch": "Sachet/Pouch",
  "itemProfile.primaryPackagingType_syringe": "Syringe",
  "itemProfile.primaryPackagingType_tube": "Tube",
  "itemProfile.secondaryPackagingType_childResistantCap": "Child-resistant cap",
  "itemProfile.secondaryPackagingType_foldingCarton": "Folding carton",
  "itemProfile.secondaryPackagingType_label": "Label",
  "itemProfile.secondaryPackagingType_tamperSeal": "Tamper seal",
  "itemProfile.tertiaryPackagingType_cardboardBox": "Cardboard box",
  "itemProfile.tertiaryPackagingType_pallet": "Pallet",
  "itemProfile.tertiaryPackagingType_shrinkWrap": "Shrink wrap",
  "itemProfile.title_editHandlingUnitProfile": "Edit handling unit profile",
  "itemProfile.title_handlingUnitProfileDetails": "Handling unit profile details",
  "itemProfile.title_itemProfileDetails": "Item profile details",
  "itemProfile.title_newHandlingUnitProfile": "New handling unit profile",
  "itemProfile.title_newItemProfile": "New item profile",
  "itemProfile.title_packaging": "Packaging",
  "itemProfile.type_automotive": "Automotive",
  "itemProfile.type_electronics": "Electronics",
  "itemProfile.type_foodAndBeverage": "Food & beverage",
  "itemProfile.type_pharma": "Pharma",
  "itemProfile.type_textiles": "Textiles",
  "jobPosition": "Position",
  "joined": "Joined",
  "key": "Key",
  "km": "km",
  "kpiIsDisabled": "This KPI is disabled and you can't select it to appear on the Command Center",
  "label": "Label",
  "label_accelerationX": "Acceleration X",
  "label_accelerationY": "Acceleration Y",
  "label_accelerationZ": "Acceleration Z",
  "label_accept": "Accept",
  "label_acceptedEbol": "Accepted at delivery",
  "label_acceptedWithDiscrepanciesEbol": "Accepted with discrepancies at delivery",
  "label_acceptShipment": "Accept shipment",
  "label_accessRule": "Access rule",
  "label_acknowledge": "Acknowledge event",
  "label_acknowledgedEventsOnly": "Acknowledged events only",
  "label_action": "Action",
  "label_actioned": "Actioned",
  "label_actionedBy": "Actioned by",
  "label_actionScorePrediction": "Action score prediction",
  "label_activate": "Activate",
  "label_activated": "Activated",
  "label_activateShipmentSegmentModalDescription": "Activating this segment will move this shipment to the selected state.",
  "label_activateShipmentSegmentModalTitle": "Would you like to activate?",
  "label_activateShipmentSegmentModalWarning": "Activating this segment will hide the current segment’s events from the timeline.",
  "label_active": "Active",
  "label_activeAlerts": "Assets with active alerts (high/medium/low)",
  "label_activeDestination": "Active destination",
  "label_activeInPastHour": "Active in past hour",
  "label_activePortalProfile": "Active portal profile",
  "label_activeRisk": "Active risk",
  "label_activeRiskDescription": "Active risk is a summary of violations that haven't been resolved yet.",
  "label_activityActionActivityType": "{action} <tooltip>{type}</tooltip>",
  "label_activityFeed": "Activity feed",
  "label_activityLogItemAuthorAndTime": "By <tooltip><typography>{user}</typography></tooltip> on <date/>",
  "label_activityStatus": "Activity status",
  "label_actualArrival": "Actual arrival",
  "label_actualCarrier": "Actual carrier",
  "label_actualCarrierDetails": "Actual carrier details",
  "label_actualDeparture": "Actual departure",
  "label_actualEndDate": "Actual end date",
  "label_actualPictureOfBol": "Actual picture of BOL",
  "label_actualRoute": "Actual route",
  "label_actualStartDate": "Actual start date",
  "label_addAdditionalPhoto": "Add additional photo",
  "label_addAssetAssignment": "Add assignment",
  "label_addAssignment": "Add assignment",
  "label_addAttachments": "Add attachments",
  "label_addColumnAfter": "Add column after",
  "label_addColumnBefore": "Add column before",
  "label_addCustomer": "Add customer",
  "label_addDeviceModel": "Add device model",
  "label_addEbolUser": "Add a secureBOL user",
  "label_addedSecureBolUsers": "Added SecureBOL users",
  "label_addEscortCompany": "Add escort company",
  "label_addEscortDriver": "Add new escort driver",
  "label_addEvent": "Add event",
  "label_addGateway": "Add gateway",
  "label_addGroup": "Add group",
  "label_addIdentityProvider": "Add identity provider",
  "label_addInventory": "Add inventory",
  "label_addItem": "Add item",
  "label_additionalPhoto": "Additional photo",
  "label_additionalPhotoCounter": "Additional photo {count}",
  "label_additionalRecipients": "Additional recipients",
  "label_addLot": "Add lot",
  "label_addManually": "Add manually",
  "label_addModel": "Add model",
  "label_addNewCategory": "Add new category",
  "label_addNewEscort": "Add new escort",
  "label_addNewGroup": "Add new group",
  "label_addNewInventoryLot": "Add new inventory lot",
  "label_addNewLocation": "Add new location",
  "label_addNewManufacturer": "Add new manufacturer",
  "label_addNewMaterial": "Add new material",
  "label_addNewNoteBelow": "Add a new note below",
  "label_addNewProductType": "Add new product type",
  "label_addNewSetting": "Add new setting",
  "label_addNewSize": "Add new size",
  "label_addNewTeam": "Add new team",
  "label_addNewType": "Add new type",
  "label_addNote": "Add note",
  "label_addPortal": "Add portal",
  "label_addProducts": "Add products",
  "label_addProfile": "Add profile",
  "label_addReminderTemplate": "Add new reminder template",
  "label_addressMismatch": "Address mismatch",
  "label_addRowAbove": "Add row above",
  "label_addRowBelow": "Add row below",
  "label_addSecondaryPhone": "Add secondary phone number",
  "label_addSecureBolUsers": "Add SecureBOL users",
  "label_addShipmentId": "Add shipment ID",
  "label_addShipmentIdSetting": "Add validation rule",
  "label_addShipmentIdToEnable": "Add shipment ID to enable",
  "label_addTagModel": "Add tag model",
  "label_addTeam": "Add new team",
  "label_addVendor": "Add vendor",
  "label_affectedDevices": "Affected devices",
  "label_affectedUnits": "Affected units",
  "label_afterDeliveryMovingRate": "After delivery moving ping rate",
  "label_afterDeliveryMovingRateDescription": "After a shipment has been delivered, closed, or canceled the device(s) will get their ping rates adjusted. Note: this only applies to device types that are REUSABLE",
  "label_afterDeliveryStationaryRate": "After delivery stationary ping rate",
  "label_agreedArrivalTime": "Agreed arrival time",
  "label_agreedDepartureTime": "Agreed departure time",
  "label_aICorrectButton": "AI correct",
  "label_aICorrectSubTitle": "You are confirming that the action model’s prediction was correct",
  "label_aICorrectTitle": "Confirm action model action",
  "label_alarmed": "Alarmed",
  "label_alarmGroup": "Alarm group name",
  "label_alarmProfilesBreached": "Alarm profiles breached",
  "label_alertCooldown": "Alert cooldown",
  "label_alertGroup": "Alert group",
  "label_alias": "Alias",
  "label_aliases": "Aliases",
  "label_allAssetDevices": "All devices assigned to the asset",
  "label_allContacts": "All contacts",
  "label_allow": "Allow",
  "label_allowRevertShipmentsToAtPickup": "Allow reverting shipments to at pickup",
  "label_allowRouteCreation": "Allow route creation",
  "label_allowRouteCreationDescription": "Turn on this toggle to show the create new route button. This will allow you to create a new route or create a new location as part of that route.",
  "label_allSegmentDevices": "Showing all devices that are assigned to the current segment.",
  "label_allSegments": "All segments",
  "label_allShipments": "All shipments",
  "label_allStates": "All states",
  "label_allYears": "All years",
  "label_alternateDeliveryLocations": "Alternate delivery locations",
  "label_alternateDeliveryLocationsDescription": "Link this location to other delivery points to provide additional delivery places.",
  "label_alternateDeliveryLocationsPlaceholder": "No alternate delivery locations added",
  "label_alternateFinalDestinationLocations": "Alternate final destination locations",
  "label_amlCheckStatus": "AML",
  "label_amountOfGeneratedShipments": "Amount of generated shipments",
  "label_any": "Any",
  "label_apacScore": "APAC score",
  "label_apacWeighting": "APAC weighting",
  "label_applicableDevices": "Applicable devices",
  "label_applicationAccess": "Application access",
  "label_appointmentId": "Appointment ID",
  "label_appointments": "Appointments",
  "label_appointmentsEnabled": "Appointment",
  "label_appointmentTime": "Appointment time",
  "label_archived": "Archived",
  "label_archiveNotification": "Archive notification",
  "label_assetAddedDate": "Asset added date",
  "label_assetAssignment": "Asset assignment",
  "label_assetAssignmentDetails": "Asset assignment details",
  "label_assetAssignments": "Asset assignments",
  "label_assetLinkedShipments": "Linked shipments",
  "label_assetShipments": "Shipments",
  "label_assetSubtype": "Asset subtype",
  "label_assetType": "Asset type",
  "label_assignAssetOnEditDescription": "Edit asset to assign a device",
  "label_assignedToMe": "Assigned to me",
  "label_assignee": "Assignee",
  "label_assignment": "Assignment",
  "label_assignmentCategory": "Assignment category",
  "label_assignments": "Assignments",
  "label_assignmentsEnabled": "Assignment",
  "label_assignmentSubtype": "Assignment subtype",
  "label_assignmentSuptype": "Assignment subtype",
  "label_assignmentType": "Assignment type",
  "label_assignToMe": "Assign to me",
  "label_atLocation": "At location",
  "label_atRiskShipmentsEmptyState": "No at-risk shipments available. Select \"Normal\" to view non-risk shipments.",
  "label_attach": "Attach",
  "label_attachFiles": "Attach files",
  "label_auditChangeAction": "<strong>{label}</strong> <action>changed</action> {oldValue}",
  "label_auditChangeWithKind": "{label} (field: {kind})",
  "label_auditedBy": "Audited by",
  "label_auditParentGroupLabelChanged": "<strong>{parentGroupLabel}</strong> <action>changed</action>",
  "label_auditTrailFor": "Audit trail for {entityName}",
  "label_authority": "Authority",
  "label_authorityRecentlyGranted": "Authority recently granted",
  "label_authorityRevoked": "Authority revoked",
  "label_authorityStatusBroker": "FMCSA > Broker authority status",
  "label_authorityStatusBrokerShort": "Broker authority status",
  "label_authorityStatusCommon": "FMCSA > Common authority status",
  "label_authorityStatusCommonShort": "Common authority status",
  "label_authorityStatusContract": "FMCSA > Contract authority status",
  "label_authorityStatusContractShort": "Contract authority status",
  "label_authorized": "Authorized",
  "label_authorizedForHireStatus": "Authorised for hire status",
  "label_autoAlert": "Auto alert",
  "label_autoAlertEmail": "Auto alert email",
  "label_autoAlertRecipients": "Auto alert recipients",
  "label_autoAlerts": "Auto alerts",
  "label_autoAlertSentAt": "Auto alert sent at",
  "label_autoclave": "Autoclave",
  "label_autoDeactivateAfterReportingInactive": "Auto-deactivate asset after reporting inactive",
  "label_autoDetectLocation": "Auto-detect location",
  "label_automatedAlertsEmails": "Auto alert emails",
  "label_automatedAlertTemplate": "Automated alert template",
  "label_autoWaiveInvalidEvents": "Auto-waive invalid events",
  "label_availableWiFiconnections": "Available WiFi connections",
  "label_averageDriverOOSRate": "Average driver out-of-service rate",
  "label_averageDrugArrestsRate": "Average drug arrest rate",
  "label_averageIncidentRate": "Average incident rate",
  "label_averageMonthlyLeasedDrivers": "Average monthly leased drivers",
  "label_averageScore": "Average score",
  "label_averageVehicleOOSRate": "Average vehicle out-of-service rate",
  "label_averageViolationRate": "Average violation rate",
  "label_awaitingConfirmation": "Awaiting confirmation",
  "label_backOfTrailer": "Back of trailer",
  "label_backToListType": "Back to {listType}",
  "label_backToShipmentList": "Back to shipment list",
  "label_badActor": "Bad actor",
  "label_badActorOverlay": "Bad actor",
  "label_baseRanges": "Base ranges",
  "label_battery": "Battery:",
  "label_batteryBelow": "Battery below {batteryLevel}%",
  "label_batteryLevel": "Battery level",
  "label_batteryLevelFull": "Full battery",
  "label_batteryLevelHigh": "High battery",
  "label_batteryLevelLow": "Low battery",
  "label_batteryLevelMedium": "Medium battery",
  "label_batteryLevelShortValue": "Batt. {value}%",
  "label_batteryLevelValue": "Battery level: {level}%",
  "label_batteryNotRequired": "Battery not required",
  "label_batteryRequired": "Battery required",
  "label_batteryUnknown": "Unknown",
  "label_belowTarget": "{number} below target",
  "label_BIPDCoverAmount": "BI&PD cover amount",
  "label_bluetoothAbbreviation": "BT",
  "label_bluetoothTagBroken": "Bluetooth tag broken",
  "label_boc3SelfRepresented": "BOC-3 self-represented new carrier",
  "label_body": "Body",
  "label_bold": "Bold",
  "label_bolLink": "SecureBOL link",
  "label_bolPincodes": "SecureBOL pincodes",
  "label_bottomCount": "Bottom {count}",
  "label_brief": "Brief",
  "label_brokerAuthorityStatus": "Broker authority status",
  "label_brokerAuthorityStatusPendingRevocation": "Broker authority status (pending revocation)",
  "label_brokerId": "Broker ID",
  "label_brokerIdRule": "Broker ID validation rule",
  "label_brokerShipmentReferenceNumber": "Broker / shipment reference number",
  "label_bssid": "BSSID",
  "label_btsValue": "BTS: {value}",
  "label_bulkTransfer": "Bulk transfer",
  "label_bulletList": "Bullet list",
  "label_businessAddress": "FMCSA > Business address",
  "label_businessAddressFull": "Business address (full)",
  "label_businessAddressPhone": "Business address telephone",
  "label_businessAddressShort": "Business address",
  "label_businessAddressTelephone": "FMCSA > Business address telephone",
  "label_businessAddressTelephoneShort": "Business address telephone",
  "label_businessType": "Business type",
  "label_byUser": "By {user}",
  "label_call": "Call",
  "label_callDuration": "Call duration",
  "label_callDurationMinutes": "Call duration (minutes)",
  "label_callFrom": "From",
  "label_callFromDetails": "From details",
  "label_callFromPhone": "From phone",
  "label_callHistory": "Call history",
  "label_callId": "Call ID",
  "label_callOverhaul": "Call Overhaul",
  "label_callRoom": "Call Room",
  "label_calls": "Calls",
  "label_callSID": "SID",
  "label_callStartTime": "Call start time",
  "label_callTo": "To",
  "label_callToDetails": "To details",
  "label_callToPhone": "To phone",
  "label_callTransfer": "Call transfer",
  "label_callType": "Call type",
  "label_cancelAlertRemindersDescription": "This will stop all future auto alert reminder emails for this alert. This action cannot be undone.",
  "label_cancelEscalationRemindersDescription": "This will stop all future escalation reminder emails for this alert. This action cannot be undone.",
  "label_cancelInvestigation": "Cancel investigation",
  "label_cancelReminders": "Cancel reminders",
  "label_cancelShipment": "Cancel shipment",
  "label_cancelTitle": "Are you sure you want to cancel?",
  "label_capacity": "Capacity",
  "label_cargoCoverMissing": "Cargo cover missing",
  "label_cargoInsuranceFiled": "Cargo insurance filed",
  "label_cargoInsuranceRequired": "Cargo insurance required",
  "label_cargoType": "Cargo type",
  "label_cargoTypeAuthority": "Cargo type authority",
  "label_carrierAddress": "Carrier address",
  "label_carrierCompanyOperationStatus": "Carrier operation status",
  "label_carrierGroups": "Carrier groups",
  "label_carrierGroupsSubtitle": "Personalise FraudWatch navigation by selecting which carrier groups are visible in the menu.",
  "label_carrierMatchedCondition": "Carrier's {condition} {simplifiedOperator}",
  "label_carrierOperationStatus": "FMCSA > Carrier operation status",
  "label_carrierOperationStatusShort": "Carrier operation status",
  "label_carrierTelephone": "Carrier telephone",
  "label_carrierViolationRatePerEvent": "Carrier violation rate per event",
  "label_caseNumber": "Case number",
  "label_catalog": "Catalog",
  "label_catalogItem": "Catalog item",
  "label_catalogManagement": "Catalog management",
  "label_categories": "Categories",
  "label_cdlFirstAndLastName": "CDL name (first & last)",
  "label_cdlFullName": "CDL name (full)",
  "label_cdlIsExpired": "CDL is expired",
  "label_cdlIsNonCommercial": "CDL is non-commercial",
  "label_cdlNumber": "CDL number",
  "label_changeLanguages": "Change languages",
  "label_changePass": "Change password",
  "label_charging": "Charging",
  "label_chargingStatus": "Charging status",
  "label_check": "Check",
  "label_checkCurrentRates": "Check current rates",
  "label_checkCurrentReportRates": "Check current report rates",
  "label_checkCurrentReportRatesSubtitle": "After a change is made, the next ping report will still use the previous rate. The new rates will be applied after this new ping report. Check current rates to see if there are any pending changes.",
  "label_checking": "Checking...",
  "label_checkReports": "Check the reports below to find out more.",
  "label_checks": "Checks",
  "label_chemicalFreightAuthority": "Chemical freight authority",
  "label_chooseCompany": "Choose current company",
  "label_claimName": "Claim name",
  "label_claimsMapping": "Claims mapping",
  "label_cleanup": "Clean up",
  "label_cleanupShipmentsFromPortal": "Cleanup all shipments from portal",
  "label_clientID": "Client ID",
  "label_clientSecret": "Client secret",
  "label_clone": "Clone",
  "label_clones": "Clones",
  "label_close": "Close",
  "label_closed": "Closed",
  "label_closedBy": "Closed by",
  "label_closedEventRiskScore": "Closed event risk score",
  "label_closedLoop": "Closed loop",
  "label_coldchainQualityGroupName": "Quality temperature alarm group name",
  "label_collapseEditor": "Collapse editor",
  "label_collapseList": "Collapse list",
  "label_collapseRow": "Collapse row",
  "label_columnsCount": "Columns count",
  "label_columnSettings": "Column settings",
  "label_comment": "Comment",
  "label_commonAuthorityStatus": "Common authority status",
  "label_commonAuthorityStatusPendingRevocation": "Common authority status (pending revocation)",
  "label_communicationChannel": "Channel",
  "label_communicationDetails": "Communication details",
  "label_companyBusinessAddress": "Business address",
  "label_companyBusinessPhone": "Business phone",
  "label_companyCellPhone": "Company cell phone",
  "label_companyDetails": "Company details",
  "label_companyEmail": "Company email",
  "label_companyEmailDomain": "Company email domain",
  "label_companyLegalName": "FMCSA > Legal name",
  "label_companyLegalNameShort": "Legal name",
  "label_companyMailingAddress": "Mailing address",
  "label_companyNotifications": "Company notifications",
  "label_companyOfficerOne": "Company officer 1",
  "label_companyOfficerTwo": "Company officer 2",
  "label_companySelection": "Company selection",
  "label_companySettings": "Company settings",
  "label_companyTeams": "Company teams",
  "label_companyTelephone": "Company telephone",
  "label_companyToTransferTo": "Company to transfer to",
  "label_companyTradeName": "FMCSA > Trade name",
  "label_companyTradeNameShort": "Trade name",
  "label_companyUsers": "Company users",
  "label_comparedToLastPeriod": "Compared to last {timePeriod}",
  "label_completedFieldsProgress": "{completed} of {total} fields completed",
  "label_completePackingList": "Complete packing",
  "label_composeNewEmail": "Compose new email",
  "label_compound": "Compound",
  "label_compoundEvents": "Compound events",
  "label_condition": "Condition",
  "label_conditional": "Conditional",
  "label_confidenceScore": "Confidence: {value} / 100",
  "label_configureCarrierGroups": "Configure carrier groups",
  "label_configureNavigationBar": "Configure navigation bar",
  "label_configureRiskScores": "Configure risk scores",
  "label_configureShipmentTab": "Configure shipment",
  "label_confirmAndAttach": "Confirm & attach",
  "label_confirmation": "Confirmation",
  "label_confirmCarrierAndDrivers": "Confirm carrier and drivers",
  "label_confirmedImageMatch": "Confirmed image match",
  "label_confirmedReason": "Confirmed reason",
  "label_confirmedReasonPlaceholder": "Please provide the reviewed action type, reason code, and type text for the confirmed reason to help improve the model.",
  "label_confirmTransfer": "Confirm transfer",
  "label_connectedTags": "Connected tags",
  "label_consecutivePingsToMoveToPickedUp": "Number of consecutive pings to move from at pickup to picked up at initial origin",
  "label_contact": "Contact",
  "label_contactAssociationsDescription": "By default, a contact is assumed to be an in-transit individual contact, until their settings specify otherwise. This means that they will display as a contact at all times for their company, and will receive all auto alerts for their company. If a contact should only display on shipments or receive alerts in certain circumstances, create associations to the relevant categories below.",
  "label_contactIsRelevantToShipmentsWhere": "This contact is relevant to shipments where",
  "label_contactMatching": "Matching contacts",
  "label_contactName": "Contact name",
  "label_contactPhone": "Contact phone",
  "label_container": "Container",
  "label_containerId": "Container ID",
  "label_contractAuthorityStatus": "Contract authority status",
  "label_contractAuthorityStatusPendingRevocation": "Contract authority status (pending revocation)",
  "label_contributingWeatherAlerts": "Contributing weather alerts",
  "label_convoy": "Convoy",
  "label_convoyDetails": "Convoy details",
  "label_convoyDeviationEventMessage": "This Shipment(s) has separated from convoy {name}. It has exceeded the convoy deviation event value of \"{convoyDeviation}\" by {shipmentDeviation} for {deliveryType} mode.",
  "label_convoyName": "Convoy name",
  "label_convoyOtherShipmentsGroup": "Other shipments",
  "label_convoyShipments": "Convoy shipments",
  "label_convoyShipmentsMessage": "Other shipments in convoy {name} are",
  "label_coo": "COO",
  "label_coordinates": "Lat., long.",
  "label_copyCoordinates": "Copy coordinates",
  "label_copyEmails": "Copy emails",
  "label_copyEmergencyEmails": "Copy emergency emails",
  "label_copyRegularEmails": "Copy regular emails",
  "label_copyShipmentRefNumbers": "Copy all references to all segments",
  "label_copyToClipboard": "Copy to clipboard",
  "label_corporation": "Corporation",
  "label_correctAction": "Correct action",
  "label_correctAtcion": "Correct action",
  "label_correctionReason": "Confirmed reason",
  "label_correctionReasonHelperText": "Please provide context for this correction to help improve the model",
  "label_corrections": "Corrections",
  "label_countExpired": "{count} expired",
  "label_countExpiring": "{count} expiring",
  "label_countries": "Countries",
  "label_cpu": "CPU",
  "label_create": "Create",
  "label_createdBy": "By <strong>{name}</strong>",
  "label_createdByAndRecipients": "By <strong>{name}</strong> to <component/>",
  "label_createdByFromTo": "By <strong>{name}</strong> from <strong>{from}</strong> to <component/>",
  "label_createdFromTo": "From <strong>{from}</strong> to <component/>",
  "label_createEmailGroup": "Create email group",
  "label_createFromExistingTemplate": "Create from existing template",
  "label_createNewGroup": "Create new group",
  "label_createNewLocation": "Create new location",
  "label_createNewNotificationCenterTicket": "Create new ticket",
  "label_createNewPackout": "Create new packout",
  "label_createNewPass": "Create new password",
  "label_createPhoneGroup": "Create phone group",
  "label_createPortalTemplate": "Create portal template",
  "label_createSavedFilter": "Create saved filter",
  "label_createShipment": "Create shipment",
  "label_createYourRoute": "Create your route",
  "label_crossInRadius": "Cross-in radius",
  "label_crossOutRadius": "Cross-out radius",
  "label_currentAssignedShipment": "Current shipment: #{shipmentId}",
  "label_currentAssignmentStatus": "Current assignment status",
  "label_currentlyOnTheCall": "Currently on the call",
  "label_currentMonth": "Current month",
  "label_currentPass": "Current password",
  "label_currentShipment": "Current shipment",
  "label_currentSpeed": "Current speed",
  "label_currentVersion": "Current version",
  "label_currentyAssignedShipment": "Currently assigned to shipment #{shipmentId}",
  "label_customer": "Customer",
  "label_customerCompany": "Customer company",
  "label_customerEmailGroups": "Customer email groups",
  "label_customerInfo": "Customer information",
  "label_customerPhoneGroups": "Customer phone groups",
  "label_customers": "Customers",
  "label_customised": "Customised",
  "label_customizePositiveFactorTableTitle": "Customize divisors for each parameter",
  "label_customizeRiskFactorTableTitle": "Customize weightings for each parameter",
  "label_customizeRiskScoresTableTitle": "Customize risk scores for each event",
  "label_customList": "Custom list",
  "label_cutomer": "Customer",
  "label_damagedGoods": "Damaged goods",
  "label_dangerZones": "Danger zones",
  "label_dateAndTime": "Date and time",
  "label_days": "Days",
  "label_daysAfter": "{number} day(s) after",
  "label_daysBefore": "{number} day(s) before",
  "label_deactivate": "Deactivate",
  "label_deactivatedUser": "Deactivated user",
  "label_debugMode": "Debug mode",
  "label_decideWithRiskGpt": "Decide with RiskGPT",
  "label_declaredCarrier": "Declared carrier",
  "label_declaredTractor": "Declared tractor",
  "label_declaredTrailer": "Declared trailer",
  "label_declineShipment": "Decline shipment",
  "label_default": "Default",
  "label_delete": "Delete",
  "label_deleteClaim": "Delete claim",
  "label_deleteColumn": "Delete column",
  "label_deleteDemoShipments": "Delete demo shipments",
  "label_deleteGroup": "Delete group",
  "label_deleteRow": "Delete row",
  "label_deleteTable": "Delete table",
  "label_deliveredTime": "Delivered time",
  "label_deliveringWithinNext": "Delivering within the next",
  "label_deliveryAlertMiles": "Delivery alert (miles)",
  "label_deliveryAlertMins": "Delivery alert (mins)",
  "label_deliveryCrossOutRadiusPercentage": "Delivery cross OUT radius (percentage)",
  "label_deliveryDay": "Delivery day",
  "label_deliveryLocation": "Delivery location",
  "label_deliverySettings": "Delivery settings",
  "label_deliveryStatus": "Delivery status",
  "label_deliveryTime": "Delivery time",
  "label_demurrageWarningTime": "Demurrage warning time (hours)",
  "label_departmentHasNoAssociations": "This department does not have any associations",
  "label_departmentsCount": "{count} departments",
  "label_description": "Description",
  "label_destinationLocation": "Destination location",
  "label_destinationName": "Destination name",
  "label_destinationPortTimeframe": "Device warning - destination port timeframe",
  "label_details": "Details",
  "label_detected": "Detected",
  "label_deviceBattery": "Device battery",
  "label_deviceBatteryHealthAlerts": "Device battery health and alerts",
  "label_deviceClientSetup": "Device client setup",
  "label_deviceControl": "Device control",
  "label_deviceControlDescription": "Ping rates will be adjusted for the first ping inside the region. Only road segments will be updated. This applies to all shipments with this regional workflow.",
  "label_deviceGenerated": "Device generated",
  "label_deviceGraph": "Device graph",
  "label_deviceImei": "Device IMEI",
  "label_deviceImeiNumber": "IMEI: {imei}",
  "label_deviceOverview": "Device overview",
  "label_devicePings": "Device pings",
  "label_devicePingsTimeline": "Device pings",
  "label_devicePlacedOnUnitId": "Device placed on unit ID",
  "label_devicePlacement": "Device placement",
  "label_devicePosition": "Device position, ID",
  "label_deviceProfile": "Device profile",
  "label_deviceReportingStatus": "Device reporting status",
  "label_deviceSelection": "Device selection",
  "label_devicesList": "List of devices",
  "label_deviceState": "Device state",
  "label_deviceStatus": "Device status",
  "label_deviceTagBattery": "Device (tag) battery",
  "label_deviceVendor": "Device vendor",
  "label_dialpad": "Dial pad",
  "label_disableAutoDeviceControl": "Disable auto device control",
  "label_disableAutomaticDeactivation": "Exclude from automatic deactivation",
  "label_disableCepForPickupAndDelivery": "Disable incorporating CEP (ping accuracy) for pickup & delivery",
  "label_discardActionBtn": "Discard",
  "label_discardChangesDescription": "This action cannot be undone.",
  "label_discardChangesTitle": "Are you sure you want to discard changes?",
  "label_displayFraudwatch": "Display FraudWatch warnings",
  "label_disruptions": "Disruptions",
  "label_distanceMeters": "CEP: <strong>{meters} m</strong>",
  "label_distanceToDeliveryAlertMiles": "Distance radius: distance to destination alert (miles)",
  "label_distanceToDeliveryAlertMins": "Time interval: distance to destination alert (mins)",
  "label_divecePositionID": "Device position, ID",
  "label_dmvCDLNumberMatch": "DMV (CDL number)",
  "label_dmvDOBMatch": "DMV (DOB)",
  "label_dmvFirstNameMatch": "DMV (first name)",
  "label_dmvLastNameMatch": "DMV (last name)",
  "label_dmvStateMatch": "DMV (state)",
  "label_documentationMismatch": "Documentation mismatch",
  "label_domain": "Domain",
  "label_doNotDisturb": "Do not disturb",
  "label_doNotDisturbModalSubTitle": "Until when should the notifications be turned off?",
  "label_doNotDisturbModalTitle": "Customise the do not disturb time",
  "label_doorSensitivity": "Door sensitivity",
  "label_doorSensor": "Door sensor",
  "label_doorStatuses": "Door statuses",
  "label_driverAndCarrierRequirements": "Driver and carrier requirements",
  "label_driverConnectSubtitle": "The Driver Connect/Escort Connect application has been enabled by the driver for this shipment",
  "label_driverDeletionAfterDeliveryTooltip": "Enter a time range (days) after shipment completion to delete driver information. Note that this deleted information cannot be retrieved.",
  "label_driverHistoricalTelephoneOne": "Driver historical telephone 1",
  "label_driverHistoricalTelephoneTwo": "Driver historical telephone 2",
  "label_driverOOSRate": "Driver out-of-service rate",
  "label_driverOutOfServiceViolationRate": "Driver Out-of-Service violation rate",
  "label_driverRiskscoreThreshold": "Driver risk-score threshold",
  "label_driverSentTo": "Driver text sent to",
  "label_driverTelephoneOne": "Driver telephone 1",
  "label_driverTelephoneTwo": "Driver telephone 2",
  "label_driverViolationRate": "Driver violation rate",
  "label_driverViolationRatePerEvent": "Driver violation rate per event",
  "label_driverWithOrderNumber": "Driver #{orderNumber}",
  "label_drugArrestRate": "Drug arrest rate",
  "label_drugArrestsRate": "Drug arrests rate",
  "label_dwellTime": "Dwell time",
  "label_edit": "Edit: {name}",
  "label_editable": "Editable",
  "label_editCarrierGroup": "Edit {name}",
  "label_editCustomer": "Edit customer",
  "label_editDeviceModel": "Device model: {name}",
  "label_editDeviceModelTooltip": "Edit device model",
  "label_editEmailGroup": "Edit email group",
  "label_editEvent": "Edit event",
  "label_editGateway": "Edit gateway",
  "label_editGroup": "Edit group",
  "label_editIdentityProvider": "Edit identity provider",
  "label_editIdentityProviderIsNotEditable": "Shared identity provider is not editable",
  "label_editInShipmentManager": "Edit in Shipment Manager",
  "label_editInventoryLot": "Edit inventory lot",
  "label_editLot": "Edit lot",
  "label_editMedicalDevice": "Edit medical device",
  "label_editOverlay": "Edit overlay",
  "label_editPhoneGroup": "Edit phone group",
  "label_editPortalAccess": "Edit portal access",
  "label_editProfile": "Edit profile",
  "label_editRiskScore": "Edit risk score",
  "label_editShipInfo": "Edit ship info",
  "label_editShipment": "Edit shipment",
  "label_editTagModel": "Edit tag model",
  "label_editTeam": "Edit team",
  "label_effectivePersonalisedScore": "Effective personalised score",
  "label_effectiveScore": "Effective score",
  "label_email": "Email",
  "label_emailDomain": "Email domain",
  "label_emailDomainMappings": "Email domain mappings",
  "label_emailGroup": "Email group",
  "label_emailGroups": "Email groups",
  "label_emails": "Emails",
  "label_emergency": "Emergency",
  "label_emergencyEmail": "Emergency email",
  "label_emergencyPhone": "Emergency phone",
  "label_employeePincodes": "SecureBOL pin manager",
  "label_enableBlurDetection": "Enable blur detection",
  "label_enableDriverLicenseValidation": "Enable driver license validation",
  "label_enableDriverPhoneValidation": "Enable SMS phone verification",
  "label_enableErrantPingDetection": "Enable errant ping detection",
  "label_enableIncomingCalls": "Enable incoming calls",
  "label_enableLowBatteryAlerts": "Enable low battery alerts",
  "label_enableLowBatteryAlertsDescription": "Notify when battery level is low during shipment creation. The low threshold is set by your workflow settings.",
  "label_enablePingRateChanges": "Enable ping rate changes",
  "label_enableShipmentConnect": "Enable Shipment Connect",
  "label_enableShipmentConnectDescription": "If enabled, you can launch the Shipment Connect app on the tablet.",
  "label_enableShipmentsWithoutTrackingInfo": "Enable shipments without tracking info",
  "label_enableShipmentsWithoutTrackingInfoDescription": "Turn on this toggle to enable creating the shipment without scanning the device. You can view shipments without tracking in the opened tab on Shipment Connect app.",
  "label_enableSSO": "Enable SSO",
  "label_endDate": "End date",
  "label_enforceSSO": "Enforce SSO",
  "label_enterShipmentReference": "Enter the shipment reference number found on your pickup assignment.",
  "label_entity": "Entity",
  "label_entityExport": "{entity} export",
  "label_escalation": "Escalation",
  "label_escalationEmail": "Escalation email",
  "label_escalationEmails": "Escalation emails",
  "label_escortCheckedInArrivalStatus": "Arrival status",
  "label_escortCompanies": "Escort companies",
  "label_escortCompaniesDescription": "Choose up to three companies. Each company can have up to four assigned drivers.",
  "label_escortConnectAccess": "Escort Connect access",
  "label_escortDriversMaxTwo": "Escort drivers (max. 2)",
  "label_escortName": "Escort name",
  "label_escorts": "Escorts",
  "label_escortSosSituationTypes": "Situation types",
  "label_escortStopReasons": "Stop reasons",
  "label_escortVehicle": "Escort vehicle",
  "label_estimatedAmountOfReplayPings": "Estimated amount of replay pings",
  "label_estimatedAnnualMileage": "Estimated annual mileage",
  "label_europeScore": "Europe score",
  "label_europeWeighting": "Europe weighting",
  "label_event": "Event",
  "label_eventDetails": "Event details",
  "label_eventGenerated": "Event generated",
  "label_eventID": "Event ID",
  "label_eventResolutionsNotificationsDescription": "Manually resolved events will auto send FYI emails for events under Notification Settings.",
  "label_eventResolutionsNotificationsTitle": "Event resolution notifications",
  "label_eventScores": "Event scores",
  "label_eventsManager": "Events manager",
  "label_eventSource": "Event source",
  "label_eventsTimeline": "Events timeline",
  "label_eventsToBeRemoved": "Events to be removed",
  "label_eventsTriggered": "Events triggered",
  "label_eventTimeline": "Event timeline",
  "label_eventTimestamp": "Event timestamp",
  "label_eventTitle": "Event title",
  "label_exceedCompaniesExportLimit": "The current selection contains more than 10,000 companies. Please apply additional filters to reduce the amount of companies.",
  "label_exceedContactsExportLimit": "The current selection contacts more than 10,000 contacts. Please apply additional filters to reduce the amount of contacts.",
  "label_excelFileUpload": "File upload (excel)",
  "label_excursionCount": "Excursion count",
  "label_excursionImpact": "Excursion impact",
  "label_excursions": "Excursions",
  "label_excursionSummary": "Excursion summary",
  "label_existingTemplate": "Existing template",
  "label_exit": "Exit",
  "label_expandEditor": "Expand editor",
  "label_expandList": "Expand list",
  "label_expandRow": "Expand row",
  "label_expiration": "Expiration",
  "label_expirationDate": "Expiration date",
  "label_expired": "Expired",
  "label_expiredLicenseBack": "License expired (back)",
  "label_expiredLicenseFront": "License expired (front)",
  "label_expiredMCSForm": "MCS form submitted more than 3 years ago",
  "label_expiring": "Expiring",
  "label_expirySwitcher": "Permanent (does not expire)",
  "label_exportingAssets": "Exporting assets",
  "label_exportingCarriers": "Exporting carriers",
  "label_exportingCatalogItems": "Exporting catalog items",
  "label_exportingCompanies": "Exporting companies",
  "label_exportingContacts": "Exporting contacts",
  "label_exportingElectronics": "Exporting electronics",
  "label_exportingGroupAsCsv": "Export group to CSV",
  "label_exportingInventoryItems": "Exporting inventory items",
  "label_exportingRecords": "Exporting records",
  "label_exportingReport": "Exporting report",
  "label_exportItems": "Export items",
  "label_exportNetwork": "Export network",
  "label_externalID": "External ID",
  "label_externalReference": "External reference",
  "label_facematchCheckStatus": "Facematch",
  "label_facilityName": "Facility name",
  "label_factorsConsidered": "Factors considered as part of this calculation",
  "label_failedImageMatch": "Failed image match",
  "label_falseRuleOutcome": "False rule outcome",
  "label_fax": "Fax",
  "label_fieldSettings": "Field settings",
  "label_fileAttached": "<strong>{fileName}</strong> attached",
  "label_fileDeleted": "<strong>{fileName}</strong> deleted",
  "label_fileFormat": "File format",
  "label_fileIsOldXlsFormat": "The file appears to be in the old .xls format. Please re-save it as .xlsx in excel.",
  "label_filterByPortal": "Filter by portal",
  "label_filterByTimeRange": "Filter by time range",
  "label_firstBatteryLevelAlert": "First battery level alert",
  "label_firstName": "First name",
  "label_firstNotif": "First notification",
  "label_fleet": "Fleet",
  "label_fleetSize": "Fleet size",
  "label_flight": "Flight",
  "label_flightModeDescription": "Enables device settings for flight shipments.",
  "label_flightNumber": "Flight number",
  "label_FMCSAAvgMonthlyLeasedDrivers": "FMCSA > Average monthly leased drivers",
  "label_FMCSAAvgMonthlyLeasedDriversShort": "Average monthly leased drivers",
  "label_FMCSABasedFleetSize": "FMCSA > Fleet size",
  "label_FMCSABasedFleetSizeShort": "Fleet size",
  "label_FMCSABasedtotalMileageMostRecentYear": "FMCSA > Total mileage (most recent year)",
  "label_FMCSABasedtotalMileageMostRecentYearShort": "Total mileage (most recent year)",
  "label_FMCSABasedTotalTrailersUnits": "FMCSA > Total trailers / units",
  "label_FMCSABasedTotalTrailersUnitsShort": "Total trailers / units",
  "label_fmcsaBIPDCoverAmount": "FMCSA > BI&PD cover amount",
  "label_FMCSABrokerAuthorityStatus": "FMCSA > Broker authority status (pending revocation)",
  "label_FMCSACargoCoverMissing": "FMCSA > Cargo cover missing",
  "label_FMCSACargoInsuranceFiled": "FMCSA > Cargo insurance filed",
  "label_FMCSACargoInsuranceFiledShort": "Cargo insurance filed",
  "label_FMCSACargoInsuranceRequired": "FMCSA > Cargo insurance required",
  "label_FMCSACargoInsuranceRequiredShort": "Cargo insurance required",
  "label_FMCSACommonAuthorityStatus": "FMCSA > Common authority status (pending revocation)",
  "label_FMCSAcompanyCellPhone": "FMCSA > Company cell phone",
  "label_FMCSAcompanyCellPhoneShort": "Company cell phone",
  "label_FMCSAcompanyEmail": "FMCSA > Company email",
  "label_FMCSAcompanyEmailShort": "Company email",
  "label_FMCSAcompanyOfficer": "FMCSA > Company officer 1",
  "label_FMCSAcompanyOfficerSecond": "FMCSA > Company officer 2",
  "label_FMCSAcompanyOfficerSecondShort": "Company officer 2",
  "label_FMCSAcompanyOfficerShort": "Company officer 1",
  "label_FMCSAcompanyTelephone": "FMCSA > Company telephone",
  "label_FMCSAcompanyTelephoneShort": "Company telephone",
  "label_FMCSAContractAuthorityStatus": "FMCSA > Contract authority status (pending revocation)",
  "label_fmcsaData": "FMCSA data",
  "label_FMCSAInadequateBIPDInsurance": "FMCSA > Inadequate BI&PD insurance",
  "label_FMCSAInadequateBIPDInsuranceShort": "Inadequate BI&PD insurance",
  "label_FMCSAMonthsSinceRegistration": "FMCSA > Registration months",
  "label_FMCSAMonthsSinceRegistrationShort": "Registration months",
  "label_FMCSASuretyBondFiled": "FMCSA > Surety bond filed",
  "label_FMCSASuretyBondFiledShort": "Surety bond filed",
  "label_FMCSASuretyBondRequired": "FMCSA > Surety bond required",
  "label_FMCSASuretyBondRequiredShort": "Surety bond required",
  "label_FMCSATotalCDLDrivers": "FMCSA > Total CDL drivers",
  "label_FMCSATotalCDLDriversShort": "Total CDL drivers",
  "label_FMCSATotalDriversEmployed": "FMCSA > Total drivers employed",
  "label_FMCSATotalDriversEmployedShort": "Total drivers employed",
  "label_FMCSATotalInterstateDrivers": "FMCSA > Total interstate drivers",
  "label_FMCSATotalInterstateDriversShort": "Total interstate drivers",
  "label_for": "For",
  "label_forecast": "Forecast",
  "label_fraudwatch": "FraudWatch",
  "label_fraudWatchConfiguration": "FraudWatch configuration",
  "label_fraudwatchDescription": "Display FraudWatch warnings on Shipment Connect for this device only. Useful to trial / gradually rollout FraudWatch.",
  "label_fraudWatchResultsFromUsdotGpt": "FraudWatch results from USDOT GPT",
  "label_frontBackDataMismatch": "Front/Back data mismatch",
  "label_gatewayModel": "Gateway model",
  "label_generalEvents": "General events",
  "label_generalFreightAuthority": "General freight authority",
  "label_generalRiskScore": "General risk score",
  "label_generalShipmentConnectSettings": "General Shipment Connect settings",
  "label_generate": "Generate",
  "label_generateChangeLogReport": "Generate change log report",
  "label_generateDemoShipments": "Generate demo shipments",
  "label_generateDemoShipmentsByIds": "Generate demo shipments by IDs",
  "label_generateInactiveReportingAlerts": "Generate inactive reporting alerts",
  "label_generatePin": "Generate PIN",
  "label_generateShipmentTab": "Generate shipment",
  "label_geofenceCrossOutDistance": "Cross out distance (percentage)",
  "label_geoJSONFormat": "geoJSON",
  "label_getEmailUpdates": "Get email updates",
  "label_globalRailways": "Global railways",
  "label_globalScore": "Global score",
  "label_globalSearchAllPortals": "Global search (all portals)",
  "label_globalSearchCaption": "<strong>Global</strong> search: portal filters ignored",
  "label_globalWeighting": "Global weighting",
  "label_goodSignal": "Good",
  "label_greedDate": "Agreed date",
  "label_grossWeight": "Gross weight",
  "label_group": "Group",
  "label_grouping": "Grouping",
  "label_groupName": "Group name",
  "label_groups": "Groups",
  "label_gsocMonitored": "GSOC monitored",
  "label_gsocTeam": "GSOC team",
  "label_handlingUnitProfiles": "Handling unit profile",
  "label_handlingUnitQuantity": "Handling unit quantity",
  "label_handlingUnitType": "Handling unit type",
  "label_hangup": "Hangup",
  "label_hardReprocess": "Hard reprocess",
  "label_hardReset": "Hard reset",
  "label_hideAlternativeDestinations": "Hide alternative destinations",
  "label_hideMapOnShipmentConnect": "Hide map on Shipment Connect",
  "label_hideTranscript": "Hide transcript",
  "label_hideZeroCounters": "Hide counters with zero values.",
  "label_highHumidity": "High humidity",
  "label_highImpact": "High impact",
  "label_highSeverityExcursions": "High severity excursions",
  "label_highValue": "High value",
  "label_highValueShipment": "High value shipment",
  "label_highVolumeActiveRisksDescription": "This shipment has a high volume of events that cannot be supported in the risk summary. Please use the event timeline to resolve this shipment.",
  "label_hiName": "Hi, {name}!",
  "label_home": "Home",
  "label_hospitals": "Hospitals",
  "label_hours": "Hours",
  "label_houseAirwayBill": "House airway bill",
  "label_householdFreightAuthority": "Household freight authority",
  "label_hypervergeVerificationStatus": "Hyperverge - verification status",
  "label_id": "ID",
  "label_idealMaximumTemperature": "Ideal maximum temperature",
  "label_idealMinimumTemperature": "Ideal minimum temperature",
  "label_idealRange": "Ideal range",
  "label_identifySanctionedCountries": "Identify the countries to which assets must not be transported",
  "label_identityProviderType": "Identity provider type",
  "label_impactedItems": "Impacted items",
  "label_impactedUnits": "Impacted units",
  "label_impactLevel": "Impact level",
  "label_impactLevelInfoMessage": "The level of impact that this disruption is likely to have on upcoming or in-transit shipments",
  "label_importAddresses": "Import addresses",
  "label_importDevicesViaDeviceProfile": "Import devices via device profile",
  "label_importElectronics": "Import electronics",
  "label_importItems": "Import items",
  "label_importMaintenance": "Import maintenance",
  "label_importOverlay": "Import overlay",
  "label_importResults": "Import results",
  "label_importValues": "Import values",
  "label_inactive": "Inactive",
  "label_inactiveForMoreThanHour": "Inactive for {minutes}+ min",
  "label_inadequateBIPDInsurance": "Inadequate BI&PD insurance",
  "label_inbound": "Inbound",
  "label_inboundMessage": "Inbound message",
  "label_incidentCause": "Incident cause",
  "label_incidentRate": "Incident rate",
  "label_incidentsOverlay": "Incidents",
  "label_includeAdditionalRecipientsAsCC": "Include additional recipients in CC field",
  "label_incomingCall": "Incoming call",
  "label_incorrectShipment": "Incorrect shipment",
  "label_indexOfTotal": "{index} of {total}",
  "label_individual": "Individual",
  "label_innerRadius": "Inner radius (miles)",
  "label_insertTable": "Insert table",
  "label_inside": "Inside",
  "label_insideRangeAlerts": "Inside range alerts",
  "label_installationType": "Installation type",
  "label_insufficientData": "Insufficient data to calculate risk score",
  "label_insurance": "Insurance",
  "label_internal": "Internal",
  "label_internalNoteDescription": "Only visible for your colleagues",
  "label_internalNotes": "Internal notes",
  "label_interstate": "Interstate",
  "label_inTotal": "{count} in total",
  "label_inTransit": "In transit",
  "label_inTransitDepartmentDescription": "Where a contact is an in-transit contact for their company, but only in specific circumstances, add in-transit associations to limit when they display on shipments or receive alerts. Once in-transit associations are added, the contact will only display on shipments and receive alerts, if the shipment’s conditions match the contact’s associations.",
  "label_inTransitSentTo": "In-Transit contacts sent to",
  "label_intrastateHazardous": "Intrastate (hazardous materials)",
  "label_intrastateNonHazardous": "Intrastate (non-hazardous materials)",
  "label_invalid": "Invalid",
  "label_invalidFile": "The selected file is not a valid {extension} file",
  "label_inventoryLots": "Inventory lots",
  "label_investigate": "Investigate",
  "label_investigation": "Investigation",
  "label_investigationPanelTitle": "Notes – {title}",
  "label_iotEvents": "IoT events",
  "label_irInstructions": "IR instructions",
  "label_isIdTokenMapping": "Is ID token mapping",
  "label_issuer": "Issuer",
  "label_italic": "Italic",
  "label_itemAttributes": "Item attributes",
  "label_itemDetails": "Item details",
  "label_itemName": "Item name",
  "label_itemsSelected": "Items selected:",
  "label_itemType": "Item type",
  "label_keepReminders": "Keep reminders",
  "label_kilometersPerHour": "km/hr",
  "label_kind": "Kind",
  "label_kpis": "KPIs",
  "label_lane": "Lane",
  "label_lanesOnRMTooltip": "Lane <strong>IS</strong>",
  "label_laneStartLocationToFinalLocation": "{from} to {to}",
  "label_lastActiveDuration": "Last active: {duration} ago",
  "label_lastClosed": "Last closed",
  "label_lastEmail": "Last email",
  "label_lastKnownLocation": "Last known location",
  "label_lastModified": "Last modified",
  "label_lastName": "Last name",
  "label_lastOpened": "Last opened",
  "label_lastPingAddress": "Last ping address",
  "label_lastPingTimestamp": "Last ping timestamp",
  "label_lastReply": "Last reply",
  "label_lastReported": "Last reported",
  "label_lastSealStatus": "Last seal status",
  "label_lastTemperature": "Last temperature",
  "label_lastTwentyFourHours": "Last 24 hours",
  "label_lastUpdated": "Last updated",
  "label_lastUpdatedDuration": "Last updated {duration} ago",
  "label_lease": "Lease",
  "label_leased": "Leased",
  "label_leConnect": "LE Connect",
  "label_leConnectLink": "LE Connect link",
  "label_legalName": "Legal name",
  "label_lessInfo": "Less info",
  "label_lightFallback": "Light fallback",
  "label_lightFallbackAfterSealCompromised": "Light fallback after seal compromised",
  "label_lightGenerated": "Light generated",
  "label_lightStopCompound": "Light & Stop(compound)",
  "label_link": "Link",
  "label_linkedPing": "Linked ping",
  "label_linkedShipments": "Linked shipments",
  "label_linkToFraudWatch": "Link to FraudWatch",
  "label_list": "List",
  "label_listOfMods": "Mode <strong>Is</strong> {modes}",
  "label_listOfTags": "List of tags",
  "label_load": "Load",
  "label_locationAccessRequired": "Location access required",
  "label_locationDepartmentDescription": "Where a contact should be the contact for a physical origin or destination location, select that location in this section. The contact will then display on the location (and not the company), and will receive alerts for that origin.",
  "label_locationRequired": "Location required",
  "label_locations": "Locations",
  "label_locationTypes": "Location types",
  "label_lockdownSetUntil": "Lockdown set until: <date/>",
  "label_lockDownShipment": "Lock down shipment",
  "label_lossValue": "Loss value",
  "label_lotNumber": "Lot number",
  "label_lots": "Lots",
  "label_lowCoverageZones": "Low coverage zones",
  "label_lowHumidity": "Low humidity",
  "label_lowImpact": "Low impact",
  "label_mailingAddress": "FMCSA > Mailing address",
  "label_mailingAddressFull": "Mailing address (full)",
  "label_mailingAddressPhone": "Mailing address telephone",
  "label_mailingAddressShort": "Mailing address",
  "label_mailingAddressTelephone": "FMCSA > Mailing address telephone",
  "label_mailingAddressTelephoneShort": "Mailing address telephone",
  "label_maintenance": "Maintenance",
  "label_maintenanceDetails": "Maintenance details",
  "label_maintenanceID": "ID",
  "label_maintenanceToggleInfo": "Allow maintenance actions on this asset",
  "label_manageUsers": "Manage users",
  "label_mandatoryStop": "Mandatory stop",
  "label_manualShipmentEventInitiator": "Initiated by",
  "label_manualShipmentEventResponse": "LE response",
  "label_manualShipmentEventResult": "Result",
  "label_manualShipmentEventStolenGoodsStatus": "Stolen goods",
  "label_manufacturer": "Manufacturer",
  "label_manufacturerNumber": "Manufacturer #",
  "label_manufacturingNumber": "Manufacturing number",
  "label_mapMeasure": "Map measure",
  "label_mapTheme": "Map theme",
  "label_markAsAvailable": "Mark as available",
  "label_markAsUnavailable": "Mark as unavailable",
  "label_markingsDescriptions": "Markings/Descriptions",
  "label_masterAirwayBill": "Master airway bill",
  "label_material": "Material",
  "label_maxAmountOfShipmentsReached": "The maximum number of shipments has been reached. Please select a shorter time range",
  "label_maxColumns": "Maximum columns: {count}",
  "label_maxHumidityLevel": "Max humidity level",
  "label_maxLightLevel": "Max light level",
  "label_maxPinedFiltersLimit": "A maximum of 8 saved filters can be added to the navigation bar",
  "label_maxPinnedFiltersReached": "Maximum amount of 8 views reached. Toggle off a view to select another.",
  "label_maxPinnedGroupsReached": "Maximum amount of {maxCount} groups reached. Toggle off a group to select another.",
  "label_maxRows": "Maximum rows: {count}",
  "label_MC": "MC",
  "label_measurementRate": "Measurement rate",
  "label_medicalDeviceFamily": "Medical device family",
  "label_mediumImpact": "Medium impact",
  "label_memory": "Memory",
  "label_mergeCarriers": "Merge carriers",
  "label_mexicoScore": "Mx, Brazil, LATAM score",
  "label_mexicoWeighting": "Mexico weighting",
  "label_mileageYear": "Mileage {mileageYear}",
  "label_milesPerHour": "mi/hr",
  "label_minHumidityLevel": "Min humidity level",
  "label_minimize": "Minimize",
  "label_minimumThreshold": "Minimum threshold",
  "label_minLightLevel": "Min light level",
  "label_missedBy": "Missed by",
  "label_missingItems": "Missing items",
  "label_missingPings": "Missing pings",
  "label_mobileApplicationsSettings": "Mobile applications settings",
  "label_modelInformation": "Model information",
  "label_modelName": "Model name",
  "label_models": "Models",
  "label_modelType": "Model type",
  "label_modelVersion": "Model version",
  "label_modusOperandi": "Modus operandi",
  "label_monthsSinceRegistration": "Registration months",
  "label_moreInfo": "More info",
  "label_movingRate": "Moving rate",
  "label_movingStatus": "Moving status",
  "label_multipleCurrencySigns": "$$$",
  "label_multipliers": "Multipliers",
  "label_mute": "Mute",
  "label_myInventory": "My inventory",
  "label_name": "Name",
  "label_nameAliases": "Name aliases",
  "label_naRailways": "NA railways",
  "label_navigate": "Navigate",
  "label_navigateToShipment": "Navigate to the shipment",
  "label_newMobileVersion": "New mobile version",
  "label_newPackout": "New packout",
  "label_newQuantity": "New quantity",
  "label_newRiskScoreTemplate": "New risk score template",
  "label_newScoreTemplate": "New score template",
  "label_newSegmentProducts": "New segment products",
  "label_newStatusUpdate": "New status update",
  "label_newSubscription": "New subscription",
  "label_nextPing": "Next ping",
  "label_noAccess": "No access",
  "label_noAccessMessage": "You don't have access to manage roles for this company",
  "label_noActiveAssetAlerts": "There are no active alerts on your assets.",
  "label_noActiveRisks": "No active risks",
  "label_noActualCarrierInfo": "No actual carrier information",
  "label_noAlarms": "No alarms",
  "label_noAssignee": "No assignee",
  "label_noAvailableThresholds": "No available thresholds",
  "label_noBatteryIssuesReported": "No battery issues reported.",
  "label_noBatteryRequired": "No battery required",
  "label_noCompanyContacts": "Contacts have not been added for this company.",
  "label_noContactsToDisplay": "No contacts to display",
  "label_noCreatedGroupsYet": "No carrier groups created yet",
  "label_noData": "No data",
  "label_noDeviceDataAvailable": "No device data available",
  "label_noDevicesAssignedToAsset": "No devices assigned to this asset",
  "label_noEmail": "No email",
  "label_noEmailGroup": "No email group",
  "label_noEndDate": "No end date",
  "label_noEvent": "No event",
  "label_noEventsAvailable": "No events available",
  "label_noEventsFound": "No events found",
  "label_noEventsMatchFilters": "No events match your current filter criteria.",
  "label_noItemsToDisplay": "No items to display",
  "label_noMatchedAssociatedAssets": "No assets associated with your company.",
  "label_noNotificationCenterTicket": "No ticket",
  "label_nonSterile": "Non sterile",
  "label_noPackingUnitsYet": "No packing units yet",
  "label_noPassiveRisks": "No risk factors",
  "label_noPhoneActivity": "No phone activity available",
  "label_noPhotosForSelectedSegment": "There are no photos for the selected segment(s)",
  "label_noPhotosToDisplay": "No photos to display",
  "label_noPickupSubmittedReported": "No device reporting issues detected during pickup submission.",
  "label_noPingsFound": "No pings found",
  "label_noPlannedCarrierInfo": "No planned carrier information",
  "label_noPortal": "No portal",
  "label_noPositiveFactors": "No positive factors",
  "label_noProductsSelected": "No products selected",
  "label_noQRStatus": "No QR status",
  "label_noRangeAlerts": "No alerts at this range",
  "label_noReason": "No reason",
  "label_noRiskFactors": "No risk factors",
  "label_noRisksIdentified": "No risks identified",
  "label_normalShipmentsEmptyState": "No shipments available. Select \"High\", \"Medium\" or \"Low\" to view at-risk shipments.",
  "label_noSavedFiltersCreatedYet": "No saved filters created yet",
  "label_noSavedFiltersCreatedYetMessage": "Open the filter pop-up, select items from the quick filter menu and then press the save icon to create a saved filter.",
  "label_noSavedFiltersYet": "No saved filters yet",
  "label_noSegmentProducts": "No products assigned to this segment",
  "label_noSensorDataAvailable": "No sensor data available",
  "label_noShipmentID": "No shipment ID",
  "label_noShipmentLoaded": "No shipment loaded",
  "label_noTags": "No tags",
  "label_notApplicable": "N/A",
  "label_notAuthorized": "Not authorized",
  "label_notDuplicatedToPortals": "Not duplicated to portal(s)",
  "label_notifFreq": "Set up notification frequency",
  "label_notificationCenter": "Notification Center",
  "label_notificationCenterTicket": "Ticket",
  "label_notificationFilters": "Notification filters",
  "label_notificationsDescription": "Alerts & Notifications controls the criteria that a shipment should meet in order for the user to receive alerts or notifications about that shipment. Alerts and notifications can be enabled/disabled from the Notification Settings page of a user’s account settings.",
  "label_notificationTemplate": "Notification template",
  "label_notificationType": "Notification type",
  "label_notifyWhenAvailableOnly": "Notify when available only",
  "label_notLeased": "Not leased",
  "label_noTrackingIssuesReported": "No tracking issues reported.",
  "label_notRated": "Not rated",
  "label_notStarted": "Not started",
  "label_notSupportedMultiTenantedUser": "Not supported for shared contacts",
  "label_notSupportedRegularUser": "Not supported for users",
  "label_noUsdotReturned": "No USDOT returned",
  "label_noWeatherAlertsSubtitleAll": "No weather alerts are expected for this route in the coming days.",
  "label_noWeatherAlertsSubtitleDay": "No weather alerts are expected for this route on <date>.",
  "label_noWeatherAlertsTitle": "No weather alerts expected!",
  "label_noWeatherIssuesReported": "No weather alerts have been reported.",
  "label_number": "Number",
  "label_numberOfConsecutivePings": "Number of consecutive pings to move from at delivery to In-Transit for final delivery",
  "label_numberOfDevicesRequired": "Number of devices required",
  "label_numberOfMonths": "{count} months",
  "label_numberOfPeopleOnCall": "Number of people on call",
  "label_occurred": "Occurred",
  "label_oceanModeDescription": "Enables device settings for ocean shipments.",
  "label_officerName": "Officer name",
  "label_ohId": "OH ID",
  "label_oldMobileVersion": "Old mobile version",
  "label_oldShipmentId": "Old shipment ID",
  "label_open": "Open",
  "label_openInAssetManager": "Open in Asset Manager",
  "label_openInNewTab": "Open in a new tab",
  "label_openInSM": "Open in Shipment Manager",
  "label_openMicZones": "Open mic zones",
  "label_openPhoneLine": "Open phone line required within this zone",
  "label_openShipment": "Open shipment",
  "label_operatingAuthorities": "Operating authorities",
  "label_operatingAuthorityNumber": "{operatingAuthorityType} number",
  "label_operatingAuthorityNumbers": "Operating authority numbers",
  "label_operatingAuthorityStatus": "Operating authority status",
  "label_operatingSince": "Operating since",
  "label_operator": "Operator",
  "label_orderedList": "Ordered list",
  "label_orderId": "Order ID",
  "label_originalPictureOfBol": "Original picture of BOL",
  "label_originalShipmentID": "Shipment ID: {id}",
  "label_originalShipmentRef": "Original shipment ref",
  "label_originalShipments": "Original shipments",
  "label_originLocations": "Origin locations",
  "label_orSelectExistingContact": "Or select existing contact",
  "label_outbound": "Outbound",
  "label_outboundCall": "Outbound call",
  "label_outboundText": "Outbound text",
  "label_outcomeNotes": "Outcome notes",
  "label_outerRadius": "Outer radius (miles)",
  "label_outOfNetworkCarrier": "Out-of-network carrier",
  "label_outOfService": "Out of service",
  "label_outside": "Outside",
  "label_outsideRangeAlerts": "Outside range alerts",
  "label_overhaulContact": "Overhaul contact",
  "label_overhaulShipmentId": "Overhaul shipment ID",
  "label_overLastDaysCount": "Over last {count} days",
  "label_ovhContractedEscort": "Overhaul contracted escort",
  "label_packing": "Packing",
  "label_packingList": "Packing list",
  "label_packingStatus": "Packing status",
  "label_packingUnits": "Packing units",
  "label_packout": "Packout",
  "label_packoutOrderId": "Packout order ID",
  "label_pairTag": "Pair tag",
  "label_palletBoxId": "Pallet/Box ID",
  "label_partialDelivery": "Partial delivery",
  "label_partialPieces": "Partial pieces",
  "label_partnership": "Partnership",
  "label_passengerFreightAuthority": "Passenger freight authority",
  "label_passiveRisk": "Passive risk",
  "label_passiveRiskDescription": "Passive risk is a summary of influencing factors who are not an issue by themselves but once an event or compound generates they make that event risk worse.",
  "label_pastingTableIsNotAllowed": "Pasting a table inside a table cell is not allowed",
  "label_pendingActualCarrier": "Pending actual carrier",
  "label_pendingActualCarrierDescription": "Pickup scheduled for",
  "label_pendingEvents": "Pending events",
  "label_permanent": "Permanent",
  "label_permissions": "Permissions",
  "label_personalFilterNotice": "This filter will be available only to you.",
  "label_personalNotificationsSettings": "Personal Notification Settings",
  "label_phoenixReincarnation": "Phoenix reincarnation",
  "label_phone": "Phone",
  "label_phoneGroup": "Phone group",
  "label_phoneGroups": "Phone groups",
  "label_phoneLine": "Phone line",
  "label_photoCapture": "Photo capture",
  "label_photoLocation": "Photo location",
  "label_photoLocationAnalysis": "Photo location analysis",
  "label_photos": "Photos",
  "label_pickedTime": "Picked time",
  "label_pickup": "Pickup",
  "label_pickupCrossOutRadiusPercentage": "Pickup cross OUT radius (percentage)",
  "label_pickupDateNotProvided": "Pickup date not provided",
  "label_pickupDepartureMovingRate": "Pickup departure moving ping rate",
  "label_pickupDepartureMovingRateInfo": "Ping rates will adjust after the shipment status moves to \"In-transit\"",
  "label_pickupDepartureSetting": "Pickup departure settings",
  "label_pickupDepartureStationaryRate": "Pickup departure stationary ping rate",
  "label_pickupLocation": "Pickup location",
  "label_pickupScheduledFor": "Pickup scheduled for <date/>",
  "label_pickupShipment": "Pickup shipment",
  "label_ping": "Ping",
  "label_pingAccuracyCep": "Ping accuracy (CEP, M)",
  "label_pingDetails": "Ping details",
  "label_pingsManager": "Pings manager",
  "label_pinned": "Pinned",
  "label_pinToNavbar": "Display on navigation bar",
  "label_placement": "Placement",
  "label_planeSegment": "Plane segment",
  "label_plannedCarrier": "Planned carrier",
  "label_plannedCarrierCategory": "Planned carrier category",
  "label_plannedDriver": "Planned driver",
  "label_plannedStopCrossOutRadiusPercentage": "Planned stop Cross-Out radius (percentage)",
  "label_plannedTractor": "Planned tractor",
  "label_plannedTrailer": "Planned trailer",
  "label_plusMore": "+ {counter} more",
  "label_policy": "Policy",
  "label_portal": "Portal",
  "label_portalAccess": "Portal access",
  "label_portalContacts": "Portal contacts",
  "label_portalContactsDescription": "List of portals where you are configured as Overhaul contact",
  "label_portalFiltersIgnored": "Portal filters ignored",
  "label_portalProfile": "Portal profile",
  "label_portalSelectionTemplates": "Portal selection templates",
  "label_portalView": "Portal view",
  "label_portalViewsWarningMessage": "This company exists in more than one portal. If the contact should be included in all portals, proceed to the next step. However, if the contact should only be included in certain portals, select those portals from the dropdown below.",
  "label_portOfRegistry": "Port of registry",
  "label_positiveFactorMultipliers": "Positive factor multipliers",
  "label_positiveFactors": "Positive factors",
  "label_positiveFactorsDescription": "Positive factors are a summary of any shipment factors that have a positive impact on shipment risk",
  "label_positiveFactorTabelTitle": "Positive factors, if detected on a shipment, are used as divisors to decrease the shipment’s risk score, to reflect the impact that each factor has on the shipment’s risk profile.",
  "label_postTransit": "Post-Transit",
  "label_powerDownDevice": "Power down device",
  "label_preclearanceDue": "Preclearance due",
  "label_preclearanceSent": "Preclearance sent",
  "label_preDepartureChecklistItems": "Pre departure checklist items",
  "label_predictedProbability": "Confusion score",
  "label_prePickupTractorInactivityAlert": "Pre pickup tractor inactivity alert (minutes)",
  "label_prePickupTrailerInactivityAlert": "Pre pickup trailer inactivity alert (minutes)",
  "label_preTransit": "Pre-Transit",
  "label_preventShipmentCreation": "Prevent shipment creation with low battery",
  "label_preventShipmentCreationDescription": "Prevent shipment creation when battery is low. Requires enabling low battery alerts.",
  "label_previewShipment": "Preview shipment",
  "label_previous": "Previous",
  "label_previousSpeed": "Previous speed",
  "label_primaryReplacementContact": "Primary replacement contact",
  "label_probabilityFor": "Probability for",
  "label_proceedToChecklist": "Proceed to checklist",
  "label_proceedToPickup": "Proceed to pickup",
  "label_product": "Product",
  "label_productDevicesAssignmentDescription": "These product devices will track all the shipment segments",
  "label_productDevicesAssignmentTitle": "Product devices being added to shipment",
  "label_productFamily": "Product family",
  "label_productLine": "Product line",
  "label_products": "Products",
  "label_productsInfo": "Products in this shipment tracked in Asset Manager.",
  "label_productType": "Product type",
  "label_ProductType": "Product type",
  "label_profile": "Profile: {name}",
  "label_profileSelection": "Profile selection",
  "label_properties": "Properties",
  "label_proposedCarrier": "Proposed carrier",
  "label_proposedEndDate": "Proposed end date",
  "label_proposedStartDate": "Proposed start date",
  "label_proposedTractor": "Proposed tractor",
  "label_proposedTrailer": "Proposed trailer",
  "label_protectionTime": "Protection time",
  "label_provideAccess": "Provide access",
  "label_provideShortDescription": "Provide a short description",
  "label_provideUserWithLocation": "Provide user and their location",
  "label_publicLink": "Public link",
  "label_publicTrackingLink": "Public tracking link",
  "label_purchaseOrdersInfo": "In total {weight} lb for {units} units.",
  "label_qrcDocument": "QRC document",
  "label_quality": "Quality",
  "label_qualityAlertName": "Quality alert name",
  "label_qualityAlertType": "Quality alert type",
  "label_qualityGroupName": "Quality group name",
  "label_qualityManagerHub": "Quality manager hub",
  "label_qualityReview": "Quality review",
  "label_qualityReviewAlarmStatus": "Quality review alarm status",
  "label_qualityReviewStatus": "Quality review status",
  "label_quickFilters": "Quick filters",
  "label_quickTransfers": "Quick transfers",
  "label_railEvents": "Rail events",
  "label_railLine": "Rail line",
  "label_railRiskScore": "Rail risk score",
  "label_rate": "Rate",
  "label_rates": "Rates",
  "label_ratesSubtitle": "Provide the expected device reporting frequency rates.",
  "label_reActivate": "Re-activate",
  "label_reactivateSegment": "Re-activate segment",
  "label_reActivateShipmentSegmentModalDescription": "Re-activating this segment will move this shipment to the selected state.",
  "label_reActivateShipmentSegmentModalTitle": "Would you like to re-activate?",
  "label_reActivateShipmentSegmentModalWarning": "Re-activating this segment will hide the current segment’s events from the timeline.",
  "label_reason": "Reason: {reason}",
  "label_reasonCode": "Reason code",
  "label_reasonCodeSelected": "Reason code selected",
  "label_reasonForContact": "Reason for contact",
  "label_reasonForCorrection": "Reason for correction",
  "label_reassignToMe": "Reassign to me",
  "label_recalculateNow": "Recalculate now",
  "label_receivedTime": "Received time",
  "label_receiveNotificationsDescription": "Select when the user should receive notifications.",
  "label_receiveNotificationsTitle": "Receive notifications for:",
  "label_recentRevocationSeverity": "Recent revocation",
  "label_recipients": "Recipients",
  "label_recipientsTo": "To <component/>",
  "label_reconnect": "Reconnect",
  "label_recordableCrashRate": "Recordable crash rate",
  "label_recorded": "Recorded",
  "label_recoveredValue": "Recovered value",
  "label_recurrence": "Recurrence",
  "label_redFlagCarrier": "Red flag carrier",
  "label_redFlagPhotoAlertToggle": "Red flag photo alert",
  "label_redFlags": "Red flags",
  "label_refreshEventsOptions": "Refresh event options",
  "label_refreshForecast": "Refresh forecast",
  "label_refreshTimeline": "Refresh timeline",
  "label_refurbishDevice": "Refurbish device",
  "label_refurbished": "Refurbished",
  "label_regenerate": "Regenerate",
  "label_regenerateDemoShipments": "Regenerate demo shipments with portal demo config",
  "label_regeneratePin": "Regenerate PIN",
  "label_regexPattern": "Regex pattern",
  "label_regionalSettings": "Regional settings",
  "label_regionalWorkflows": "Regional workflows",
  "label_regions": "Regions",
  "label_regular": "Regular",
  "label_regulatoryBorderDelay": "Regulatory / border delay",
  "label_reject": "Reject",
  "label_rejectedEbol": "Rejected at delivery",
  "label_releaseType": "Release/Campaign type",
  "label_reload": "Reload",
  "label_reminderName": "Reminder name",
  "label_reminders": "Reminders",
  "label_reminderSetFor": "Reminder set for: <date/>",
  "label_reminderSetUntil": "Reminder set until <date/>",
  "label_reminderTemplate": "Reminder template",
  "label_removeFromConvoyOnCancelMessage": "Shipment has been removed from convoy {name} due to update to shipment status {status}",
  "label_removeFromConvoyOnDeliveredMessage": "Shipment has been removed from convoy {name} due to shipment delivery update at {location} on <date/>",
  "label_removeFromConvoyOnEditMessage": "Shipment has been manually removed from convoy via convoy edit",
  "label_removeMedicalDevicesOnEdit": "Changing \"Appointment location\", \"Appointment date & time\" or \"Workflow\" will remove all assigned medical devices",
  "label_removePortal": "Remove portal",
  "label_removeVendor": "Remove vendor",
  "label_renameTemplate": "Rename template",
  "label_renameTemplateSubTitle": "You can update the name of the template below",
  "label_reopenedEvents": "Re-opened events",
  "label_repeat": "Repeat",
  "label_replay": "Replay",
  "label_replayedShipmentLogs": "Replayed shipment logs",
  "label_reply": "Reply",
  "label_replyAll": "Reply all",
  "label_replyMode": "Reply mode",
  "label_replyTo": "Reply to",
  "label_replyToInboundMessage": "Reply to inbound message",
  "label_report": "Report",
  "label_reportChorusTags": "Report chorus tags",
  "label_reportedBy": "Reported by",
  "label_reportHistory": "Report history",
  "label_reportId": "Report id",
  "label_reportIncident": "Report incident",
  "label_reportingStatus": "Reporting status",
  "label_reportName": "Report name",
  "label_reportParameters": "Report parameters",
  "label_reportParametersDescription": "Use the following fields to define the attributes to be contained in this report.",
  "label_reportReelables": "Report reelables",
  "label_requiredReferenceFieldsOnShipment": "Required reference numbers on shipment creation",
  "label_reset": "Reset",
  "label_resetExpirationDate": "Reset expiration date",
  "label_resetFirstReport": "Reset first report",
  "label_resetPermissionConfirmation": "Are you sure you want to reset this permission?",
  "label_resetTablePreferences": "Reset columns order and size to default",
  "label_resetToDefault": "Reset to default",
  "label_resolved": "Resolved",
  "label_respondingTo": "Responding to",
  "label_restartInvestigation": "Restart investigation",
  "label_restrictionsDescription": "Restrictions do not impact alerts and notifications. To limit when a user should receive alerts, go to the Alerts & Notifications tab.",
  "label_restrictionsRegulatesDescription": "Restrictions regulates what the user can access when using the Overhaul application. For example, if a user is restricted to an origin, then they will only have access to shipments with that origin in Shipment Manager and Risk Monitor.",
  "label_results": "Results",
  "label_retakePhoto": "Retake photo",
  "label_retypeNewPass": "Retype new password",
  "label_review": "Review",
  "label_reviewAction": "Reviewed action",
  "label_reviewActionModalSubTitle": "Please provide the reviewed action type, reason code, and type text for the confirmed reason to help improve the model.",
  "label_reviewedReasonCode": "Reviewed reason code",
  "label_reviewer": "Reviewer",
  "label_reviewStatus": "Review status",
  "label_riskCategory.high": "High risk",
  "label_riskCategory.low": "Low risk",
  "label_riskCategory.medium": "Medium risk",
  "label_riskCategory.noData": "No risk data",
  "label_riskCategory.noRisk": "No risk",
  "label_riskFactorMultipliers": "Risk factor multipliers",
  "label_riskFactors": "Risk factors",
  "label_riskFactorsDescription": "Risk factors summarises any shipment factors that have a negative impact on shipment risk",
  "label_riskFactorTableCalculationLogic": "Shipment score*[(1+multiplier_1 +multiplier_2 + ..) *(1-mitigator_1 -mitigator_2)]",
  "label_riskFactorTableSubtitle": "The shipment multipliers are applied using the following calculation logic:",
  "label_riskFactorTableTitle": "Risk factors, if detected on a shipment, are used as multipliers to increase the shipment’s risk score, to reflect the impact that each factor has on the shipment’s risk profile.",
  "label_riskGPTImageConfirmation": "RiskGPT confirmed image match",
  "label_riskGPTImageDetails": "RiskGPT image details",
  "label_riskGptStructuredData": "RiskGPT structured data",
  "label_risks": "Risks",
  "label_riskScore": "Risk score",
  "label_riskScoreNumber": "Risk score number",
  "label_riskScoreSettings": "Risk score settings",
  "label_riskScoreTemplate": "Risk score template",
  "label_riskScoreTemplateWarning": "This workflow uses a risk score template from {portalName}. Removing this portal from this workflow will result in the standardised risk scores being used instead",
  "label_riskSummary": "Risk summary",
  "label_riskZoneLightSettings": "Risk zone & delivery light settings",
  "label_roadClosure": "Road closure",
  "label_roadSegment": "Road segment",
  "label_rotateLeft": "Rotate left",
  "label_rotateRight": "Rotate right",
  "label_rowsCount": "Rows count",
  "label_rule": "Rule",
  "label_ruleName": "Rule name",
  "label_rules": "Rules",
  "label_ruleTooltip": "Rule tooltip",
  "label_runningAnotherCarriersTractorFleet": "Running another carrier's tractor fleet",
  "label_runningStoppedCarriersTrailerFleet": "Running a stopped carrier's trailer fleet",
  "label_saferStatus": "Safer status",
  "label_saferStatusLastUpdatedAt": "Safer status last updated at",
  "label_safety": "Safety",
  "label_safetyRating": "Safety rating",
  "label_salesRep": "Sales rep",
  "label_sameUsdotInfoTitle": "Same as planned carrier (USDOT matches)",
  "label_satisfactory": "Satisfactory",
  "label_savedFilterViews": "Saved filter views",
  "label_savedFilterViewsSubtitle": "The saved filter will appear in the navigation bar with a shipment count.",
  "label_saveFilters": "Save filters",
  "label_saveSelection": "Save selection",
  "label_scacAliases": "SCAC code aliases",
  "label_scacCode": "SCAC code",
  "label_scan": "Scan",
  "label_scGoDriverOnlyPickup": "Shipment Connect Go driver only pickup",
  "label_scopes": "Scopes",
  "label_score": "Score",
  "label_scoreDecreaseByTrend": "-{trendValue} score decrease",
  "label_scoreIncreaseByTrend": "+{trendValue} score increase",
  "label_scoreUnchanged": "Score unchanged",
  "label_seal": "Seal",
  "label_sealOpenGenerated": "Seal open generated",
  "label_searchCarrierData": "Search by carrier name, USDOT or operating authorities",
  "label_searchFmcsa": "Search FMCSA",
  "label_searchForShipment": "Search for your shipment",
  "label_searchResults": "Search results",
  "label_secondBatteryLevelAlert": "Second battery level alert",
  "label_secondNotif": "Second notification",
  "label_security": "Security",
  "label_securityRiskModelWeightingCategories": "Security risk model weighting categories",
  "label_seeAssociatedContacts": "See associated contacts",
  "label_seeMore": "See {count} more",
  "label_segment": "Segment",
  "label_segmentNumber": "Segment number",
  "label_segments": "Segments",
  "label_selectAction": "Select action",
  "label_selectCoo": "Select COO",
  "label_selectedProductsCount": "Selected products: {count}",
  "label_selectFieldName": "Select field name",
  "label_selectOwner": "Select owner",
  "label_selectPortalsToLocationDuplicate": "Select the portals to duplicate locations to",
  "label_selectReason": "Select a reason",
  "label_selectRegion": "Select region",
  "label_selectSharedEntityProvider": "Select shared entity provider",
  "label_selectSource": "Select source",
  "label_selectTeam": "Select team",
  "label_selectTimeframe": "Select timeframe",
  "label_selectToAttachSmsFile": "Select where you want to attach photos",
  "label_selfieCheckStatus": "Selfie liveness",
  "label_senderEmail": "Sender email",
  "label_sendNow": "Send now",
  "label_sendReply": "Send reply",
  "label_sendTo": "Send to",
  "label_sensorData": "Sensor data",
  "label_serviceState": "Service state",
  "label_setActiveDestination": "Set active destination",
  "label_setDefaultDashboard": "Set as default dashboard",
  "label_setStockThreshold": "Set stock threshold",
  "label_shareableLink": "Shareable link",
  "label_shareContact": "Share contact",
  "label_sharedAddressCluster": "Shared address cluster",
  "label_sharedEmailDomainCluster": "Shared email domain cluster",
  "label_sharedPhoneNumberCluster": "Shared phone number cluster",
  "label_sharedPortals": "Shared portals",
  "label_sharePublicLink": "Share public link",
  "label_shipment": "Shipment",
  "label_shipmentAssets": "Shipment assets (products)",
  "label_shipmentCanceled": "Shipment canceled",
  "label_shipmentClosed": "Shipment closed",
  "label_shipmentCreationSettings": "Shipment creation settings",
  "label_shipmentDeclined": "Shipment declined",
  "label_shipmentDelivered": "Shipment delivered",
  "label_shipmentDemoDataSubtitle": "This page is responsible for demo data for portal \"{name}\"",
  "label_shipmentDemoDataTitle": "Shipment demo data",
  "label_shipmentDeviation": "Shipment deviation",
  "label_shipmentNotFound": "Shipment not found",
  "label_shipmentRecipientEmail": "Shipment QR code delivery recipient email address",
  "label_shipmentReference": "Shipment reference",
  "label_shipmentRiskScore": "Shipment risk score",
  "label_shipmentsOverhaul": "Shipments (Overhaul)",
  "label_shipmentStatuses": "Shipment statuses",
  "label_shipmentTimeline": "Shipment timeline",
  "label_shipmentUnwatchStateChanged": "You have successfully unwatched this shipment. The shipment will be removed from your ‘watching‘ shipment group.",
  "label_shipmentValue": "Shipment value",
  "label_shipmentWatchStateChanged": "Watched shipments can be viewed in the ‘Watching’ shipment group in your navigation bar. Click ‘Configure navigation bar’ to enable this view.",
  "label_ships": "Ships",
  "label_shipSegment": "Ship segment",
  "label_showAlternativeDestinations": "Show alternative destinations",
  "label_showDestinations": "Show destinations",
  "label_showEscortConnectAccess": "Show Escort Connect access",
  "label_showForecast": "Show forecast",
  "label_showMore": "Show {count} more",
  "label_showMotionStatusChangeEvents": "Show moving/stationary events",
  "label_showVehicleStatusChangeEvents": "Show moving/stationary events",
  "label_showViolationOnDeviceGraph": "Show violation on device graph",
  "label_signalStrength": "Signal strength",
  "label_simplifiedOperator": "Matches",
  "label_skip": "Skip",
  "label_sms": "SMS",
  "label_sortAscending": "Sort ascending",
  "label_sortDescending": "Sort descending",
  "label_ssid": "SSID",
  "label_sso": "SSO",
  "label_ssoIdentityProviders": "SSO identity providers",
  "label_SSORole": "SSO role",
  "label_ssoSettings": "SSO settings",
  "label_stagingTime": "Staging alert: time before delivery (mins)",
  "label_standardized": "Standardized",
  "label_standardizedPhotos": "Standardized photos",
  "label_standardizedPhotosDescription": "Setting this toggle will require the standardized photo fields for vision GPT for pickup submission: 1. Carrier Name/Logo and DOT/MC# 2. Photo of trailer doors (include license plate, doors, seal) 3. Picture of tractor 4. Picture of trailer side logo 5. Pictures of BoL 6. Picture of driver license 7. Photo of trailer opacity",
  "label_standardizedQrc": "Standardized QRCs",
  "label_startingDate": "Starting <date/>",
  "label_startPickup": "Start pickup",
  "label_startVerification": "Start verification",
  "label_state": "State",
  "label_stationaryRate": "Stationary rate",
  "label_sterile": "Sterile",
  "label_sterility": "Sterility",
  "label_stopGenerated": "Stop generated",
  "label_stopsCount": "{count} stops",
  "label_storageRequirements": "Storage requirements",
  "label_strongSignal": "Strong",
  "label_subcategory": "Subcategory",
  "label_submitAnyway": "Submit anyway",
  "label_submitChecklist": "Submit checklist",
  "label_submitCorrection": "Submit correction",
  "label_submitReview": "Submit review",
  "label_submitVerification": "Submit verification",
  "label_subscribeToReport": "Subscribe to report",
  "label_subscriptionIs": "<span>{name}<span> <strong>Is<strong> <span>{title}<span/>",
  "label_subscriptionIsNot": "<span>{name}<span> <strong>Is not<strong> <span>{title}<span/>",
  "label_subscriptionName": "Subscription name",
  "label_subType": "Sub-type",
  "label_supervisors": "Supervisors",
  "label_suretyBondFiled": "Surety bond filed",
  "label_suretyBondRequired": "Surety bond required",
  "label_surgeon": "Surgeon",
  "label_switchReasonWorkflowGroupChange": "Updated to regional workflow group rates",
  "label_switchToMobileVersion": "Switch to mobile version",
  "label_systemEntity": "System",
  "label_systemStandardizedPhoto": "System standardized photo",
  "label_systemViews": "System views",
  "label_tag": "Tag",
  "label_tagDetectionDescription": "Enables BLE (bluetooth low energy) tag reading.",
  "label_tagDetectionMode": "Tag detection mode",
  "label_tagDeviceId": "Tag device ID",
  "label_tagModel": "Tag model: {name}",
  "label_tagPlate": "Tag/Plate",
  "label_tagRxTime": "Tag RX time",
  "label_tags": "Tags",
  "label_takePhoto": "Take photo",
  "label_target": "Target",
  "label_team": "Team",
  "label_teamName": "Team name",
  "label_teams": "Teams",
  "label_telematicsShipmentAndRouteDeviations": "Telematics shipment and route deviations only",
  "label_telematicsStopsOnly": "Telematics stops only",
  "label_telematicsStopsOnlyDescription": "Shipments will only generate stop and detention time events from telematics sources. IoT devices will NOT generate stops when enabled. If there are no telematics data after pickup submission, then we will default back to normal stop logic.",
  "label_telephone": "Telephone",
  "label_temperatureState": "Temperature state",
  "label_templateName": "Template name",
  "label_temporary": "Temporary",
  "label_tempThresholdName": "Temperature threshold name",
  "label_tenantID": "Tenant ID",
  "label_tenantType": "Tenant type",
  "label_textQrc": "Text QRC",
  "label_texts": "Texts",
  "label_theme": "Theme",
  "label_thirdBatteryLevelAlert": "Third battery level alert",
  "label_threatsFound": "Threats found",
  "label_threatsResolved": "Threats resolved",
  "label_time": "Time",
  "label_timeAtLocation": "Time at location",
  "label_timeFormat": "Time format",
  "label_timesInUTC": "Times are in UTC",
  "label_timestamp": "Timestamp",
  "label_timeWithinZone": "Time within the zone",
  "label_timezone": "Time zone",
  "label_timing": "Timing",
  "label_toAlertEmail": "To <strong>Auto alert email</strong>",
  "label_toEscalationEmail": "To <strong>Escalation email</strong>",
  "label_toggleDetails": "Toggle details",
  "label_topCount": "Top {count}",
  "label_topTenMostAlertRoutes": "Top 10 routes that resulted in the highest number of alerts",
  "label_topTenShipments": "Top 10 shipments",
  "label_topTenShipmentsInMinutes": "Top 10 shipments (in minutes)",
  "label_totalActiveAssets": "Total active assets",
  "label_totalAppointments": "Total appointments",
  "label_totalAssets": "Total assets",
  "label_totalCDLDrivers": "Total CDL drivers",
  "label_totalDriversEmployed": "Total drivers employed",
  "label_totalDriverViolationRate": "Total driver violation rate",
  "label_totalExcursions": "Total excursions",
  "label_totalInterstateDrivers": "Total interstate drivers",
  "label_totalMileage": "Total mileage",
  "label_totalMileageMostRecentYear": "Total mileage (most recent year)",
  "label_totalMileageYear": "Total mileage {mileageYear}",
  "label_totalOnHand": "Total on hand",
  "label_totalOperatingMonths": "Total operating months",
  "label_totalPersonalisedScore": "Total personalised score",
  "label_totalPieces": "Total pieces",
  "label_totalScore": "Total score",
  "label_totalTimeOutOfRange": "Total time out of range",
  "label_totalTrailers": "Total trailers",
  "label_totalTrailersUnits": "Total trailers / units",
  "label_totalTrucks": "Total trucks",
  "label_totalVehicles": "Total vehicles",
  "label_totalViolationRate": "Total violation rate",
  "label_trackingDevice": "Tracking device",
  "label_trackingDevices": "Tracking devices",
  "label_trackingSource": "Tracking source",
  "label_trackRecord": "Track record",
  "label_tractorFleetSourceUsdot": "Tractor fleet source USDOT",
  "label_tradeName": "Trade name",
  "label_traffic": "Traffic",
  "label_trailerFleetSourceUsdot": "Trailer fleet source USDOT",
  "label_trailers": "Trailers",
  "label_trailerSeal": "Trailer seal",
  "label_trainSegment": "Train segment",
  "label_transfer": "Transfer",
  "label_transferAsset": "Transfer asset to another company",
  "label_transferIntoCompany": "Transfer into company *",
  "label_transferOutOfCompany": "Transfer out of company",
  "label_transferSent": "Transfer request sent",
  "label_trucks": "Trucks",
  "label_trueRuleOutcome": "True rule outcome",
  "label_ttsDetails": "TTS details",
  "label_type": "Type",
  "label_unarchiveNotification": "Unarchive notification",
  "label_unassign": "Unassign",
  "label_unauthorizedCarrier": "Unauthorized carrier",
  "label_unauthorizedCarrierCategory": "Unauthorized carrier category",
  "label_unauthorizedDriver": "Unauthorized driver",
  "label_undeliverableBusinessAddress": "Undeliverable business address",
  "label_undeliverableMailingAddress": "Undeliverable mailing address",
  "label_underline": "Underline",
  "label_unit": "Unit",
  "label_unitIds": "Unit IDs",
  "label_unitItemQuantity": "Unit-item quantity",
  "label_unitOfMeasure": "Unit of measure",
  "label_unitQuantity": "Unit qty",
  "label_units": "Units",
  "label_unknown": "Unknown",
  "label_unknownBattery": "Unknown battery",
  "label_unlockShipment": "Unlock shipment",
  "label_unmute": "Unmute",
  "label_unresolved": "Unresolved",
  "label_unsatisfactory": "Unsatisfactory",
  "label_unsavedChanges": "Unsaved version",
  "label_unsavedVersion": "Unsaved version",
  "label_unstructuredData": "Un-Structured data",
  "label_until": "Until",
  "label_uom": "UOM",
  "label_updateActualRoute": "Update actual route",
  "label_updatedBy": "Updated by",
  "label_updateDestination": "Update destination",
  "label_uploadEventAttachments": "Upload and add event attachments using the file upload options below.",
  "label_usage": "Usage",
  "label_usageType": "Usage type",
  "label_usCanadaScore": "US/Canada score",
  "label_usCanadaWeighting": "US/Canada weighting",
  "label_usCarrierRiskscoreThreshold": "US carrier risk-score threshold",
  "label_usCarriersEnabled": "US carriers",
  "label_usdot": "USDOT",
  "label_usdotNotProvided": "USDOT not provided",
  "label_usDotNumber": "USDOT number",
  "label_usdotNumberWithValue": "USDOT {usdotNumber}",
  "label_usdotStatus": "USDOT status",
  "label_usePKCE": "Use PKCE",
  "label_userInvestigating": "{userName} investigating",
  "label_USStates": "US states",
  "label_utilizationValue": "Utilization value",
  "label_valid": "Valid",
  "label_validExample": "Valid example (shown to users)",
  "label_validity": "Validity",
  "label_valueCurrency": "Value currency",
  "label_valuesAdded": "Values added",
  "label_valueStolen": "Value stolen",
  "label_vehicleOOSRate": "Vehicle out-of-service rate",
  "label_vehicleOutOfServiceViolationRate": "Vehicle Out-of-Service violation rate",
  "label_vendorsSettings": "Vendors settings",
  "label_verificationStatus": "Verification status",
  "label_verified": "Verified",
  "label_verifiedCarrier": "Verified carrier",
  "label_verifiedCarrierTooltipInfo": "US motor carriers confirmed by the FMCSA records",
  "label_verify": "Verify",
  "label_versionControl": "Version control",
  "label_viaDeviceProfile": "Via device profile",
  "label_viewActiveNotifications": "View active notifications",
  "label_viewAll": "View all",
  "label_viewAlternativeDestinations": "View alternative destinations",
  "label_viewArchivedNotifications": "View archived notifications",
  "label_viewChecklistItems": "View checklist items",
  "label_viewEbol": "View eBOL",
  "label_viewed": "Viewed",
  "label_viewedBy": "Viewed by",
  "label_viewedByNameTimeAgo": "Viewed by {name} {time} ago",
  "label_viewFullReport": "View full report",
  "label_viewItemDetails": "View item details",
  "label_viewLocations": "View locations",
  "label_viewMissingItems": "View missing items",
  "label_viewPackout": "View packout",
  "label_viewRiskscoreTemplate": "View risk score template",
  "label_viewSecureBol": "View secureBOL",
  "label_viewTemperatureReport": "View temperature report",
  "label_viewTranscript": "View transcript",
  "label_viewWorkflowItems": "View workflow items",
  "label_violationEnabled": "Enable violation",
  "label_violationRate": "Violation rate",
  "label_virtualBusinessAddress": "Virtual business address",
  "label_virtualMailingAddress": "Virtual mailing address",
  "label_voicemailStatus": "Voicemail status",
  "label_waiveEvent": "Waive event",
  "label_warehouses": "Warehouses",
  "label_watchOfficerAction": "Watch officer action",
  "label_weakSignal": "Weak",
  "label_weatherSummary": "Weather summary",
  "label_weatherWarningsForecast": "Weather warnings forecast",
  "label_weatherWarningsForecastDescription": "Upcoming weather warnings for this shipment's route",
  "label_webToWeb": "Web to web",
  "label_welcomeDriver": "Welcome, {name}!",
  "label_widgetSettings": "Widget settings",
  "label_wifiData": "Wifi data",
  "label_wOCorrectButton": "WO correct",
  "label_wOCorrectModalSubTitle": "You are confirming that the watch Officer’s action was correct and the AI prediction needs improvement",
  "label_wOCorrectModalTitle": "Confirm watch officer action",
  "label_workflowItem": "Workflow item",
  "label_workflowSteps": "Workflow steps",
  "label_workspace": "Workspace",
  "label_yesImSure": "Yes, I'm sure",
  "label_you": "You",
  "label_yourLocation": "Your location",
  "label_zoomIn": "Zoom in",
  "label_zoomOut": "Zoom out",
  "lanes": "Lanes",
  "lanesAssociationsChip": "{from} to {to}",
  "language": "Language",
  "language_cs": "Czech",
  "language_de": "German",
  "language_dk": "Danish",
  "language_en": "English",
  "language_en-US": "English US",
  "language_es": "Spanish",
  "language_es-MX": "Spanish (Mexico)",
  "language_fr": "French",
  "language_hu": "Hungarian",
  "language_id": "Indonesian",
  "language_it": "Italian",
  "language_ja": "Japanese",
  "language_nl": "Dutch",
  "language_no": "Norwegian",
  "language_pl": "Polish",
  "language_pt": "Portuguese",
  "language_pt-BR": "Portuguese (Brazil)",
  "language_ru": "Russian",
  "languages": "Languages",
  "language_s": "Language(s)",
  "language_se": "Swedish",
  "language_tr": "Turkish",
  "language_uk": "Ukrainian",
  "language_vi": "Vietnamese",
  "language_zh": "Chinese simplified",
  "language_zh-MY": "Chinese traditional",
  "last": "Last",
  "lastActive": "Last active",
  "lastAssignedToOrigin": "Last assigned to origin",
  "lastClosedTime": "Last closed time",
  "lastDeliveryLocationIs": "Last delivery location is",
  "lastDeviceData": "Last device data",
  "lastLocation": "Last location",
  "lastName": "Last name",
  "lastNamePlaceholder": "Enter last name",
  "lastNDays": "Last {count} days",
  "lastOpenTime": "Last open time",
  "lastPing": "Last ping",
  "lastPort": "Last port",
  "lastPortTime": "Last port time",
  "lastReportDate": "Last report date",
  "lastReturned": "Last returned",
  "lastSealClosedTime": "Last seal closed time",
  "lastSealOpenTime": "Last seal open time",
  "lastSevenDays": "Last 7 days",
  "lastThirtyDays": "Last 30 days",
  "lastUpdate": "Last update",
  "lastUpdated": "Last updated",
  "lastUpdateDate": "Last update: <date>",
  "lastUpdatedDuration": "Updated {duration} ago",
  "lastUpdateTimestamp": "Last update timestamp",
  "lat": "Lat",
  "latCoordsPlaceholder": "Lat e.g. 35.13959",
  "late": "Late",
  "late_arrival_violation": "Late arrival",
  "late_delivery_violation": "Late delivery",
  "late_departure": "Late departure",
  "lateDeparture": "Late departure (minutes)",
  "lateDepartureMinutes": "Late departure alert (minutes)",
  "late_departure_pickup_shipment_event": "Late departure",
  "late_departure_violation": "Late departure",
  "lateEtaMinutes": "Late ETA (minutes)",
  "lateETAStatus": "ETA - late - expected time of delivery",
  "lateETAStatusKPIHint": "Expected time delivery - LATE: active & projecting to deliver late",
  "late_pickup_violation": "Late pickup",
  "late_pre_check_submission_violation": "Late Pre-Departure checklist",
  "latestEvent": "Latest event",
  "latitude": "Latitude",
  "leave": "Leave",
  "leave_ddi_radius_shipment_event": "Departure from pickup",
  "leavePage": "Leave page",
  "leave_pickup_location_shipment_event": "Leave pickup location",
  "leaving_lockdown_location_shipment_event": "Lock down exit alert",
  "leaving_lockdown_location_violation": "Lock down exit alert",
  "LEConnect": "LE Connect",
  "legal_name": "Legal name",
  "legIsCancelled": "This leg is cancelled",
  "length": "Length",
  "lengthUnit_cm": "cm",
  "lengthUnit_in": "in",
  "licenseComputedStatus_expired": "Expired",
  "licenseComputedStatus_nearlyExpires": "Nearly expires",
  "licenseComputedStatus_notCdl": "CDL not detected",
  "licenseComputedStatus_notVerified": "Not verified",
  "licenseComputedStatus_verificationIncomplete": "Verification incomplete",
  "licenseVerificationDateColumn": "License validated",
  "licenseVerificationStatus_autoApproved": "Auto approved",
  "licenseVerificationStatus_autoDeclined": "Auto declined",
  "licenseVerificationStatusColumn": "License status",
  "licenseVerificationStatus_error": "Error",
  "licenseVerificationStatus_manuallyApproved": "Manually approved",
  "licenseVerificationStatus_manuallyDeclined": "Manually declined",
  "licenseVerificationStatus_needsReview": "Needs review",
  "licenseVerificationStatus_ongoing": "Ongoing",
  "licenseVerificationStatus_userCancelled": "User cancelled",
  "light": "Light",
  "lightAlertDelay": "Light alert delay",
  "lightAlerts": "Light alerts",
  "light_alert_violation": "Light alert",
  "lightSettings": "Light settings",
  "light_shipment_event": "Light alert",
  "limit": "Limit",
  "limitsValidationError": "Must be {typeOne} than {typeTwo} limit",
  "line": "Line",
  "link": "Link",
  "liquidGasCapacity": "Liquid gas capacity",
  "liquidOilCapacity": "Liquid oil capacity",
  "listOfPOs": "List of PO#s",
  "listOfTags": "List of tags",
  "liveUpdatesExpired": "Live updates have been expired in this session. Please refresh the page to resume updates",
  "lng": "Lng",
  "lngCoordsPlaceholder": "Lng e.g. -90.051",
  "loader": "Loading data",
  "loading": "Loading...",
  "load_lock_shipment_event": "Load lock submission",
  "locale": "Locale",
  "localTimezone": "User local time zone",
  "location": "Location",
  "locationActivate": "Are you sure you want to activate the location {name}?",
  "locationActivationSuccessfullMessage": "Location activated successfully",
  "locationAddress": "Location address",
  "locationAfterMerge": "Location after merge",
  "location_arrival": "Location arrival",
  "locationAttributes": "Location attributes",
  "locationCount": "Location count",
  "locationCreatedSuccessfully": "Location created successfully",
  "locationCreatedSuccessfullySubtitle": "{locationName} is now available. Do you want to continue and add additional attributes?",
  "locationCreator": "Location creator",
  "locationCustomer": "Customer",
  "locationDataUpdateErrorMessage": "Additional attributes saved successfully however there was an error when saving location attributes.",
  "locationDeactivate": "Are you sure you want to deactivate the location {name}?",
  "locationDeactivationSuccessfullMessage": "Location deactivated successfully",
  "locationDepartment": "Location department",
  "locationDepartmentSubtitle": "Select the relevant location where the department is shown:",
  "location_departure": "Location departure",
  "locationDepot": "Depot",
  "locationDisruptionImpactLevel_high": "High",
  "locationDisruptionImpactLevel_low": "Low",
  "locationDisruptionImpactLevel_medium": "Medium",
  "locationDisruptionType_civilUnrest": "Civil unrest",
  "locationDisruptionType_naturalDisaster": "Natural disaster",
  "locationDisruptionType_regulatoryDelay": "Regulatory & border delay",
  "locationDisruptionType_roadClosure": "Road closure & infrastructure disruption",
  "locationDisruptionType_weather": "Weather",
  "locationDistributionCentre": "Distribution centre",
  "locationEditor": "Location editor",
  "locationEscalations": "Location escalations",
  "locationEscalationsSubtitle": "Select the relevant location types:",
  "locationFromTo": "{from} <strong>to</strong> {to}",
  "locationFulfillmentnCenter": "Fulfillment center",
  "locationHint": "Choose locations by searching for location alias, name, address, lat./long. Or airport and seaport short codes.",
  "locationImportInfoMessage": "Please note that this import may take an extended period of time where existing locations are being updated",
  "locationIsAvailable": "{locationName} is now available.",
  "locationIsNowAvailable": "1 location is now available.",
  "locationIsNowDeactivated": "1 location is now deactivated.",
  "locationName": "Location name",
  "locationNotes": "Location notes (optional)",
  "locationNumber": "#{number} {locationName}",
  "locationOutsideGeofenceError": "To add the geofence, the location must be inside the boundary",
  "locationOutsideStorage": "Outside storage",
  "locations": "Locations",
  "locations.activeHours": "Active hours",
  "locationsAndZones": "Locations & zones",
  "locationsAreNowAvailable": "{locationCount} locations are now available.",
  "locationsAreNowDeactivated": "{locationCount} locations are now deactivated.",
  "locations.createAddress": "Create address",
  "locations.createAddressManually": "Create address manually",
  "locations.createManually": "Create manually",
  "locationsDeactivatedSuccessfully": "Locations deactivated successfully",
  "locations.deliveryCrossInDescription": "Note, where workflow settings exist related to delivery cross in/out, the location settings will take priority",
  "locations.editAddress": "Edit address",
  "locations.infoMessage_activeHours": "Where active hours exist, the selected zone will be enabled during that period of time and disabled outside of it. Where a day has no active hours listed, it will be active at all times on that day.",
  "locations.infoMessage_addGeofence": "Add an additional polygonal geofence to the location",
  "locations.infoMessage_ensureCorrectCoordinates": "When editing address, please ensure coordinates are correct",
  "locations.infoMessage_locationIsOnActiveRoute": "This location currently exists on an active route. Please remove this location from the route to continue",
  "locations.label_addActiveHours": "Add active hours",
  "locations.label_allPortals": "Global (show for all portals)",
  "locations.label_correctAddressNotFound": "Correct address not found?",
  "locations.label_editActiveHours": "Edit active hours",
  "locations.label_ignoreCertainEvents": "Ignore certain events",
  "locations.label_ignoreEvents": "Ignore events",
  "locations.label_ignoreEventsTooltip": "Selected events will generate without a risk score inside this geofence",
  "locations.label_selectIgnoreEvents": "Select ignore events types",
  "locations.locationDeactivateAssignedDevicesWarning": "Warning! You are attempting to deactivate a location that currently has devices assigned. Please re-assign these devices and try again.",
  "locationsMergeStep_reviewAndMerge": "Review and merge",
  "locationsMergeStep_reviewAndMergeDescription": "Verify the details below before finalizing the merge",
  "locationsMergeStep_selectAdditionalAttrs": "Select additional attributes",
  "locationsMergeStep_selectLocations": "Select locations",
  "locationsMergeStep_selectLocationsDescription": "Select two or more locations with the same latitude and longitude to merge. You will be able to choose the preferred attributes for the merged location in the following steps",
  "locationsMergeStep_selectPrimaryAttrs": "Select primary attributes",
  "locationsMergeStep_selectPrimaryAttrsDescription": "Compare the attributes of the selected locations on each card and select your preferred values",
  "locations.noActiveHours": "No active hours added",
  "locationsReactivatedSuccessfully": "Locations reactivated successfully",
  "locations.shipmentRefToggle": "Shipment ref optional",
  "locations.warningMessage_locationDeactivateAssignedMedicalDevices": "Warning! You are attempting to deactivate a location that currently has medical devices assigned. Please re-assign these medical devices and try again.",
  "locationType": "Location type",
  "locationType_airport": "Airport",
  "locationType_dangerZone": "Danger zone",
  "locationType_disruption": "Disruption",
  "locationType_distributionCenter": "Distribution center",
  "locationType_ebol": "eBOL",
  "locationType_hospital": "Hospital",
  "locationType_hotZone": "Hot zone",
  "locationType_location": "Location",
  "locationType_lowCoverageZone": "Low coverage zone",
  "locationType_openMicZone": "Open mic zone",
  "locationType_safeZone": "Safe zone",
  "locationType_seaport": "Seaport",
  "locationType_warehouse": "Warehouse",
  "locationUpdatedError": "Error occurred while saving location.",
  "locationUpdatedSuccessfully": "Location saved successfully",
  "locationVendor": "Vendor",
  "lock": "Lock",
  "lockDown": "Lock down duration",
  "lockDownCanceledByUser": "Shipment unlocked by {userName}",
  "lockDownHistory": "Shipment lockdowns",
  "lockDownlabel": "Lockdown",
  "lockDownRadius": "Lock down radius",
  "lockDownSetAt": "Lockdown set at:",
  "lockdownShipment": "Lockdown shipment",
  "locked": "Locked",
  "locked_down": "Shipment locked down",
  "lockedDownAt": "Locked down at",
  "lockedDownUntil": "Locked down until",
  "logo": "Logo",
  "logOut": "Log out",
  "long": "Long",
  "longitude": "Longitude",
  "losses": "Losses",
  "lossValue": "Loss value",
  "lostDamaged": "Lost/Damaged",
  "lostDamagedIncidents": "Lost/Damaged incidents",
  "lostDeviceThresholdDays": "Lost device threshold (days)",
  "lostShipmentsKPIHint": "Count of Lost/Damaged incidents",
  "loves": "Love's",
  "low": "Low",
  "low_battery_level_shipment_event": "Low battery level",
  "low_battery_level_violation": "Low battery level",
  "lowerShockLimit": "Lower shock limit for devices (G)",
  "lowerTempLimitInFahrenheit": "Lower temperature limit for devices (fahrenheit)",
  "lowerTiltLimitInDegrees": "Lower tilt limit for devices (degrees)",
  "lowest": "Lowest",
  "lowLimitValue": "Lower {value}{units} limit",
  "lowPriorityRange": "Low priority",
  "lowPriorityRisk": "Low priority risk",
  "lowPriorityRisks": "Low priority risks",
  "Low Priority Risks": "Low priority risks",
  "lowRisk": "Low risk",
  "lowRiskCount": "{count} low risk",
  "lowRiskPopulation": "Low risk population",
  "lowRiskViolations": "Low risk violations",
  "lowSecurity": "Public",
  "lum": "LUM",
  "lumDescription": "Lumen - the unit of measurement for luminous flux",
  "lux": "LUX",
  "luxDescription": "Lux - the unit of measurement for illuminance",
  "luxLumError": "One of lux or lum should be entered",
  "m": "m",
  "mainIdentifier": "Customize shipment identifier",
  "maintenanceShop": "Maintenance shop",
  "make": "Make",
  "manageActions": "Manage asset actions",
  "manageCompany": "Manage company",
  "manageContacts": "Manage contacts",
  "manager": "Manager",
  "manual": "Manual",
  "manualEnteringLogic": "Logic is dependent on manually entering each reason in each language",
  "manualShipmentEventIncidentCause_criminal": "Criminal",
  "manualShipmentEventIncidentCause_driver": "Driver",
  "manualShipmentEventIncidentCause_hardware": "Hardware / equipment",
  "manualShipmentEventIncidentCause_other": "Other",
  "manualShipmentEventIncidentCause_shipment": "Shipment",
  "manualShipmentEventIncidentType_alteredPaperwork": "Altered paperwork",
  "manualShipmentEventIncidentType_attempted": "Attempted",
  "manualShipmentEventIncidentType_beingFollowed": "Being followed",
  "manualShipmentEventIncidentType_btsBypassed": "BTS bypassed",
  "manualShipmentEventIncidentType_conveyanceIssue": "Conveyance issue",
  "manualShipmentEventIncidentType_deviceIssue": "Device issue",
  "manualShipmentEventIncidentType_doubleBrokering": "Double brokering",
  "manualShipmentEventIncidentType_doubleLoading": "Double loading",
  "manualShipmentEventIncidentType_driverIssue": "Driver issue",
  "manualShipmentEventIncidentType_fraud": "Fraud",
  "manualShipmentEventIncidentType_ftlTheft": "FTL theft",
  "manualShipmentEventIncidentType_hijacking": "Hijacking",
  "manualShipmentEventIncidentType_hostage": "Hostage",
  "manualShipmentEventIncidentType_other": "Other",
  "manualShipmentEventIncidentType_pilferage": "Pilferage",
  "manualShipmentEventIncidentType_shipmentIssue": "Shipment issue",
  "manualShipmentEventIncidentType_suspected": "Suspected",
  "manualShipmentEventIncidentType_suspiciousActivity": "Suspicious activity",
  "manualShipmentEventInitiator_broker": "Broker",
  "manualShipmentEventInitiator_carrier": "Carrier",
  "manualShipmentEventInitiator_client": "Client/Shipper",
  "manualShipmentEventInitiator_driver": "Driver",
  "manualShipmentEventInitiator_gsoc": "GSOC",
  "manualShipmentEventReasonCode_alternateDelivery": "Alternate delivery",
  "manualShipmentEventReasonCode_atDelivery": "At delivery",
  "manualShipmentEventReasonCode_attemptedTheft": "Attempted theft",
  "manualShipmentEventReasonCode_containerWellCheck": "Container well check",
  "manualShipmentEventReasonCode_crossdock": "Crossdock",
  "manualShipmentEventReasonCode_customsIssue": "Customs issue",
  "manualShipmentEventReasonCode_driverNonCompliance": "Driver non-compliance",
  "manualShipmentEventReasonCode_falseAlert": "False alert",
  "manualShipmentEventReasonCode_falseDeviationAlert": "False deviation alert",
  "manualShipmentEventReasonCode_falseLightAlert": "False light alert",
  "manualShipmentEventReasonCode_falsePanicButtonAlert": "False panic button alert",
  "manualShipmentEventReasonCode_falseSealOpenAlert": "False seal open alert",
  "manualShipmentEventReasonCode_falseSeparationAlert": "False separation alert",
  "manualShipmentEventReasonCode_knowLocation": "Know location",
  "manualShipmentEventReasonCode_lightAtPort": "Light at port",
  "manualShipmentEventReasonCode_ltl": "LTL",
  "manualShipmentEventReasonCode_mixedUpLoad": "Mixed up load",
  "manualShipmentEventReasonCode_pilferage": "Pilferage",
  "manualShipmentEventReasonCode_recovery": "Recovery",
  "manualShipmentEventReasonCode_reEscalatedEvent": "Re-escalated event",
  "manualShipmentEventReasonCode_safeZone": "Safe zone",
  "manualShipmentEventReasonCode_sealOpenAtPort": "Seal open at port",
  "manualShipmentEventReasonCode_theft": "Theft",
  "manualShipmentEventReasonCode_trafficAccident": "Traffic accident",
  "manualShipmentEventReasonCode_transload": "Transload",
  "manualShipmentEventReasonCode_unknown": "Unknown",
  "manualShipmentEventReasonCode_wrongDestinationOriginIssue": "Wrong destination origin issue",
  "manualShipmentEventResponseType_both": "Both (PS & LE)",
  "manualShipmentEventResponseType_LE": "LE",
  "manualShipmentEventResponseType_none": "None",
  "manualShipmentEventResponseType_private": "Private",
  "manualShipmentEventResponseType_security": "Security",
  "manualShipmentEventResult_fullLoss": "Full loss",
  "manualShipmentEventResult_pilferage": "Pilferage",
  "manualShipmentEventResult_preventative": "Preventative",
  "manualShipmentEventResult_recovered": "Recovered",
  "manualShipmentEventStolenGoodsStatus_fullLoss": "Full loss",
  "manualShipmentEventStolenGoodsStatus_no": "No",
  "manualShipmentEventStolenGoodsStatus_partial": "Partial",
  "manualShipmentEventStolenGoodsStatus_recovered": "Recovered",
  "manual_submit_shipment_event": "Planned stop submission",
  "manufacturer": "Manufacturer",
  "manufacturerCountry_chinaMainland": "China Mainland",
  "manufacturerCountry_chinaTaiwan": "China Taiwan",
  "manufacturerCountry_malaysia": "Malaysia",
  "manufacturerCountry_philippines": "Philippines",
  "manufacturerCountry_unitedStates": "United States",
  "manufacturerCountry_vietnam": "Vietnam",
  "map": "Map",
  "mapboxIncidentsOverlay": "Mapbox incidents overlay",
  "mapCantLoad": "Map Can't be loaded",
  "mapIndicatingNonComplianceRisks": "Map indicating non-compliance risks, incidents and losses",
  "mapLoadingError": "Map failed to load. Please, <button1>reload</button1> the map or <button2>refresh</button2> the page if problem persists",
  "mapMeasure": "Map measure",
  "mapView": "Map view",
  "Map View": "Map view",
  "markAsRead": "Mark as read",
  "marketAt": "At",
  "marketBy": "By",
  "masterAirWaybill": "Master air waybill",
  "masterCompany": "Master company",
  "masterShipmentConnect": "Master Shipment Connect",
  "max": "Max",
  "maximum": "Maximum",
  "maximumPallets": "Maximum pallets",
  "maximumPingLimitExceeded": "A maximum of 10000 pings has been exceeded for this device",
  "maximumPortalsSelected": "Maximum number of portals selected.",
  "maximumVolume": "Maximum volume",
  "maximumWeight": "Maximum weight",
  "maximumWordLength": "Event reasons may have a maximum character count of 20",
  "maxLogoSize": "Max. Size 12 MB",
  "maxrouteLocationsWarning": "The maximum number of locations that can be used on a route is 25",
  "maxSpeed": "Max speed",
  "maxTemp": "Maximum temperature",
  "maxTwoDrivers": "Maximum 2 drivers can be selected",
  "maxVehicleImages": "The maximum number of images that can be uploaded, in a single upload, is 10",
  "MBOL": "MBOL",
  "mbolTooltip": "Master bill of landing, this field can also be used for container tracking",
  "MCNumber": "MC number",
  "measureDistance": "Measure distance",
  "measurementRate": "OH measurement rate",
  "measurementUnit": "Measurement unit",
  "mechanical_failure_manual_shipment_event": "Mechanical failure",
  "medicalDeviceEvent_inTransit": "In transit",
  "medicalDeviceProductType_fullKneeReplacement": "Full knee replacement",
  "medicalDeviceProductType_partialKneeReplacement": "Partial knee replacement",
  "medicalDeviceType_fabricRoll": "Fabric roll",
  "medicalDeviceType_other": "Other",
  "medicalDeviceType_tote": "Tote",
  "medicalDeviceType_tray": "Tray",
  "medium": "Medium",
  "mediumPriorityRange": "Medium priority",
  "mediumPriorityRisk": "Medium priority risk",
  "mediumPriorityRisks": "Medium priority risks",
  "Medium Priority Risks": "Medium priority risks",
  "mediumRisk": "Medium risk",
  "mediumRiskCount": "{count} medium risk",
  "mediumRiskPopulation": "Medium risk population",
  "mediumRiskViolations": "Medium risk violations",
  "merge": "Merge",
  "mergeCompanies": "Merge companies",
  "mergeCompanies.carrierAliases": "Carrier aliases",
  "mergeCompanies.companiesThatWillBeMerged": "Companies that will be merged:",
  "mergeCompanies.description_selectCompanies": "Carriers with USDOT numbers that duplicate {companyName} will appear below. Select one or more carrierrs that you want to merge and proceed to the next step. If no carriers are displayed, go back to the companies page and ensure the USDOT number(s) for the carrier(s) that you want to merge, has been populated.",
  "mergeCompanies.editAliases": "Edit aliases",
  "mergeCompanies.editAliasesDescription": "Aliases provide an alternative way to find a carrier when creating shipments, aside from its name.",
  "mergeCompaniesFieldItemSize": "Companies to merge field must have at least 1 item",
  "mergeCompanies.label_aliasStepDescription": "Aliases provide an alternative way to find a company when creating shipments, aside from its name.",
  "mergeCompanies.label_editPortalAliases": "Edit {portalName} aliases",
  "mergeCompanies.label_verifiedUSDOT": "Verified USDOT",
  "mergeCompanies.label_viewCompanyLink": "View company",
  "mergeCompanies.label_viewThreats": "View threats",
  "mergeCompanies.label_youAreMerging": "You are merging...",
  "mergeCompanies.noUSDOT": "No USDOT",
  "mergeCompanies.reviewOutcomeStep": "Review and merge",
  "mergeCompanies.shipmentsUsedWithVerifiedCarrier": "Shipments used with verified carrier",
  "mergeCompanies.step_editAliases": "Edit aliases",
  "mergeCompanies.subtitle_mergeWithVerifiedCarrier": "Merging with verified carriers helps Overhaul detect double-brokering at pickup.",
  "mergeCompanies.subtitle_reviewOutcome": "Review and confirm the outcome of merging the selected carriers.",
  "mergeCompanies.successMessage_aliasesWereSaved": "All aliases were saved for the portal.",
  "mergeCompanies.successMessage_carriersMerged": "{unverifiedCompaniesCounter} carriers have been merged into {verifiedCompanyName}.",
  "mergeCompanies.successTitle_carriersMerged": "Carriers merged successfully!",
  "mergeCompanies.title_mergeWithVerifiedCarrier": "Merge with verified carrier",
  "mergeCompanies.title_reviewOutcome": "Review outcome of the merge",
  "mergeCompanies.title_selectCompanies": "Select companies",
  "mergeCompanies.warningSubtitle_companiesThatWillBeMerged": "After this merge, only {verifiedCompanyName} will remain. This action can't be undone.",
  "mergeCompanies.warningTitle_companiesThatWillBeMerged": "You are merging {count} companies into {verifiedCompanyName}.",
  "mergeLocation": "Merge location",
  "mergeLocations": "Merge locations",
  "mergingResultsPreview": "Merging results preview",
  "message": "Message",
  "message_enterShipmentIdToLoad": "Enter any shipment ID and hit load. The same ID always rebuilds the same demo shipment, or pick a demo profile to start from a specific scenario.",
  "message_packingUnitDeleted": "Packing unit deleted",
  "messages": "Messages",
  "Messages": "Messages",
  "messagesCount": "Messages {count}",
  "meters": "Meters",
  "metric": "Metric",
  "mi": "mi",
  "milestone": "Milestone",
  "milestone_delivered_shipment_event": "Delivered",
  "milestone_picked_up_shipment_event": "Picked up",
  "milestoneReportedBy": "{source} reported",
  "min": "Min",
  "minimum": "Minimum",
  "Minimum": "Min",
  "min_max_temperature_out_of_range": "Temp Min/Max OUT OF RANGE alert",
  "min_max_temperature_within_range": "Temp Min/Max IN RANGE alert",
  "minTemp": "Minimum temperature",
  "minutes": "Minutes",
  "mismatched_seaport_info_shipment_event": "Mismatched seaport info",
  "mismatched_seaport_info_violation": "Mismatched seaport info",
  "missedFlightAlert": "Missed flight alert",
  "missed_flight_alert_shipment_event": "Missed flight alert",
  "missed_flight_violation": "Missed flight",
  "missed_ship_alert_shipment_event": "Missed vessel alert",
  "missed_ship_violation": "Missed ship",
  "missedVesselAlert": "Missed vessel alert",
  "missing": "Missing",
  "missingEscalationPriority": "Esc. Priority",
  "missingInformation": "Missing information",
  "missingLanguage": "Missing language",
  "mmsi": "Mmsi",
  "MMSI": "MMSI",
  "MMSITooltip": "Maritime mobile service identity. A unique 9 digit number for identifying a vessel",
  "mobile": "Mobile",
  "mobileDevicePlacement": "Driver Connect",
  "mobileTracking": "Mobile app tracking",
  "mobileTrackingDelay": "Mobile tracking delay (mins)",
  "mode": "Mode",
  "mode_continuous": "Continuous",
  "model": "Model",
  "modes": "Modes",
  "modesTooltip": "Selecting road only, will display shipments that are road segments exclusively. Choosing air, ocean or rail will display shipments that have either air, ocean or rail segments and road segments",
  "monday": "Monday",
  "monitored": "Monitored",
  "monitoredByGsoc": "This workflow is actively monitored by GSOC.",
  "monitoringStatisticsTitle": "Key monitoring statistics",
  "moreActions": "More actions",
  "mostDelayed": "Most delayed",
  "mostEarly": "Most early",
  "mostRecent": "Most recent",
  "mostRecentPing": "Most recent ping",
  "motionEvents": "Motion events",
  "motionStatus": "Motion status",
  "motionStatusChange": "Motion status change: {subtype}",
  "move": "Move",
  "moveAddHideWidgets": "Move, add/hide widgets",
  "moveAtDelivery": "Move to \"At delivery\"",
  "moveAtPickup": "Move to \"At pickup\"",
  "moveDelivered": "Move to \"Delivered\"",
  "moveInTransit": "Move to \"In transit\"",
  "movement": "Movement",
  "movementAccuracy": "Movement accuracy",
  "movementAccuracyHint": "The required position accuracy when in movement state",
  "moveToPickedUp": "Move to \"Picked up\"",
  "moving": "Moving",
  "movingAwayFromDelivery": "Shipment deviation (miles)",
  "moving_away_from_delivery_shipment_event": "Shipment deviation alert",
  "movingStationary": "Moving/Stationary",
  "mph": "mph",
  "multipleShipmentUploaded": "You successfully created {uploadedCount} new shipments",
  "mustBeBiggerThanSecondBatteryAlert": "Must be higher than second battery level alert",
  "mustBeBiggerThanThirdBatteryAlert": "Must be higher than third battery level alert",
  "mustBeLessThanFirstBatteryAlert": "Must be less than first battery level alert",
  "mustBeLessThanSecondBatteryAlert": "Must be less than second battery level alert",
  "myAssets": "My assets",
  "myCarriers": "My carriers",
  "myDashboards": "My dashboards",
  "myNetwork": "My network",
  "myShippers": "My shippers",
  "myTeam": "My team",
  "n/a": "N/A",
  "name": "Name",
  "navigateToShipment": "Navigate to shipment",
  "navlink_addShipment": "Add shipment",
  "navlink_addShipmentRedesigned": "SC Go: add shipment",
  "navlink_alerts": "Alerts",
  "navlink_assetAppointments": "Asset appointments",
  "navlink_assetAssignments": "Asset assignments",
  "navlink_assetManager": "Asset Manager",
  "navlink_assets": "Assets",
  "navlink_auditLogReports": "Audit log reports",
  "navlink_automatedAlertTemplates": "Automated alert templates",
  "navlink_carriers": "Carriers",
  "navlink_carrierWatchlist": "Carrier watchlist",
  "navlink_commandCenterDashboard": "Command Center",
  "navlink_companies": "Companies",
  "navlink_complianceReport": "Compliance",
  "navlink_corrections": "Corrections",
  "navlink_customers": "Customers",
  "navlink_custom_fields": "Custom fields",
  "navlink_deviceAndTagManagement": "Device & tag management",
  "navlink_deviceModels": "Device models",
  "navlink_deviceProfiles": "Device profiles",
  "navlink_deviceVendors": "Device vendors",
  "navlink_drivers": "Drivers",
  "navlink_ebolManager": "SecureBOL",
  "navlink_emailGroups": "Email groups",
  "navlink_embeddedReports": "Embedded reports",
  "navlink_escalationAndAutoAlertTemplates": "Escalation & auto alert templates",
  "navlink_escalationContacts": "Contacts",
  "navlink_escalationTemplates": "Escalation templates",
  "navlink_eventNames": "Event reason codes",
  "navlink_fraudwatch": "FraudWatch",
  "navlink_gateways": "Gateways",
  "navlink_handlingUnitAlerting": "Handling unit alerting",
  "navlink_healthcareAppointments": "Appointments",
  "navlink_healthcareDashboard": "Healthcare dashboard",
  "navlink_inventory": "Inventory",
  "navlink_itemAlerting": "Item alerting",
  "navlink_learning": "Insights",
  "navlink_locationManagement": "Locations & zones",
  "navlink_medicalDevices": "Medical devices",
  "navlink_medtechAttributes": "MedTech attributes",
  "navlink_network": "Network",
  "navlink_notificationCenterGroups": "NC groups",
  "navlink_notifications": "Notifications",
  "navlink_overhaulContacts": "Overhaul contacts",
  "navlink_overlays": "Overlays",
  "navlink_portals": "Portals",
  "navlink_powerBiReports": "Embedded reports",
  "navlink_qrc_manager": "Instructions",
  "navlink_quality": "Quality",
  "navlink_regions": "Regions",
  "navlink_riskGptPrompts": "RiskGPT prompts",
  "navlink_riskScoreRules": "Riskscore rules",
  "navlink_roles": "Roles",
  "navlink_routes": "Routes",
  "navlink_scGoPickup": "SC Go pickup",
  "navlink_sentinel": "Risk Monitor",
  "navlink_shipmentConnect": "Shipment Connect",
  "navlink_shipmentConnectGoHome": "Shipment Connect Go",
  "navlink_shipmentIdSettings": "Shipment ID settings",
  "navlink_shipmentManager": "Shipment Manager",
  "navlink_shipmentRiskScore": "Shipment risk scores",
  "navlink_shipments": "Shipment Manager",
  "navlink_ships": "Ship info",
  "navlink_tagModels": "Tag models",
  "navlink_team": "Team",
  "navlink_templates": "Escalation & auto alert templates",
  "navlink_users": "Users",
  "navlink_workflows": "Workflows",
  "near_delivery_detention_time_exceeded_shipment_event": "Delivery location detention alert",
  "near_home_detention_time_exceeded_shipment_event": "Home stop detention alert",
  "near_pickup_detention_time_exceeded_shipment_event": "Pickup location detention alert",
  "near_planned_stop_detention_time_exceeded_shipment_event": "Planned stop detention alert",
  "networkByRiskLevel.description_emptyState": "Add carriers to your network to start seeing data here.",
  "networkInventory.exceedExportLimit": "The current selection contains more than 10,000 network items. Please apply additional filters to reduce the amount of network items.",
  "networkInventory.label_exportingNetworkItems": "Exporting network items",
  "networkRiskScore.description_emptyState": "Available when more score changes occur",
  "new": "New",
  "newCustomField": "New custom field",
  "newDashboard": "New dashboard",
  "newDestinations": "New destinations",
  "newEscalation": "Send new escalation",
  "newestDeviceUpdate": "Most recent device ping",
  "newestPickupDate": "Pickup date (newest first)",
  "newMessage": "New message",
  "newOrigins": "New origins",
  "newRecords": "New records",
  "newRegionalWorkflow": "New regional workflow",
  "newRouteWasCreated": "A new route was created.",
  "newSegmentDevices": "New segment devices",
  "newWorkflow": "New workflow",
  "next": "Next",
  "nextLocationNearby": "The following locations are nearby:",
  "nextRoutesCantBeCreated": "The following routes could not be duplicated to portal(s):",
  "nextSevenDays": "Next 7 days",
  "nextStep": "Next step",
  "nextThirtyDays": "Next 30 days",
  "no": "No",
  "noActiveShipments": "No active shipments",
  "noActivityLogEvents": "No activity log events for this shipment",
  "noActivityLogsYet": "No activity logs yet",
  "noAddressInformation": "No address information",
  "noAgreedDateProvided": "No agreed date provided",
  "noAppliedFilter": "No applied filter",
  "noAssetsAvailable": "No assets available",
  "noAssetsMatch": "No assets match the current filters",
  "noAttachments": "No attachments yet",
  "noAttachmentsAdded": "No attachments added to this shipment.",
  "noBrokerID": "No broker ID",
  "noCarrierID": "No carrier ID",
  "noChangesMade": "You haven't made any changes yet",
  "noChatsYet": "No chats yet",
  "no_contact_maintained_manual_shipment_event": "No contact maintained",
  "no_contact_maintained_manual_violation": "No contact maintained",
  "noContactsErrorMessage": "No contacts found. Contact your supervisor for help.",
  "noContactsMsg": "There are no contacts yet ...",
  "noContactsToDisplay": "No contacts to display - contacts have not been added for this company.",
  "no_container_subscription_found_shipment_event": "No container subscription found",
  "no_container_subscription_found_violation": "No container subscription found",
  "noCriticalAlerts": "There are no critical alerts",
  "noData": "No data",
  "noDataAvailable": "No data available",
  "noDataProvided": "No data provided",
  "noDeviceData": "No device data",
  "noDevicesAssigned": "No devices were assigned",
  "noDevicesAssignedToTheShipment": "No devices assigned to the shipment.",
  "no_device_tracking_at_flight_departure_shipment_event": "No device tracking at flight departure",
  "no_device_tracking_at_flight_departure_violation": "No device tracking at flight departure",
  "noDifference": "No difference",
  "noEmailsAvailableToCopy": "No emails available to copy for {type}",
  "noEscalationsYet": "No escalations yet",
  "no_eta_status": "No ETA status",
  "noETAStatus": "ETA - no status - expected time of delivery",
  "noETAStatusKPIHint": "Expected time of delivery - no status: active & undelivered shipments that do not have a calculated expected time of delivery",
  "noEvents": "No events",
  "noEventsFound": "No timeline events found.",
  "noEventsReceivedForSelectedDevices": "No events received for the selected device(s).",
  "noFilteredContactsToDisplay": "No contacts to display - contacts have been added for this company but are hidden by filters.",
  "nofreightForwarderID": "No freight forwarder ID",
  "noGeofenceAdded": "No geofence added.",
  "noInfo": "There is no information",
  "noInstructionsForThisEvent": "There is no instructions for this event type at this time.",
  "noMatchingResult": "No matching result found",
  "noMessages": "No messages",
  "nominal": "Nominal",
  "noMove": "No move",
  "non_compliance": "Non - compliance",
  "nonComplianceIncidents": "Non-Compliance incidents",
  "nonComplianceMetricHint": "A count of compliance risks that have not been escalated to an incident",
  "nonCompliant": "Non-Compliant",
  "none": "None",
  "noNotesAdded": "No notes added to this shipment.",
  "noNotesAddedToEvent": "No notes added to this event.",
  "noNotificationsYet": "No notifications yet",
  "non_red_zone_restart": "Non-Redzone stop start",
  "non_redzone_stop": "Non-Redzone stop",
  "nonRiskZone": "Non-risk zone",
  "nonRiskZoneMobileNta": "Non-Redzone mobile NTA (mins)",
  "non_risk_zone_no_tracking_shipment_event": "Non-Risk zone no tracking alert",
  "non_risk_zone_no_tracking_violation": "Non-Risk zone no tracking alert",
  "nonRiskZoneNTA": "Non-risk zone NTA",
  "nonRiskZoneVehicleNta": "Non-Redzone vehicle NTA (mins)",
  "noOptions": "No options",
  "noOtpStatus": "No OTP status",
  "noPendingChanges": "No pending changes",
  "no_pickup_submission_violation": "No pickup submission & photos",
  "no_planned_stop_submission_violation": "No planned stop submission",
  "no_proof_of_delivery_violation": "No proof of delivery",
  "noResultsFound": "No results found",
  "normal": "Normal",
  "normalPriority": "Normal",
  "no_route_between_ports_shipment_event": "No route between ports",
  "no_route_between_ports_violation": "No route between ports",
  "northAmericaRailOverlay": "N/A rail overlay",
  "northAmericaRailways": "NA railways",
  "noSavedLocationsWithinMiles": "No saved locations within {miles} miles.",
  "noScheduleProvided": "No schedule provided",
  "noSegmentsDrivers": "No drivers were added to this segment",
  "noSegmentsEquipment": "No equipment was added to this segment",
  "noShipmentDrivers": "No drivers were added to this shipment",
  "noShipmentEquipment": "No equipment was added to this shipment",
  "noShipments": "No shipments",
  "noShipmentsText": "There are no shipments matching that criteria.",
  "noShipmentsToDisplay": "There are no shipments to display",
  "noShipperID": "No shipper ID",
  "no_status": "No status",
  "notAvailable": "Not available",
  "note": "Note",
  "notes": "Notes",
  "notesTab": "Notes",
  "notGreaterThanMax": "Maximum value should be greater than minimum",
  "notifEnabled": "Notifications enabled",
  "notification": "Notification",
  "notification_adminCarrierRiskScore": "Carrier risk score",
  "notification_adminDriverRiskScore": "Driver risk score (admin)",
  "notification_admin_poi_imported": "POI database updates",
  "notification_airport_wait_time_exceeded": "Airport wait time exceeded",
  "notification_approveFromPickupApproved": "Shipment pickup approval: allowed",
  "notification_approveFromPickupDepartedAfterRejected": "Shipment pickup approval: departed after rejected",
  "notification_approveFromPickupIgnored": "Approve from pickup: ignored",
  "notification_approveFromPickupRejected": "Shipment pickup approval: rejected",
  "notification_arrived_at_airport": "Arrival at airport",
  "notification_arrived_at_sea_port": "Vessel has arrived at SeaPort",
  "notification_assetBtSealOpen": "Asset seal open",
  "notification_assetHumidityAlert": "Humidity alert",
  "notification_assetInactive": "Asset status set to inactive",
  "notification_assetLightAlert": "Light alert",
  "notification_asset_nta_alert": "Asset no tracking alert",
  "notification_assetShockAlert": "Shock alert",
  "notification_assetSpeedAlert": "Speed alert",
  "notification_assetTemperatureAlert": "Temperature alert",
  "notification_assetTiltAlert": "Tilt alert",
  "notification_assignment_required": "Driver assignment request",
  "notification_at_risk_eta_status_change": "ETA: at risk",
  "notification_backInRange": "Back in range",
  "notification_batteryPingRatesAutoUpdatedAlert": "Battery ping rates auto updated alert",
  "notification_brokerCouldntFindReplacement": "Approvals: broker couldn't find a replacement",
  "notification_cancelled_flight_alert": "Cancel flight alert",
  "notification_cancelled_flight_segment": "Flight segment cancelled",
  "notification_carrierRiskScore": "Carrier risk score",
  "notification_coldChainTemperatureAlert": "Quality temperature alert",
  "notification_cold_chain_temperature_report_notification": "Temperature report on shipment delivery",
  "notification_convoyShipmentSeparation": "Convoy separation alert",
  "notification_countryWithRestrictionsEntry": "Entry to country with trade restrictions",
  "notification_countryWithRestrictionsExit": "Exit from country with trade restrictions",
  "notification_dangerZoneStop": "Dangerzone stop",
  "notification_delayed_departure_after_pickup": "Delayed departure after pickup",
  "notification_delayed_vessel_arrival_notification": "Delayed vessel arrival",
  "notification_demurrageWarningAtDestinationPort": "Demurrage warning",
  "notification_departedWithoutPickupApproval": "Shipment pickup approval: departed before decision",
  "notification_departure_from_destination_port_notification": "Departure from destination port",
  "notification_description_adminCarrierRiskScore": "Selecting this option will deliver notifications into the #high-risk-scores Slack channel when a carrier's score exceeds 50.",
  "notification_description_adminDriverRiskScore": "Selecting this option will deliver notifications into the #high-risk-scores Slack channel when a driver who’s score exceeds 50 is added to a shipment.",
  "notification_description_admin_poi_imported": "Select this option if you want to receive notifications when POI (points of interest) database is updated (daily at 4:30 a.m.).",
  "notification_description_airport_wait_time_exceeded": "Select this checkbox if you want to receive notifications that a shipment remains at an airport during the time exceeding the one set in a shipment workflow.",
  "notification_description_approveFromPickupIgnored": "Select this option to receive FraudWatch notifications when approvers in your company didn't respond to the approval in time",
  "notification_description_approveFromPickupRejected": "Select this option to receive notifications when approvers reject shipments assigned with high-risk carriers/drivers before pickup",
  "notification_description_arrived_at_sea_port": "Select this option if you want to receive notifications that the vessel has arrived at a seaport for an ocean segment of a shipment (an arrived to seaport location event is generated).",
  "notification_description_assetBtSealOpen": "Select this notification if you want notifications when a door bluetooth seal alert is generated.",
  "notification_description_assetHumidityAlert": "Select this checkbox if you want to receive notifications that a humidity level in a vehicle is outside the allowed humidity level range (a humidity alert is generated).",
  "notification_description_assetLightAlert": "Select this checkbox if you want to receive notifications that a light level in a vehicle is bigger than allowed (a light alert is generated).",
  "notification_description_asset_nta_alert": "Select this option if you want to receive notifications that the device has not sent pings after the defined time range set in Asset Manager workflow (a no tracking alert is generated).",
  "notification_description_assetShockAlert": "Select this checkbox if you want to receive notifications that a shock level in a vehicle is outside the allowed shock level range (a shock alert is generated).",
  "notification_description_assetSpeedAlert": "Select this checkbox if you want to receive notifications that a speed level in a vehicle is outside the allowed speed level range (a speed alert is generated).",
  "notification_description_assetTiltAlert": "Select this checkbox if you want to receive notifications that a tilt level in a vehicle is outside the allowed tilt level range (a tilt alert is generated).",
  "notification_description_assignment_required": "Select this checkbox if you want to receive notifications that a shipment has been created without a driver/dispatch user assigned to it with a request to assign them.",
  "notification_description_at_risk_eta_status_change": "Select this option if you want to receive notifications that a segment of your shipment has received an ETA: at risk status. NOTE: if during a shipment processing the status changed from at risk to early, and then back to at risk, you will not receive the notification that the status changed to the ETA: at risk for the second time. You will only receive one notification about one status change per segment.",
  "notification_description_backInRange": "Enable this where you wish to receive a notification when a shipment returns inside the acceptable temperature range after being outside and generating an immediate alert",
  "notification_description_batteryPingRatesAutoUpdatedAlert": "Select this checkbox if you want to receive notifications that a battery ping/reporting rates were updated",
  "notification_description_brokerCouldntFindReplacement": "Select this option to receive notifications when brokers, during the approvals process, indicate they cannot replace the assigned carrier/driver/truck/trailer. In this circumstance, shippers should reassign the broker or directly-contract the load instead",
  "notification_description_cancelled_flight_alert": "Select this checkbox if you want to receive notifications about the flight cancellation after the FlightAware service has sent such an alert. NOTE: to receive a cancelled flight alert notification, in a shipment workflow for a plane segment, select the flight cancelled alert checkbox.",
  "notification_description_cancelled_flight_segment": "Select this option if you want to receive notifications that the flight segment of the shipment is cancelled (manual cancellation via sentinel or Shipment Manager).",
  "notification_description_carrierRiskScore": "Select this option to receive notifications when a carrier is added to a shipment that exceeds the workflow > Road > Alerts & events > Intelligence > US carrier risk-score threshold.",
  "notification_description_coldChainTemperatureAlert": "Select this checkbox if you want to receive notifications that a temperature in a vehicle is outside the allowed quality temperature range set in the shipment workflow.",
  "notification_description_cold_chain_temperature_report_notification": "Generates a temperature report for the user in Shipment Manager upon shipment delivery",
  "notification_description_delayed_departure_after_pickup": "Select this option if you want to receive notifications that a shipment has had a pickup submission event but has not yet departed the pickup location after a period of time set in the workflow.",
  "notification_description_delayed_vessel_arrival_notification": "Select this option if you want to receive notifications when a shipment arrives at a seaport with delay.",
  "notification_description_departedWithoutPickupApproval": "Select this option to receive FraudWatch notifications when a shipment departed pickup before an approver in your company made a decision to allow / reject departure. This could be a serious risk where a driver departed unexpectedly when high-risks were identified.",
  "notification_description_departureToApproveFromPickupApproved": "Select this option to receive FraudWatch notifications when approvers in your company approved departure from pickup when risks were identified.",
  "notification_description_departureToApproveFromPickupRejected": "Select this option to receive FraudWatch notifications when approvers in your company reject departure from pickup when risks were identified. After an approval is rejected, this notification will only be generated if the shipment departs pickup and transitions to in transit.",
  "notification_description_detention_time_exceeded": "Select this checkbox if you want to receive notifications that a shipment stays at a delivery location longer that the set time (a delivery detention alert is generated).",
  "notification_description_device_off_site_at_flight_departure": "Select this option if you want to receive notifications that the devices is outside the departure airport location at the time of flight departure (the device off-site at flight departure event is generated).",
  "notification_description_devices_import_results": "Select this option if you want to receive notifications that a list of devices was uploaded to device manager with some errors in device details. NOTE: you will receive this notification only if the device list is uploaded to your portal.",
  "notification_description_door_open_alert": "Select this checkbox if you want to receive notifications about the door opened events sent from TMS. NOTE: to receive a door open alert notification, in a shipment workflow for a truck segment, select the door state change alert checkbox.",
  "notification_description_driverReturnToOrigin": "Select this option to receive FraudWatch notifications when drivers depart pickup either: a) when a driver departs after an approver rejected departure or b) when a driver departs before an approver decided to allow/reject departure from pickup. Requires the “Require pickup approval” toggle to be enabled.",
  "notification_description_driverRiskScore": "Select this option to receive notifications when a driver is added to a shipment that exceeds the workflow > Road > Alerts & events > Intelligence > Carrier / driver risk-score threshold.",
  "notification_description_driver_sos_alert": "Select this checkbox if you want to receive notifications that a driver has submitted SOS from a mobile application (a driver SOS alert shipment event is generated).",
  "notification_description_early_eta_status_change": "Select this option if you want to receive notifications that a segment of your shipment has received an ETA: early status. NOTE: if during a shipment processing the status changed from early to at risk, and then back to early, you will not receive the notification that the status changed to the ETA: early for the second time. You will only receive one notification about one status change per segment.",
  "notification_description_early_final_delivery_departure": "Select this option if you want to receive notifications that a shipment has left the final delivery location before the extended monitoring period set in a shipment workflow (an early final delivery departure event is generated).",
  "notification_description_engine_ignition_alert_enabled": "Select this option if you want to receive notifications about generated engine ignition on/off events on a shipment.",
  "notification_description_equipment_door_close_alert": "Select this option if you want to receive notifications that the trailer door has been closed (a door closed event is generated).",
  "notification_description_equipment_door_open_alert": "Select this option if you want to receive notifications that the trailer door has been opened (a door opened event is generated).",
  "notification_description_equipment_location_arrival": "Select this option if you want to receive notifications that the asset has arrived to the location (based on cross IN and cross OUT radius for geofences set in Asset Manager workflow).",
  "notification_description_equipment_location_departure": "Select this option if you want to receive notifications that the asset has departed from the venue location (based on cross IN and cross OUT radius for geofences)set in Asset Manager workflow).",
  "notification_description_equipment_temperature_back_in_thresholds": "Select this option if you want to to receive notifications that the temperature is back in range (a temperature in range alert is generated).",
  "notification_description_equipment_temperature_thresholds_broken": "Select this option if you want to to receive notifications that the temperature is out of range (a temperature out of range alert is generated).",
  "notification_description_equipment_trailer_connected": "Select this option if you want to receive notifications that a trailer has been connected to the power source. Notification will be generated when trailer_power_status: true is sent in vehicle_events.",
  "notification_description_equipment_trailer_disconnected": "Select this option if you want to receive notifications that a trailer has been disconnected from the power source. Notification will be generated when trailer_power_status: false is sent in vehicle_events.",
  "notification_description_eta_destination": "Select this checkbox if you want to receive two notifications that a shipment in transit is about to enter a delivery location. The default time for the first notification is 1 h before the estimated time of arrival (ETA), for the second notification – 30 mins. However, you can customize this time by clicking \"First notification: 1h 0min second notification: 0h 30min\" and setting up the necessary notification frequency.",
  "notification_description_expiredDeviceCalibration": "Enable this checkbox if you wish to receive a notification where a device attempting to be used has a possibly expired calibration certificate",
  "notification_description_high_riskscore_alert": "Select this checkbox if you want to receive notifications about a high risk level on the shipment route (received from the weatheroptics), and a \"HighRiskscoreAlertShipmentEvent\" is generated.",
  "notification_description_hotzone_stop": "Select this checkbox if you want to receive notifications that a driver has made an unplanned stop in a hotzone radius (a \"StopShipmentEvent\" is generated).",
  "notification_description_humidity_alert": "Select this option if you want to receive notifications that the humidity level for device in a vehicle is smaller or bigger than the limit set in a shipment workflow (a humidity alert is generated).",
  "notification_description_late_departure": "Select this checkbox if you want to receive notifications that a shipment is delayed from the pickup time (a late departure shipment event is generated).",
  "notification_description_late_eta_status_change": "Select this option if you want to receive notifications that a segment of your shipment has received an ETA: late status. NOTE: if during a shipment processing the status changed from late to early, and then back to late, you will not receive the notification that the status changed to the ETA: late for the second time. You will only receive one notification about one status change per segment.",
  "notification_description_left_lockdown": "Select this checkbox if you want to receive notifications that a shipment has left a stop location earlier than the lock-down time set by a driver. This can signal that a shipment is stolen, (a \"LeavingLockdownLocationShipmentEvent\" is generated).",
  "notification_description_light_alert": "Select this checkbox if you want to receive notifications that a light level in a vehicle is bigger than allowed (a light alert is generated).",
  "notification_description_long_loading_shipment_event": "Select this checkbox if you want to receive notifications that a driver remains at a pickup location during the time exceeding the one set in the workflow.",
  "notification_description_long_unloading_shipment_event": "Select this checkbox if you want to receive notifications that a driver remains at a delivery location during the time exceeding the one set in the workflow (the delivery detention time event is generated).",
  "notification_description_low_battery_level": "Select this checkbox if you want to receive notifications that the battery level of the device on a shipment is lower than the set value, (a low battery alert is generated).",
  "notification_description_min_max_temperature_out_of_range_level_1": "Select this option if you want to receive notifications that the temperature value for level 1-3 is out of range based on the values set in the Asset Manager workflow (a temperature out of range alert is generated). NOTE: the notifications for each temperature level (level 1 / level 2 / level 3) are configured separately.",
  "notification_description_min_max_temperature_out_of_range_level_2": "Select this option if you want to receive notifications that the temperature value for level 1-3 is out of range based on the values set in the Asset Manager workflow (a temperature out of range alert is generated). NOTE: the notifications for each temperature level (level 1 / level 2 / level 3) are configured separately.",
  "notification_description_min_max_temperature_out_of_range_level_3": "Select this option if you want to receive notifications that the temperature value for level 1-3 is out of range based on the values set in the Asset Manager workflow (a temperature out of range alert is generated). NOTE: the notifications for each temperature level (level 1 / level 2 / level 3) are configured separately.",
  "notification_description_min_max_temperature_within_range_level_1": "Select this option if you want to to receive notifications that the temperature value for level 1-3 is back in the temperature range based on the values set in the Asset Manager workflow (a temperature in range alert is generated). NOTE: the notifications for each temperature level (level 1 / level 2 / level 3) are configured separately.",
  "notification_description_min_max_temperature_within_range_level_2": "Select this option if you want to to receive notifications that the temperature value for level 1-3 is back in the temperature range based on the values set in the Asset Manager workflow (a temperature in range alert is generated). NOTE: the notifications for each temperature level (level 1 / level 2 / level 3) are configured separately.",
  "notification_description_min_max_temperature_within_range_level_3": "Select this option if you want to to receive notifications that the temperature value for level 1-3 is back in the temperature range based on the values set in the Asset Manager workflow (a temperature in range alert is generated). NOTE: the notifications for each temperature level (level 1 / level 2 / level 3) are configured separately.",
  "notification_description_missed_flight_alert": "Select this checkbox if you want to receive notifications that a flight has departed without a shipment on board (the flightaware service shows that the flight has already departed but the device on a shipment sends pings outside the plane route). NOTE: to receive a missed flight alert notification, in a shipment workflow for a plane segment, select the missed flight alert checkbox.",
  "notification_description_missed_vessel_alert": "Select this checkbox if you want to receive notifications that a vessel has departed without a shipment on board (the marinetraffic service shows that the vessel has already departed but the device on a shipment sends pings outside the vessel route). NOTE: to receive a missed vessel alert notification, in a shipment workflow for a ocean segment, select the missed vessel alert checkbox.",
  "notification_description_no_device_tracking_at_flight_departure": "Select this option if you want to receive notifications about no device being assigned to a shipment or no device / mobile / vehicle being associated with the shipment at the time of flight departure (a no device tracking at flight departure event is generated).",
  "notification_description_on_time_eta_status_change": "Select this option if you want to receive notifications that a segment of your shipment has received an ETA: on time status. NOTE: if during a shipment processing the status changed from on time to early, and then back to on time, you will not receive the notification that the status changed to the ETA: on time for the second time. You will only receive one notification about one status change per segment.",
  "notification_description_openMicZoneEntry": "When a shipment enters an open mic zone",
  "notification_description_openMicZoneExit": "When a shipment exits an open mic zone",
  "notification_description_pickupApprovalRequested": "Select this option to receive notifications and review and action risks identified by FraudWatch, when a Shipment Connect user submits a pickup with high-risk carriers / drivers assigned.",
  "notification_description_plane_delayed_alert": "Select this option if you want to receive notifications about the delayed flight event generated for a shipment.",
  "notification_description_planned_route_deviation": "Select this checkbox if you want to receive notifications that a driver has deviated from the planned route for more than the allowed number of miles which is set in a workflow (a planned route deviation alert is generated).",
  "notification_description_planningApprovalApproved": "Select this option to receive notifications when approvers allow shipments assigned with high-risk carriers / drivers.",
  "notification_description_planningApprovalRejected": "Select this option to receive notifications when approvers reject shipments assigned with high-risk carriers / drivers before pickup.",
  "notification_description_planningApprovalRequested": "Select this option to receive notifications and review and action risks identified by FraudWatch, when a Shipment Connect user creates / updates a shipment with high-risk carriers / drivers assigned.",
  "notification_description_preclearanceApprovalRequested": "Select this option to receive notifications and review and action risks identified by FraudWatch during driver preclearance: a high-risk driver, a driver proposing a different carrier, truck or trailer than planned, a driver declining the shipment, or a driver not completing pre-clearance.",
  "notification_description_pre_pickup_device_inactivity": "Select this checkbox if you want to receive notifications about the device being inactive before a pickup (a pre pickup device inactivity alert is generated).",
  "notification_description_redFlagPhotoAlert": "Select this option to receive notifications when red flags are detected from the photo of the US DOT during pickup.",
  "notification_description_red_zone_crossed": "Select this checkbox if you want to receive notifications that a driver has left the redzone radius without violation(s).",
  "notification_description_red_zone_crossed_shipper": "Select this checkbox if you want to receive notifications that a driver has left the redzone radius without violation(s).",
  "notification_description_red_zone_crossed_shipper_violation": "Select this checkbox if you want to receive notifications that a driver has left the redzone radius with violation(s).",
  "notification_description_red_zone_crossed_violations": "Select this checkbox if you want to receive notifications that a driver has left the redzone radius with violation(s).",
  "notification_description_redzone_stop": "Select this checkbox if you want to receive notifications that a driver has stopped in a redzone radius.",
  "notification_description_reportingStatusInactive": "Device or asset reporting status has been changed to inactive.",
  "notification_description_safezone_stop": "Select this checkbox if you want to receive notifications that a driver has stopped in a recommended safezone radius without any violations.",
  "notification_description_secureBolAccepted": "Select this option to receive notifications when SecureBOL destination accept shipments",
  "notification_description_secureBolAcceptedWithDiscrepancies": "Select this option to receive notifications when SecureBOL destination accepts shipments with discrepancies",
  "notification_description_secureBolCreated": "Select this option to receive notifications when SecureBOL shipment has been created",
  "notification_description_secureBolRejected": "Select this option to receive notifications when SecureBOL destination rejects shipments",
  "notification_description_shipment_arrival": "Select this checkbox if you want to receive notifications that a driver has arrived at a pickup location. It is done either manually by a driver when they submit their arrival at pickup via sherpa or is auto-generated by receiving pings from the pickup location.",
  "notification_description_shipment_canceled": "Select this checkbox if you want to receive notifications that a shipment in contracting status was cancelled by a Broker/Admin user. NOTE: the contracting status means that a shipment was created at least 30 minutes ago and contains no information that can allow the shipment to be tracked.",
  "notification_description_shipment_created": "Select this checkbox if you want to receive notifications that a new shipment has been created via TMS / Shipment Connect / Shipment Manager on your portal.",
  "notification_description_shipment_deliver": "Select this checkbox if you want to receive notifications that a driver has arrived at a delivery location. It is done either manually by a driver when they submit their arrival at delivery via sherpa or is auto-generated by receiving pings from the delivery location.",
  "notification_description_shipment_delivered": "Select this checkbox if you want to receive notifications that a driver has arrived at a delivery location. Either a driver manually submits the delivery via sherpa or is auto-generated by receiving at least two pings from the delivery radius.",
  "notification_description_shipment_departure": "Select this checkbox if you want to receive notifications that a driver has submitted bill of lading at pickup acknowledging the receipt of cargo for a shipment.",
  "notification_description_shipmentDoubleBrokered": "Select this option to receive notifications when a shipment's USDOT changed to a different USDOT during Shipment Connect's DDI / checkout process - which may indicate double-brokering.",
  "notification_description_shipment_driver_finish": "Select this checkbox if you want to receive notifications that a driver has arrived at a delivery location. Either a driver manually submits the delivery via sherpa or is auto-generated by receiving at least two pings from the delivery radius.",
  "notification_description_shipment_left_pickup_radius": "Select this checkbox if you want to receive notifications that a driver has left the pickup location radius (the departure from pickup event is generated).",
  "notification_description_shipment_otp_late": "Select this option if you want to receive notifications when a shipment has successfully delivered at final destination with an On-Time-Performance status of “Late”",
  "notification_description_shipment_shipper_finish": "Select this checkbox if you want to receive notifications that a driver has arrived at a delivery location. Either a driver manually submits the delivery via sherpa or is auto-generated by receiving at least two pings from the delivery radius.",
  "notification_description_shipment_status_change_notification": "Select this option if you want to receive notifications when shipments that you’re watching change shipment status.",
  "notification_description_shock_alert": "Select this checkbox if you want to receive notifications that a shock level in a vehicle is outside the allowed shock level range (a shock alert is generated).",
  "notification_description_sos_poi_created": "Select this option if you want to receive notifications when POI (points of interest) database is updated (daily at 4:30 a.m.).",
  "notification_description_stop": "Select this checkbox if you want to receive notifications that a driver has submitted an unplanned stop (the \"StopShipmentEvent\" is generated).",
  "notification_description_support_delivered_success": "Select this option if you want to receive notifications that a shipment has been delivered with no violation(s).",
  "notification_description_support_delivered_violations": "Select this option if you want to receive notifications that a shipment has been delivered with violation(s).",
  "notification_description_temperature_alert": "Select this checkbox if you want to receive notifications that a temperature in a vehicle is outside the allowed temperature range set in a shipment workflow.",
  "notification_description_tilt_alert": "Select this checkbox if you want to receive notifications that a tilt level in a vehicle is outside the allowed tilt level range (a tilt alert is generated).",
  "notification_description_tts_threshold_exceeded": "Select this option if you want to receive notifications that the time exceeds the time for TTS threshold set in a shipment workflow (a TTS threshold exceeded event is generated).",
  "notification_description_tts_validated_duration_exceeded": "Select this option if you want to receive notifications that the time exceeds the time for TTS set in a shipment workflow (a TTS validated duration exceeded event is generated).",
  "notification_description_unapproved_carrier": "Receive a notification when a carrier company present on the Overhaul carrier watchlist gets added to a shipment",
  "notification_description_unapproved_driver": "Receive a notification when a driver present on the Overhaul carrier watchlist gets added to a shipment",
  "notification_description_unconfirmed_arrival": "Select this checkbox if you want to receive notifications that a driver has not arrived at pickup location in the pickup time set during shipment creation and displayed in Shipment Manager.",
  "notification_description_unexpectedActualCarrier": "Select this option to receive FraudWatch notifications when actual carriers identified at pickup are out-of-network",
  "notification_description_updated_vessel_info_alert": "Select this option if you want to receive notifications that a vessel information (such as vessel name, MMSI, or IMO) has been updated and the updated vessel info event has been generated and added to the shipment timeline. NOTE: the updated vessel info events and notifications are generated only for milestone-tracked shipments.",
  "notification_description_wrong_flight_number_alert": "Select this checkbox if you want to receive notifications that a shipment with an invalid flight number is created. NOTE: to receive a wrong flight number notification, in a shipment workflow for a plane segment, select the wrong flight number checkbox.",
  "notification_detention_time_exceeded": "Detention time exceeded",
  "notification_device_off_site_at_flight_departure": "Device off site at flight departure",
  "notification_devices_import_results": "Devices import results notification",
  "notification_distanceToDestinationAlert": "Distance to destination alert",
  "notification_door_open_alert": "Door open alert",
  "notification_driver_in_delivery": "Delivery prompt",
  "notification_driver_information_updates_notification": "Driver information updates",
  "notification_driverReturnToOrigin": "Driver: return to origin",
  "notification_driverRiskScore": "Driver risk score",
  "notification_driver_sos_alert": "Driver SOS",
  "notification_early_eta_status_change": "ETA: early",
  "notification_early_final_delivery_departure": "Early departure from final delivery",
  "notificationEmailList": "Notification email list",
  "notification_engine_ignition_alert_enabled": "Engine ignition on/off alert",
  "notification_equipment_door_close_alert": "Trailer's door close alert",
  "notification_equipment_door_open_alert": "Trailer's door open alert",
  "notification_equipment_location_arrival": "Location arrival alert",
  "notification_equipment_location_departure": "Location departure alert",
  "notification_equipment_temperature_back_in_thresholds": "Temperature back in range alert",
  "notification_equipment_temperature_thresholds_broken": "Temperature out of range alert",
  "notification_equipment_trailer_connected": "Trailer connected to tractor alert",
  "notification_equipment_trailer_disconnected": "Trailer disconnected from tractor alert",
  "notification_escortAssigned": "Escort assigned",
  "notification_escortBegins": "Escort begins",
  "notification_escortCheckedIn": "Escort checked in",
  "notification_escortCompleted": "Escort completed",
  "notification_eta_destination": "ETA notification to destination",
  "notification_expiredDeviceCalibration": "Device calibration certificate expiration notice",
  "notification_healthcareAppointmentAutoclaveWarning": "Autoclave warning",
  "notification_healthcareAppointmentCanceled": "Appointment cancelled",
  "notification_healthcareAppointmentCheckedIn": "Checked in",
  "notification_healthcareAppointmentInTransit": "In transit",
  "notification_healthcareAppointmentLeadTimeAlert": "Lead time alert",
  "notification_healthcareAppointmentMedicalDeviceOffSite": "Medical device off-site",
  "notification_healthcareAppointmentPostOpFailureToPickup": "Post-op failure to pickup",
  "notification_healthcareAppointmentProcedureComplete": "Procedure complete",
  "notification_healthcareAppointmentReadyForPickup": "Ready for pickup",
  "notification_healthcareAppointmentReadyForProcedure": "Ready for procedure",
  "notification_healthcareAppointmentSterilizationWarning": "Sterilization warning",
  "notification_high_riskscore_alert": "High riskscore alert",
  "notification_hotzone_stop": "Hotzone stop",
  "notification_humidity_alert": "Humidity alert",
  "notification_invalid_container_tracking_at_seaport_notification": "Invalid container tracking at seaport",
  "notification_invalid_flight_tracking_notification": "Invalid flight tracking",
  "notification_invalid_vessel_info_notification": "Invalid vessel info",
  "notification_late_departure": "Late departure",
  "notification_late_eta_status_change": "ETA: late",
  "notification_left_lockdown": "Left locked down location alert",
  "notification_light_alert": "Light alert",
  "notification_lightCompoundedStop": "Stop & light",
  "notification_long_loading_shipment_event": "Wait time exceeded at pickup",
  "notification_long_unloading_shipment_event": "Wait time exceeded at delivery",
  "notification_low_battery_level": "Low battery level alert",
  "notification_manualEvents": "Manual events",
  "notification_medicalDeviceAutoclave": "Autoclave occurred",
  "notification_medicalDeviceExcessiveDwell": "Excessive dwell",
  "notification_medicalDeviceInTransit": "In transit",
  "notification_medicalDeviceLocationArrival": "Arrived",
  "notification_medicalDeviceLocationDeparture": "Departed",
  "notification_medicalDeviceLogisticalTurn": "Logistical turn",
  "notification_medicalDeviceLowAutoclave": "Low autoclave",
  "notification_medicalDeviceLowLogisticalTurns": "Low logistical turns",
  "notification_medicalDeviceLowUtilization": "Low utilization",
  "notification_medicalDeviceReportFromOutboundRoom": "Report from outbound",
  "notification_medicalDeviceSilent": "Silent device",
  "notification_medicalDeviceSterilization": "Sterilization occurred",
  "notification_min_max_temperature_out_of_range_level_1": "Asset Manager - level 1 temperature alert - OUT OF RANGE",
  "notification_min_max_temperature_out_of_range_level_2": "Asset Manager - level 2 temperature alert - OUT OF RANGE",
  "notification_min_max_temperature_out_of_range_level_3": "Asset Manager - level 3 temperature alert - OUT OF RANGE",
  "notification_min_max_temperature_within_range_level_1": "Asset Manager - level 1 temperature alert - IN RANGE",
  "notification_min_max_temperature_within_range_level_2": "Asset Manager - level 2 temperature alert - IN RANGE",
  "notification_min_max_temperature_within_range_level_3": "Asset Manager - level 3 temperature alert - IN RANGE",
  "notification_mismatched_seaport_info_notification": "Mismatched seaport info",
  "notification_missed_flight_alert": "Missed flight alert",
  "notification_missed_vessel_alert": "Missed vessel alert",
  "notification_movingAwayCompoundedStop": "Stop & shipment deviation",
  "notification_no_container_subscription_found_notification": "No container subscription found",
  "notification_no_device_tracking_at_flight_departure": "No device tracking at flight departure",
  "notification_ocean_mode_warning_at_destination_notification": "Device warning - ocean mode at destination port",
  "notification_ocean_mode_warning_at_origin_notification": "Device warning - ocean mode at origin seaport",
  "notification_offer_new": "New offer received",
  "notification_on_time_eta_status_change": "ETA: on time",
  "notification_openMicZoneEntry": "Open mic zone ENTRY",
  "notification_openMicZoneExit": "Open mic zone EXIT",
  "notificationPageSubTitle": "Select which associations will trigger alerts and notifications.",
  "notification_pickupApprovalRequested": "Pickup approval requested",
  "notification_pickup_without_tracking": "Pickup submitted with no tracking",
  "notification_plane_delayed_alert": "Delayed flight",
  "notification_planned_route_deviation": "Route deviation",
  "notification_planningApprovalApproved": "Shipment planning approval: allowed",
  "notification_planningApprovalRejected": "Shipment planning approval: rejected",
  "notification_planningApprovalRequested": "Planning approval requested",
  "notification_preclearanceApprovalRequested": "Preclearance approval requested",
  "notification_pre_pickup_device_inactivity": "Pre pickup device inactivity",
  "notification_redFlagPhotoAlert": "Red flag photo - USDOT",
  "notification_red_zone_crossed": "Redzone exited without violation(s)",
  "notification_red_zone_crossed_shipper": "Redzone exited without violation(s)",
  "notification_red_zone_crossed_shipper_violation": "Redzone exited with violation(s)",
  "notification_red_zone_crossed_violations": "Redzone exited with violation(s)",
  "notification_redzone_stop": "Redzone stop",
  "notificationReply_autoAlert": "Automated alert",
  "notificationReply_escalationEmails": "Escalation emails",
  "notification_reportingStatusInactive": "Reporting status: inactive",
  "notification_routeDeviationCompoundedStop": "Stop & route deviation",
  "notifications": "Notifications",
  "notification_safezone_stop": "Safezone stop",
  "notification_sanctionedStateEntry": "Entry to state with restrictions",
  "notification_sanctionedStateExit": "Exit from state with restrictions",
  "notifications.autoAlertsMethods": "Auto alert methods",
  "notifications.autoAlertsMethodsDescription": "Activate the communication methods for this user to receive auto alerts.",
  "notification_scGoDriverPreclearanceForCarrier": "Carrier notification: driver required to preclear",
  "notification_sealOpenCompoundedStop": "Stop & seal open",
  "notification_seal_open_notification": "Seal open",
  "notification_section_asset_manager": "Asset Manager",
  "notification_section_cold_chain_temperature_alerts": "Quality temperature alerts",
  "notification_section_fraudwatch": "FraudWatch",
  "notification_section_fraudwatch_authorization": "FraudWatch authorization",
  "notification_section_fraudwatch_risks": "FraudWatch risks",
  "notification_section_general": "General",
  "notification_section_healthcare": "Healthcare",
  "notificationSection_healthcare": "Healthcare",
  "notification_section_healthcare_medical_devices": "Healthcare – non-appointment",
  "notification_section_poi": "POI",
  "notification_section_shipment": "Shipment",
  "notification_section_shipment_tracking": "Shipment tracking",
  "notification_section_truckshield": "TruckShield: general",
  "notification_section_truckshield_driver_behavior": "TruckShield: driving behaviour",
  "notification_secureBolAccepted": "SecureBOL accepted at delivery",
  "notification_secureBolAcceptedWithDiscrepancies": "SecureBOL accepted with discrepancies at delivery",
  "notification_secureBolCreated": "SecureBOL created",
  "notification_secureBolRejected": "SecureBOL rejected at delivery",
  "notification_separationAlert": "Separation alert notification",
  "notificationSettings": "Notification Settings",
  "notification_shipment_arrival": "Driver arrived at pickup",
  "notification_shipment_canceled": "Contracted shipment cancelled",
  "notification_shipment_created": "Shipment created",
  "notification_shipment_deliver": "Arrival at delivery",
  "notification_shipment_delivered": "Shipment delivered",
  "notification_shipment_departure": "Bill of lading submitted",
  "notification_shipment_destroyed": "Offered shipment cancelled",
  "notification_shipmentDeviations": "Shipment deviation notification",
  "notification_shipmentDoubleBrokered": "Shipment double brokered",
  "notification_shipment_driver_finish": "Driver finish notification",
  "notification_shipment_left_pickup_radius": "Driver departed pickup",
  "notification_shipment_otp_late": "Shipment delivered late",
  "notification_shipmentRemovedFromConvoy": "Shipment removed from convoy",
  "notification_shipment_shipper_finish": "Shipper finish notification",
  "notification_shipmentStaging": "Shipment staging",
  "notification_shipment_status_change_notification": "Shipment status changes",
  "notification_shipment_waiting_fuel_confirm": "Confirm shipment Pre-Check",
  "notification_shock_alert": "Shock alert",
  "notifications.label_viewAssociations": "View associations",
  "notifications.notificationsMethods": "Notification methods",
  "notifications.notificationsMethodsDescription": "Activate the communication methods for this user to receive notifications.",
  "notification_sos_poi_created": "Overhaul driver has requested SOS in your area",
  "notificationsSubTitle": "Toggle on/off in-app, email or SMS notifications.",
  "notificationStatus_open": "Open",
  "notificationStatus_pending": "Pending",
  "notificationStatus_resolved": "Resolved",
  "notification_stop": "Stop",
  "notificationsUpdatedDescription": "Your Notification Settings have been updated successfully. Please allow up to 10 minutes for these changes to be synced.",
  "notification_support_delivered_success": "Shipment is delivered without violation(s)",
  "notification_support_delivered_violations": "Shipment is delivered with violation(s)",
  "notification_support_redzone_success": "Redzone exit without violation(s)",
  "notification_support_redzone_violations": "Redzone exit with violation(s)",
  "notification_tagReunited": "Tag reunited alert",
  "notification_tagSeparated": "Tag separation detected alert",
  "notification_temperature_alert": "Temperature alert",
  "notificationTemplates": "Notification templates",
  "notification_tilt_alert": "Tilt alert",
  "notification_tts_threshold_exceeded": "TTS threshold exceeded notification",
  "notification_tts_validated_duration_exceeded": "TTS validated duration exceeded",
  "notificationType_email": "Email",
  "notificationType_inApp": "In app",
  "notificationType_push": "Push",
  "notificationType_sms": "Sms",
  "notification_unapproved_carrier": "Unapproved carrier",
  "notification_unapproved_driver": "Unapproved driver",
  "notification_unconfirmed_arrival": "Driver not yet arrived at pickup",
  "notification_unexpectedActualCarrier": "Carrier out-of-network",
  "notification_updated_vessel_info_alert": "Updated vessel info",
  "notification_vessel_berthed_notification": "Vessel berthed at destination port",
  "notification_wrong_flight_number_alert": "Wrong flight number",
  "notifiedParty": "Notified party",
  "notMonitored": "Not monitored",
  "noToDateSelected": "No to date selected",
  "notOnTime": "Not on time",
  "notProvided": "Not provided",
  "noTracking": "No tracking",
  "NoTrackingAlerts": "No tracking alerts",
  "no_tracking_alert_violation": "No tracking alert",
  "noTrackingReport": "No tracking report yet",
  "no_tracking_shipment_event": "No tracking alert",
  "notSelected": "Not selected",
  "notShared": "Not shared",
  "noValue": "No value",
  "no_vessel_info_shipment_event": "No vessel info",
  "no_vessel_info_violation": "No vessel info",
  "noWorkflowQRCMessage": "No assigned QRC links yet. Copy from workflow or portal to populate fields",
  "nta": "NTA",
  "ntaDelayAtAirportSeaport": "NTA delay at Airport/Seaport",
  "ntaDelayAtOriginDestination": "NTA delay at Origin/Destination",
  "null": "Null",
  "number": "Number",
  "numberItemsSelected": "{value} items selected",
  "numberOfDrivers": "Number of drivers",
  "numberOfKms": "{count} km",
  "numberOfTotalShipments": "{number} total shipments",
  "ocean": "Ocean",
  "ocean_mode": "Ocean mode",
  "oceanMode": "Ocean mode",
  "ocean_mode_desc": "Ocean mode enables device settings for ocean shipments",
  "ocean_mode_warning_at_destination_shipment_event": "Device warning - ocean mode at destination port",
  "ocean_mode_warning_at_destination_violation": "Device warning - ocean mode at destination port",
  "ocean_mode_warning_at_origin_shipment_event": "Device warning - ocean mode at origin port",
  "ocean_mode_warning_at_origin_violation": "Device warning - ocean mode at origin port",
  "oceanScacCode": "Ocean SCAC code",
  "oceanScacCodeTooltip": "Providing the SCAC code will result in our reliable container tracking. The following carriers require a container number and MBOL number for tracking: CKLU / CK lines, RCLU / regional container lines (RCL), WECU / W.E.C. (west european container) lines.",
  "oceanSettings": "Ocean settings",
  "oceanShippingMode": "Mode: ocean",
  "oceanWorkflowCreated": "Ocean workflow is successfully created",
  "oceanWorkflowUpdated": "Ocean workflow is successfully updated",
  "off": "Off",
  "oh": "Overhaul",
  "oh_admin": "Super admin",
  "OIDC.label_clientId": "OIDC client ID",
  "OIDC.label_metadataUrl": "OIDC metadata URL",
  "OIDC.label_secretId": "OIDC secret ID",
  "ok": "Ok",
  "oldestDeviceUpdate": "Oldest device ping",
  "oldestPickupDate": "Pickup date (oldest first)",
  "omniIntegration": "Omnitracs integration",
  "on": "On",
  "onDateTime": "[On] {date} [at] {time}",
  "onlyForEmergencies": "Only for emergencies at the moment",
  "on_time": "On-Time",
  "onTime": "On time",
  "onTimeETAStatus": "ETA - on time - expected time of delivery",
  "onTimeETAStatusKPIHint": "Expected time delivery - on time: active & projecting to deliver on time",
  "on_time_performance": "On-Time performance",
  "onTimePerformance": "On-Time performance",
  "onTimePerformanceKPI": "On-time performance",
  "onTimePerformanceTooltip": "This KPI displays the percentage of shipments that have been delivered on time. It represents those shipments that have been delivered on time as a % of all delivered shipments that had a final ETA status of one of early, late, at risk or on time. It excludes those shipments that have no ETA status.",
  "open": "Open",
  "opened": "Opened",
  "openingHours": "Opening hours",
  "operatingMode": "Operating mode",
  "operators": "Operators",
  "optionalExtraFields": "Optional extra fields",
  "or": "Or",
  "orderAbbreviation": "ORD",
  "orderNumber": "Order number",
  "origin": "Origin",
  "originalEta": "Original ETA",
  "originAndDeliveryRadius": "Origin and delivery radius",
  "originAndDestinationNotMatch": "The origin and destination should not match",
  "originContacts": "Origin contacts",
  "originIATA": "Origin IATA",
  "originICAO": "Origin ICAO",
  "originLabel": "Origin",
  "originLocation": "Origin location",
  "originLocations": "Origin",
  "origin_pick_up": "Origin pick up",
  "originPort": "Origin port",
  "originPortMovingRate": "Origin port moving rate",
  "originPortMovingRateTooltip": "Settings for entering into ocean mode at the origin port. This settings will automatically be applied until the shipment transitions off of the ocean segment",
  "originPortStationaryRate": "Origin port stationary rate",
  "originRedzoneRadius": "Origin redzone radius",
  "origins": "Origins",
  "Origins": "Origins",
  "origin_shipment_start": "Origin pre-pickup checklist",
  "other": "Other",
  "otherEmails": "Other emails",
  "otherGlobalSettings": "Other global event & alert settings",
  "otherLocations": "Other locations",
  "OTP": "OTP",
  "otp.action_enterVerificationCode": "Enter verification code",
  "otp.action_resendIfDidNotReceiveOtp": "Didn't receive code? Resend",
  "otp.action_resendIfDidNotReceiveOtpInTime": "Didn't receive code? Resend in {time}",
  "otp.description_enterVerificationCode": "We sent you a one-time password. Enter it below before updating carrier and driver assignments.",
  "OTPs": "OTPs",
  "OTPStatus": "OTP status",
  "otp.successMessage_otpCodeSent": "OTP code sent",
  "outboundIntegration": "Outbound integration",
  "outboundShipmentsRisk": "Outbound shipments by risk by segment mode",
  "outboundShipmentsRiskKPIHint": "Outbound shipments by risk by segment mode where the origin location has a location type of distribution centre, depot, or outside storage",
  "outOfOffice": "Out of office",
  "outOfOfficePlaceholder": "Select out of office date range",
  "outsideLocation": "Outside location",
  "outsideStorageCrossIn": "Outside storage cross IN radius (miles)",
  "outsideStorageCrossInTooltip": "The radius for arriving at a outside storage location",
  "outsideStorageCrossOut": "Outside storage cross OUT radius (miles)",
  "outsideStorageCrossOutTooltip": "The radius for departing a outside storage location",
  "overall": "Overall",
  "overallHeight": "Overall height",
  "overallLength": "Overall length",
  "overallWidth": "Overall width",
  "overhaulContacts": "Overhaul contacts",
  "overhaulContacts.addContact": "Add Overhaul contact",
  "overhaulContacts.csm": "CSM",
  "overhaulContacts.kam": "KAM",
  "overhaulContactsOnly": "Overhaul contacts only",
  "overhaulContacts.primaryContact": "Primary contact",
  "overhaulContacts.secondaryContact": "Secondary contact",
  "overhaulContacts.tertiaryContact": "Tertiary contact",
  "overhaulId": "Overhaul ID",
  "overhaulInternalContacts": "Overhaul internal contacts",
  "overhaulLocations": "Overhaul locations",
  "overlay": "{name} overlay",
  "overlayName": "Overlay name",
  "overlays": "Overlays",
  "overview": "Overview",
  "owner": "Owner",
  "ownerAttributes": "Owner attributes",
  "ownerEmail": "Owner email",
  "owner_name": "Owner name",
  "packerName": "Packer name",
  "packerNameRequired": "Packer name is required",
  "packingList.confirmationMessage_deletePackingUnit": "Delete packing unit: {deviceImei}?",
  "packingList.description_addDevices": "Select one or more devices. Each device will create a packing unit.",
  "packingList.description_addUnitsToTrack": "Add the units this device will track.",
  "packingList.description_deletePackingUnit": "This packing unit and its associated data will be permanently deleted. This action can’t be undone.",
  "packingList.description_selectHandlingUnitProfileAndDeviceSettings": "Select handling unit profile and device settings",
  "packingList.description_selectHandlingUnitProfiles": "Select handling unit profiles that you want to add to your packing list",
  "packingList.description_selectItemProfiles": "Select item profiles that you want to add to your packing list",
  "packingList.emptyState_noUnitsAdded": "No units added yet",
  "packingList.error_deviceAlreadyAdded": "This device has already been added",
  "packingList.error_deviceAssignedToAsset": "This device is currently assigned to asset ID {assetId}. It must be removed from that asset before it can be reassigned.",
  "packingList.error_deviceAssignedToMedicalDevice": "This device is currently assigned to medical device ID {medicalDeviceId}. It must be removed from that medical device before it can be reassigned.",
  "packingList.error_deviceAssignedToOrder": "This device is currently assigned to order ID {orderId}. It must be removed from that order before it can be reassigned.",
  "packingList.error_deviceAssignedToShipment": "This device is currently assigned to shipment ID {shipmentId}. It must be removed from that shipment before it can be reassigned.",
  "packingList.error_deviceUnavailable": "This device is currently unavailable",
  "packingList.error_noDeviceAvailable": "No device available",
  "packingList.error_unitAlreadyAdded": "This unit has already been added",
  "packingList.error_unitIdRequired": "Unit ID is required",
  "packingList.label_addHandlingUnitProfile": "Add handling unit profile",
  "packingList.label_addHandlingUnitProfiles": "Add handling unit profiles to {name}",
  "packingList.label_addItemProfiles": "Add item profiles to {name}",
  "packingList.label_addLotNumber": "Add lot number",
  "packingList.label_addUnit": "Add unit",
  "packingList.label_addUnits": "Add units",
  "packingList.label_assiciateWithShipment": "Associate with shipment",
  "packingList.label_createList": "Create list",
  "packingList.label_createNewList": "Create new list",
  "packingList.label_createNewPackingList": "Create new packing list",
  "packingList.label_deleteDevice": "Delete device",
  "packingList.label_deletePackingUnit": "Delete packing unit",
  "packingList.label_devicePlacedOn": "Device placed on",
  "packingList.label_deviceSettings": "Device settings",
  "packingList.label_generalInfo": "General info",
  "packingList.label_handlingUnitProfiles": "Handling unit profiles",
  "packingList.label_imeiValue": "IMEI: {imei}",
  "packingList.label_itemProfiles": "Item profiles",
  "packingList.label_listId": "Packing list ID",
  "packingList.label_personalIdentifier": "Personal identifier",
  "packingList.label_quantityShort": "QTY",
  "packingList.label_scanOrEnterDeviceImei": "Scan or enter device IMEI",
  "packingList.label_scanOrEnterUnitId": "Scan or enter unit ID",
  "packingList.label_selectPlacement": "Select placement",
  "packingList.label_selectUnitId": "Select unit ID",
  "packingList.label_summary": "Packing list summary",
  "packingList.label_totalWeight": "Total weight",
  "packingList.label_unitId": "Unit ID",
  "packingList.label_viewSummary": "View summary ({number})",
  "packingList.successMessage_devicesAdded": "Devices added",
  "packingList.successMessage_packingUnitDeleted": "Packing unit deleted",
  "packingList.title_packingUnit": "Packing unit",
  "packingStatus_archived": "Archived",
  "packingStatus_completed": "Completed",
  "packingStatus_deactivated": "Deactivated",
  "packingStatus_deleted": "Deleted",
  "packingStatus_delivered": "Delivered",
  "packingStatus_inProgress": "In progress",
  "packout": "Packout",
  "packoutDate": "Packout date",
  "packoutTab_active": "Active",
  "packoutTab_archived": "Archived",
  "packoutTab_completed": "Packing completed",
  "packoutTab_inProgress": "Packing in progress",
  "packoutTime": "Packout time",
  "page": "Page",
  "pageNotFound": "Oops, page not found",
  "pageSubtitle_ebolTable": "Browse your bill of lading records",
  "pageTitle_appointmentsWorkflows": "Appointments workflows",
  "pageTitle_bol": "BOL: {value}",
  "pageTitle_companyAssociations": "{userName} - company associations",
  "pageTitle_contactAssociations": "{userName} - Contact's associations",
  "pageTitle_ebolTable": "View your BOL’s",
  "pageTitle_handlingUnitProfiles": "Handling unit profiles",
  "pageTitle_handlingUnitWorkflow": "Handling unit",
  "pageTitle_inventoryWorkflows": "Inventory workflows",
  "pageTitle_itemProfiles": "Item profiles",
  "pageTitle_medicalDeviceWorkflows": "Medical device workflows",
  "pageTitle.packingLists": "Packing lists",
  "pageTitle_userAssociations": "{userName} - User's associations",
  "pagination": "Showing {from} - {to} out of {total}",
  "pairingFailed": "Pairing failed",
  "pairingFailedInfo": "Pairing tag {imei} failed. Please try again or consider using a different tag.",
  "pairingSuccessful": "Pairing successful",
  "pairingSuccessfulInfo": "The tag {imei} has been paired successfully. You can now proceed to create shipment.",
  "panic_alert_shipment_event": "Panic alert",
  "panic_alert_violation": "Panic alert",
  "parentImei": "Parent IMEI",
  "parentLocations": "Parent locations",
  "partial_delivery_manual_shipment_event": "Partial delivery",
  "partners": "Partners",
  "partnersAndEquipment": "Partners & equipment",
  "partOfValue": "{value1} of {value2}",
  "passiveRisk.double_brokered_risk": "Double-brokered shipment",
  "passiveRisk.driver_risk": "High driver risk score",
  "passiveRisk.label_comodity": "Commodity: {value}",
  "passiveRisk.label_contactCompliance": "Contact compliance",
  "passiveRisk.label_driverCompliance": "Driver compliance",
  "passiveRisk.label_escort": "Escort",
  "passiveRisk.label_highCarrierRiskScore": "High carrier risk score",
  "passiveRisk.label_highRiskCompany": "High risk company",
  "passiveRisk.label_highValue": "High value",
  "passiveRisk.label_noCarrierContacts": "No carrier contacts",
  "passiveRisk.label_noDriverPhone": "No driver phone",
  "passiveRisk.label_redFlagPhotoUsdot": "Red flag photo - USDOT",
  "passiveRisk.label_teamDrivers": "Team driver",
  "passiveRisk.unapproved_carrier_risk": "Unapproved carrier",
  "password": "Password",
  "passwordConfirmation": "Password confirmation",
  "pasteInteractiveQrc": "Paste interactive QRC",
  "PDF": "PDF",
  "pending": "Pending",
  "Pending Events": "Pending events",
  "pendingStatus": "Pending status",
  "peopleAndPartners": "People & partners",
  "percentageChange": "Percentage change (%)",
  "performance": "Performance",
  "permission": "Permission",
  "permission_access_escalation_templates": "View/Edit escalation templates",
  "permission_access_riskscore_rules": "View/Edit riskscoring rules",
  "permission_activate_deactivate_routes": "Deactivate routes",
  "permission_activate_deactivate_workflow": "Activate/Deactivate workflow",
  "permission_active_shipments_dashboard_widget": "Active shipments",
  "permission_active_shipments_in_redzone_dashboard_widget": "Active shipments in RedZone",
  "permission_activity_log_view": "View activity log",
  "permission_add_routes": "Add/Edit routes",
  "permission_admin_invitation": "Invite super admin",
  "permission_admin_page_access": "Admin page access",
  "permission_asset_dashboard": "Asset dashboard",
  "permission_assetManagerAssetsTransfer": "Asset transfer",
  "permission_asset_manager_event_management": "Asset Manager event management",
  "permission_at_risk_eta_status_dashboard_widget": "ETA - at risk - expected time of delivery",
  "permission_bulk_route_actions": "Route bulk actions",
  "permission_bulk_shipments_close": "Bulk update shipment status",
  "permission_callBasedNotificationCenter": "Call based Notification Center",
  "permission_call_vessel_position": "Call vessel position",
  "permission_carrier_compliance_by_risk_dashboard_widget": "Carrier compliance by risk events",
  "permission_carriers_manage": "Manage carriers",
  "permission_carriers_view": "View carriers",
  "permission_carrier_users_manage": "Edit carrier users",
  "permission_chain_of_custody_power_bi": "Chain of custody",
  "permission_co2e_dashboard_widget": "CO2 scope 3 emissions summary - OTR",
  "permission_command_center_dashboard": "Command Center",
  "permission_company_manage": "Edit my company details",
  "permission_company_management_page_access": "Company management page access",
  "permission_completing_today_dashboard_widget": "Completing today",
  "permission_contact_department_filtering": "Contact auto-filter toggle access",
  "permission_contactsPageAccess": "Contacts page access",
  "permission_create_manual_events": "Create manual events",
  "permission_createNewCarriers": "Create new carriers",
  "permission_create_workflow": "Create workflow",
  "permission_daily_shipments_status_dashboard_widget": "Daily shipment status",
  "permission_dashboard_save": "Add new dashboard",
  "permission_dashboard_share": "Share dashboards",
  "permission_deactivate_companies": "Deactivate companies",
  "permission_deviceDebug": "Device debug",
  "permission_device_management_access": "Device/Tag view",
  "permission_deviceManagementActivateDeactivate": "Device/Tag activate and deactivate",
  "permission_deviceManagementCreate": "Device/Tag create",
  "permission_deviceManagementDebug": "Device/Tag debug",
  "permission_deviceManagementEdit": "Device/Tag edit",
  "permission_deviceManagementEditModel": "Device model edit",
  "permission_deviceManagementExportDeviceData": "Device history export",
  "permission_deviceManagementGateways": "Gateways access",
  "permission_deviceProfileSetup": "Device profile setup",
  "permission_disruption_zone_manage": "Manage disruptions",
  "permission_drivers_manage": "Add and remove drivers",
  "permission_early_eta_status_dashboard_widget": "ETA - early - expected time of delivery",
  "permission_ebolAccess": "SecureBOL access",
  "permission_edit_carrier_watchlist": "Edit carrier watchlist",
  "permission_edit_companies": "Edit companies and employees",
  "permission_edit_countries": "Edit countries",
  "permission_editNonAdminUserPortalFilter": "Edit Non-Admin user portal filter",
  "permission_edit_risk_events": "Edit risk events",
  "permission_editUserPortalFilter": "Edit user portal filter",
  "permission_edit_workflow": "Edit workflow",
  "permission_enableEscortConnect": "Enable Escort Connect",
  "permission_enableOvhContractedEscorts": "Enable Overhaul contracted escorts",
  "permission_equipment_management_access": "Asset Manager",
  "permission_eta_at_risk_map_dashboard_widget": "Expected time of delivery shipment status map",
  "permission_eventBasedNotificationCenter": "Event based Notification Center",
  "permission_fraudwatchApproversAccess": "FraudWatch: approvals",
  "permission_fraudwatchAuthorizationAccess": "FraudWatch: authorization",
  "permission_fraudwatchDashboardAccess": "Dashboard and events access",
  "permission_fraudwatchRisksAccess": "FraudWatch: risks",
  "permission_generalEmailsSupportNotificationCenter": "General emails support Notification Center",
  "permission_global_custom_fields": "Custom fields",
  "permission_handlingUnitsPackingListAccess": "Manage packing",
  "permission_handlingUnitsProfilesAccess": "Handling unit profiles",
  "permission_healthcareAssignMedicalDevicesToAppointments": "Assign medical devices to appointments",
  "permission_healthcareManageAppointments": "Manage appointments",
  "permission_healthcareManageMedicalDevices": "Manage medical devices",
  "permission_healthcareManageMedtechAttributes": "Manage medtech attributes",
  "permission_healthcareViewAccess": "Medical devices & appointments access",
  "permission_hide_display_dashboard_widgets": "Hide/Display dashboard widgets",
  "permission_high_risk_by_event_type_dashboard_widget": "High risk shipments by event type",
  "permission_impersonate": "Impersonate",
  "permission_inbounds_dashboard_widget": "Inbound shipments by risk by segment mode",
  "permission_inboundSupportNotificationCenter": "Inbound support Notification Center",
  "permission_indicateKnownBadActors": "Indicate known bad actors (Intel team)",
  "permission_inventoryManagementAccess": "Inventory management",
  "permission_inventoryManagementItemProfileAccess": "Handling unit profiles",
  "permission_inventoryManagementPackingListAccess": "Create packing lists",
  "permission_late_eta_status_dashboard_widget": "ETA - late - expected time of delivery",
  "permission_learning_and_resource_center": "Insights access",
  "permission_le_connect_access": "LE Connect access",
  "permission_lm_location_additional_attributes": "Additional attributes",
  "permission_lm_location_advanced_import_export": "Advanced Import/Export",
  "permission_lm_location_clone_zones": "Duplicate zones to different portals",
  "permission_lm_location_manage_geofence": "Geofence",
  "permission_lm_location_manage_ports": "Manage Seaports/Airports",
  "permission_lm_location_manage_standards": "Manage standard locations",
  "permission_lm_location_manage_zones": "Manage zones",
  "permission_lm_location_view": "View",
  "permission_logistics_dashboard": "Logistics dashboard",
  "permission_lost_shipments_dashboard_widget": "Lost/Damaged incidents",
  "permission_manage_asset_actions": "View, add and delete asset actions",
  "permission_manage_assets_access": "Manage assets",
  "permission_manageCompaniesCustomPowerBiReports": "Manage other reports (e.g. custom, intel)",
  "permission_manageCompaniesPowerBiReports": "Manage app-prod reports",
  "permission_manageConsumableItems": "Manage catalog items",
  "permission_manage_customers": "Customer company management",
  "permission_manage_event_reasons": "Manage event reasons",
  "permission_manageInventoryItems": "Manage inventory items",
  "permission_manage_location_contacts": "Manage contacts on locations",
  "permission_manage_manual_incident": "Report an Incident-Add/Edit/Delete",
  "permission_managePowerBiReports": "Manage report administration",
  "permission_manage_power_bi_workspaces": "Manage report administration",
  "permission_manage_risk_score_templates": "Add/Edit risk score template",
  "permission_map_incidents_dashboard_widget": "Risks, incidents & losses map",
  "permission_mergeCarriers": "Merge carriers",
  "permission_no_eta_status_dashboard_widget": "ETA - no status - expected time of delivery",
  "permission_non_compliance_dashboard_widget": "Non-Compliance incidents",
  "permission_non_drivers_manage": "Add and remove non-driver members",
  "permission_notificationCenter": "Notification Center",
  "permission_notificationCenterPhotoVerificationsAccess": "View photos in Notification Center",
  "permission_ontime_eta_status_dashboard_widget": "ETA - on time - expected time of delivery",
  "permission_on_time_performance_dashboard_widget": "On-Time performance",
  "permission_outboundCalling": "Outbound calling",
  "permission_outbounds_dashboard_widget": "Outbound shipments by risk by segment mode",
  "permission_outboundTexting": "Outbound texting",
  "permission_personalize_dashboard_layouts": "Drag & drop dashboard widgets",
  "permission_pois_view": "Manage POI page",
  "permission_portalSsoSettingsEdit": "Edit portal SSO settings",
  "permission_qualityExcursionByTimeDashboardWidget": "Quality excursions by time period",
  "permission_qualityExcursionIncidents": "Quality alerts & alert response times",
  "permission_qualityManagerAccess": "Quality manager access",
  "permission_qualityRegulatoryHeatMapDashboardWidget": "Quality regulatory Non-Compliance heat map",
  "permission_qualityReviewAcceptRejectShipment": "QR accept/reject shipment",
  "permission_qualityReviewPageAccess": "Quality review page access",
  "permission_qualityReviewStatusUpdate": "QR status update",
  "permission_qualityRiskScoreDashboardWidget": "Quality risk score",
  "permission_qualityRiskStatusDashboardWidget": "Quality risk status",
  "permission_recovered_incidents_dashboard_widget": "Recovered incidents",
  "permission_reminderAction": "Reminder action",
  "permission_remove_employee_associations": "Remove links",
  "permission_removeShipmentAttachment": "Remove attachments from shipments",
  "permission_reports_access": "Reports access",
  "permission_riskEventsPerformanceDashboardWidget": "Carrier/Broker/FF quality performance",
  "permission_riskGptChatTab": "RiskGPT chat tab",
  "permission_riskGptInvestigation": "RiskGPT investigation",
  "permission_rmViewInvalidEvents": "View invalid events on event timeline",
  "permission_roles_view": "Manage list of roles and permissions",
  "permission_scGoCreateShipment": "Shipment Connect Go - create/update shipment",
  "permission_scGoPickupShipment": "Shipment Connect Go - pickup shipment",
  "permission_scLiteCreateShipment": "Shipment Connect lite - create shipment",
  "permission_scLitePickupShipment": "Shipment Connect lite - pickup shipment",
  "permission_section_access": "Access",
  "permission_section_account_settings": "Account settings",
  "permission_section_admin": "Admin",
  "permission_section_asset_manager": "Asset Manager",
  "permission_section_assets": "Assets",
  "permission_section_companies": "Companies",
  "permission_section_compliance_kpis": "Dashboard - compliance KPIs",
  "permission_section_configuration": "Configuration",
  "permission_section_dashboard_configuration": "Dashboard configuration",
  "permission_section_dashboards": "Dashboards",
  "permission_section_device_management": "Device management",
  "permission_section_fraudwatch": "FraudWatch",
  "permission_section_handlingUnits": "Handling unit alerting",
  "permission_section_healthcare": "Healthcare",
  "permission_section_insight": "Insights",
  "permission_section_inventory": "Inventory",
  "permission_section_item_alerting": "Handling unit alerting",
  "permission_section_kpis_compliance": "KPIs: compliance",
  "permission_section_kpis_risk": "KPIs: risk",
  "permission_section_kpis_visibility": "KPIs: visibility",
  "permission_section_lanes": "Routes",
  "permission_section_learning_and_resource_center": "Insights",
  "permission_section_locations": "Locations",
  "permission_section_operations": "Operations",
  "permission_section_people": "People",
  "permission_section_poi": "POI",
  "permission_section_qualityManager": "Quality manager",
  "permission_section_quality_review": "Quality review (QR)",
  "permission_section_reports": "Reports",
  "permission_section_risk": "Risk",
  "permission_section_risk_kpis": "Dashboard - risk KPIs",
  "permission_section_routes": "Routes",
  "permission_section_setup": "Setup",
  "permission_section_shipments": "Shipments",
  "permission_section_users": "Users",
  "permission_section_visibility": "Visibility",
  "permission_section_visibility_kpis": "Dashboard - visibility KPIs",
  "permission_section_workflow": "Workflow",
  "permission_section_workflows": "Workflows",
  "permission_security_dashboard": "Security dashboard",
  "permission_sendEscalationEmails": "Send escalation emails",
  "permission_sentinel_access": "Watcher sentinel access",
  "permission_sentinel_device_control": "Sentinel device control",
  "permission_share_company_to_portal": "Share company to portal",
  "permission_share_user_to_company": "Share to company",
  "permission_share_user_to_portal": "Share to portal",
  "permission_shipment_group_manage": "Manage shipment group",
  "permission_shipmentIdSettingsAccess": "Shipment ID settings",
  "permission_shipment_insights": "Shipment insights",
  "permission_shipment_mode_dashboard_widget": "Mode",
  "permission_shipments_by_status_dashboard_widget": "Shipment status",
  "permission_shipments_change_status_to_at_pickup": "Status change - at pickup",
  "permission_shipments_close": "Close/Cancel shipments",
  "permission_shipments_edit": "Edit shipments",
  "permission_shipmentsHardReset": "Hard reset/reprocess shipments",
  "permission_shipments_manage": "Post, edit, delete shipments",
  "permission_shipments_messages": "View, send and receive chat messages related to shipment",
  "permission_shipments_move_between_in_transit_and_delivery_states": "Move to at delivery and back to in Transit/Delivered",
  "permission_shipments_move_to_in_transit": "Move to in transit",
  "permission_shipments_move_to_picked_up": "Move to picked up",
  "permission_shipments_reopen": "Re-open completed shipments",
  "permission_shipments_view_price_and_cargo": "View shipment price and cargo liability",
  "permission_shipment_temperature_alerts_dashboard_widget": "Shipment temperature alerts",
  "permission_shipment_temperature_report_access": "Quality temperature report",
  "permission_shippers_manage": "Manage shippers",
  "permission_shippers_view": "View shippers",
  "permission_simpl_access": "Shipments access",
  "permission_team_edit": "Edit my team (create user, change role)",
  "permission_team_view": "View my team",
  "permission_textMessagesNotificationCenter": "View texts in Notification Center",
  "permission_time_spent_in_quality_excursion_dashboard_widget": "Time spent in quality excursions",
  "permission_track_and_trace_view": "View track and trace",
  "permission_user_change_role": "Change OH user role",
  "permission_user_deactivation": "Deactivate users/contacts",
  "permission_user_edit": "Edit user profile (untill driver/OO become verified)",
  "permission_user_invitation": "Invite non-super admin members",
  "permission_user_performance_dashboard_widget": "Carrier/Broker/FF performance - delivered shipments",
  "permission_user_report_generation": "Generate user\"s report (includes 1. reports of all users; 2. report for separate user with pending verif. & verif. in progress)",
  "permission_userSetup": "User setup",
  "permission_users_view": "View all users (includes filtering and search)",
  "permission_viewConsumableInventoryNetwork": "View network",
  "permission_viewConsumableItems": "View catalog items",
  "permission_viewEventValidity": "View event validity in RM",
  "permission_viewInventoryItems": "View inventory items",
  "permission_view_power_bi_reports": "Embedded reports access",
  "permission_viewPowerBiReports": "Embedded reports access",
  "permission_viewQRCs": "View QRCs",
  "permission_view_routes": "View routes",
  "permission_view_user_management": "View users management",
  "permission_violation_approve": "Approve violations",
  "permission_violations_dashboard_widget": "Violations",
  "personalisation": "Personalisation",
  "petro-travel": "Petro travel plaza",
  "phone": "Phone",
  "phoneNumber": "Phone number",
  "phoneVerificationDateColumn": "Number last verified",
  "phoneVerificationStatusColumn": "Number status",
  "phoneVerificationStatus_failed": "Failed",
  "phoneVerificationStatus_pending": "Pending",
  "phoneVerificationStatus_verified": "Verified",
  "phone_watch_ended_manual_shipment_event": "PhoneWatch ended",
  "phone_watch_started_manual_shipment_event": "PhoneWatch started",
  "photoUploaderError": "Error. The file format is incorrect. Supported file formats: png, .jpeg or .jpg",
  "photoVerification.button_submitAnyway": "Submit anyway",
  "photoVerification.completedFieldsProgress": "{completed} of {total} fields completed",
  "photoVerification.description_backOfTrailer": "Show both doors, the trailer number, and the seal. Stand back so all fit.",
  "photoVerification.description_blurryPhoto": "Please retake it to ensure all details are clear.",
  "photoVerification.description_photoVerificationSubmitted": "Thank you. Your photos for shipment {shipmentId} have been received. No further action is needed. We will review them shortly and contact you if needed.",
  "photoVerification.description_trailerSeal": "Get close so the seal number is readable and the seal is shown to be intact.",
  "photoVerification.label_expectedPhotoMatch": "Expected photo match",
  "photoVerification.label_sendPhotoVerificationLink": "Send photo verification link",
  "photoVerificationLocationMatch_differentLocationsDetected": "Different locations detected",
  "photoVerificationLocationMatch_sameLocation": "Same location",
  "photoVerificationRequest_submitted": "Submitted",
  "photoVerificationResult_confirmed": "Confirmed",
  "photoVerificationResult_failed": "Failed",
  "photoVerificationStatus_failed": "All checks failed",
  "photoVerificationStatus_mixed": "Mixed results",
  "photoVerificationStatus_passed": "All checks passed",
  "photoVerificationStatus_processing": "Processing",
  "photoVerification.successMessage_verificationSubmitted": "Verification submitted",
  "photoVerification.warning_blurryPhoto": "Your photo looks a bit blurry.",
  "physicianIntensivists": "Physician intensivists",
  "picked up": "Picked up",
  "picked_up": "Picked up",
  "picked_up_activity_label": "Picked up",
  "pickup": "Pickup",
  "pick_up": "Pick up",
  "pickupAndDelivery": "Pick up & delivery",
  "pickupApproval.action_allowEntity": "Allow {entityType}",
  "pickupApproval.action_confirmAssignments": "Confirm assignments",
  "pickupApproval.action_rejectEntity": "Reject {entityType}",
  "pickupApproval.action_updateAssignments": "Update assignments",
  "pickupApproval.actualCarrierInfoText": "The company identified at the shipment's pickup location in custody of your load. It may be different from the 'planned carrier' you originally intended due to operational changes or double-brokering.",
  "pickupApproval.approvalExpiredMessage": "Allowing / rejecting departure from pickup for this shipment is no longer possible.",
  "pickupApproval.button_submitDecision": "Submit decision",
  "pickupApproval.cancelledStatusMessage": "The risky carrier/driver(s) that required approval have been removed from this shipment. If any risks are identified on the newly-assigned entities, a new approval event/notification will generate.",
  "pickupApproval.cancelledStatusTitle": "Approval cancelled",
  "pickupApproval.confirmationDescription_shipperWillBeNotified": "We will inform {shipperName} so that they can hand over the shipment to a different broker.",
  "pickupApproval.confirmationTitle_shipperWillBeNotified": "Are you sure? {shipperName} will be notified.",
  "pickupApproval.description_authorizationRejected": "Authorization rejected by the customer. Reassign to mitigate",
  "pickupApproval.description_awaitingAuthorization": "Awaiting authorization from the customer",
  "pickupApproval.description_carrierEmptyState": "Pickup is scheduled for <datetime/>",
  "pickupApproval.description_confirmUpdateAssignments": "If the replacements you assign carry any new risks, a new approval case will be created and you'll be notified.",
  "pickupApproval.description_editAssignments": "Fix the carrier, driver(s), truck or trailer identified with risks in three steps:",
  "pickupApproval.description_editAssignmentsStep1": "<bold>Book a replacement</bold> with your carrier or supplier.",
  "pickupApproval.description_editAssignmentsStep2": "Once booked, <bold>select them below</bold> to update the shipment.",
  "pickupApproval.description_editAssignmentsStep3": "Once every risky entity is replaced, <bold>submit this form</bold> and the case will be \"Mitigated\".",
  "pickupApproval.description_enterVerificationCodeSentToEmail": "We sent a one-time password to your email ending in {contact}. Enter it below before updating carrier and driver assignments.",
  "pickupApproval.description_enterVerificationCodeSentToPhone": "We sent a one-time password to your phone ending in {contact}. Enter it below before updating carrier and driver assignments.",
  "pickupApproval.description_newRisksNeedReview": "The replacements you assigned have new risks, so a new approval case has been created.",
  "pickupApproval.description_noReplacementFound": "If no replacement can be found, use the button below to let {shipperName} know a new broker is needed.",
  "pickupApproval.description_requested": "Awaiting decision from an approver to allow / reject departure from pickup.",
  "pickupApproval.description_reviewRisks": "Review each risk below and choose to allow or reject it, based on your company's or customer's agreed tolerance for that risk. The driver, truck and trailer depend on the carrier - so if you reject the carrier, they will need to be replaced too.",
  "pickupApproval.description_updateAssignments": "Change carrier, driver, tractor, or trailer assignments directly from this page.",
  "pickupApproval.description_updatingShipmentInformation": "This process may take a few minutes. It is safe to refresh the page to check whether the changes have been applied.",
  "pickupApproval.doubleBrokeringRiskDescription": "Double brokering occurs when a shipment organized through a broker or carrier is handed off to a different carrier. This means that another company, not the one you initially booked, is intending to depart with your load.",
  "pickupApproval.doubleBrokeringRiskShortDescription": "Carrier mismatch detected: planned and actual carriers differ.",
  "pickupApproval.error_invalidVerificationCode": "Invalid code",
  "pickupApproval.error_previouslyRejectedAssignments": "All entities highlighted in red were previously rejected. Update the assignments to reflect the new entities that you booked.",
  "pickupApproval.error_undecidedEntities": "Select allow or reject for all entities before submitting.",
  "pickupApproval.highRiskCarrierDescription": "The carrier's risk score exceeds the threshold configured in the shipment's workflow.",
  "pickupApproval.highRiskDriverDescription": "The driver's risk score exceeds the threshold configured in the shipment's workflow.",
  "pickupApproval.ignoredStatusDescription": "No decision was made within the allotted time.",
  "pickupApproval.ignoredStatusTitle": "Approval window expired",
  "pickupApproval.infoMessage_automaticRejection": "Drivers, tractor and trailer will automatically be rejected.",
  "pickupApproval.infoMessage_driverAutomaticRejection": "Driver's carrier, tractor and trailer would be automatically rejected.",
  "pickupApproval.infoMessage_proposedCarrierAutomaticRejection": "Driver's carrier, tractor and trailer would be automatically rejected. Only one carrier can be used for this shipment.",
  "pickupApproval.label_allowDeparture": "Allow departure from pickup?",
  "pickupApproval.label_editAssignments": "Edit assignments",
  "pickupApproval.label_notifyCustomer": "Notify customer",
  "pickupApproval.label_pickupDateTime": "Pickup date & time",
  "pickupApproval.overviewDescription": "Review risk details below and choose to reject or allow departure from pickup.",
  "pickupApproval.overviewTitle": "Risks identified at pickup",
  "pickupApproval.plannedCarrierInfoText": "The carrier company you're planning to use for this shipment.",
  "pickupApproval.stage_pickup": "Pickup",
  "pickupApproval.stage_planning": "Planning",
  "pickupApproval.stage_preclearance": "Pre-clearance",
  "pickupApprovalStatus.allowedAutoDecision": "Allowed (auto-decision)",
  "pickupApprovalStatus.approved": "Approved",
  "pickupApprovalStatus.cancelled": "Cancelled",
  "pickupApprovalStatus.ignored": "Ignored",
  "pickupApprovalStatus.mitigated": "Mitigated",
  "pickupApprovalStatus.rejected": "Rejected",
  "pickupApprovalStatus.rejectedAutoDecision": "Rejected (auto-decision)",
  "pickupApprovalStatus.requested": "Requested",
  "pickupApproval.subtitle_pickupPhotos": "Pickup photos",
  "pickupApproval.successMessage_assignmentsUpdated": "Assignments updated! The case's status may take several minutes to reflect as \"Mitigated\". You will receive a new approval request notification if any risks associated with the newly-assigned entities are identified.",
  "pickupApproval.successMessage_autoDecisionAllowedBySettings": "Auto-allowed by Overhaul. FraudWatch identified all risks are within your organization’s approved threshold.",
  "pickupApproval.successMessage_autoDecisionAllowedByTimeout": "Auto-allowed by Overhaul. An approver did not respond within the allotted time.",
  "pickupApproval.successMessage_autoDecisionRejectedBySettings": "Auto-rejected by Overhaul. FraudWatch identified a risk that exceeds your organization’s approved threshold.",
  "pickupApproval.successMessage_autoDecisionRejectedByTimeout": "Auto-rejected by Overhaul. An approver did not respond within the allotted time.",
  "pickupApproval.successMessage_customerNotified": "Shipper notified that a replacement broker is needed.",
  "pickupApproval.successMessage_departureAllowed": "Departure allowed by {userName}",
  "pickupApproval.successMessage_departureRejected": "Departure rejected by {userName}",
  "pickupApproval.successMessage_risksMitigated": "Risks mitigated",
  "pickupApproval.threatsSectionTitle": "Threats identified in FraudWatch",
  "pickupApproval.title_approvalsForShipment": "Approvals for shipment #{shipmentNumber}",
  "pickupApproval.title_approved": "Departure allowed",
  "pickupApproval.title_areYouSure": "Are you sure?",
  "pickupApproval.title_awaitingApprovalEntityName": "Awaiting approval: {entityName}",
  "pickupApproval.title_carrierEmptyState": "We're awaiting carrier confirmation",
  "pickupApproval.title_editShipmentAssignments": "Edit shipment assignments",
  "pickupApproval.title_ignored": "Approval ignored",
  "pickupApproval.title_mitigated": "Risks mitigated",
  "pickupApproval.title_newRisksNeedReview": "New risks need your review",
  "pickupApproval.title_noReplacementFound": "No replacement found",
  "pickupApproval.title_proposedAssignmentsByDriver": "Proposed assignments by driver #{orderNumber} - {driverName}",
  "pickupApproval.title_proposedAssignmentsByTwoDrivers": "Proposed assignments by driver #{firstOrderNumber} - {firstDriverName} and driver #{secondOrderNumber} - {secondDriverName}",
  "pickupApproval.title_rejected": "Departure rejected",
  "pickupApproval.title_rejectedAssignments": "Rejected assignments",
  "pickupApproval.title_rejectedByAnApprover": "Rejected by an approver",
  "pickupApproval.title_rejectedEntityNameByAnApprover": "Rejected by an approver: {entityName}",
  "pickupApproval.title_requested": "Awaiting approval",
  "pickupApproval.title_updateAssignments": "Update assignments",
  "pickupApproval.title_updatingShipmentInformation": "Please wait while we update shipment information",
  "pickupApproval.title_whatNext": "What next?",
  "pickupApproval.unauthorizedCarrierRiskDescription": "The actual carrier was set as \"Unauthorized\" by someone in your company and should not be used.",
  "pickupApproval.validation_uniqueDriver": "Please select a unique driver option",
  "pickupAttachments": "Pickup attachments",
  "pickupCrossInRadius": "Pickup cross IN radius (miles)",
  "pickupDetentionTime": "Pickup detention time (minutes)",
  "PickupLocation": "Pickup location",
  "pickupLocationsLabel": "Pickup locations",
  "pickup_outside_violation": "Pickup outside",
  "pickupRequiredFieldslabel": "Required fields on pickup",
  "pickups": "Pickups",
  "pickupSubmission": "Pickup submission",
  "pickupToolEnabled": "Pickup tool enabled",
  "pickupToolMode": "Pickup tool mode",
  "pickup_without_tracking_shipment_event": "Pickup submitted with no tracking",
  "pickup_without_tracking_violation": "Pickup without tracking",
  "pilferage_manual_incident_shipment_event": "Pilferage",
  "pilferage_manual_incident_violation": "Pliferage",
  "placeholder_businessType": "Select business type",
  "placeholder_cargoType": "Select cargo type",
  "placeholder_enterShipmentReference": "Search by a shipment reference",
  "placeholder_hospitals": "Select hospitals",
  "placeholder_messageRiskGpt": "Message RiskGPT",
  "placeholderNone": "None",
  "placeholder_searchByLotNumber": "Search by lot number",
  "placeholder_searchPackingUnits": "Search packing units",
  "placeholder_selectAssetSubtype": "Select asset subtype",
  "placeholder_selectAssetType": "Select asset type",
  "placeholder_selectSubtype": "Select sub-type",
  "placeholder_selectTemplate": "Select template",
  "placeholder_semanticSearch": "AI search",
  "placeholder_templateName": "Insert template name",
  "placeholder_warehouses": "Select warehouses",
  "placeOfBuild": "Place of build",
  "plane": "Plane",
  "plane_alert_shipment_event": "Plane alert",
  "plane_delayed_arrival_shipment_event": "Delayed flight arrival",
  "plane_delayed_shipment_event": "Delayed flight",
  "plane_delayed_violation": "Delayed flight",
  "plane-ship-truck": "Plane & ship & truck",
  "plane-truck": "Plane & truck",
  "planned": "Planned",
  "plannedArrival": "Planned arrival",
  "plannedArrivalAtSegmentDestination": "Planned arrival at segment destination",
  "plannedDateNotProvided": "Planned date not provided",
  "plannedDelivery": "Planned delivery",
  "plannedDeliveryAtFinalDestination": "Planned delivery at final destination",
  "plannedDeliveryDate": "Planned delivery date",
  "plannedDeparture": "Planned departure",
  "plannedDistance": "Planned distance",
  "plannedDuration": "Planned duration",
  "plannedFinalDelivery": "Planned final delivery",
  "plannedPickup": "Planned pickup",
  "plannedPickupDate": "Planned pickup date",
  "planned_restart": "Planned stop start",
  "plannedRoute": "Planned route",
  "planned_route_deviation_shipment_event": "Route deviation alert",
  "planned_stop": "Planned stop",
  "plannedStop": "Planned stop",
  "plannedStopCrossInRadius": "Planned stop cross IN radius (miles)",
  "plannedStopDetentionTime": "Planned stop detention time (minutes)",
  "PlannedStopLocation": "Planned StopLocation",
  "planned_stop_outside_violation": "Planned stop outside",
  "platformTimezone": "Platform time zones",
  "pleaseAddWorkflowMode": "Please add at least one mode to create the workflow",
  "pleaseChooseClient": "Please, choose client",
  "pleaseChooseCorrectFile": "Please choose {extention} file",
  "pleaseChooseWorkflow": "Please, choose workflow",
  "pleaseExportToCsv": "Please export to CSV to view shipments",
  "pleaseFillDate": "Please fill the date",
  "pleaseSelectPortal": "Please select portal",
  "pleaseUpdateFile": "Please update your spreadsheet according to the instructions and upload it again",
  "POAlreadyAdded": "PO number is already added",
  "PoDAttachments": "PoD attachments",
  "poi": "POI",
  "poi.label_diesel": "Diesel",
  "poi.label_gasMidgrade": "Gas midgrade",
  "poi.label_gasPremium": "Gas premium",
  "poi.label_gasUnleaded": "Gas unleaded",
  "poi.label_propane": "Propane",
  "polygon": "Polygon",
  "polygon_arrival": "Polygon arrival",
  "polygonArrival": "Arrived at {locationName}",
  "polygon_departure": "Polygon departure",
  "polygonDeparture": "Departed from {locationName}",
  "po_number_cant_be_empty": "PO number can't be empty",
  "popAtRisk": "Population at risk",
  "popupDescription_employeePin": "This PIN can be used to access the <a>secureBOL app</a> on the location: {location}",
  "popupTitle_employeePin": "PIN for user {username}",
  "portal": "Portal",
  "portalAndCompany": "Portal & company",
  "portalAttributes": "Portal attributes",
  "portalClientCompany": "Client company",
  "portalClientCompanyTooltip": "Select the client company so that it can be displayed in Risk Monitor",
  "portalCreateError": "Error! Portal page {name} was not added.",
  "portalCreateSuccess": "Success! Portal page {name} has been added.",
  "portalCreationErrorMsg": "The following errors occurred during portal creation:",
  "portalCreationErrors": "Portal creation errors",
  "portalDemoConfig": "Portal demo config",
  "portal_ids": "Portals",
  "portalIsDemo": "Portal is demo?",
  "PortalIsTest": "Portal is test?",
  "portalName": "Portal name",
  "portalNameSettings": "Portal {name} settings",
  "portals": "Portals",
  "portalSettings": "Portal settings",
  "portalSettings.insuranceIntegration": "Loadsure integration",
  "portalSettings.label_allowedLinkedShipments": "Allow linked shipments",
  "portalSettings.label_autoDeactivateUnassignedDevices": "Auto deactivate devices not assigned to shipments or assets",
  "portalSettings.label_blockDriverConnectWelcomeNotification": "Block Driver Connect welcome notification",
  "portalSettings.label_cwcChannelName": "Container wellness check channel name",
  "portalSettings.label_doorOpenSlackbot": "Door open slackbot",
  "portalSettings.label_driverDeletionAfterDelivery": "Driver deletion after delivery",
  "portalSettings.label_escalationsEnableWosSelectDepartments": "Escalations: enable WOs select departments",
  "portalSettings.label_escalationTemplatesAccess": "Escalation templates access",
  "portalSettings.label_intelFeatureAccess": "Intelligence as a service",
  "portalSettings.label_irInstructionsLink": "IR instructions link",
  "portalSettings.label_outboundShipmentNotifyPeriod": "Outbound shipment notify period (minutes)",
  "portalSettings.label_qualityFeatureAccess": "Quality feature access",
  "portalSettings.label_routeDistanceToDestinationAlertControl": "Route distance to destination alert control",
  "portalSettings.label_tmsAllowNewPlannedCarriers": "TMS: allow creation of new planned carriers",
  "portalSettingsSaved": "Success! Settings have been applied to portal page {pageName}",
  "portalSettingsSaveError": "Error! Settings have not been applied to portal page {pageName}",
  "portalSettings.tmsAllowNewPlannedCarriers": "TMS: allow creation of new planned carriers",
  "portalSettings.tmsRouteAutoCreationEnabled": "Create new routes via shipment create API",
  "portalSettings.tooltip_tmsAllowNewPlannedCarriers": "Disable to prevent TMS from assigning planned carriers to shipments that are outside of the Customer's carrier network.",
  "portalsIndexPage": "Portals index page",
  "portalsLabel": "Portals",
  "portalUpdateError": "Changes to {name} weren’t applied.",
  "portalUpdateSuccess": "Changes to {name} were applied.",
  "portName": "Port name",
  "postShipment": "Post shipment",
  "poUploadInstuction": "Upload and add multiple customer PO#S using the file upload button below. To learn more on how to properly format and upload your spreadsheet",
  "power": "Power",
  "powerStatus": "Power status",
  "precheckCompleted": "DDI pre check",
  "preclearance.description_addTrailerInformationIfAvailable": "Add trailer information if you already have it.",
  "preclearance.description_carrierAndEquipmentDetailsSubtitle": "Some fields may be required depending on the pickup location or broker requirements.",
  "preclearance.description_carrierNameHelper": "Confirm this matches the carrier assigned to your pickup.",
  "preclearance.description_completeLicenseVerification": "Complete license verification.",
  "preclearance.description_confirmCarrier": "Confirm the carrier you’re driving for.",
  "preclearance.description_declineShipmentConfirmation": "The shipment owner will be notified that you declined. This action cannot be undone.",
  "preclearance.description_enterTractorNumberAndPhoto": "Enter your tractor number and take a tractor photo.",
  "preclearance.description_gatePassShownAfterGateCheck": "Once pickup approval is confirmed, you’ll receive a gate pass to show at the origin. Your shipment ID will only be shown after the required gate check is completed.",
  "preclearance.description_preclearanceSubmitted": "Thank you, your pre-clearance has been submitted. We will notify you shortly with your next steps. You may now close this page",
  "preclearance.description_shipmentDeclined": "The shipment has been declined, and the customer will be notified. You may now close this page.",
  "preclearance.description_shipmentIdHiddenUntilGateApproval": "Shipment ID hidden until gate approval.",
  "preclearance.description_shipmentPreclearanceRequired": "You’ve been assigned to a pickup that requires pre-clearance before arrival. Review the details below, then accept or decline this shipment.",
  "preclearance.description_tractorNumberHelper": "This is the truck/tractor you’ll arrive with at the origin.",
  "preclearance.description_tractorNumberReplaced": "You are replacing the planned tractor. We will send this change to the customer for approval. If the change is not approved, the shipment will be reassigned to another driver. Keep the tractor if possible.",
  "preclearance.description_tractorPhotoHelper": "Take a clear photo of the tractor you’ll arrive with.",
  "preclearance.description_trailerNumberHelper": "If you already know your trailer number, enter it here.",
  "preclearance.description_trailerNumberReplaced": "You are replacing the planned trailer. We will send this change to the customer for approval. If the change is not approved, the shipment will be reassigned to another driver. Keep the trailer if possible.",
  "preclearance.description_trailerPhotoHelper": "Take a clear photo of the trailer if available.",
  "preclearance.description_usdotNumberHelper": "Use the USDOT number for the carrier you're driving for today.",
  "preclearance.description_usdotNumberReplaced": "You are replacing the planned carrier. We will send this change to the customer for approval. If the change is not approved, the shipment will be reassigned to another driver. Keep the planned carrier if possible.",
  "preclearance.description_verifyYourPhoneBySms": "Verify your phone by SMS.",
  "preclearance.label_carrierAndEquipmentDetails": "Carrier and equipment details",
  "preclearance.label_carrierDetails": "Carrier details",
  "preclearance.label_declineShipmentConfirmation": "Decline this shipment?",
  "preclearance.label_gatePassAfterApproval": "Gate pass after approval",
  "preclearance.label_plannedCarrierAndEquipment": "Planned carrier and equipment",
  "preclearance.label_preclearanceSubmitted": "Pre-Clearance submitted",
  "preclearance.label_shipmentDeclined": "Shipment declined",
  "preclearance.label_shipmentPreclearanceRequired": "Shipment pre-clearance required",
  "preclearance.label_tractorNumber": "Tractor number",
  "preclearance.label_tractorPhoto": "Tractor photo",
  "preclearance.label_trailerDetailsIfAvailable": "Trailer details, if available",
  "preclearance.label_trailerNumber": "Trailer number",
  "preclearance.label_trailerPhoto": "Trailer photo",
  "preclearance.label_truckDetails": "Truck details",
  "preclearance.label_verifyIdentity": "Verify identity",
  "preclearance.label_verifyYourIdentity": "Verify your identity",
  "preclearance.label_whatYoullNeed": "What you’ll need",
  "preclearance.placeholder_tractorNumber": "Enter tractor number",
  "preclearance.placeholder_trailerNumber": "Enter trailer number if available",
  "preclearance.placeholder_usdotNumber": "Enter USDOT number",
  "preclearance.subtitle_verifyIdentity": "Complete phone and license verification so we can finish your pre-clearance and prepare your gate pass.",
  "preclearance.successMessage_carrierDetailsSubmitted": "Carrier details submitted",
  "predictedArrival": "Predicted arrival time",
  "preferences": "Preferences",
  "prePickupDeviceInactivityAlert": "Pre pickup device inactivity alert (minutes)",
  "prePickupDeviceInactivityEvents": "Pre pickup device inactivity events",
  "pre_pickup_device_inactivity_violation": "Pre pickup device inactive",
  "preview": "Preview",
  "previousStep": "Previous step",
  "primary": "Primary",
  "primaryEscalationPriorityDescription": "To be contacted first, subject to schedule, as part of escalations to this company.",
  "print": "Print",
  "priorActionsSummary": "Prior actions summary",
  "priorActionsSummaryPlaceholder": "Summarize any prior QRC steps carried out from calls / emails including: who was contacted / details gathered / outcomes / agreed next steps",
  "priority": "Priority",
  "priorityGroupName": "Priority group name",
  "priorityRiskHigh": "Violation - high priority risks",
  "priorityRiskLow": "Notice - low priority risks",
  "priorityRiskMedium": "Warning - medium priority risks",
  "profile": "Profile",
  "profileNavItem.companyAssociations": "Company associations",
  "profileNavItem.contactAssociations": "Contact associations",
  "profileNavItem.description_companyAssociations": "View the user’s companies and share to new companies",
  "profileNavItem.description_contactAssociations": "Configure the associations that determine when the contact is displayed on shipments",
  "profileNavItem.description_userAssociations": "Configure the user’s access restrictions and alerts/notification associations",
  "profileNavItem.userAssociations": "User associations",
  "profilePicture": "Profile picture",
  "profilePictureSubtitle": "Supported file formats: .png, .jpeg or .jpg",
  "protectionTimeExpired": "Protection time expired",
  "provideComment": "Provide comment",
  "provideReason": "Provide reason",
  "purchaseOrderNumbers": "Purchase order numbers",
  "purchase_orders": "Purchase orders",
  "push": "Push",
  "qrAlertStatus_alarmed": "Alarmed",
  "qrAlertStatus_noAlarms": "No alarms",
  "qrcVersionUpdated": "Instructions have been updated.",
  "qualityIncidents": "Quality excursions incidents",
  "qualityReviewStatus.inQualityReview": "In quality review",
  "qualityReviewStatus_inReview": "In review",
  "qualityReviewStatus_pendingReview": "Pending review",
  "qualityReviewStatus.qualityAccept": "Quality accept",
  "qualityReviewStatus.qualityArrivedComplete": "Quality arrived complete",
  "qualityReviewStatus.qualityArrivedPartially": "Quality arrived partially",
  "qualityReviewStatus.qualityClosed": "Quality closed",
  "qualityReviewStatus.qualityDiscard": "Quality discard",
  "qualityReviewStatus.qualityReceiverAccept": "Quality receiver accept",
  "qualityReviewStatus.qualityReceiverReject": "Quality receiver reject",
  "qualityReviewStatus_reviewCompleted": "Review completed",
  "qualityReview_tooltip_affectedDevices": "All devices on this shipment with at least one excursion at any severity level",
  "qualityReview_tooltip_affectedUnits": "All handling units on this shipment with at least one excursion at any severity level",
  "qualityReview_tooltip_alarmProfilesBreached": "All alarm profiles with at least one excursion at any severity level, for both the shipment and its handling units",
  "qualityReview_tooltip_company": "The company is also referred to as the shipper for whom the shipment belongs",
  "qualityReview_tooltip_deliveredTime": "The time the shipment arrived at its destination",
  "qualityReview_tooltip_destination": "Destination is where the shipment will be delivered, or its stopping point",
  "qualityReview_tooltip_excursionCount": "Total in-transit temperature excursions in the shipment, including all severities (low, normal, medium, high)",
  "qualityReview_tooltip_highSeverityExcursions": "Total excursions on the shipment with high severity only",
  "qualityReview_tooltip_origin": "The origin is where the shipment started from",
  "qualityReview_tooltip_overhaulShipmentId": "Shipment ID provided by Overhaul. This can be used to search the shipment within Overhaul apps like Risk Monitor and packing",
  "qualityReview_tooltip_pickedTime": "The time the shipment started its journey from the origin",
  "qualityReview_tooltip_shipmentReference": "Reference number for the shipment that is used on packout, order ID and other internal systems",
  "qualityReview_tooltip_totalTimeOutOfRange": "Total time out of range, calculated by adding the time out of range of each excursion at all severities",
  "qualityReview_tooltip_workflow": "Workflow is a set of instructions agreed in the contract on how the shipment will be handled",
  "qualityTemperatureMessage_base": "Temperature has breached alert {alertName} within the quality temperature alert group {alertGroupName} on workflow {workflowName}.",
  "qualityTemperatureMessage_device": "IMEI {deviceImei} located in {devicePlacement}.",
  "qualityTemperatureMessage_immediate": "This alarm is an {alertKind} alert type. It alerts as soon as the temperature is out of range.",
  "qualityTemperatureMessage_nonImmediate": "This alarm is a {alertKind} alert type. It alerts when the temperature is out of range for greater than or equal to {threshold}.",
  "quantity": "Quantity",
  "quater": "Quarter",
  "quickFilters": "Quick filters",
  "quickReactionChecklist": "Quick reaction checklist",
  "radius": "Radius",
  "rail": "Rail",
  "railBatterySettings": "Battery settings rail",
  "railFinalDestinationMovingRate": "Rail final destination moving rate",
  "railFinalDestinationRadius": "Rail final destination radius (miles)",
  "railFinalDestinationRadiusInfo": "Once the shipment is inside this radius from final destination, the risk events will change. If set to 0, only the outside radius settings will be applied.",
  "railFinalDestinationStationaryRate": "Rail final destination stationary rate",
  "railSettings": "Rail settings",
  "railShippingMode": "Mode: rail",
  "railWorkflowCreated": "Rail workflow is successfully created",
  "railWorkflowUpdated": "Rail workflow is successfully updated",
  "range": "Range",
  "rangeFrom": "Range from",
  "rangeNotSelected": "No From/To date range selected",
  "rangeTo": "Range to",
  "rateGraph.description_singleCarrierEmptyState": "Available after the carrier's initial Overhaul delivery.",
  "reactivate": "Reactivate",
  "reactivateDeactivationDateCheckbox": "Set an automatic deactivation date",
  "reactivatedSuccessfully": "Routes reactivated successfully",
  "reactivateSelectedLocations": "Are you sure you want to activate selected locations?",
  "reactivateSelectedRoutes": "Are you sure you want to activate selected routes?",
  "reactivateUserDescription": "Reactivating this user will restore access to the platform. Would you like to reactivate the user permanently or only until a specific date?",
  "reactivateUserTitle": "Reactivate {value}",
  "readOnlyField": "This field is read-only.",
  "ready_shipment_event": "Origin pre-pickup without violations",
  "reason": "Reason",
  "reasonsTitle": "Reasons for waiving & acknowledgement",
  "receivedFrom": "Received from",
  "recentEvents": "Recent events",
  "recoveredIncidents": "Recovered incidents",
  "recoveredIncidentsKPIHint": "A count of recovered incidents",
  "recovered_manual_incident_shipment_event": "Recovered",
  "recovered_manual_incident_violation": "Recovered",
  "recoveredValue": "Recovered value",
  "recovery": "Recovery",
  "redirectLimitExceeded": "The maximum number of shipments for redirect has been reached.",
  "redZone": "Red zone",
  "Redzone": "Redzone",
  "red_zone_crossed_shipment_event": "Redzone exit",
  "redzoneRadius": "Redzone radius (miles)",
  "red_zone_restart": "Redzone stop start",
  "red_zone_restart_violation": "Redzone stop start",
  "red_zone_stop": "Redzone stop",
  "redzone_stop": "Redzone stop",
  "redzoneStopDetentionTime": "Redzone stop detention time (minutes)",
  "redzone_stop_violation": "Redzone stop",
  "reeferAlarm": "Reefer alarm",
  "reeferOnOff": "Reefer On/Off",
  "reeferType": "Reefer type",
  "reeferVin": "Reefer VIN",
  "reference": "Reference",
  "referenceNumber": "Reference number",
  "referenceNumbers": "Reference numbers",
  "references": "References",
  "refresh": "Refresh",
  "refreshPage": "Refresh page",
  "refrigerated": "Refrigerated",
  "region": "Region",
  "regionalEventsPlaceholder": "Select events to apply regional rules",
  "regionalWorkflow": "Regional workflow",
  "regional_workflow_in_use_shipment_event": "Regional workflow in use",
  "regions": "Regions",
  "regularEscalationsSubTitle": "Select the contact methods that this contact can be reached by for regular escalations.",
  "regularEscalationsTitle": "Regular escalations",
  "regular_restart": "Stop start",
  "regular_stop": "Stop",
  "relative": "Relative",
  "relayLocationRequiredToggle": "Relay location required",
  "relayLocations": "Relay locations",
  "relayLocationsPlaceholder": "Select relay locations",
  "remainingDuration": "Remaining duration",
  "remainingProtectionTime": "Remaining protection time",
  "remind": "Remind",
  "reminderCanceledByUser": "Reminder canceled by {userName}",
  "reminderSetByUser": "Reminder set by {userName}",
  "reminding": "Reminding",
  "remove": "Remove",
  "removeAsDefaultFilter": "Remove as default filter",
  "removed": "Removed",
  "removeDepartmentAssociationBtn": "Remove association",
  "removeDepartmentAssociationMassege": "Are you sure you want to delete the department association?",
  "removeGeofence": "Remove geofence",
  "removePortalAssociation": "This action will deactivate associated employees, remove any subscriptions, and un-link origin locations. Are you sure you want to continue?",
  "removeTheCompanyAndRoleAssociation": "This action will remove the company and role association for this user. Are you sure you want to continue?",
  "rename": "Rename",
  "renameDepartment": "Rename department",
  "renameDepartmentSubTitle": "You can update the department name below",
  "reopen": "Reopen",
  "reopenBtn": "Reopen",
  "reopened": "Reopened",
  "Re-opened Events": "Re-opened events",
  "reopenEvent": "Do you really want to reopen event?",
  "repair": "Mechanic and repair shops",
  "reportAnIncident": "Report an incident",
  "ReportGenerating": "Report generating",
  "reporting_rate": "OH moving rate",
  "reportingRates": "Reporting rates",
  "reports": "Reports",
  "reportSubscription.successMessage_sent": "The report is being prepared and will be delivered shortly.",
  "requireContainer": "Require container",
  "requiredDriverNumber": "Required driver number",
  "requiredExtraFields": "Required extra fields",
  "requireOceanScacCode": "Require ocean SCAC code",
  "requireTemperatureSelection": "Require temperature selection",
  "reset": "Reset",
  "resetAll": "Reset all",
  "resetFilter": "Reset filter",
  "resetMapZoom": "Reset default map zoom",
  "resetPassword": "Reset password",
  "resetPermissions": "Reset permissions",
  "rest-area": "Rest areas",
  "restartAuto": "Restart auto",
  "restartInvestigation": "Restart investigation",
  "restartManual": "Restart manual",
  "restaurants": "Restaurants",
  "restoreDefaultConfirmation": "Are you sure you want to restore the default positioning for all metrics on this dashboard?",
  "restrictCompanySubTitle": "Select company(ies) to restrict user access.",
  "restrictions": "Restrictions",
  "restrictLocationSubTitle": "Select the items to restrict user access.",
  "restrictPageSubTitle": "Configure the access restrictions for the user.",
  "restrictPageTitle": "Restrict user access",
  "restrictWorkflowSubTitle": "Select workflow(s) to restrict user access.",
  "resultsPerPage": "Results per page",
  "returned": "Returned",
  "returnedLogic": "Returned logic",
  "returnToEscalationContacts": "Return to escalation contacts",
  "returnToIOT": "Return to IoT",
  "reusable": "Reusable",
  "reverseLogistics": "Reverse logistics",
  "reviewAndUpdate": "Review and update",
  "reviewConfirm": "Review and confirm",
  "revocationSeverity.high": "High",
  "revocationSeverity.low": "Low",
  "revocationSeverity.medium": "Medium",
  "revocationSeverity.noRisk": "No risk",
  "risk": "Risk",
  "riskAdjustedPopulation": "Risk adjusted population",
  "riskCategory.high": "High",
  "riskCategory.low": "Low",
  "riskCategory.medium": "Medium",
  "riskCategory.normal": "Normal",
  "riskEvent": "Risk event",
  "riskEventBreakdownsByCarrier": "Risk event breakdowns by carrier",
  "riskEventBreakdownsByOrigin": "Risk event breakdowns by origin",
  "risk_event_incomplete_pickup": "Incomplete pickup",
  "risk_event_incomplete_pre_check": "Incomplete pre check",
  "risk_event_pickup_not_submitted": "Pickup not submitted",
  "risk_event_redzone_stop": "Redzone stop",
  "risk_event_route_deviation": "Route deviation",
  "risk_events": "Risk events",
  "riskEvents": "Risk events",
  "riskEventsAlerts": "Risk events & alerts",
  "riskEventsFilterDescription": "Filter shipments by event risk level or event type in their shipment timeline.",
  "riskEventsInsideFinalDestinationRadius": "Risk events inside final destination radius",
  "riskEventsOutsideFinalDestinationRadius": "Risk events outside final destination radius",
  "risk_event_unauthorized_stop": "Unauthorized stop",
  "risk_event_violation": "Risk event",
  "riskEvent_warningMessage": "The risk level of each violation is now determined by risk score and may be different to the risk priority selected in this workflow. View the <a>risk score template</a> in use for this workflow to check the risk score of each event. <br /> <br /> This violation level is still used for reports, notification content, and other areas outside of shipment prioritisation.",
  "riskFactor.label_inDangerZone": "Geofence: danger zone",
  "riskFactor.label_inHotZone": "Geofence: hotzone",
  "riskFactor.label_inOpenMicZone": "Geofence: open mic zone",
  "riskFactor.label_inRededZone": "Geofence: redzone",
  "riskGPT": "RiskGPT",
  "riskGPTChatClearedByUser": "Chat cleared by {userName}",
  "riskGPTGreeting": "Hi, I'm RiskGPT, here to help answer questions about the current alert",
  "riskGptPrompts.editPromptTitle": "Edit prompt",
  "riskGptPrompts.promptName": "Prompt name",
  "riskGptPrompts.summaryPageTitle": "RiskGPT prompts",
  "riskGptPrompts.type": "RiskGPT type",
  "riskKPIGroup": "Risk KPIs",
  "riskLevel": "Risk level",
  "riskLevel_high": "High",
  "riskLevel_low": "Low",
  "riskLevel_medium": "Medium",
  "riskLevel_normal": "Normal",
  "riskModelCategory_commodity": "Commodity",
  "riskModelCategory_company": "Company",
  "riskModelCategory_compliance": "Compliance",
  "riskModelCategory_device": "Device",
  "riskModelCategory_escort": "Escort",
  "riskModelCategory_geofence": "Geofence",
  "riskModelCategory_teamDriver": "Team driver",
  "riskScoreLevel_high": "High",
  "riskScoreLevel_low": "Low",
  "riskScoreLevel_medium": "Medium",
  "riskScoreLevel_superUrgent": "Super urgent",
  "riskScoreLevel_urgent": "Urgent",
  "riskScoreModel.editModelTitle": "Edit: {modelName} model",
  "riskScoreModels": "Risk score models",
  "riskScoreModels.addCategory": "Add category",
  "riskScoreModels.addCheck": "Add check",
  "riskScoreModels.confirmationMessage_deleteCategoryDescription": "Are you sure you want to delete the {name} category?",
  "riskScoreModels.confirmationMessage_deleteCheckDescription": "Are you sure you want to delete the {name} check?",
  "riskScoreModels.confirmationMessage_recalculateScores": "Are you sure you want to recalculate all scores?",
  "riskScoreModels.deleteCategoryTitle": "Delete category",
  "riskScoreModels.deleteCheckTitle": "Delete check",
  "riskScoreModels.editCategory": "Edit category",
  "riskScoreModels.editCheck": "Edit check",
  "riskScoreModels.editModel": "Edit model",
  "riskScoreModels.entityCategory": "Category",
  "riskScoreModels.errorTitle_checksFetch": "Failed to retrieve checks.",
  "riskScoreModels.helperText_categoryIcon": "Select an icon to illustrate the check on the intelligence dashboard.",
  "riskScoreModels.helperText_checkIcon": "Select an icon to illustrate the check on the intelligence dashboard.",
  "riskScoreModels.label_category": "Category",
  "riskScoreModels.label_categoryDescription": "Category description",
  "riskScoreModels.label_categoryIcon": "Category icon",
  "riskScoreModels.label_categoryName": "Category name",
  "riskScoreModels.label_check": "Check",
  "riskScoreModels.label_checkDescription": "Check description",
  "riskScoreModels.label_checkIcon": "Check icon",
  "riskScoreModels.label_checkName": "Check name",
  "riskScoreModels.label_checkOutcome": "Check outcome",
  "riskScoreModels.label_enabledCheck": "Include rules in score calculation",
  "riskScoreModels.label_model": "Model",
  "riskScoreModels.label_recalculateScoresDescription": "This will recalculate and update all scores using the latest rule changes.",
  "riskScoreModels.loadingChecks": "Loading checks...",
  "riskScoreModels.successMessage_categorySaved": "{categoryName} category was saved to the {modelName} model",
  "riskScoreModels.successMessage_checkSaved": "{checkName} check was saved to the {modelName} model",
  "riskScoreModels.successMessage_deleteCategoryDescription": "Category {name} was successfully deleted",
  "riskScoreModels.successMessage_deleteCheckDescription": "Check {name} was successfully deleted",
  "riskScoreModels.successMessage_scoresUpdated": "Scores updated successfully!",
  "riskScoreModels.successMessage_scoresUpdatedDescription": "All carrier scores now reflect the latest rule changes.",
  "riskScoreModels.successTitle_categoryCreated": "Category created successfully!",
  "riskScoreModels.successTitle_categoryUpdated": "Category updated successfully!",
  "riskScoreModels.successTitle_checkCreated": "Check created successfully!",
  "riskScoreModels.successTitle_checkUpdated": "Check updated successfully!",
  "riskScoreRules": "Risk score rules",
  "riskScoreRules.actionsSectionTitle": "Perform this action:",
  "riskScoreRules.addConditionBtn": "Add condition",
  "riskScoreRules.addRuleBtn": "Add rule",
  "riskScoreRules.addRuleTitle": "Add rule",
  "riskScoreRules.addValuesDescription": "Add values manually or import them using the feature below.",
  "riskScoreRules.conditionsSectionTitle": "Meets <input/> of the following conditions",
  "riskScoreRules.confirmationMessage_deleteActionDescription": "Are you sure you want to delete the {name} rule?",
  "riskScoreRules.deleteActionTitle": "Delete rule",
  "riskScoreRules.editAddressesBtn": "{addressesCount} added addresses",
  "riskScoreRules.editRuleTitle": "Edit rule",
  "riskScoreRules.emptyState": "No rules found.",
  "riskScoreRules.increaseRiskScoreAction": "Increase riskscore",
  "riskScoreRules.isAnyThatContainOperator": "Is any that contain",
  "riskScoreRules.isAnyThatExactlyMatchOperator": "Is any that exactly match",
  "riskScoreRules.isAnyThatWordMatchOperator": "Is any that word match",
  "riskScoreRules.isGreaterThanOperator": "Is greater than",
  "riskScoreRules.isLessThanOperator": "Is less than",
  "riskScoreRules.isNotAnyThatContainOperator": "Is not any that contain",
  "riskScoreRules.isNotAnyThatExactlyMatchOperator": "Is not any that exactly match",
  "riskScoreRules.isNotAnyThatWordMatchOperator": "Is not any that word match",
  "riskScoreRules.label_addAddresses": "Add addresses",
  "riskScoreRules.label_addValues": "Add values",
  "riskScoreRules.label_editValues": "{valuesCount} added values",
  "riskScoreRules.matchesAnyNerabyOperator": "Matches any nearby",
  "riskScoreRules.matchesAnyOperator": "Matches any",
  "riskScoreRules.notShownOnMap": "Not shown on the map",
  "riskScoreRules.rulePropertiesSectionTitle": "Rule properties",
  "riskScoreRules.selectedAddressesDescription": "Addresses that will be evaluated in the rule:",
  "riskScoreRules.selectedValuesDescription": "Values that will be evaluated in the rule:",
  "riskScoreRules.shownOnMap": "Shown on the map",
  "riskScoreRules.successMessage_badActorOverlayDisabled": "{name} removed from the bad actor overlay",
  "riskScoreRules.successMessage_badActorOverlayEnabled": "{name} added to the bad actor overlay",
  "riskScoreRules.successMessage_deleteDescription": "Rule {name} was successfully deleted",
  "riskScoreRuleValue.downloadAddressesImportTemplate": "Import multiple addresses using file import button below. <a>Download template</a>. A maximum of 1,000 values can be added in total and values must include address, city and state.",
  "riskScoreRuleValue.downloadImportTemplate": "Import multiple values using file import button below. <a>Download template</a>. A maximum of 1,000 values can be added in total and values must be at least two characters long.",
  "riskScoreTrend.description_emptyState": "Available when the carrier's score is next recalculated",
  "riskScoreTrend.label_allTimeInterval": "Past two years",
  "riskScoreTrend.label_decreasedTrend": "Decreased {value}",
  "riskScoreTrend.label_increasedTrend": "Increased {value}",
  "riskScoreTrend.label_sinceLastUpdate": "Since last update",
  "riskScoreTrend.label_unchangedTrend": "Unchanged",
  "riskSeverity": "Risk severity",
  "risksIncidentsLossesMap": "Risks, incidents & losses map",
  "riskWarning.description_changeInPlanProposedCarrier": "The driver indicated that they intend to work with a different carrier",
  "riskWarning.description_changeInPlanProposedTractor": "The driver indicated that they intend to use a different tractor",
  "riskWarning.description_changeInPlanProposedTrailer": "The driver indicated that they intend to use a different trailer",
  "riskWarning.description_doubleBrokeringRiskCarrierWarning": "Double-Brokering risk - USDOT differs from planned carrier.",
  "riskWarning.description_driverDeclinedShipmentDriver": "Driver preclearance submission generated <generated></generated>",
  "riskWarning.description_firstTimeCarrierWarning": "First time carrier in Overhaul.",
  "riskWarning.description_firstTimeDriver": "First time driver in Overhaul.",
  "riskWarning.description_highRiskWarning": "High risk - identified by FraudWatch.",
  "riskWarning.description_outOfNetworkCarrierWarning": "Using a carrier not recognized in your network increases the risk of loss, theft, and regulatory violations due to lack of established trust and vetting.",
  "riskWarning.description_preclearanceSubmissionOverdueDriver": "Preclearance invite sent <sent></sent> was not submitted within the {windowHours}-hour window (due <due></due>)",
  "riskWarning.description_rejectedCarrierWarning": "Carrier not allowed for use by an approver. Rebook and replace before starting pickup.",
  "riskWarning.description_rejectedDriverWarning": "Driver not allowed for use by an approver.",
  "riskWarning.description_unauthorizedCarrierWarning": "Assigned as unauthorized - by someone in your company.",
  "riskWarning.label_carrierDashboardRedirectButton": "View risk assessment",
  "riskWarning.label_carrierProposedByDriver": "Carrier proposed by driver",
  "riskWarning.label_changeInPlanProposed": "Change in plan proposed",
  "riskWarning.label_driverDeclinedShipmentDriver": "Driver declined shipment",
  "riskWarning.label_firstTimeCarrier": "First time carrier",
  "riskWarning.label_firstTimeDriver": "First time driver",
  "riskWarning.label_highRiskCarrier": "High risk carrier",
  "riskWarning.label_highRiskDriver": "High risk driver",
  "riskWarning.label_matchesPlannedEntity": "Matches with planned {entityType}",
  "riskWarning.label_outOfNetworkCarrierWarning": "Carrier outside of network",
  "riskWarning.label_potentialDoubleBrokering": "Potential double-brokering",
  "riskWarning.label_preclearanceSubmissionOverdueDriver": "Preclearance not submitted within the allotted time",
  "riskWarning.label_rejectedCarrierWarning": "Carrier rejected",
  "riskWarning.label_rejectedDriverWarning": "Driver(s) rejected",
  "riskWarning.label_risksIdentified": "{count} risks identified",
  "riskWarning.label_tractorProposedByDriver": "Tractor proposed by driver",
  "riskWarning.label_trailerProposedByDriver": "Trailer proposed by driver",
  "riskZone": "Risk zone",
  "riskZoneMobileNta": "Redzone/Hotzone mobile NTA (mins)",
  "risk_zone_no_tracking_shipment_event": "Risk zone no tracking alert",
  "risk_zone_no_tracking_violation": "Risk zone no tracking alert",
  "riskZoneNTA": "Risk zone NTA",
  "riskZoneVehicleNta": "Redzone/Hotzone vehicle NTA (mins)",
  "rmoModel": "Model",
  "rmoPortalSetting.createNewCarriersDescription": "Disable when using any carriers outside of a Customer's network exceeds their risk tolerance. Disabling this toggle ensures Shipment Connect users can only assign planned carriers from the network.",
  "rmoPortalSetting.sectionSubtitle_referenceFields": "Reference fields",
  "rmoPortalSetting.sectionSubtitle_rolesAndResponsibilities": "Roles and responsibilities",
  "rmoPortalSetting.toggle_createNewCarriers": "Allow creation of new planned carriers",
  "rmoPortalSetting.toggle_shipmentOperatorMatch": "Don’t allow the same shipment creator and shipment auditor",
  "road": "Road",
  "road_air": "Road/Air",
  "road_air_ocean": "Road/Air/Ocean",
  "roadCorrectionLocation": "Road correction location",
  "road_ocean": "Road/Ocean",
  "roadSettings": "Road settings",
  "roadShippingMode": "Mode: road",
  "roadWorkflowCreated": "Road workflow is successfully created",
  "roadWorkflowUpdated": "Road workflow is successfully updated",
  "role": "Role",
  "roleName": "Role name",
  "roles": "Roles",
  "rotateDeviceWarning": "Please rotate your device to portrait.",
  "route": "Route",
  "routeActivate": "Are you sure you want to activate the route {name}?",
  "routeActivationSuccessfullMessage": "Route activated successfully",
  "routeCantBeCreatedOnPortals": "{routeName} to: {portals}",
  "routeCreatedSuccessfully": "Route created successfully",
  "routeCreator": "Route creator",
  "routeDeactivate": "Are you sure you want to deactivate the route {name}?",
  "routeDeactivationSuccessfullMessage": "Route deactivated successfully",
  "routeDetails": "Route details",
  "routeDeviation": "Route deviation",
  "route_deviation_violation": "Route deviation",
  "routeEditor": "Route editor",
  "routeIsAssociated": "This route is already associated with shipment",
  "routeIsAvailable": "{routeName} is now available.",
  "routeIsNowAvailable": "1 route is now available.",
  "routeIsNowDeactivated": "1 route is now deactivated.",
  "routeLegend": "Route legend",
  "routeName": "Route name",
  "routeNotes": "Route notes (optional)",
  "routeNotesAttribute": "Route notes",
  "routePerformance": "Route performance",
  "routePerformance.aboveAverageDuration": "<span>{percent}% above</span> average on route",
  "routePerformance.averageDuration": "Average duration",
  "routePerformance.belowAverageDuration": "<span>{percent}% below</span> average on route",
  "routePerformance.earlyArrival": "Early",
  "routePerformance.lateArrival": "{hoursCount} hr late",
  "routePerformance.lateShipments": "Late",
  "routePerformance.metrics": "Route metrics",
  "routePerformance.noTimezoneChange": "No timezone change",
  "routePerformance.observedShipments": "Observed shipments",
  "routePerformance.onTimeArrival": "On time",
  "routePerformance.originToDestination": "Origin to destination",
  "routePerformance.performanceComparison": "<span>Like {percent}%</span> of shipments on route",
  "routePerformance.routeInformation": "Route information",
  "routePerformance.timezoneChanges": "Timezone changes",
  "routePerformance.weatherAtDestination": "Weather at destination (°{unit})",
  "routes": "Routes",
  "routesAreNowAvailable": "{routeCount} routes are now available.",
  "routesAreNowDeactivated": "{routeCount} routes are now deactivated.",
  "routeSelection": "Route selection",
  "routesFromSamePortalError": "Please choose routes that are from the same portal",
  "routeUpdatedSuccessfully": "Route updated successfully",
  "row": "Row",
  "rows": "Rows",
  "run": "Run",
  "runDeviceCheck": "Run check",
  "safezoneDetentionTime": "Safezone detention time (minutes)",
  "safe_zone_restart": "Safezone stop start",
  "safe_zone_restart_violation": "Safezone stop start",
  "safeZones": "Safe zones",
  "safe_zone_stop": "Safezone stop",
  "safezone_stop": "Safezone stop",
  "safezoneStopDetentionTime": "Safezone stop detention time (minutes)",
  "safezone_stop_violation": "Safezone stop",
  "satellite": "Satellite",
  "satelliteMapView": "Satellite map view",
  "saturday": "Saturday",
  "save": "Save",
  "saveARoute": "Save a route",
  "saveAs": "Save as",
  "saveAsNew": "Save as new",
  "saveAsNewDashboard": "Save as new dashboard",
  "saveChanges": "Save changes",
  "saveDashboard": "Save dashboard",
  "saveDashboardConfirmation": "This dashboard will be available only to you.",
  "savedFilterIndividualMessage": "This filter will be available only to you",
  "savedFilters": "Saved filters",
  "savedFilterViews.errorMessage": "Close and reopen the modal to try again.",
  "savedFilterViews.errorTitle": "Saved filters could not be fetched",
  "saveFilters": "Save filters",
  "saveNewPass": "Save new password",
  "savePassword": "Save password",
  "saveProgress": "Save progress",
  "saveRouteAs": "Save route as",
  "saveRoutePrompt": "A route can only be saved if it is not linked to a shipment and no changes have been made to the intermediary or segment locations",
  "saveSharedConfirmation": "Are you sure you want to update this dashboard? All changes will be visible for other users.",
  "scacCode": "SCAC code",
  "scanBarcode": "Scan barcode",
  "scGO.editShipmentPage_title": "Edit shipment",
  "scGO.editShipmentPage_unavailableDescription": "We couldn't load this shipment's details for editing. Please try again, or contact support if the problem continues.",
  "scGO.editShipmentPage_unavailableLabel": "Shipment can't be edited right now",
  "scGO.findShipmentPage_continueToEditButton": "Continue to edit",
  "scGO.findShipmentPage_description": "Enter the shipment reference number to find and update an existing shipment.",
  "scGO.findShipmentPage_helperText": "Enter the shipment reference number for the shipment you want to update.",
  "scGO.findShipmentPage_searchPlaceholder": "Search by a shipment reference number",
  "scGO.findShipmentPage_title": "Find a shipment to edit",
  "scGO.homePage_editShipmentTileDescription": "Find an existing shipment and add or update shipment details.",
  "scGO.homePage_editShipmentTileLabel": "Edit shipment",
  "scGO.pickup_addDriversDescription": "Add up to {count} drivers for this shipment",
  "scGO.pickup_validationLoading": "Wait until validation is complete",
  "scGO.pickup_verifyCarrierDescription": "Verify the carrier that arrived for pickup",
  "schedule": "Schedule",
  "scheduledArrival": "Scheduled arrival",
  "scheduledDeparture": "Scheduled departure",
  "schedulePlaceholder": "No open hours added",
  "sea": "Sea",
  "seal_closed_shipment_event": "Seal closed",
  "seal_low_battery_level_shipment_event": "Low battery - bluetooth seal",
  "seal_low_battery_level_violation": "Low battery - bluetooth seal",
  "seal_open_shipment_event": "Seal open",
  "seal_state_change_violation": "Seal open",
  "sealStatus": "Seal status",
  "seaport_ids": "Seaport",
  "seaports": "Seaports",
  "Seaports": "Seaports",
  "seaportWithUnlocode": "{unlocode} seaport",
  "search": "Search",
  "searchAddress": "Search address",
  "searchAllPortals": "Search all portals",
  "searchArchive": "Search in archive",
  "searchBy": "Search by",
  "searchByEventTitle": "Search by event title",
  "searchExternalAddresses": "Search external locations",
  "searchForShipments": "Search for shipments",
  "searchLocations": "Search locations",
  "searchLocationsPlaceholder": "Please type at least 3 characters",
  "secondary": "Secondary",
  "secondaryEscalationPriorityDescription": "To be contacted second, subject to schedule, as part of escalations to this company.",
  "secondBatteryLevelAlert": "Second battery level alert (%)",
  "secondBatteryLevelMovingPingRate": "Second battery level moving ping rate",
  "secondBatteryLevelStationaryPingRate": "Second battery level stationary ping rate",
  "secondNotif": "Second notification",
  "secure-storage": "Secure storage",
  "security": "Security",
  "segment": "Segment",
  "segmentEtaFinalDelivery": "Segment ETA final delivery",
  "segmentEtaNextDelivery": "Segment ETA next delivery",
  "segment_status_created": "Segment created",
  "segmentsWithoutSecondDriver": "Segments without second driver: {value}",
  "segregatedBallastCapacity": "Segregated ballast capacity",
  "select": "Select",
  "selectAll": "Select all",
  "selectBrokers": "Select brokers",
  "selectCarriers": "Select carriers",
  "selectChildLocations": "Select child locations",
  "selectClient": "Select client:",
  "selectCompany": "Select company",
  "selectCompanyStep": "Select company",
  "selectCompanyTitle": "Select the company to create a contact for:",
  "selectContacts": "Select contacts",
  "selectContactsToAddDepartment": "Select contacts to add to the department.",
  "selectCountry": "Select country",
  "selectCustomers": "Select customers",
  "selectCustomersPlaceholder": "Select customers",
  "selectDate": "Select date",
  "selectDestinationPlaceholder": "Select destination",
  "selectDestinations": "Select destinations",
  "selectDrivers": "Select drivers",
  "selectedPortal": "Selected portal",
  "selectedRecipientsSectionDescription": "The following contacts will be emailed:",
  "selectedRecipientsSectionPlaceholder": "Contacts of the selected companies will appear here.",
  "selectedValue": "Selected value",
  "selectEvent": "Select event",
  "selectEvents": "Select events",
  "selectExistingContacts": "Select existing contacts",
  "selectExportRange": "Select a date range to export the device data",
  "selectFields": "Select fields",
  "selectFinalDestination": "Select final destination",
  "selectFinalDestinationPlaceholder": "Select final destination",
  "selectItemsToBeAlerted": "Select items to be alerted",
  "selectLanguage": "Select language",
  "selectLocationType": "Select location type",
  "selectModel": "Select model",
  "selectModelPlaceholder": "Select model",
  "selectOrigin": "Select origin",
  "selectOriginPlaceholder": "Select origin",
  "selectOrigins": "Select origins",
  "selectParentLocations": "Select parent locations",
  "selectPlacement": "Select placement",
  "selectPortal": "Select portal",
  "selectPortalComanyTitle": "Select or create a company as owner of the portal",
  "selectPortalPlaceholder": "Select portal",
  "selectReason": "Select reason",
  "selectRegions": "Select regions",
  "selectRiskEvents": "Select risk events",
  "selectRole": "Select role",
  "selectRoute": "Select route",
  "selectShipmentSegment": "Select shipment segment",
  "selectSipmentIDPlaceholder": "Select shipment ID",
  "selectStateModal": "Select state modal",
  "selectStatus": "Select status",
  "selectStatusesPlaceholder": "Select statuses",
  "selectSubRole": "Select Sub-Role",
  "selectTimezone": "Select timezone",
  "selectVendorPlaceholder": "Select vendor",
  "selectWorkflow": "Select workflow:",
  "selectWorkflowGroups": "Select workflows",
  "selectWorkflows": "Select workflows",
  "selectYourDestinationPortal": "Select your destination portal(s).",
  "sendBtn": "Send",
  "sendEmail": "Send email",
  "sensor": "Sensor",
  "sensorAlerts": "Sensor alerts",
  "sensorData": "SENSOR DATA",
  "sensorEventDetectionDelay": "Event detection delay (mins)",
  "sensorLoggingPeriod": "Sensor logging period",
  "sensorLoggingPeriodHint": "The interval, in seconds, between logged measurements when in normal timer state",
  "sensorRange_above": "Above {numericValue}",
  "sensorRange_and": "{numericValue1} and {numericValue2}",
  "sensorRange_below": "Below {numericValue}",
  "sensorRange_between": "Between {numericValue1} and {numericValue2}",
  "sensorRange_or": "{numericValue1} or {numericValue2}",
  "sensorSettings": "Sensor settings",
  "sensorType": "Sensor type",
  "sensorType_humidity": "Humidity",
  "sensorType_light": "Light",
  "sensorType_shock": "Shock",
  "sensorType_speed": "Speed",
  "sensorType_temperature": "Temperature",
  "sensorType_tilt": "Tilt",
  "sentEscalate": "Sent",
  "sentinelExpiryTime": "Sentinel expiry time (hours)",
  "sentTo": "Sent to",
  "separatedAt": "Separated at",
  "separationAndTimelineEvents": "Separation & timeline events",
  "separationEventMiles": "Separation event miles",
  "separation_shipment_event": "Separation alert",
  "serialNumber": "Serial number",
  "setAsDefaultFilter": "Set as default filter",
  "setOrCancelReminder": "Set/Cancel a reminder",
  "setReminder": "Set reminder",
  "settings": "Settings",
  "setupRates": "Set up reporting rates",
  "setupRatesShort": "Set up rates",
  "severe": "Severe",
  "severe/High/MediumRisk": "High/Medium/Severe risk",
  "severe/HighRisk": "High/Severe risk",
  "severeRiskPopulation": "Severe risk population",
  "share": "Share",
  "shareConfirmationMessage": "Are you sure you want to share the {name} dashboard to all users?",
  "shared": "Shared",
  "sharedAddressClusterRiskLevel.critical": "Critical",
  "sharedAddressClusterRiskLevel.high": "High",
  "sharedAddressClusterRiskLevel.medium": "Medium",
  "sharedAddressClusterRiskLevel.noRisk": "No risk",
  "sharedAsset": "Shared asset",
  "sharedEmailDomainClusterRiskLevel.noRisk": "No risk",
  "sharedEmailDomainClusterRiskLevel.riskDetected": "Risk detected",
  "sharedIdentityProvider_azureAD": "Azure AD",
  "sharedIdentityProvider_google": "Google",
  "sharedPhoneNumberClusterRiskLevel.noRisk": "No risk",
  "sharedPhoneNumberClusterRiskLevel.riskDetected": "Risk detected",
  "shareLink": "Share link",
  "shareModalTitle": "Share your dashboard",
  "sherpaHideCompletedShipments": "Sherpa - hide completed shipments",
  "ship": "Ship",
  "ship_departure_shipment_event": "Departure from seaport location",
  "shipId": "Ship. ID",
  "shipIMO": "Ship IMO",
  "shipment": "Shipment",
  "shipmentAssets.description_productsInShipment": "Products in this shipment tracked in Asset Manager.",
  "shipmentAssets.label_inactiveAsset": "Asset archived or deleted",
  "shipmentAssets.label_noAccessToAssetDetails": "You do not have access to see this asset details",
  "shipmentAssets.label_noShipmentAssets": "No assets added to this shipment.",
  "shipmentAssets.label_viewInAssetManager": "View in Asset Manager",
  "shipmentAttachments": "Shipment attachments",
  "shipmentAttributes": "Shipment attributes",
  "shipmentAuditorRequired": "Shipment auditor required",
  "shipmentCantLoad": "Shipment can't be loaded",
  "shipmentConnect": "Shipment Connect",
  "shipmentConnectEnabled": "Shipment Connect enabled",
  "shipmentConnectRadius": "Shipment Connect radius",
  "shipmentConvoy.confirmationMessage_remove": "Convoys must have at least two shipments. Are you sure you want to delete this convoy?",
  "shipmentConvoy.infoMesage_createOrLinkConvoy": "Create a new one or link to an existing convoy",
  "shipmentConvoy.infoMessage_noConvoy": "This shipment is not linked to any convoy",
  "shipmentConvoy.infoMessage_selectConvoy": "Select the convoy to which you wish to add this shipment",
  "shipmentConvoy.infoMessage_setModeDeviations": "Set the separation limits for shipments from the convoy in each transport mode.",
  "shipmentConvoy.infoMessage_shipmentsAmount": "At least 2 shipments are required to a convoy be valid",
  "shipmentConvoy.label_createConvoy": "Create convoy",
  "shipmentConvoy.label_createNew": "Create new",
  "shipmentConvoy.label_deviationLimits": "Deviation limits",
  "shipmentConvoy.label_deviationMode": "{mode} mode deviation",
  "shipmentConvoy.label_existingConvoy": "Existing convoy",
  "shipmentConvoy.label_linkToConvoy": "Link to convoy",
  "shipmentConvoy.label_selectConvoy": "Select an existing convoy",
  "shipmentConvoy.successMessage_linkToConvoy": "Current shipment was linked to the convoy",
  "shipmentConvoy.successMessage_removed": "{name} was removed as required",
  "shipmentConvoy.successMessage_saved": "{name} convoy created successfully.",
  "shipmentConvoy.successMessage_updated": "{name} was updated",
  "shipmentCreate.addDeviceForm_subtitle": "Select device and add it to the shipment.",
  "shipmentCreate.button_editDevices": "Edit devices",
  "shipmentCreate.button_hideRefNumbers": "Hide additional reference numbers",
  "shipmentCreate.button_removeRoute": "Remove route",
  "shipmentCreate.button_showRefNumbers": "Add additional reference numbers",
  "shipmentCreate.button_updateSements": "Edit segment information",
  "shipmentCreate.carrierRefNumber_helperText": "This carrier reference number is used to identify this segment only.",
  "shipmentCreate.creationSuccessMessage": "Shipment #{value} was successfully created",
  "shipmentCreate.creationSuccessTitle": "Shipment created",
  "shipmentCreate.devicesSection_tooltip": "Link monitoring devices (like GPS or iot sensors or bluetooth seals) to your shipment for real-time visibility and alerts.",
  "shipmentCreate.devices_subtitle": "Add tracking device",
  "shipmentCreate.failedToFetchDevice": "Device {imei} could not be found.",
  "shipmentCreate.label_assignedDevices": "Assigned devices",
  "shipmentCreate.label_brokerRefNumber": "Broker reference number",
  "shipmentCreate.label_carrierRefNumber": "Carrier reference number",
  "shipmentCreate.label_containerNumber": "Container number",
  "shipmentCreate.label_escortCompany": "Escort company",
  "shipmentCreate.label_shipmentRefNumber": "Shipment reference number",
  "shipmentCreate.label_shipmentSegments": "Segments",
  "shipmentCreate.label_shipperRefNumber": "Shipper reference number",
  "shipmentCreate.label_trackingRefNumber": "Tracking reference number",
  "shipmentCreate.locationAgreedDatetime": "{location} date and time",
  "shipmentCreate.lowestDeviceBattery": "Lowest battery",
  "shipmentCreate.referenceNumbers_subtitle": "Add reference numbers",
  "shipmentCreate.referenceNumbers_tooltip": "You must add a reference number to help identify and track your shipment. You can add additional reference numbers such as shipment, tracking, carrier, shipper, or container numbers, and even add custom fields if needed. These references make it easier to match your shipment across systems.",
  "shipmentCreate.reportingDevices": "Reporting",
  "shipmentCreate.routeSection_subtitle": "Add route",
  "shipmentCreate.routeSection_tooltip": "Select a predefined route with origin, destination, and stop locations. You can also create a new route and save it for future use.",
  "shipmentCreate.segmentsEmptyState_subtitle": "Please select a route to enter segment information.",
  "shipmentCreate.segmentsEmptyState_title": "Route not selected",
  "shipmentCreate.segmentsOverviewPopup_caption": "Provide details for each route segment, including pickup and delivery dates and time, carrier, drivers, and devices.",
  "shipmentCreate.segmentsOverviewPopup_title": "Provide segment information",
  "shipmentCreate.segmentsSection_tooltip": "Provide details for your shipment, including pickup and delivery dates and time, carrier, drivers, and devices.",
  "shipmentCreate.segments_subtitle": "Add segment information",
  "shipmentCreate.stakeholders_subtitle": "Add shipment stakeholders",
  "shipmentCreate.stakeholders_tooltip": "Select a shipper, customer and broker. Shipper is a required field, if this field is read only a shipper has been selected for your organization.",
  "shipmentCreate.totalSegments_label": "Total segments:",
  "shipmentCreate.transportationModes_label": "Transportation modes:",
  "shipmentCreate.updateSuccessMessage": "Shipment #{value} was successfully updated",
  "shipmentCreate.updateSuccessTitle": "Shipment updated",
  "shipmentCreate.workflow_subtitle": "Add workflow",
  "shipmentCreate.workflow_tooltip": "Select a pre-defined workflow template used to customize and define shipping requirements based on the customers SOP (standard operating procedure). If this field is read only a default workflow has been selected for your organization.",
  "shipmentCreationDate": "Shipment creation date",
  "shipmentCreatorRequired": "Shipment creator required",
  "shipmentCustomFieldsDescription": "Select a custom field to add to this shipment. A custom field allows you to categorise shipments to make it easier to track and manage important shipments. If custom fields have been defined on other shipments, they will be available to add to this shipment.",
  "shipmentDateValidation": "Shipment date validation",
  "shipmentDeliveryDate": "Shipment delivery date",
  "shipmentDelivery.label_agreedDeliveryDateTime": "Agreed delivery date/time",
  "shipmentDelivery.label_lastReading": "Last reading",
  "shipmentDelivery.label_qualityReviewCompleted": "Quality review completed",
  "shipmentDelivery.label_shipmentDetails": "Shipment details",
  "shipmentDelivery.label_temperatureThresholdName": "Temperature threshold name",
  "shipmentDelivery.label_totalAlarms": "Total alarms",
  "shipmentDelivery.label_totalExcursions": "Total excursions",
  "shipmentDelivery.label_totalTimeOutOfRange": "Total time out of range",
  "shipmentDelivery.status_accepted": "Accepted",
  "shipmentDelivery.status_rejected": "Rejected",
  "shipmentDepartedWithoutTracking": "Shipment departed without tracking",
  "shipmentDepartureRiskApprovalAction_allow": "Allow",
  "shipmentDepartureRiskApprovalAction_reject": "Reject",
  "shipmentDepartureRiskApprovalAction_requireManualReview": "Require manual review",
  "shipmentDisappearedFromSentinel": "Shipment disappeared from sentinel",
  "shipmentEventValidity.invalid": "Invalid",
  "shipmentEventValidity.pending": "Pending validation",
  "shipmentEventValidity.potentiallyInvalid": "Potentially invalid",
  "shipmentEventValidity.valid": "Valid",
  "shipmentExportError": "Export failed, please try again.",
  "shipmentExportErrorTooltip": "Contact support if this problem persists.",
  "shipmentFiltersUpdated": "Shipment filters were updated",
  "shipmentGroup_highValue": "High value",
  "shipmentGroup_highValueDescription": "Any shipments that have the ‘High value shipment’ checkbox selected",
  "shipmentGroup_incidentReported": "Incidents",
  "shipmentGroup_incidentReportedDescription": "Any shipments with a manual incident added to the timeline",
  "shipmentGroup_inProgress": "In progress",
  "shipmentGroup_inProgressDescription": "Any shipment with an open violation where the investigation has started but the event has not been waived or acknowledged yet",
  "shipmentGroup_investigate": "Investigate",
  "shipmentGroup_investigateDescription": "Any shipments with an open violation where the investigation has not started yet",
  "shipmentGroup_mapView": "Map view",
  "shipmentGroup_mapViewDescription": "Any shipments that are in your current map view",
  "shipmentGroup_watching": "Watching",
  "shipmentGroup_watchingDescription": "Any shipments that you have watched. Use the ‘Watch’ icon in the shipment header to add a shipment to this group",
  "shipmentID": "Shipment ID",
  "shipmentIdentifier_carrierDetailsAbbreviated": "CAR",
  "shipmentIdentifier_carrierRefAbbreviated": "CRR",
  "shipmentIdentifier_carrierReference": "Carrier reference",
  "shipmentIdentifier_carrierRefNumber": "Carrier ref. #",
  "shipmentIdentifier_container": "Container",
  "shipmentIdentifier_containerRefAbbreviated": "CON",
  "shipmentIdentifier_customId": "Custom ID",
  "shipmentIdentifier_customIdAbbreviated": "CSM",
  "shipmentIdentifier_driver": "Driver",
  "shipmentIdentifier_flightNumber": "Flight number",
  "shipmentIdentifier_houseAirWaybillAbbreviated": "HAWB",
  "shipmentIdentifier_houseBillofLadingAbbreviated": "HBOL",
  "shipmentIdentifier_internationalMaritimeOrganizationNumberAbbreviated": "IMO",
  "shipmentIdentifier_maritimeMobileServiceIdentityNumberAbbreviated": "MMSI",
  "shipmentIdentifier_masterAirWaybillAbbreviated": "MAWB",
  "shipmentIdentifier_masterBillOfLadingAbbreviated": "MBOL",
  "shipmentIdentifier_oceanSCACCode": "Ocean SCAC code",
  "shipmentIdentifier_overhaulId": "Overhaul ID",
  "shipmentIdentifier_overhaulIdAbbreviated": "OHI",
  "shipmentIdentifier_shipmentId": "Shipment ID",
  "shipmentIdentifier_shipmentRefAbbreviated": "SRN",
  "shipmentIdentifier_shipmentReference": "Shipment reference",
  "shipmentIdentifier_shipmentRefNumber": "Shipment ref. #",
  "shipmentIdentifier_shipName": "Ship name",
  "shipmentIdentifier_shipperRefAbbreviated": "SHP",
  "shipmentIdentifier_shipperReference": "Shipper reference",
  "shipmentIdentifier_shipperRefNumber": "Shipper ref. #",
  "shipmentIdentifier_trackingRefAbbreviated": "TRK",
  "shipmentIdentifier_trackingReference": "Tracking reference",
  "shipmentIdentifier_trackingRefNumber": "Tracking ref. #",
  "shipmentIdentifier_tractor": "Tractor",
  "shipmentIdentifier_trailer": "Trailer",
  "shipmentIds": "Shipment IDs",
  "shipmentInfoIsMissingMessage": "Escalation contacts couldn’t be retrieved because shipment information is missing. Contact your supervisor for help.",
  "shipmentInformation": "Shipment information",
  "shipmentInsurance.certificatePurchasing": "Insurance certificate purchasing",
  "shipmentInsurance.viewCertificate": "View insurance certificate",
  "shipmentIsAlreadyLocked": "Shipment is already locked",
  "shipmentLeftLockDownAfter": "Left lockdown after",
  "shipmentLocations": "Shipment locations",
  "shipmentLockedByUser": "Shipment locked down by {userName}",
  "shipmentLockedDownAt": "Locked down at",
  "shipmentLockedDownFor": "Locked down for",
  "shipmentManagerBetaAppAccess": "Shipment Manager beta app access",
  "shipmentManager.estimatedArrivalAt": "Estimated arrival at",
  "shipmentManager.estimatedFinalDeliveryAt": "Estimated final delivery at",
  "shipmentManagerETARiskFlag": "Shipment Manager ETA at risk flag",
  "shipmentManagerRequiredFields": "Required fields on shipment creation",
  "shipmentMode": "Shipment mode",
  "shipment_modes": "Shipment mode",
  "shipmentModes": "Shipment modes",
  "shipment_notes": "Shipment notes",
  "shipmentNotes": "Shipment notes",
  "shipmentPerformance": "Shipment performance",
  "shipmentPosted": "Shipment posted",
  "shipmentQrCode": "Shipment QR code",
  "shipment_reassignment_manual_shipment_event": "Shipment reassignment",
  "shipmentRelatedAttachments": "Attachments related to this shipment",
  "shipmentRelatedDetails": "Details related to this shipment",
  "shipmentRelatedEscalations": "Escalations related to this shipment",
  "shipmentRelatedMessages": "Messages related to this shipment",
  "shipmentRelatedNotes": "Shipment notes related to this shipment",
  "shipmentRelatedNotifications": "Notifications related to this shipment",
  "shipmentReleaseType_customBespoke": "Custom / bespoke",
  "shipmentReleaseType_eventSpecific": "Event-specific",
  "shipmentReleaseType_generalRelease": "General release",
  "shipmentReleaseType_limitedEdition": "Limited edition",
  "shipmentReleaseType_npi": "NPI",
  "shipmentReleaseType_preRelease": "Pre-release",
  "shipmentReleaseType_promotionalRelease": "Promotional release",
  "shipmentReleaseType_recallReplacement": "Recall / replacement",
  "shipmentReplay": "Shipment replay",
  "shipmentReport.deliveryAcceptance": "Delivery acceptance",
  "shipmentReport.deliveryCompleted": "This shipment has been <strong>accepted</strong> on <time/>",
  "shipmentReport.deliveryRejected": "This shipment has been <strong>rejected</strong> on <time/>",
  "shipmentReport.deliveryRejection": "Delivery rejection",
  "shipmentReport.fillInUserData": "Please fill in to complete delivery",
  "shipmentReport.label_acceptDelivery": "Accept delivery",
  "shipmentReport.label_rejectDelivery": "Reject delivery",
  "shipmentReport.riskGpt_disclaimer": "The purpose of RiskGPT is to provide guidance and context based on your company’s standard operating procedures. Overhaul takes NO responsibility for the decision to accept or reject this shipment.",
  "shipmentReport.successMessage_deliveryCompleted": "Thank you for completing the delivery process. The relevant parties have been notified.",
  "shipmentReport.userDataSubmit": "Continue to shipment",
  "shipmentReport.userDataTitle": "Enter your name to view shipment information",
  "shipmentRiskScore.label_templateCannotBeDeleted": "This risk score template is being used on active workflows and cannot be deleted",
  "shipments": "Shipments",
  "shipmentsBetaAccess": "Shipments beta access",
  "shipmentsCount": "{count} shipments",
  "shipmentSegmentStatus_active": "Active",
  "shipmentSegmentStatus_cancelled": "Cancelled",
  "shipmentSegmentStatus_delivered": "Delivered",
  "shipmentSegmentStatus_failed": "Failed",
  "shipmentSegmentStatus_pending": "Pending",
  "shipment_start": "Shipment start",
  "shipment_status": "Shipment status",
  "shipmentStatus_atDelivery": "At delivery",
  "shipmentStatus_atDestinationAirport": "At destination airport",
  "shipmentStatus_atDestinationPort": "At destination port",
  "shipmentStatus_atIntermediateAirport": "At intermediate airport",
  "shipmentStatus_atIntermediatePort": "At intermediate port",
  "shipmentStatus_atOriginAirport": "At origin airport",
  "shipmentStatus_atOriginPort": "At origin port",
  "shipmentStatus_atPickup": "At pickup",
  "shipmentStatus_awaitingPickup": "Awaiting pickup",
  "shipmentStatus_canceled": "Canceled",
  "shipmentStatusChangeAction_atDelivery": "At delivery",
  "shipmentStatusChangeAction_atPickup": "At pickup",
  "shipmentStatusChangeAction_cancel": "Cancel",
  "shipmentStatusChangeAction_close": "Close",
  "shipmentStatusChangeAction_delivered": "Delivered",
  "shipmentStatusChangeAction_inTransit": "In transit",
  "shipmentStatusChangeAction_pickedUp": "Picked up",
  "shipmentStatusChange.atPickupDescription": "Updating the status to “At pickup” will result in the removal of events from the shipment timeline.",
  "shipmentStatusChangeMessage_askBackInTransit": "Are you sure you would like to “Re-open shipment” and move the shipment ID #{shipmentId} back to in transit",
  "shipmentStatusChangeMessage_askMoveAtDelivery": "Are you sure you would like to move load to \"At delivery\" ID #{shipmentId}?",
  "shipmentStatusChangeMessage_askMoveAtPickup": "Are you sure you would like to move load to \"At pickup\" ID #{shipmentId}?",
  "shipmentStatusChangeMessage_askMoveInTransit": "Are you sure you would like to move load to \"In transit\" ID #{shipmentId}?",
  "shipmentStatusChangeMessage_askMoveToPickedUp": "Are you sure you would like to move load to \"Picked up\" ID #{shipmentId}?",
  "shipmentStatus_closed": "Closed",
  "shipmentStatus_contracting": "Contracting",
  "shipment_status_created": "Shipment created",
  "shipmentStatus_delivered": "Delivered",
  "shipmentStatus_departedDelivery": "Departed delivery",
  "shipmentStatus_departedPickup": "Departed pickup",
  "shipmentStatus_dispatching": "Dispatching",
  "shipment_statuses": "Shipment status",
  "shipmentStatus_inRouteToPickup": "In route to pickup",
  "shipmentStatus_inTransit": "In transit",
  "shipmentStatusKPIHint": "Active shipments by active, not yet active, in transit, delivered or closed status",
  "shipmentStatusLabel": "Shipment status",
  "shipmentStatus_opened": "Opened",
  "shipmentStatus_pickedUp": "Picked up",
  "shipment_telematics_audit_manual_shipment_event": "Shipment telematics audit",
  "shipmentTrackingExtension": "Shipment tracking extension at final delivery (minutes)",
  "shipmentTrackingExtensionHint": "The amount of time the shipment continues to be tracked for, after a shipment achieves “At delivery” status, when the status change is based solely on GPS location data from the shipment tracker.",
  "shipmentUnitedView": "United view",
  "shipmentValue": "Shipment value",
  "shipment_workflow_in_use_shipment_event": "Shipment workflow in use",
  "shipMMSI": "Ship MMSI",
  "shipName": "Ship name",
  "shipper": "Shipper",
  "shipperAbbr": "SHP",
  "shipperLabel": "Shipper",
  "shipperReference": "Shipper reference",
  "shipperRefNum": "Shipper ref.",
  "shippers": "Shippers",
  "shipping_container": "Shipping container",
  "shipTrackingStatus_completed": "Tracking completed",
  "shipTrackingStatus_pending": "Pending",
  "shipTrackingStatus_tracking": "Currently tracking",
  "ship-truck": "Ship & truck",
  "shipType_bulkCarrier": "Bulk carrier",
  "shipType_chemicalTanker": "Chemical tanker",
  "shipType_container": "Container",
  "shipType_gasTanker": "Gas tanker",
  "shipType_oilTanker": "Oil tanker",
  "shipType_reefer": "Reefer",
  "shipType_roRo": "RoRo",
  "shock": "Shock",
  "shockAlertDelay": "Shock alert delay",
  "shock_alert_violation": "Shock alert",
  "shock_shipment_event": "Shock alert",
  "show": "Show",
  "showAllAddresses": "Show all addresses",
  "showAsContact": "Show as contact",
  "showCarrierReferenceInput": "Show carrier reference input",
  "showDetails": "Show details",
  "showEmployeePinTooltip": "Show PIN",
  "showLastPingOnMap": "Show last ping on the map",
  "showLess": "Show less",
  "showMore": "Show more",
  "sh_owner": "Account owner",
  "showOnlyCompletedShipments": "Show only completed shipments",
  "showPopAtRisk": "Show population at risk overlay",
  "showShipments": "Show shipments",
  "showShipmentsCreated": "Show shipments created",
  "showShipmentsWithPickup": "Show shipments with pickup",
  "showShipperReferenceInput": "Show shipper reference input",
  "showTrackEvents": "Show track events",
  "showTrackingReferenceInput": "Show tracking reference input",
  "singleShipmentUploaded": "You successfully created {uploadedCount} new shipment",
  "size": "Size",
  "skipDdiFirstPickup": "Skip DDI on first pickup",
  "skipDdiSecondPickup": "Skip DDI on second pickup",
  "skipErrantPing": "Skip errant ping (tractor/trailer)",
  "sms": "Sms",
  "smthWentWrong": "Whoops, something went wrong",
  "snoozed": "Snoozed",
  "snoozedAtPlaceholder": "Snoozed at",
  "somethingWentWrong": "Oops, something went wrong",
  "somethingWentWrongRefresh": "Oops, something went wrong. Please refresh page.",
  "sopInstructions.addInstruction": "Add instruction",
  "sopInstructions.awaitingApprovalDescription": "Displayed when approval is still pending.",
  "sopInstructions.awaitingApprovalSubtitle": "Awaiting approval",
  "sopInstructions.instructionLabel": "Instruction {{number}}",
  "sopInstructions.modalDescription": "Optional: customize SOP instructions that Shipment Connect users will see during the approval process:",
  "sopInstructions.modalDescriptionTooltip": "These instructions are shown to Shipment Connect users during the approval process when a carrier or driver is not allowed during planning, or when pickup approval is pending, rejected, or approved. You can use the default instructions or customize them.",
  "sopInstructions.pickupApprovedDescription": "Displayed when approval was allowed.",
  "sopInstructions.pickupApprovedSubtitle": "Pickup allowed",
  "sopInstructions.pickupRejectedDescription": "Displayed when approval was rejected.",
  "sopInstructions.pickupRejectedSubtitle": "Pickup rejected",
  "sopInstructions.pickupTitle": "Pickup",
  "sopInstructions.planningRejectedDescription": "When the selected carrier or driver is not approved to be used.",
  "sopInstructions.planningRejectedSubtitle": "Plan rejected",
  "sopInstructions.planningTitle": "Planning",
  "sopInstructions.tab_pickupApproved": "Pickup approved",
  "sopInstructions.tab_pickupAwaitingApproval": "Awaiting approval",
  "sopInstructions.tab_pickupRejected": "Pickup rejected",
  "sortBy": "Sort by",
  "sortLabel.deliveryAt": "Estimated delivery / delivered date",
  "SOS": "SOS",
  "sound": "Sound",
  "source": "Source",
  "sourse": "Event source",
  "spanish": "Spanish",
  "spanish_mx": "Spanish (Mexico)",
  "spanishSpeaking": "Spanish speaking",
  "speed": "Speed",
  "spoiled_manual_incident_shipment_event": "Spoiled",
  "spoiled_manual_incident_violation": "Spoiled",
  "spokenLanguages": "Spoken languages",
  "ssoConfig.claimMappings_displayName": "Display name",
  "ssoConfig.claimMappings_displayNameDescription": "Claim that provides the display name or full name for the user (e.g.: \"Name\").",
  "ssoConfig.claimMappings_email": "Email",
  "ssoConfig.claimMappings_emailDescription": "Claim that provides the email of the user (e.g.: \"Email\").",
  "ssoConfig.claimMappings_givenName": "Given name",
  "ssoConfig.claimMappings_givenNameDescription": "Claim that provides the first name of the user (e.g.: \"given_name\").",
  "ssoConfig.claimMappings_identityProvider": "Identity provider",
  "ssoConfig.claimMappings_identityProviderDescription": "Claim that provides the token issuer name (e.g.: \"Iss\").",
  "ssoConfig.claimMappings_issuerUserId": "Issuer user ID",
  "ssoConfig.claimMappings_issuerUserIdDescription": "Claim that provides the unique identifier for the signed-in user (e.g.: \"Id\" or \"Sub\").",
  "ssoConfig.claimMappings_roles": "Roles",
  "ssoConfig.claimMappings_rolesCollection": "Roles (array)",
  "ssoConfig.claimMappings_rolesCollectionDescription": "Claim that provides the user roles from the IdP for RBAC controls.",
  "ssoConfig.claimMappings_rolesDescription": "Claim that provides the user roles from the IdP for RBAC controls.",
  "ssoConfig.claimMappings_surName": "Surname",
  "ssoConfig.claimMappings_surNameDescription": "Claim that provides the last name of the user (e.g.: \"family_name\").",
  "ssoConfiguration": "SSO configuration",
  "ssoIdentity.label_genericOIDC": "Generic OIDC",
  "ssoIdentity.label_google": "Google",
  "ssoIdentity.label_identityProvider": "Identity provider",
  "ssoIdentity.label_microsoft": "Microsoft",
  "ssoIdentity.label_okta": "Okta",
  "ssoSetting.successMessage_saved": "SSO settings are successfully saved",
  "Stage": "Stage",
  "starting": "Starting",
  "startInvestigation": "Start investigation",
  "state": "State",
  "static": "Static",
  "stationary": "Stationary",
  "stationary_reporting_rate": "OH stationary rate",
  "status": "Status",
  "statuses": "Statuses",
  "statusGroup.inProgress": "In progress",
  "statusGroup.past": "Past",
  "stepDeckTrailer": "Step deck trailer",
  "stop": "Stop",
  "stopDetectionInterval": "Stop detection interval (minutes)",
  "stopDetectionRadius": "Stop detection radius (miles)",
  "stopDuration": "Stop duration",
  "stopMandatoryGeoArrival": "Stop mandatory for geofence arrival",
  "stopping": "Stopping",
  "stops": "Stops",
  "street": "Street",
  "subdomain": "Subdomain",
  "subject": "Subject",
  "submissionFields": "Submission fields",
  "submit": "Submit",
  "submitAsanaTicket": "This workflow includes GSOC monitored events. To update read only fields, you must <a>submit an asana ticket</a> with quality for review.",
  "subrole": "Sub-role",
  "subRole": "Sub-Role",
  "subrolesPlaceholder": "All sub-roles",
  "subsequentLoadTimeMinutes": "Subsequent load time (minutes)",
  "subtitle_bolPhoto": "Bill of lading photo",
  "subtitle_cameraError": "Access to camera is denied.",
  "subtitle_configureRiskScores": "Assign scores to risk factors based on your risk tolerance and priorities. Permitted values: 0 - 100.",
  "subtitle_createRouteDescription": "Enter your pickup and delivery locations to set up your shipment route.",
  "subtitle_deleteUserPin": "This will log them out of secureBOL and disable their PIN.",
  "subtitle_ebolTitle": "Electronic bill of lading",
  "subtitle_pairTag": "Tag is a tracking device which is paired to the parent devices and provides you with additional level of protection.",
  "subtype": "Subtype",
  "success": "Success",
  "successDescription_locationsPartiallyDuplicated": "Duplications were partially successful but some locations were already present or locations with the same name currently exist on the destination portal(s) and could not be duplicated to them.",
  "successes": "Successes",
  "successful": "Successful",
  "successMessage_activated": "Successfully activated",
  "successMessage_addVerifiedCompany": "The new company was added and its risk score has been calculated.",
  "successMessage_appointmentCancelled": "Appointment cancelled successfully",
  "successMessage_archived": "Successfully archived",
  "successMessage_assetTransfered": "Asset transferred successfully!",
  "successMessage_assetTransferedIntoCompany": "Asset has been transferred into company {companyName}.",
  "successMessage_assignmentCancelled": "Assignment cancelled successfully",
  "successMessage_available": "Successfully made available",
  "successMessage_bulkCancelAppointmentsTitle": "Appointments cancelled successfully",
  "successMessage_bulkDeactivateDevicesTitle": "Devices deactivated successfully",
  "successMessage_callServiceReconnected": "Reconnected to calling service",
  "successMessage_cancelled": "Successfully cancelled",
  "successMessage_cancelLockdownProcessing": "Shiment unlock request is being processed in the background",
  "successMessage_carrierCompanyCategoryUpdated": "Category updated to {category}",
  "successMessage_clonedShipment": "Cloned shipment: {cloneId}",
  "successMessage_created": "Successfully created",
  "successMessage_createManualEventSubmit": "Event has been created and is currently being processed",
  "successMessage_deactivated": "Successfully deactivated",
  "successMessage_deleted": "Successfully deleted",
  "successMessage_deviceLocked": "Device locked successfully.",
  "successMessage_devicePoweredOff": "Device powered down successfully.",
  "successMessage_deviceUnlocked": "Device unlocked successfully.",
  "successMessage_deviceVendorCreated": "Device vendor {name} successfully created",
  "successMessage_deviceVendorUpdated": "Device vendor {name} successfully updated",
  "successMessage_emailSent": "Email was successfully sent",
  "successMessage_escalationEmailSent": "Escalation email sent successfully",
  "successMessage_eventAdded": "Event has been added",
  "successMessage_fileAttachedToEvent": "Photo successfully attached to event ID: {eventID}",
  "successMessage_fileAttachedToShipment": "Photo successfully attached to shipment ID: {shipmentID}",
  "successMessage_gatewayAdded": "Gateway added successfully",
  "successMessage_gatewayUpdated": "Gateway updated successfully",
  "successMessage_generated": "Successfully generated",
  "successMessage_locationsAreDuplicated": "All locations were successfully duplicated to the selected portals.",
  "successMessage_locationsMerged": "Selected locations have been merged into {locationName}",
  "successMessage_locationsPartiallyDuplicated": "Duplications were partially successful.",
  "successMessage_lockdownProcessing": "Shiment lockdown request is being processed in the background",
  "successMessage_medicalDeviceTransferred": "Medical device transferred successfully!",
  "successMessage_medicalDeviceTransferredIntoCompany": "Medical device has been transferred into company {companyName}.",
  "successMessage_noShipmentExcursions": "No excursions happened on this shipment.",
  "successMessage_noteSent": "Note was successfully sent",
  "successMessage_notificationArchived": "Notification has been successfully archived",
  "successMessage_notificationResolved": "Successfully resolved",
  "successMessage_notificationUnarchived": "Notification has been successfully unarchived",
  "successMessage_packingListCompleted": "Successfully completed",
  "successMessage_packingListCompletedDescription": "Successfully completed {name}",
  "successMessage_processing": "Successfully processing",
  "successMessage_qualityReviewStatusUpdated": "QR status updated successfully",
  "successMessage_reActivated": "Successfully re-activated",
  "successMessage_refurbishDevice": "Device refurbished successfully.",
  "successMessage_replySent": "Reply was successfully sent",
  "successMessage_reportSubscriptionCreated": "Report subscription {name} successfully created",
  "successMessage_reportSubscriptionUpdated": "Report subscription {name} successfully updated",
  "successMessage_reset": "Successfully reset",
  "successMessage_resetFirstReport": "First report datetime updated successfully",
  "successMessage_ruleCreated": "The rule was created.",
  "successMessage_ruleUpdated": "The rule was updated.",
  "successMessage_saved": "Successfully saved",
  "successMessage_setActiveDestination": "Destination has been set and is currently being processed",
  "successMessage_shipmentHardReprocessed": "Shipment hard reprocess triggered successfully",
  "successMessage_shipmentHardReset": "Shipment hard reset triggered successfully",
  "successMessage_shipmentLinkSent": "Shipment link sent",
  "successMessage_shipmentReadyForClone": "Shipment is ready for clone",
  "successMessage_successDeleted": "Successfully removed {name}",
  "successMessage_thankYou": "Thank you",
  "successMessage_unarchived": "Successfully unarchived",
  "successMessage_unavailable": "Successfully made unavailable",
  "successMessage_updated": "Successfully updated",
  "successMessage_uploadShipmentAttachments": "Attachments uploaded successfully",
  "successMessage_verificationSubmitted": "Verification submitted!",
  "successMessage_workflowActivated": "Workflow {name} was successfully activated",
  "successMessage_workflowArchived": "Workflow {name} was successfully archived",
  "successMessage_workflowDeactivated": "Workflow {name} was successfully deactivated",
  "successMessage_workflowDeleted": "Workflow {name} was successfully deleted",
  "summary": "Summary",
  "summaryStep": "Summary",
  "summerDWT": "Summer DWT",
  "summerDWTTooltip": "Deadweight - max weight a vessel can carry, excluding its own weight",
  "sunday": "Sunday",
  "supervisorContactFilterDescription": "Escalation contacts are automatically filtered by shipment data which may be incorrect. <b>Update any incorrect details below and click next to see the relevant escalation contacts.</b>",
  "supportedFormats": "Supported file formats",
  "switchingQRCVerstionPrompt": "Proceeding will reset progress. Are you sure you want to switch new version ?",
  "switchQRCVersion": "Switch to the newest version",
  "switch_reason_destination_port": "Updated to destination port settings",
  "switch_reason_first_battery_level": "Updated to first battery level ping rates",
  "switch_reason_origin_port": "Updated to origin port settings",
  "switchReason.pickupDepartureRates": "Updated to pickup departure rates",
  "switch_reason_rail_final_destination": "Updated to rail final destination settings",
  "switchReason.reusableDeviceDeliverySettings": "Updated to reusable device delivery settings",
  "switch_reason_second_battery_level": "Updated to second battery level ping rates",
  "switch_reason_third_battery_level": "Updated to third battery level ping rates",
  "systemChatMessages_cancelledAlertReminders": "Auto alert reminders cancelled",
  "systemChatMessages_cancelledEscalationReminders": "Escalation reminders cancelled",
  "systemChatMessages_cancelledReminder": "Reminder cancelled",
  "systemChatMessages_escalationEmailSent": "Escalation email sent",
  "systemChatMessages_eventAcknowledged": "Event acknowledged",
  "systemChatMessages_eventAutoAcknowledged": "Event auto-acknowledged",
  "systemChatMessages_eventWaived": "Event waived",
  "systemChatMessages_firstEscalationReminderSent": "Reminder #1 sent",
  "systemChatMessages_investigationFinished": "Investigation finished",
  "systemChatMessages_investigationReopened": "Investigation reopened",
  "systemChatMessages_investigationStarted": "Investigation started",
  "systemChatMessages_lockDownCanceled": "Shipment unlocked",
  "systemChatMessages_reminderSet": "Reminder set for {duration}",
  "systemChatMessages_secondEscalationReminderSent": "Reminder #2 sent",
  "systemChatMessages_shipmentLocked": "Shipment locked down",
  "systemChatMessages_solveEscalationReminderSent": "Auto-Solve sent",
  "systemChatMessages_zendeskNoteCreated": "ZenDesk note created",
  "systemChatMessages_zendeskTicketCreated": "ZenDesk ticket created",
  "systemChatMessages_zendeskTicketUpdated": "Additional contacts added",
  "systemLanguage": "System language",
  "tableAction.successMessage_activated": "Successfully activated {name}",
  "tableAction.successMessage_available": "Successfully made available {name}",
  "tableAction.successMessage_cancelled": "Successfully cancelled {name}",
  "tableAction.successMessage_deactivated": "Successfully deactivated {name}",
  "tableAction.successMessage_deleted": "Successfully removed {name}",
  "tableAction.successMessage_unavailable": "Successfully made unavailable {name}",
  "tag": "Tag",
  "tagAdded": "Tag added successfully",
  "tagAlreadyAssigned": "Tag already assigned",
  "tagAlreadyAssignedToDevice": "Tag {tagImei} is already assigned to device {deviceImei}. Would you like to reassign this tag to a new device?",
  "tagAlreadyAssignedToShipment": "Tag {tagImei} is already assigned to shipment {shipmentId}. Would you like to reassign this tag to a new shipment?",
  "tag_detection": "Tag detection",
  "tag_detection_desc": "Tag detection mode turns on BLE tag reading",
  "tagImei": "Tag IMEI",
  "tagIsOnShipment": "Tag device will be re-assigned from shipment ID {shipmentId}, do you want to confirm this action?",
  "tagModel": "Tag model",
  "tagModel.successMessage_created": "Tag model {name} was successfully created",
  "tagModel.successMessage_updated": "Tag model {name} was successfully updated",
  "tagModelUsage_bluetoothLabel": "Bluetooth label",
  "tagModelUsage_bluetoothSeal": "Bluetooth seal",
  "tagModelUsage_bluetoothSealModified": "Bluetooth seal - modified",
  "tagModelUsage_bluetoothTagCompliance": "Bluetooth tag - compliance",
  "tagModelUsage_bluetoothTagProximity": "Bluetooth tag - proximity",
  "tagsNavBtn": "Tags",
  "tagUpdated": "Tag updated successfully",
  "teamMembers": "Team members",
  "teamName": "Team name",
  "telematicsProvider": "Telematics provider",
  "telematics_unavailable_manual_shipment_event": "Telematics unavailable",
  "telematics_unavailable_manual_violation": "Telematics unavailable",
  "temp": "Temp.",
  "temperature": "Temperature",
  "temperatureAlertDelay": "Temperature alert delay",
  "temperatureAlertStatus_noAlert": "No alerts",
  "temperatureAlertStatus_tooCold": "Too cold",
  "temperatureAlertStatus_tooHot": "Too hot",
  "temperatureAlertStatus_unknown": "Uncategorised",
  "temperature_alert_violation": "Temperature alert",
  "temperatureLogging": "Temperature logging",
  "temperatureLoggingHint": "Whether temperature reports should be logged. Use the \"Temperature sensor logging period\" to change the interval between logs.",
  "temperatureRangeName": "Temperature range name",
  "temperatureReport": "Temperature report",
  "temperature_settings": "Temperature settings",
  "temperature_shipment_event": "Temperature alert",
  "tempGraphForAssetNmbr": "Temperature graph for asset",
  "template": "Template",
  "templateLanguage": "Template language",
  "templateType": "Template type",
  "templateVariantSubtitle": "Select the portal(s) that the escalation email template should be applied to:",
  "templateWasUpdated": "The template was updated.",
  "tempRange": "Temperature range",
  "tempUnits": "Temperature units",
  "tenantType_common": "Common",
  "tenantType_consumers": "Consumers",
  "tenantType_organizations": "Organizations",
  "terminalName": "Terminal name",
  "tertiary": "Tertiary",
  "tertiaryEscalationPriorityDescription": "To be contacted third, subject to schedule, as part of escalations to this company.",
  "test": "Test",
  "text": "Text",
  "textQrc.aiScanner": "AI scanner",
  "textQrc.scanningImage": "Scanning image",
  "textQrc.scanTimeoutError": "Scan processing is taking too long. Please try again.",
  "textQrc.uploadImageToScan": "Upload image to scan",
  "theft_manual_incident_shipment_event": "Theft",
  "theft_manual_incident_violation": "Theft",
  "themeMode_dark": "Dark",
  "themeMode_light": "Light",
  "thermoking": "ThermoKing",
  "thirdBatteryLevelAlert": "Third battery level alert (%)",
  "thirdBatteryLevelMovingPingRate": "Third battery level moving ping rate",
  "thirdBatteryLevelStationaryPingRate": "Third battery level stationary ping rate",
  "threshold": "Threshold",
  "thresholds": "Thresholds",
  "thursday": "Thursday",
  "tilt": "Tilt",
  "tiltAlertDelay": "Tilt alert delay",
  "tilt_alert_violation": "Tilt alert",
  "tiltAndShockSettings": "Tilt & shock settings",
  "tilt_shipment_event": "Tilt alert",
  "time": "Time",
  "timeExpired": "Time expired",
  "timeInFinalGeofence": "Time in final geofence",
  "timeInHours": "{value} hours",
  "timeline": "Timeline",
  "time/location": "Time/Location",
  "timeProximityAssetTracking": "Time/Proximity asset tracking",
  "timerAccuracy": "Timer accuracy",
  "timerAccuracyHint": "The required position accuracy when reporting in normal (timer) mode",
  "timeRangeForShockBreach": "Time range for shock breach (minutes)",
  "timeRangeForTempBreach": "Time range for temperature breach (minutes)",
  "timeRangeForTiltBreach": "Time range for tilt breach (minutes)",
  "timeThreshold": "Time threshold",
  "timeUnit_secondsShort": "sec",
  "timezone": "Time zone (user)",
  "time_zone": "Timezone",
  "timezoneNotSelected": "Timezone not selected",
  "title": "Title",
  "title_deleteUserPin": "Are you sure you want to revoke this user's access?",
  "title_editMaintenanceAssignment": "Edit maintenance assignment",
  "title_editUserPin": "Edit user PIN",
  "title_newMaintenanceAssignment": "New assignment - maintenance",
  "title_pingControlsTimeAndLocation": "Time and location are controlled by this ping",
  "title_shipmentDetails": "Shipment details",
  "title_welcomeToShipmentConnectGo": "Welcome to Shipment Connect Go",
  "tmsShipmentsSettingDescription": "When this feature is enabled the user will be prompted to enter the shipment reference number. If this reference number is already associated with a TMS shipment, the shipment details will be prepopulated on the shipment.",
  "to": "To",
  "toDate": "To date",
  "today": "Today",
  "toggleTheNewDesign": "You can toggle on/off the new design of our shipments view here.",
  "tooltip_filterEbolSource": "SecureBOL means the BOL was created in the standalone tool. Shipment Connect means the QR code was linked in the Shipment Connect app. You can filter of view both together.",
  "tooltipLabel_coldChainGroup": "Alarm group: {value}",
  "tooltipLabel_portal": "Portal: {value}",
  "tooltipLabel_workflow": "Workflow: {value}",
  "tooltip_provideUserWithLocation": "If you don't see the relevant user, please go to the \"Users\" tab and \"Add new user\" for your company. The user will then show in this dropdown",
  "tooltip_showEscortConnectAccess": "Enabling will allow the user of this tablet to view the “Escort Connect access” toggle. This will allow the user to allow/block access to Escort Connect for escorts assigned to that shipment. Note: it is possible to allow access to all escorts in company settings",
  "tooltip_workflowSendDriverSmsLink": "Send an sms to the driver with a link to Shipment Connect Go pickup. You should ensure you enable the driver pre-pickup checklist and driver pickup fields in the road section.",
  "total": "Total",
  "totalAlerts": "Total alerts",
  "totalAttempted": "Total attempted",
  "totalCount": "Total count of OTR shipments",
  "totalDistance": "Total distance",
  "totalHours": "Total hours",
  "totalShipments": "Total shipments",
  "totalViolations": "Total violations",
  "totalViolation(s)": "Total Violation(s)",
  "tracking": "Tracking",
  "trackingLink": "Tracking link",
  "trackingReceived": "Tracking received",
  "trackingReference": "Tracking reference",
  "trackingRefNum": "Tracking ref.",
  "trackingReport": "Tracking report",
  "tractor": "Tractor",
  "Tractor": "Tractor",
  "tractorLogo": "Tractor logo",
  "tractors": "Tractors",
  "tractor_stolen_shipment_event": "Confirmed theft",
  "traffic_accident_manual_incident_shipment_event": "Traffic accident",
  "traffic_accident_manual_incident_violation": "Traffic accident",
  "trafficOverlay": "Traffic overlay",
  "trailer": "Trailer",
  "Trailer": "Trailer",
  "trailerLogo": "Trailer logo",
  "trailers": "Trailers",
  "trailerType": "Trailer type",
  "trailerType_dryVan": "Dry van",
  "trailerType_flatBed": "Flatbed",
  "trailerType_refrigerated": "Refrigerated",
  "trailerType_stepDeckTrailer": "Step deck trailer",
  "train": "Train",
  "train_workflow_inside_restart_shipment_event": "Auto - Unplanned/Safezone/Hotzone stop start",
  "train_workflow_inside_stop_shipment_event": "Auto - Unplanned/Safezone/Hotzone stops",
  "train_workflow_outside_restart_shipment_event": "Auto - Unplanned/Safezone stop start",
  "train_workflow_outside_stop_shipment_event": "Auto - Unplanned/Safezone stops",
  "transferMode.label_air": "Air",
  "transferMode.label_ocean": "Ocean",
  "transferMode.label_rail": "Rail",
  "transferMode.label_road": "Road",
  "transitioned": "Transitioned",
  "translucentTrailer": "Translucent trailer?",
  "translucentTrailerTooltip": "Enabling this toggle will turn off light events for the shipment",
  "traveledDistance": "Total OTR KM travelled",
  "trending": "Trending",
  "trial": "Trial",
  "truck": "Truck",
  "true": "True",
  "tryAgain": "Try again",
  "tts": "Time & temperature sensitive shipment",
  "ttsCountdown": "TTS countdown",
  "ttsCountdownHint": "TTS validated duration - TTS elapsed time",
  "ttsDetails": "TTS countdown timer details",
  "ttsElapsedTime": "TTS elapsed time",
  "ttsElapsedTimeHint": "The amount of time since packout",
  "ttsLabel": "TTS",
  "ttsMustBeLessThanValidDuration": "Must be less than validated duration",
  "ttspackoutTime": "Packout time",
  "ttspackoutUser": "Packer name",
  "TTSRequired": "TTS required",
  "ttsThreshold": "TTS threshold",
  "ttsThresholdCountdown": "TTS threshold countdown",
  "tts_threshold_exceeded_shipment_event": "TTS threshold exceeded",
  "tts_threshold_exceeded_violation": "TTS threshold exceeded",
  "ttsThresholdHint": "An earlier alert time than total transit time",
  "ttsThresholdMinutes": "TTS threshold (minutes)",
  "ttsThresholdTime": "TTS threshold time",
  "ttsValidatedDuration": "TTS validated duration",
  "tts_validated_duration_exceeded_shipment_event": "TTS validated duration exceeded",
  "tts_validated_duration_exceeded_violation": "TTS validated duration exceeded",
  "ttsValidatedDurationHint": "The total time Temperature-Controlled packaging/ environment will protect products",
  "ttsValidatedDurationMins": "TTS validated duration (mins)",
  "ttsValidation": "TTS validation",
  "tuesday": "Tuesday",
  "type": "Type",
  "typeShipmentId": "Type shipment ID's",
  "typeToSearch": "Type to search",
  "unableToUploadFile": "'Unable to upload. Some fields are incorrect",
  "unapproved_carrier_violation": "Unapproved carrier",
  "unapproved_driver_violation": "Unapproved driver",
  "unassigned": "Unassigned",
  "unauthorized_restart_violation": "Unauthorized stop start",
  "unauthorized_stop_violation": "Unauthorized stop",
  "unconfirmed_arrival_violation": "Unconfirmed arrival",
  "undefined": "Undefined",
  "unexpectedActualCarrier.eventDescription": "Carrier was identified at pickup and is out-of-network.",
  "ungroupByPriority": "Ungroup by event priority",
  "uniqueDeviceModelError": "Device model should be unique per single placement",
  "uniqueIdentifier": "Unique identifier",
  "uniqueNamePlaceholder": "Insert a unique name",
  "units": "Units",
  "units_cant_be_empty": "Units can't be empty",
  "units_must_be_a_number": "Units must be a number",
  "units_must_be_greater_than_zero": "Units must be greater than 0",
  "unknownAddress": "Unknown address",
  "unlock": "Unlock",
  "unlocked": "Unlocked",
  "Unlocked": "Unlocked",
  "unlocode": "UN/LOCODE",
  "unmonitored": "Unmonitored",
  "unpairingFailed": "Unpairing failed",
  "unpairingFailedInfo": "Tag {imei} cannot be unpaired. Please try again or cancel this action.",
  "unpairingSuccessful": "Unpairing successful",
  "unpairingSuccessfulInfo": "Tag {imei} has been unpaired. Please proceed.",
  "unpairTag": "Unpair tag",
  "unpairTagInfo": "Are you sure you want to un-pair and un-assign the tag from this shipment?",
  "unplanned_detention_time_exceeded_shipment_event": "Unplanned stop detention alert",
  "unplanned_restart": "Unplanned stop start",
  "unplanned_stop": "Unplanned stop",
  "unplannedStopDetentionTime": "Unplanned stop detention time (minutes)",
  "unread": "Unread",
  "unsavedChanges": "You have unsaved changes. Are you sure you want to leave this page ?",
  "unshare": "Unshare",
  "unshareConfirmationMessage": "Are you sure you want to unshare the {name} dashboard? It will not be visible to other users anymore.",
  "unshareModalTitle": "Unshare your dashboard",
  "unsnooze": "Unsnooze violation",
  "unwatchingShipment": "Unwatched shipment",
  "unwatchingShipmentMsg": "You will no longer receive notifications",
  "upcoming": "Upcoming",
  "update": "Update",
  "updateAirWorkflow": "Update air workflow",
  "updated": "Updated",
  "updatedAt": "Updated at",
  "updatedRecords": "Updated records",
  "updated_vessel_info_shipment_event": "Updated vessel info",
  "updated_vessel_info_violation": "Updated vessel info",
  "updateExistingEvent": "Update an existing event",
  "updateFilters": "Update filters",
  "updateOceanWorkflow": "Update ocean workflow",
  "updateProfilePicture": "Update profile picture",
  "updateRailWorkflow": "Update rail workflow",
  "updateRoadWorkflow": "Update road workflow",
  "updates": "Shipment updates",
  "updateShipment": "Update shipment",
  "updateShipmentStatus": "Update shipment status",
  "upload": "Upload",
  "uploadConfigFile": "Upload {extension} config",
  "uploadedBy": "Uploaded by",
  "uploadFailed": "Upload failed",
  "uploadFile": "Upload file",
  "uploadFiles": "Upload files",
  "uploadLogo": "Upload logo",
  "uploadMultipleShipments": "Upload and create multiple shipments using button below. To assign you'll need the ID for that workflow. This is shown below. To learn more on how to properly format and upload your spreadsheet.",
  "uploadShipmentAttachments": "Upload and add shipment attachments using the file upload button below.",
  "uploadSizeError": "File exceeded the max upload of {maxSize}MB",
  "upperTempLimitInFahrenheit": "Upper temperature limit for devices (fahrenheit)",
  "upperTiltLimitInDegrees": "Upper tilt limit for devices (degrees)",
  "uppserShockLimit": "Upper shock limit for devices (G)",
  "url": "URL",
  "urlShouldStartWith": "URL should start with {url}",
  "USDotNumber": "US DOT number",
  "usdotPlaceholder": "Enter USDOT number",
  "usedCount": "Used tokens: {tokensCount}",
  "user": "User",
  "userAccountSettings": "{userName} account settings",
  "userCallStatus_away": "Away",
  "userCallStatus_offline": "Offline",
  "userCallStatus_onCall": "On a call",
  "userCallStatus_online": "Online",
  "userCallStatus_transferOnly": "Transfer only",
  "userDetails": "User details",
  "userFullAccess": "Full access",
  "userId": "User ID",
  "userManagement": "User management",
  "userPerformanceKPITitle": "Carrier/Broker/FF performance - delivered shipments",
  "userPerformanceKPITooltip": "Top/Bottom 10 Carrier/Broker/Freight forwarder performance re Pickup/Delivery for delivered shipments",
  "userPhoneExtension": "Ext: {extension}",
  "userRestrictedAccess": "Restricted access",
  "userRole": "User role",
  "userRoleKind_broker": "Broker",
  "userRoleKind_carrier": "Carrier",
  "userRoleKind_customer": "Customer",
  "userRoleKind_escort": "Escort",
  "userRoleKind_oh": "Overhaul",
  "userRoleKind_shipper": "Shipper",
  "users": "Users",
  "usersTimezone": "User’s timezone",
  "utilization": "Utilization",
  "uuid": "UUID",
  "validatedDuration": "Validated duration",
  "validatedDurationDescription": "The maximum, validated, allowable time for transportation.",
  "validation_belowNotGreaterThanAbove": "The number used for the “Below” input may not be larger than that used for the “Above” input.",
  "validation_both_zero": "Both fields can't be 0",
  "validation_can_not_add_empty": "Can not add empty",
  "validation_center_in_geofence": "Warning! Geofence may need to be updated due to a change in co-ordinates",
  "validation_confirmUsdotNumber": "Confirm the USDOT number before proceeding",
  "validation_coordinates": "Coordinates are invalid",
  "validation_dateNotInThePast": "Must be in the future",
  "validation_destinationLocation": "Destination location must be different from origin",
  "validation_driverLicenseNotVerified": "Driver license must be verified",
  "validation_driverPhoneNotVerified": "Driver phone number must be verified",
  "validation_duplicateBetweenOhContactSections": "Same contact can’t be in both CSM and KAM sections",
  "validation_duplicateInSameOhContactSection": "Same contact can’t be duplicated within one section",
  "validation_end_date": "Must be less or equal to start date",
  "validation_escalationReminderTiming": "Enter value between 1 minute and 13 hours",
  "validation_eventDateBiggerThanDeviceDate": "Event generated date must be after device generated date",
  "validation_incorrect_password": "Incorrect password",
  "validation_innerRadiusSmallerThanOuter": "Inner radius must be less or equal to the outer radius",
  "validation_integer": "Must be an integer",
  "validation_invalid": "Invalid",
  "validation_invalid_format": "Invalid format. Should be similar to: {example}",
  "validation_invalidMMSI": "Must be exactly 9 digits",
  "validation_invalid_password_format": "Password should be at least 8 characters long and contain one uppercase letter, one lowercase letter, one special character and a number",
  "validation_invalid_regex_pattern": "Invalid expression",
  "validation_invalidSegments": "Segments information should be adjusted",
  "validation_is_required": "{name} is required",
  "validation_later_than_previous_time": "Should be later than previous time",
  "validation_location_not_much_segment_mode": "Location type does not match the segment mode",
  "validation_master_awb_number": "Should start with three digits, then a hyphen and eight digits after",
  "validation_maxDaysCount": "Value can't be more than {count} days",
  "validation_measurementRate": "OH measurement rate should be less or equal than OH moving rate",
  "validation_minGreaterByOneThanPrevMax": "Min must be exactly 1 greater than the previous level's max",
  "validation_min_less_max": "Min must be less than max",
  "validation_minNotBiggerThanPrevMax": "Min must be greater than previous level max",
  "validation_note_field": "The max length is 300 characters",
  "validation_notificationEmailDomain": "Email domain should be @app.over-haul.com",
  "validation_notification_frequency": "The first notification should be more the second notification",
  "validation_noWhitespace": "Whitespaces are not allowed",
  "validation_numberDecimalPlaces": "Value must have at most 2 decimal places",
  "validation_number_max": "Must be equal or less than {max}",
  "validation_number_min": "Must be equal or more than {min}",
  "validation_number_min_zero": "Must be greater than or equal to 0",
  "validation_number_negative": "Must be a negative number",
  "validation_numberOfDevicesRequired": "Please assign {count} required device(s) to this segment",
  "validation_numberOfTagsRequired": "Please assign {count} required tag(s) to this segment",
  "validation_number_positive": "Must be a positive number",
  "validation_onlyLettersNumbersUnderscores": "Should contain only letters, numbers and underscores",
  "validation_only_numbers": "Only 0-9 characters can be used",
  "validation_only_numbers_and_symbols": "Should contain only numbers and symbols",
  "validation_onlyNumbersAndUppercaseLetters": "Only numbers and uppercase letters can be used",
  "validation_outerRadiusBiggerThanInner": "Outer radius must be bigger or equal to the inner radius",
  "validation_password_dont_match": "Passwords don't match",
  "validation_phone_invalid": "Phone is invalid",
  "validation_rangeFromNotGreaterThanRangeTo": "The number used for the “Range from” input may not be larger than that used for the “Range to” input.",
  "validation_rangeOutsideIdealRange": "Alert range should not cross over the ideal range.",
  "validation_regex_validation_timed_out": "Poor performance. Takes more than {milliseconds}ms to execute",
  "validation_required": "Required",
  "validation_reset_password_token": "Reset password link has expired",
  "validation_routeGeometryRequired": "There is no route between the given coordinates",
  "validation_sensor_range_max": "Max must be bigger than {rangeType} max",
  "validation_sensor_range_min": "Min must be less than {rangeType} min",
  "validation_shouldBeLessThanReportingRate": "Should not be greater than the reporting rate set",
  "validation_should_be_number": "Value should be a number",
  "validation_should_not_be_empty": "Should not be empty",
  "validation_special_chars": "Special characters are not allowed",
  "validation_startDatebeforeEndDate": "Start date should be before end date",
  "validation_string_email": "Invalid email detected",
  "validation_string_length": "Must be exactly {length} characters",
  "validation_string_max": "Must be at most {max} characters",
  "validation_string_min": "Must be at least {min} characters",
  "validation_tagImei": "Only numbers, letters, and hyphens can be used",
  "validation_unique_languages": "Only one option per language is allowed. Remove duplicated option(s) and try again.",
  "validation_uniqueness": "Should be unique",
  "validation_uppercase_letters": "Must be only uppercase letters",
  "validation_url": "Invalid URL",
  "validation_usdot": "Please enter a valid USDOT number",
  "validation_workflowDoesNotSupportRouteType": "Selected workflow does not support route type",
  "validation_zeroOrGreaterThanFifteen": "Must be 0 or greater than 15",
  "validation_zeroOrGTE": "Must be 0 or greater than or equal to {min}",
  "validFirstPickup": "First pickup location is valid.",
  "value": "Value",
  "valueCurrency": "Value currency",
  "values": "Values",
  "vehicleErrorMessage": "VIN for {vehicleType} was not found",
  "vehicleInfo": "Lookup {vehicleType} info",
  "vehicleNumber": "Number",
  "vehiclePicture": "Vehicle picture",
  "vehicle_status_change": "Motion status change",
  "vehicleTag": "Tag",
  "vehicleVIN": "VIN",
  "vendor": "Vendor",
  "vendorCrossIn": "Vendor cross IN radius (miles)",
  "vendorCrossInTooltip": "The radius for arriving at a vendor location",
  "vendorCrossOut": "Vendor cross OUT radius (miles)",
  "vendorCrossOutTooltip": "The radius for departing a vendor location",
  "venue": "Venue",
  "venue_arrival": "Location arrival",
  "venueArrivalDeparture": "Venue Arrival/Departure",
  "venue_departure": "Location departure",
  "vessel": "Vessel",
  "vessel_berthed_shipment_event": "Vessel berthed at destination port",
  "vesselIMO": "Vessel IMO",
  "vesselLocation": "Vessel location",
  "vesselMMSI": "Vessel MMSI",
  "vesselName": "Vessel name",
  "view": "View",
  "viewCompanyId": "View company IDs",
  "viewLocation": "View location",
  "viewLocationDetail": "View location detail",
  "viewProfile": "View profile",
  "viewRoute": "View route",
  "viewRouteDetail": "View route detail",
  "viewShipment": "View shipment",
  "vin": "VIN",
  "violationBreakdown": "Violation breakdown",
  "violation_carrierRiskScore": "Carrier risk score",
  "violation_coldChainTemperatureAlert": "Quality temperature alert",
  "violation_compoundDangerzoneStop": "Compound: dangerzone stop",
  "violation_compoundHotzoneStop": "Compound: hotzone stop",
  "violation_compoundLight": "Compound: light",
  "violation_compoundRedzoneStop": "Compound: redzone stop",
  "violation_compoundRouteDeviation": "Compound: route deviation",
  "violation_compoundSealOpen": "Compound: seal open",
  "violation_compoundShipmentDeviation": "Compound: shipment deviation",
  "violation_compoundStop": "Compound: stop",
  "violation_convoyDeviation": "Convoy deviation alert",
  "violation_dangerZoneStop": "Dangerzone stop",
  "violation_demurrageWarningAtDestinationPort": "Demurrage warning at destination port",
  "violation_distanceToDestinationAlert": "Distance to destination alert",
  "violation_doubleBrokered": "Shipment double brokered",
  "violation_driverChecklist": "Driver pre-pickup checklist",
  "violation_driverRiskScore": "Driver risk score",
  "violation_escortSosAlert": "Escort SOS alert",
  "violation_firstTimeCarrier": "First time carrier seen in Overhaul",
  "violation_firstTimeDriver": "First time driver seen in Overhaul",
  "violation_handlingUnitQualityTemperatureAlert": "Packing unit temperature alert",
  "violation_incompleteDriverPickupViolation": "Incomplete driver pickup",
  "violation_incompleteDriverPreCheckViolation": "Incomplete driver pre-pickup checklist",
  "violation_itemQualityTemperatureAlert": "Item quality temperature alert",
  "violation_lateDriverPreCheckSubmissionViolation": "Late driver pre-check submission",
  "violation_lightCompoundedStop": "Stop & light",
  "violation_lightStopCompound": "Light & Stop(compound)",
  "violation_mechanicalFailureManual": "Mechanical failure",
  "violation_movingAwayCompoundedStop": "Stop & shipment deviation",
  "violation_openMicZoneEnter": "OpenMic zone entry",
  "violation_openMicZoneExit": "OpenMic zone exit",
  "violation_outOfHoursSeaportDeparture": "Out of hours seaport departure",
  "violation_outOfNetworkCarrier": "Out-of-network carrier",
  "violation_partialDelivery": "Partial delivery",
  "violation_planningApprovalRequested": "Planning approval requested",
  "violation_portContainerWellnessCheck": "Container wellness check (port)",
  "violation_railContainerWellnessCheck": "Container wellness check (rail)",
  "violationRatio": "Violation ratio - {ratio}%",
  "violation_redFlagPhotoAlert": "Red flag photo - USDOT",
  "violation_redZoneCrossed": "Redzone exit",
  "violation_routeDeviationCompoundedStop": "Stop & route deviation",
  "violations": "Violations",
  "violation_sealIsNotClosed": "Seal is not closed",
  "violation_sealOpenAndStopCompound": "Seal open & Stop(compound)",
  "violation_sealOpenCompoundedStop": "Stop & seal open",
  "violation_shipmentInfoValidation": "Shipment info validation",
  "violation_shipmentReportedIssues": "Shipment reported issues",
  "violation_shipmentStaging": "Shipment staging",
  "violation_splitShipment": "Split shipment",
  "violation_tagReunited": "Tag reunited",
  "violation_tagSeparated": "Tag separation detected",
  "violation_telematicsJamming": "Telematics jamming",
  "violation_tractorInactivePrePickupLocation": "Pre pickup tractor inactive",
  "violation_tractorSlowdown": "Tractor slowdown",
  "violation_trailerInactivePrePickupLocation": "Pre pickup trailer inactive",
  "violationType": "Violation type",
  "violation_unexpectedActualCarrier": "Unexpected actual carrier",
  "violation_updatedFlightInfo": "Updated flight info",
  "visibilityKPIGroup": "Visibility KPIs",
  "voltage": "Voltage",
  "voyage": "Voyage",
  "waive": "Waive",
  "waived": "Waived",
  "waivedEvents": "Waived events",
  "Waived Events": "Waived events",
  "waiveOpenEventsOnShipmentComplete": "Waive open events on shipment complete",
  "walmart": "Walmart",
  "wantDeactivateCompany": "Are you sure you would like to deactivate this company?",
  "wantDeactivateCustomField": "Are you sure you would like to deactivate this custom field ?",
  "wantToContinue": "Are you sure you want to continue?",
  "warning": "Warning",
  "warningMessage_medicalDeviceDeactivation": "If the medical device belongs to any existing groups, it will be removed from them.",
  "warningMessage_mergeLocations": "You are merging {locationsCount} locations. The merged locations will be removed. All associated data will either be added to the master location, {locationName}, or will be removed, based on your previous selections",
  "warningMessage_pinnedFilterRemoval": "This custom template will also be removed from the rail navigation.",
  "warningMessage_transferAsset": "You are about to transfer asset ID {assetNumber} from company {assetCompany} to company {selectedCompany}",
  "warningMessage_transferAssetDescription": "The device and assigned location will need to be updated for company {selectedCompany}. The existing history for asset {assetNumber} will remain with the original company {assetCompany} and any new updates to the asset will be assigned to company {selectedCompany}",
  "warningMessage_transferMedicalDevice": "You are about to transfer medical device {identifier} from company {currentCompany} to company {selectedCompany}",
  "warningMessage_transferMedicalDeviceDescription": "The existing history for medical device {identifier} will remain with the original company {currentCompany} and any new updates will be assigned to company {selectedCompany}.",
  "warningMessage_unavailableContactCall": "This contact is not available at this time, so exercise caution and only call in emergency",
  "warningMessage_undoneAction": "Action cannot be undone",
  "watching": "Watching",
  "watchingShipmentMsg": "You will receive notifications selected in your <a>account settings</a>",
  "watchingShipmentSuccess": "Successfully watching this shipment",
  "watchingSwitchLabel": "View ‘Watched’ shipments only",
  "watchOfficerContactFilterDescription": "Escalation contacts are automatically filtered by the following shipment data. <b>Contact your supervisor if any of the information is invalid.</b>",
  "Weather": "Weather",
  "weatherAlertThreshold": "Weather alert threshold",
  "weather_badVisibility": "Bad visibility",
  "weather_extremeWeather": "Extreme weather",
  "weather_freezingRain": "Freezing rain",
  "weatherOptics": "WeatherOptics",
  "weatherOpticsIntegration": "WeatherOptics integration",
  "weather_rain": "Rain",
  "weather_snow": "Snow",
  "weather_wind": "Wind",
  "wednesday": "Wednesday",
  "weeks": "Weeks",
  "weekShortcutsTitle": "Quick selection for the full week:",
  "weigh-stations": "Weigh stations",
  "weight": "Weight",
  "weight_cant_be_empty": "Weight can't be empty",
  "weight_must_be_a_number": "Weight must be a number",
  "weight_must_be_greater_than_zero": "Weight must be greater than 0",
  "weightUnit_kg": "kg",
  "weightUnit_lb": "lb",
  "weightUnits": "Weight units",
  "width": "Width",
  "winds": "Winds",
  "withCarrierData": "With {carrierData}",
  "withoutShipments": "Without shipments",
  "withShipments": "With shipments",
  "withViolations": "With violations",
  "wo_coldIndex": "Cold index",
  "wo_coldIndexDescription": "The cold index signals the percentage of a route where the temperature is below the threshold set.",
  "wo_crashIndex": "Crash index",
  "wo_crashIndexDescription": "The crash index signals the increased risk of vehicle accidents under various conditions.",
  "wo_disruptionIndex": "Disruption index",
  "wo_disruptionIndexDescription": "The disruption index quantifies overall weather-based interference by dynamically weighting sub-indices based on current conditions.",
  "wo_heatIndex": "Heat index",
  "wo_heatIndexDescription": "The heat index signals the percentage of a route where the temperature is above the threshold set.",
  "workDoesntContainSegment": "Selected workflow doesn't contain {segmentType} segment",
  "workflow": "Workflow",
  "workflowDetentionSettings.infoMessage_allowStopsWithMotionStatus": "By default (off), stops will only be generated when a motion status is stationary. When enabled, stops can be generated with a moving motion status",
  "workflowDetentionSettings.label_allowStopsWithMotionStatus": "Allow stops with moving motion status",
  "workflowExtraFields.confirmationMessage_deleteExtraField": "Are you sure you want to delete extra field {name}?",
  "workflowExtraFields.editExtraFeld": "Edit extra field",
  "workflowExtraFields.inputType_auditor": "Auditor",
  "workflowExtraFields.inputType_checkbox": "Checkbox",
  "workflowExtraFields.inputType_checklist": "Checklist",
  "workflowExtraFields.inputType_confirmation": "Confirmation",
  "workflowExtraFields.inputType_duration": "Duration",
  "workflowExtraFields.inputType_fleet": "Fleet",
  "workflowExtraFields.inputType_input": "Input",
  "workflowExtraFields.inputType_photo": "Photo",
  "workflowExtraFields.inputType_profileRequirment": "Profile requirement",
  "workflowExtraFields.inputType_signature": "Signature",
  "workflowExtraFields.label_addExtraField": "Add extra field",
  "workflowExtraFields.label_editExtraFeld": "Edit extra field",
  "workflowExtraFields.reorderExtraFieldsCaption": "Drag and drop extra fields to determine the position order that will be displayed on Shipment Connect.",
  "workflowExtraFields.successMessage_extraFieldDeleted": "Extra field {name} was successfully deleted",
  "workflowFraudWatchSettings.approvalStage_pickup": "Stage: pickup",
  "workflowFraudWatchSettings.approvalStage_planning": "Stage: planning",
  "workflowFraudWatchSettings.approvalStage_preclearance": "Stage: preclearance",
  "workflowFraudWatchSettings.caption_pickupApprovalSettings": "Approver settings",
  "workflowFraudWatchSettings.caption_shipmentConnectSettings": "Shipment Connect settings",
  "workflowFraudWatchSettings.description_configureApprovals": "The approval process allows a team to review FraudWatch risks identified on Overhaul shipments. Select which risks cause a given shipment stage to be: automatically allowed, rejected or require a manual decision by an approver.",
  "workflowFraudWatchSettings.infoMessage_changeInPlanProposed": "Enable to generate the \"Change in plan proposed\" event when a driver, after completing pre-clearance, indicates they plan to use a different carrier, truck or trailer than originally planned",
  "workflowFraudWatchSettings.infoMessage_configureApprovals": "The approval process allows a team to review FraudWatch risks identified on Overhaul shipments. Select which risks cause departure from pickup to be: allowed, rejected or require a manual decision by an approver.",
  "workflowFraudWatchSettings.infoMessage_excludeUsVerifiedCarriers": "Enabling this toggle means that Shipment Connect/Manager users will be unable to select verified US motor carriers when creating / updating shipments. Disable if the workflow will never have shipments with US road segments.",
  "workflowFraudWatchSettings.infoMessage_hideFraudWatchWarningsInShipmentConnect": "Enabling this toggle will hide all FraudWatch risk warnings displayed in-app to Shipment Connect users. Enable this setting to outsource the risk review process to the approver group exclusively for a lighter pickup process.",
  "workflowFraudWatchSettings.infoMessage_pickupApprovalRequired": "Enabling this toggle will require approval from a group of approvers (customer-facing) to Shipment Connect users before allowing departure from pickup when a high-risk carrier / driver is identified. Users / contacts become approvers by enabling the pickup approval requested notification via account → auto Alerts & Notifications settings.",
  "workflowFraudWatchSettings.infoMessage_pickupApprovalTime": "How much time approvers have to respond before the approval is considered “Ignored”. The time starts when the pickup submission & photos event is generated. If approval was not received within the pickup window (i.e. the approval was ignored), Shipment Connect users will be instructed to let the shipment depart.",
  "workflowFraudWatchSettings.infoMessage_planningApprovalRequired": "Enabling this toggle will require approval from customers when FraudWatch identifies high-risks during shipment creation.",
  "workflowFraudWatchSettings.infoMessage_planningApprovalTime": "Set the number of hours before the planning pickup time on a shipment that notifications to approvers will generate. For example, if 10 hours is entered, when high-risks are found, an approval request will send to approvers 10 hours before the shipment's planned pickup time.",
  "workflowFraudWatchSettings.infoMessage_shipmentDoubleBrokeredEventEnabled": "Toggle-on to generate the shipment double brokered event and Shipment Connect in-app warning when double-brokering is identified when users update a road segment's USDOT number.",
  "workflowFraudWatchSettings.label_changeInPlanProposed": "Change in plan proposed",
  "workflowFraudWatchSettings.label_configureApprovals": "Configure approvals",
  "workflowFraudWatchSettings.label_excludeUsVerifiedCarriers": "Exclude US verified motor carriers from shipment creation",
  "workflowFraudWatchSettings.label_hideFraudWatchWarningsInShipmentConnect": "Hide all FraudWatch risk warnings in Shipment Connect",
  "workflowFraudWatchSettings.label_pickupApprovalTime": "Approval window (hours)",
  "workflowFraudWatchSettings.label_planningApprovalRequired": "Require planning approval",
  "workflowFraudWatchSettings.label_planningApprovalTime": "Require approval x hours before pickup time",
  "workflowFraudWatchSettings.label_shipmentDoubleBrokeredEventEnabled": "Shipment double brokered event",
  "workflowGeneralSettings.cumulativeRiskScoreThreshold": "Cumulative risk score threshold",
  "workflowGeneralSettings.delayedEvents": "Delayed auto alert events",
  "workflowGeneralSettings.delayedEventsDescription": "Events selected below will have a delay between each notification to prevent the user from being overwhelmed by notifications from the same event",
  "workflowGeneralSettings.delayRiskEventLevelUntilPickup": "Delay risk event level generation until picked up",
  "workflowGeneralSettings.disableCarrierEditShipmentConnect": "Don't allow editing of carrier",
  "workflowGeneralSettings.disableSealNotClosedWarning": "Turn off seal not closed popup warning.",
  "workflowGeneralSettings.disableSealNotClosedWarningTooltip": "Note this warning should only be turned off for origins that use devices with long ping rates due to poor connectivity",
  "workflowGeneralSettings.driverTextEvents": "Driver text auto alert events",
  "workflowGeneralSettings.driverTextEventsDescription": "Driver(s) with valid phone numbers will receive automated texts for the selected risk events. Events will still be auto-acknowledged when a driver’s phone is not provided.",
  "workflowGeneralSettings.infoMessage_escalateRiskEvents": "The risk events listed in this drop down will require the GSOC supervisor rule to action (remind, waive or acknowledge) the risk events.",
  "workflowGeneralSettings.infoMessage_expandWatchableStatus": "Includes devices, tractors, trailer and mobile sources",
  "workflowGeneralSettings.infoMessage_preclearanceInvitationIgnoreTime": "Defines how many hours after a driver's pre-clearance invite is sent the driver's case is considered ignored, so drivers can be reassigned in time. When the time elapses, a \"Preclearance submission overdue\" timeline event is generated for each driver who has not submitted pre-clearance. E.g. With \"5\" set, the event is generated 5 hours after the invite was sent for each driver who has not submitted pre-clearance.",
  "workflowGeneralSettings.infoMessage_preemptiveDetentionNotifications": "When enabled, where a stop event occurs, a notification will be sent to the driver to let them know how much time they may remain stopped before a detention occurs",
  "workflowGeneralSettings.inTransitAutoAlertEvents": "In-transit auto alert events",
  "workflowGeneralSettings.inTransitAutoAlertEventsDescription": "A <strong>contact</strong> or <strong>user</strong> will receive <strong>in-transit</strong> alerts if their individual associations match the shipment details with their association settings on Alerts & Notifications, and the auto alert toggle is enabled on Notification Settings",
  "workflowGeneralSettings.label_delayBetweenNotifications": "Delay between notifications (minutes)",
  "workflowGeneralSettings.label_delayedEvents": "Select delayed auto alerts",
  "workflowGeneralSettings.label_doNotGeneratePickupAlerts": "Do not generate pickup submission alerts on 2+ segments",
  "workflowGeneralSettings.label_driverOnlyPickup": "Driver only pickup",
  "workflowGeneralSettings.label_driverTextEvents": "Select driver auto alerts",
  "workflowGeneralSettings.label_escalateRiskEvents": "Escalate risk events",
  "workflowGeneralSettings.label_inTransitAutoAlertEvents": "Select in-transit auto alert events",
  "workflowGeneralSettings.label_numberOfTagsRequired": "Number of tags required",
  "workflowGeneralSettings.label_originAutoAlertEvents": "Select origin auto alert events",
  "workflowGeneralSettings.label_preclearanceInvitationIgnoreTime": "Preclearance invitation ignore time",
  "workflowGeneralSettings.label_preemptivNotifications": "Pre-emptive notifications",
  "workflowGeneralSettings.label_reminderEnabled": "Auto alert reminders",
  "workflowGeneralSettings.label_requireDriverPreclearance": "Require driver preclearance",
  "workflowGeneralSettings.label_requireTag": "Require an assigned tag",
  "workflowGeneralSettings.label_selectReminderTemplate": "Select reminder template",
  "workflowGeneralSettings.label_sendDriverPreclearanceNotification": "Send driver preclearance notification",
  "workflowGeneralSettings.liveRiskScoreThreshold": "Live risk score threshold",
  "workflowGeneralSettings.originAutoAlertEvents": "Origin auto alert events",
  "workflowGeneralSettings.originAutoAlertEventsContact": "A <strong>contact</strong> will receive origin auto alerts if the origin is selected on departments & individual associations -> individual associations -> location -> origin and the auto alert toggle is enabled on Notification Settings",
  "workflowGeneralSettings.originAutoAlertEventsUser": "A <strong>user</strong> will receive origin auto alerts if the origin is selected on Alerts & Notifications and the auto alert toggle is enabled on Notification Settings",
  "workflowGeneralSettings.preemptiveDetentionNotifications": "Pre-emptive notifications for detention time",
  "workflowGeneralSettings.prohibitCancelShipment": "Don’t allow cancelling of shipment",
  "workflowGeneralSettings.prohibitEditShipment": "Don’t allow edit of shipment",
  "workflowGeneralSettings.requiredCustomerAssignment": "Require customer assignment",
  "workflowGeneralSettings.requiredTagsShipmentConnect": "Tag pairing required on Shipment Connect",
  "workflowGeneralSettings.restrictAutoAlertThreshold": "Restrict auto alert threshold",
  "workflowGeneralSettings.restrictAutoAlertThresholdInfo": "Where the risk score on a shipment breaches the threshold set, all auto alerts and auto acknowledgement will be disabled and manual action will be required instead",
  "workflowGeneralSettings.scGoDriverLicenseVerification": "Enable driver license validation",
  "workflowGeneralSettings.scGoDriverPhoneVerification": "Enable SMS phone verification",
  "workflowGeneralSettings.scGoSendPreclearanceNotificationHoursBefore": "Send preclearance invitation x hours before pickup",
  "workflowGeneralSettings.selectInTransitUserContacts": "Select in-transit users/contacts to be alerted",
  "workflowGeneralSettings.shipmentConnectConfiguration": "Shipment Connect configuration",
  "workflowGeneralSettings.shipmentConnectGoConfiguration": "Shipment Connect Go configuration",
  "workflowGeneralSettings.skipPlannedCarrierDetails": "Skip planned carrier details page",
  "workflowGeneralSettings.tooltip_requireDriverPreclearance": "Automatically send the driver(s) a preclearance link when assigned to the shipment / after clearing planning approval (if enabled). Drivers indicate the carrier and equipment planned to be used, and verify their identity and phone number. After submitting preclearance, drivers will either receive a notification to proceed to origin or shipment canceled (when a driver was rejected during preclearance approval)",
  "workflowGeneralSettings.tooltip_sendDriverPreclearanceLink": "Automatically send the driver a preclearance link when they’re assigned to the shipment. The driver must provide carrier and equipment information and verify their identity and phone number before arriving at the origin.",
  "workflow_groups": "Workflow",
  "workflow_incomplete_information_shipment_event": "Incomplete shipment information",
  "workflowItem_assign_qr_code": "Link QR code",
  "workflowItems": "Workflow items",
  "workflowItem_showBolQrCode": "Link BOL only",
  "workflowItem_showBolQrCodeDescription": "When disabled the receiver will be able to view all pickup photos",
  "workflowName": "Workflow name",
  "workflowNTASettings.autoWaiveInLowCoverageZone": "Auto-Waive NTAs in low coverage zones",
  "workflowQRWebpageSettings.label_decideDeliveryWithGpt": "Decide Accept/Reject delivery with ChatGPT",
  "workflowQRWebpageSettings.label_excursionMessageDisplayed": "QR webpage excursion message displayed",
  "workflowQRWebpageSettings.label_reportsDisplayed": "QR webpage reports displayed",
  "workflowQRWebpageSettings.title": "QR page reports & message display",
  "workflowQualitySettings.label_authenticatedAcceptRejectActions": "Authenticated Accept/Reject",
  "workflowQualitySettings.label_displayUserAcceptRejectDeliveryEvents": "Display user Accept/Reject delivery shipment events on the shipment timeline",
  "workflowQualitySettings.label_displayUserAccessToEventsWebpage": "Display user access to shipment webpage events",
  "workflowQualitySettings.label_excludeNormalEventsFromQrWebpage": "Exclude normal quality events from the QR webpage",
  "workflowQualitySettings.label_generateQrCodeOnShipmentCreate": "Generate QR code on shipment create",
  "workflowQualitySettings.label_highRiskExcursionsOnly": "High risk excursions only",
  "workflowQualitySettings.label_manualDeliveryAccept": "Move shipment to delivered only on delivery accepted Sign-Off",
  "workflowQualitySettings.label_waitTimeForAutomaticDeliveryUpdate": "Wait time for automatic delivery update",
  "workflowQualitySettings.manualDeliveryAcceptCondition_always": "Always",
  "workflowQualitySettings.manualDeliveryAcceptCondition_withAlerts": "Only where quality temperature alerts generated",
  "workflowQualitySettings.title": "Quality",
  "workflowQualityTemperatureThresholds.infoMessage_insideAlerts": "Inside alerts will generate an alert when the temperature falls within the ranges set",
  "workflowQualityTemperatureThresholds.infoMessage_outsideAlerts": "Outside alerts will generate an alert when the temperature falls outside of the ranges set",
  "workflowQualityTemperatureThresholds.label_addAlert": "Add alert",
  "workflowQualityTemperatureThresholds.label_addNewAlert": "Add new alert",
  "workflowQualityTemperatureThresholds.label_alertGroupName": "Alert group name",
  "workflowQualityTemperatureThresholds.label_alertName": "Alert name",
  "workflowQualityTemperatureThresholds.label_alertSetting": "Alert setting",
  "workflowQualityTemperatureThresholds.label_alertSettingsCreator": "Alert settings creator",
  "workflowQualityTemperatureThresholds.label_alertSettingsEditor": "Alert settings editor",
  "workflowQualityTemperatureThresholds.label_alertType": "Alert type",
  "workflowQualityTemperatureThresholds.label_idealTemperatureRange": "Ideal temperature range",
  "workflowQualityTemperatureThresholds.label_insideAlerts": "Inside alerts",
  "workflowQualityTemperatureThresholds.label_outsideAlerts": "Outside alerts",
  "workflowQualityTemperatureThresholds.label_selectAlertType": "Select alert type",
  "workflowQualityTemperatureThresholds.label_temperatureAlertDelay": "Quality temperature alert delay",
  "workflowQualityTemperatureThresholds.temperatureAlertDelayHint": "Enable this setting to generate temperature alerts only after the departure from pickup event",
  "workflow_restart_shipment_event": "Manual/Auto - Redzone/Non-Redzone/Safezone/Hotzone stop start",
  "workflowRiskEvents.label_dangerZoneStop": "Manual/Auto - dangerzone stop",
  "workflows": "Workflows",
  "workflowSensorSettings.riskZonesLowerLightThreshold": "Risk zones & delivery lower light threshold",
  "workflowSensorSettings.riskZonesLowerLightThresholdInfo": "When inside of a delivery, redzone, hotzone, dangerzone, or open mic zone, these light settings will be applied for all devices and placements. These fields are not editable",
  "workflowSeparationSettings.label_consecutiveSeparatedPings": "Consecutive separated pings",
  "workflowSeparationSettings.label_deviceSeparation": "Device separation",
  "workflowSeparationSettings.label_tagSeparation": "Tag separation",
  "workflowSeparationSettings.label_tagSeparationInfo": "Both tag separation settings must be met for an event to generate.",
  "workflowSeparationSettings.label_tagSeparationMissedPings": "Tag separation number of missed pings",
  "workflowSeparationSettings.label_tagSeparationTime": "Tag separation time (minutes)",
  "workflowSetting.automatedDepartureDecision": "Automated departure decision when a case is ignored",
  "workflowSetting.infoMessage_outOfNetworkCarrier": "Enable to generate a risk when the planned/actual carrier assigned is outside the Customer's network.<br />Enable if the customer considers using any carrier that is not part of their pre-defined network a risk.<br />Can be used instead of shipment double-brokered risk when the TMS cannot provide planned carrier accurately",
  "workflowSetting.infoMessage_pickupApprovalRequired": "Enabling this toggle will require approval from customers when FraudWatch identifies high-risks during pickup.",
  "workflowSetting.infoMessage_unexpectedActualCarrierEventEnabled": "Enable to generate an event when the actual carrier identified at pickup, is outside the Customer's network. Useful in scenarios where \"Planned carrier\" is unknown / cannot be assigned to segments.",
  "workflowSetting.label_unexpectedActualCarrierEventEnabled": "Unexpected actual carrier risk",
  "workflowSetting.pickupApprovalRequired": "Require pickup approval",
  "workflowSettings": "Workflow settings",
  "workflowSettings.infoMessage_actualCarrierEnabled": "\"Actual carrier\" dropdown field on road segments on Shipment Manager's Create/Update shipment page",
  "workflowSettings.label_actualCarrierEnabled": "Capture actual carrier on road segments (SM)",
  "workflowSettings.label_productDevicesTracking": "Automatically add product asset devices as tracking devices for shipments",
  "workflowSettings.label_secondDriverReminder": "Trigger pop-up notification to add second driver (SC & SM)",
  "workflow_stop_shipment_event": "Manual/Auto -Unplanned/Redzone/Safezone/Hotzone stops",
  "workflowType_handlingUnit": "Handling unit",
  "workflowType_inventory": "Inventory",
  "workSchedule": "Work schedule",
  "workTimeForWholeWeek": "24/7",
  "wo_roadIndex": "Road index",
  "wo_roadIndexDescription": "The road index signals weather-based driving risk and danger calculated from traffic flow, road capacity, and historical accidents under various conditions.",
  "wo_tippingIndex": "Tipping index",
  "wo_tippingIndexDescription": "The tipping index represents the likelihood of a truck tipping over due to wind, vehicle, and directional factors.",
  "wrap": "Wrap",
  "wrongFileFormat": "Wrong file format",
  "wrongFlightNumberAlert": "Wrong flight number alert",
  "wrong_flight_number_alert_shipment_event": "Wrong flight number alert",
  "wrong_flight_number_violation": "Wrong flight number",
  "year": "Year",
  "yearOfBuild": "Year of build",
  "yearQuarter": "Year & quarter",
  "yes": "Yes",
  "yesCancel": "Yes, cancel",
  "yesChange": "Yes, change",
  "yesShare": "Yes, share",
  "yesUnshare": "Yes, unshare",
  "youHaveUnsavedModes": "You have unsaved changes in the following workflow modes:",
  "yourChangesSaved": "Your changes have been saved",
  "zendeskEscalation_addRecipientsOpenLabel": "Add recipients",
  "zendeskEscalation_addRecipientsSubmitLabel": "Add recipients",
  "zendeskEscalation_addRecipientsTitle": "Add recipients to escalation",
  "zendeskEscalation.commentDefaultValue": "Adding additional recipients for visibility as per the QRC: {names}.",
  "zendeskEscalation_commentsSectionDescription": "Zendesk requires a message in order to add recipients to and existing ticket:",
  "zendeskEscalation_commentsSectionTitle": "Additional recipient comments",
  "zendeskEscalation_deactivatedAssociationChanged": "Deactivated / association changed",
  "zendeskEscalation_emergencyContactOption": "Emergency contacts",
  "zendeskEscalation_recipientsSectionNoContactsMessage": "All possible recipients were already contacted.",
  "zendeskEscalation_recipientsSectionPreviouslyContacted": "Previously contacted:",
  "zendeskEscalation_recipientsSectionTitle": "Select recipients",
  "zendeskEscalation_regularAndEmergencyContactsOption": "Regular and emergency contacts",
  "zendeskEscalation_regularContactsOption": "Regular contacts",
  "zendeskEscalation_selectCompanyContactsDescription": "Select the companies that should be emailed below:",
  "zendeskEscalation_selectContactTypeDescription": "Specify which contacts you want to escalate to:",
  "zendeskEscalation.selectedLocationRecipientsPlaceholder": "Contacts of the selected locations will appear here.",
  "zendeskEscalation.selectLocationContactsDescription": "Select the locations that should be emailed below:",
  "zendeskEscalation_sendEscalationEmailTitle": "Send escalation email",
  "zendeskEscalation.successMessage_createTicketSubmit": "Zendesk ticket has been created and is currently being processed",
  "zendeskEscalation.ticketContactsInfo": "<b>{count}</b> contacts included in total",
  "zendeskEscalation_ticketNumber": "Ticket number",
  "zendeskEscalation.zendeskTicketUpdatedByUser": "Additional contacts added by {userName}",
  "zendeskNoteCreatedByUser": "ZenDesk note by {userName}",
  "zendeskTicketCreatedByUser": "ZenDesk ticket created by {userName}",
  "zendeskTicketNumber": "Ticket number #{number}",
  "zip": "Zip code",
  "zoneLocations.map_dangerZoneGeofence": "Danger zone geofence",
  "zoneLocations.map_dangerZoneRadius": "Danger zone radius",
  "carrierRiskDashboard.label_moreThreats_one": "+ <u>{count} more threat</u>",
  "carrierRiskDashboard.label_moreThreats_other": "+ <u>{count} more threats</u>",
  "carrierRiskDashboard.label_threats_one": "{count} threat",
  "carrierRiskDashboard.label_threats_other": "{count} threats",
  "confirmationDescription_companyTeamDeactivation_one": "This team has {count} user. Deactivating the team will automatically remove the team members. Are you sure you want to deactivate the team?",
  "confirmationDescription_companyTeamDeactivation_other": "This team has {count} users. Deactivating the team will automatically remove the team members. Are you sure you want to deactivate the team?",
  "confirmationMessage_userFullAccessAuthorised_one": "I confirm that this user is authorised to have full access",
  "confirmationMessage_userFullAccessAuthorised_other": "I confirm that the users are authorised to have full access",
  "confirmUserFullAccessModalBody_one": "This user will have unrestricted access to all locations, workflows and companies available on this portal. Are you sure you want to continue?",
  "confirmUserFullAccessModalBody_other": "The users will have unrestricted access to all locations, workflows and companies available on this portal. Are you sure you want to continue?",
  "deleteEventVariantConfirmation_zero": "Are you sure you want to delete the {eventName} template used for {firstPortalName}?",
  "deleteEventVariantConfirmation_one": "Are you sure you want to delete the {eventName} template used for {firstPortalName} and {count} other portal?",
  "deleteEventVariantConfirmation_other": "Are you sure you want to delete the {eventName} template used for {firstPortalName} and {count} other portals?",
  "driverPickup.description_nearlyExpires_zero": "{name}’s license expires within {count} months. Please ensure renewal before the expiry date",
  "driverPickup.description_nearlyExpires_one": "{name}’s license expires within {count} month. Please ensure renewal before the expiry date",
  "driverPickup.description_nearlyExpires_other": "{name}’s license expires within {count} months. Please ensure renewal before the expiry date",
  "driverPickup.expiresWithinDays_zero": "Expires within {days} days",
  "driverPickup.expiresWithinDays_one": "Expires within {days} day",
  "driverPickup.expiresWithinDays_other": "Expires within {days} days",
  "error_maxTagsValidation_one": "Device can have at most {count} paired tag",
  "error_maxTagsValidation_other": "Device can have at most {count} paired tags",
  "errorMessage_pleaseConfirmFullAccess_one": "Please confirm that this user is authorised to have full access",
  "errorMessage_pleaseConfirmFullAccess_other": "Please confirm that the users are authorised to have full access",
  "escalationEmails.label_contactsIncluded_zero": "{count} contacts included",
  "escalationEmails.label_contactsIncluded_one": "{count} contact included",
  "escalationEmails.label_contactsIncluded_other": "{count} contacts included",
  "fraudwatch.label_numberOfCarriers_zero": "{count} carriers",
  "fraudwatch.label_numberOfCarriers_one": "{count} carrier",
  "fraudwatch.label_numberOfCarriers_other": "{count} carriers",
  "healthcare.amountOfAutoclaves_zero": "<strong>{count}</strong> autoclaves",
  "healthcare.amountOfAutoclaves_one": "<strong>{count}</strong> autoclave",
  "healthcare.amountOfAutoclaves_other": "<strong>{count}</strong> autoclaves",
  "healthcare.amountOfSterilizations_zero": "<strong>{count}</strong> sterilizations",
  "healthcare.amountOfSterilizations_one": "<strong>{count}</strong> sterilization",
  "healthcare.amountOfSterilizations_other": "<strong>{count}</strong> sterilizations",
  "healthcare.amountOfTurns_zero": "<strong>{count}</strong> turns",
  "healthcare.amountOfTurns_one": "<strong>{count}</strong> turn",
  "healthcare.amountOfTurns_other": "<strong>{count}</strong> turns",
  "hoursShort_one": "{count} hr",
  "hoursShort_other": "{count} hrs",
  "infoMessage_assetSensorAlertDetails_zero": "{sensorType} of {value}{unit} exceeds max setting of {maxLimit}{unit} by {excursionValue}{unit}",
  "infoMessage_assetSensorAlertDetails_one": "{sensorType} of {value}{unit} exceeds max setting of {maxLimit}{unit} by {excursionValue}{unit} for more than the {sensorType} time threshold of {timeThreshold} minute",
  "infoMessage_assetSensorAlertDetails_other": "{sensorType} of {value}{unit} exceeds max setting of {maxLimit}{unit} by {excursionValue}{unit} for more than the {sensorType} time threshold of {timeThreshold} minutes",
  "infoMessage_assetTemperatureAlert_zero": "Temperature of {currentValue} exceeds the temperature settings because it is {rangeType} the minimum temperature {minLimit} to maximum temperature {maxLimit}",
  "infoMessage_assetTemperatureAlert_one": "Temperature of {currentValue} exceeds the temperature settings because it is {rangeType} the minimum temperature {minLimit} to maximum temperature {maxLimit} for longer than the workflow time threshold of {timeThreshold} minute",
  "infoMessage_assetTemperatureAlert_other": "Temperature of {currentValue} exceeds the temperature settings because it is {rangeType} the minimum temperature {minLimit} to maximum temperature {maxLimit} for longer than the workflow time threshold of {timeThreshold} minutes",
  "infoMessage_estimatedCompletion_one": "Please check back in approximately {count} minute for the completion status.",
  "infoMessage_estimatedCompletion_other": "Please check back in approximately {count} minutes for the completion status.",
  "infoMessage_humidityAlertDetails_one": "Humidity of {value} exceeds max setting of {maxLimit} by {excursionValue} for more than the humidity time threshold of {timeThreshold} minute",
  "infoMessage_humidityAlertDetails_other": "Humidity of {value} exceeds max setting of {maxLimit} by {excursionValue} for more than the humidity time threshold of {timeThreshold} minutes",
  "label_barge_zero": "Barges",
  "label_barge_one": "Barge",
  "label_barge_other": "Barges",
  "label_bluetoothSeal_zero": "Bluetooth seal",
  "label_bluetoothSeal_one": "Bluetooth seal",
  "label_bluetoothSeal_other": "Bluetooth seal ({count})",
  "label_closeShipments_zero": "Close shipments",
  "label_closeShipments_one": "Close shipment",
  "label_closeShipments_other": "Close shipments",
  "label_driver_zero": "Drivers",
  "label_driver_one": "Driver",
  "label_driver_other": "Drivers",
  "label_editPairedTags_one": "Edit {count} paired tag",
  "label_editPairedTags_other": "Edit {count} paired tags",
  "label_electronics_zero": "Electronics",
  "label_electronics_one": "Electronics",
  "label_electronics_other": "Electronics",
  "label_errorResultMessage_one": "The following device could not be updated",
  "label_errorResultMessage_other": "The following {count} devices could not be updated",
  "label_escortDriver_zero": "Escort drivers",
  "label_escortDriver_one": "Escort driver",
  "label_escortDriver_other": "Escort drivers",
  "label_escortDriversMaxCount_one": "Escort driver (max. {count})",
  "label_escortDriversMaxCount_other": "Escort drivers (max. {count})",
  "label_eventsWithNotes_one": "{count} event with notes",
  "label_eventsWithNotes_other": "{count} events with notes",
  "label_eventWithAttachments_one": "{count} event with attachments",
  "label_eventWithAttachments_other": "{count} events with attachments",
  "label_hideEvents_one": "Hide {count} event",
  "label_hideEvents_other": "Hide {count} events",
  "label_medicalDevice_zero": "Medical devices",
  "label_medicalDevice_one": "Medical device",
  "label_medicalDevice_other": "Medical devices",
  "label_networksInRangeCount_one": "{count} network in range",
  "label_networksInRangeCount_other": "{count} networks in range",
  "label_numberOfDrivers_one": "{count} driver",
  "label_numberOfDrivers_other": "{count} drivers",
  "label_plane_zero": "Planes",
  "label_plane_one": "Plane",
  "label_plane_other": "Planes",
  "label_selectedDeviceIdsDescription_one": "The profile will be applied to {count} device",
  "label_selectedDeviceIdsDescription_other": "The profile will be applied to {count} devices",
  "label_ship_zero": "Ships",
  "label_ship_one": "Ship",
  "label_ship_other": "Ships",
  "label_shipmentsSelected_zero": "{count} shipments selected",
  "label_shipmentsSelected_one": "{count} shipment selected",
  "label_shipmentsSelected_other": "{count} shipments selected",
  "label_successResultMessage_one": "The profile was applied to {count} device.",
  "label_successResultMessage_other": "The profile was applied to {count} devices.",
  "label_tractor_zero": "Tractors",
  "label_tractor_one": "Tractor",
  "label_tractor_other": "Tractors",
  "label_trailer_zero": "Trailers",
  "label_trailer_one": "Trailer",
  "label_trailer_other": "Trailers",
  "label_vessel_zero": "Vessels",
  "label_vessel_one": "Vessel",
  "label_vessel_other": "Vessels",
  "minutesShort_one": "{count} min",
  "minutesShort_other": "{count} mins",
  "numberOfDays_one": "{count} day",
  "numberOfDays_other": "{count} days",
  "numberOfHours_one": "{count} hour",
  "numberOfHours_other": "{count} hours",
  "numberOfMiles_one": "{count} mile",
  "numberOfMiles_other": "{count} miles",
  "pickupApproval.label_photosCount_one": "{count} photo",
  "pickupApproval.label_photosCount_other": "{count} photos",
  "pickupApproval.threatsFoundInCategorySubtitle_one": "{count} threat found in",
  "pickupApproval.threatsFoundInCategorySubtitle_other": "{count} threats found in",
  "placeholder_company_one": "Select company",
  "placeholder_company_other": "Select companies",
  "reportSubscriptionsCount_zero": "No subscriptions active",
  "reportSubscriptionsCount_one": "{count} subscription active",
  "reportSubscriptionsCount_other": "{count} subscriptions active",
  "riskScoreModels.label_hideRules_one": "Hide {count} rule",
  "riskScoreModels.label_hideRules_other": "Hide {count} rules",
  "riskScoreModels.label_showRules_one": "Show {count} rule",
  "riskScoreModels.label_showRules_other": "Show {count} rules",
  "sensorAlertType_humidity_one": "{count} humidity alert",
  "sensorAlertType_humidity_other": "{count} humidity alerts",
  "sensorAlertType_light_one": "{count} light alert",
  "sensorAlertType_light_other": "{count} light alerts",
  "sensorAlertType_shock_one": "{count} shock alert",
  "sensorAlertType_shock_other": "{count} shock alerts",
  "sensorAlertType_temperature_one": "{count} temperature alert",
  "sensorAlertType_temperature_other": "{count} temperature alerts",
  "sensorAlertType_tilt_one": "{count} tilt alert",
  "sensorAlertType_tilt_other": "{count} tilt alerts",
  "successMessage_bulkCancelAppointments_zero": "{count} appointments are now cancelled",
  "successMessage_bulkCancelAppointments_one": "{count} appointment is now cancelled",
  "successMessage_bulkCancelAppointments_other": "{count} appointments are now cancelled",
  "successMessage_bulkDeactivateDevices_zero": "{count} devices are now deactivated",
  "successMessage_bulkDeactivateDevices_one": "{count} device is now deactivated",
  "successMessage_bulkDeactivateDevices_other": "{count} devices are now deactivated",
  "validation_array_max_one": "Must have at most {count} item",
  "validation_array_max_other": "Must have at most {count} items",
  "validation_array_min_one": "Must have at least {count} item",
  "validation_array_min_other": "Must have at least {count} items",
  "validation_maxDriversCount_one": "Maximum {count} driver can be selected",
  "validation_maxDriversCount_other": "Maximum {count} drivers can be selected",
  "warningMessage_shipmentExcursions_zero": "No excursions have occurred on the shipment.",
  "warningMessage_shipmentExcursions_one": "1 excursion has occurred on the shipment.",
  "warningMessage_shipmentExcursions_other": "Multiple excursions have occurred on the shipment.",
  "warningMessage_shipmentExcursionsCount_one": "1 excursion happened on this shipment.",
  "warningMessage_shipmentExcursionsCount_other": "{count} excursions happened on this shipment.",
  "warningMessage_userFullAccess_one": "This user will have unrestricted access to all locations, workflows and companies available on this portal",
  "warningMessage_userFullAccess_other": "The users will have unrestricted access to all locations, workflows and companies available on this portal"
}